import { C as e, H as t, T as n, U as r, b as i, c as a, g as o, h as s, k as c, l, p as u, t as d, u as f, x as p, y as m } from "./useCollections-BPbWcv6t.js";
import { a as h, i as g, n as _, r as v } from "./languageStore-CczIN6A7.js";
import { a as y, i as b, n as x, r as S, t as C } from "./useNotification-DG8dLwTE.js";
import { Banner as w, Box as T, Button as E, FieldWrapper as ee, FlexBox as D, FormField as te, FormGrid as ne, InputSelectionList as O, ModalBody as re, ModalFoot as ie, ModalHead as k, SelectionList as ae, Spinner as oe, Text as se } from "@dixa/lib-shared-habla";
import { Fragment as A, jsx as j, jsxs as ce } from "react/jsx-runtime";
import * as M from "react";
import N, { Component as le, createContext as ue, forwardRef as de, lazy as fe, memo as pe, useCallback as me, useContext as he, useDebugValue as ge, useEffect as _e, useLayoutEffect as ve, useMemo as ye, useReducer as be, useRef as xe, useState as Se } from "react";
import "classnames";
import { ampli as Ce } from "lib-shared-tracking";
import we from "react-dom";
import { Controller as Te, appendErrors as Ee, get as De, set as Oe, useForm as ke, useWatch as Ae } from "react-hook-form";
import { atom as je, atom as Me, createStore as Ne, useAtom as Pe, useAtomValue as Fe, useSetAtom as Ie } from "jotai";
import { atom as Le, createStore as Re } from "jotai/vanilla";
import { useHydrateAtoms as ze } from "jotai/utils";
import Be from "lodash/cloneDeep.js";
import Ve from "lodash/defaultsDeep.js";
import He from "lodash/castArray.js";
import Ue from "lodash/map.js";
import "lodash/last.js";
import We from "lodash/keyBy.js";
import Ge from "lodash/merge.js";
import Ke from "lodash/values.js";
import qe from "lodash/pick.js";
import "lodash/isEqual.js";
import Je from "lodash/debounce";
import Ye from "lodash/throttle";
import Xe from "lodash/omit.js";
import Ze from "lodash/defaults.js";
//#region ../../../node_modules/@hookform/resolvers/dist/resolvers.mjs
var Qe = (e, t, n) => {
	if (e && "reportValidity" in e) {
		let r = De(n, t);
		e.setCustomValidity(r && r.message || ""), e.reportValidity();
	}
}, $e = (e, t) => {
	for (let n in t.fields) {
		let r = t.fields[n];
		r && r.ref && "reportValidity" in r.ref ? Qe(r.ref, n, e) : r.refs && r.refs.forEach((t) => Qe(t, n, e));
	}
}, et = (e, t) => {
	t.shouldUseNativeValidation && $e(e, t);
	let n = {};
	for (let r in e) {
		let i = De(t.fields, r), a = Object.assign(e[r] || {}, { ref: i && i.ref });
		if (tt(t.names || Object.keys(e), r)) {
			let e = Object.assign({}, De(n, r));
			Oe(e, "root", a), Oe(n, r, e);
		} else Oe(n, r, a);
	}
	return n;
}, tt = (e, t) => e.some((e) => e.startsWith(t + ".")), nt = function(e, t) {
	for (var n = {}; e.length;) {
		var r = e[0], i = r.code, a = r.message, o = r.path.join(".");
		if (!n[o]) if ("unionErrors" in r) {
			var s = r.unionErrors[0].errors[0];
			n[o] = {
				message: s.message,
				type: s.code
			};
		} else n[o] = {
			message: a,
			type: i
		};
		if ("unionErrors" in r && r.unionErrors.forEach(function(t) {
			return t.errors.forEach(function(t) {
				return e.push(t);
			});
		}), t) {
			var c = n[o].types, l = c && c[r.code];
			n[o] = Ee(o, t, n, i, l ? [].concat(l, r.message) : r.message);
		}
		e.shift();
	}
	return n;
}, rt = function(e, t, n) {
	return n === void 0 && (n = {}), function(r, i, a) {
		try {
			return Promise.resolve(function(i, o) {
				try {
					var s = Promise.resolve(e[n.mode === "sync" ? "parse" : "parseAsync"](r, t)).then(function(e) {
						return a.shouldUseNativeValidation && $e({}, a), {
							errors: {},
							values: n.raw ? r : e
						};
					});
				} catch (e) {
					return o(e);
				}
				return s && s.then ? s.then(void 0, o) : s;
			}(0, function(e) {
				if (function(e) {
					return Array.isArray(e?.errors);
				}(e)) return {
					values: {},
					errors: et(nt(e.errors, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a)
				};
				throw e;
			}));
		} catch (e) {
			return Promise.reject(e);
		}
	};
};
//#endregion
//#region ../form/src/utils/index.ts
function it(e) {
	return { error: e.error?.message || void 0 };
}
fe(() => import("./dist-0hxVR4sR.js").then((e) => ({ default: e.Editor })));
//#endregion
//#region ../form/src/components/hookForm/fieldSelectionList.tsx
function at({ control: e, name: t, label: n, required: r, description: i, itemsLoading: a, equalityFn: o, placeholders: s, listItems: c, multiple: l = !0, disabled: u }) {
	return /* @__PURE__ */ j(Te, {
		control: e,
		name: t,
		render: ({ field: e, fieldState: t }) => /* @__PURE__ */ j(ee, {
			label: n,
			required: r,
			meta: it(t),
			description: i,
			children: /* @__PURE__ */ j(O, {
				multiple: l,
				value: e.value,
				onChange: (t) => e.onChange(t.selectedValues),
				disabled: a || u,
				placeholder: a ? s.loading : s.empty,
				equalityFn: o,
				getItemTitleByValue: ot,
				selectionListProps: { style: {
					maxHeight: 300,
					overflow: "auto"
				} },
				children: (c || []).map((e) => /* @__PURE__ */ j(ae.Item, {
					value: e,
					children: /* @__PURE__ */ j(se.Paragraph, { children: e.name })
				}, e.id))
			})
		})
	});
}
function ot(e) {
	return /* @__PURE__ */ j(A, { children: e?.name });
}
//#endregion
//#region ../../../node_modules/zod/v3/helpers/util.js
var st;
(function(e) {
	e.assertEqual = (e) => {};
	function t(e) {}
	e.assertIs = t;
	function n(e) {
		throw Error();
	}
	e.assertNever = n, e.arrayToEnum = (e) => {
		let t = {};
		for (let n of e) t[n] = n;
		return t;
	}, e.getValidEnumValues = (t) => {
		let n = e.objectKeys(t).filter((e) => typeof t[t[e]] != "number"), r = {};
		for (let e of n) r[e] = t[e];
		return e.objectValues(r);
	}, e.objectValues = (t) => e.objectKeys(t).map(function(e) {
		return t[e];
	}), e.objectKeys = typeof Object.keys == "function" ? (e) => Object.keys(e) : (e) => {
		let t = [];
		for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && t.push(n);
		return t;
	}, e.find = (e, t) => {
		for (let n of e) if (t(n)) return n;
	}, e.isInteger = typeof Number.isInteger == "function" ? (e) => Number.isInteger(e) : (e) => typeof e == "number" && Number.isFinite(e) && Math.floor(e) === e;
	function r(e, t = " | ") {
		return e.map((e) => typeof e == "string" ? `'${e}'` : e).join(t);
	}
	e.joinValues = r, e.jsonStringifyReplacer = (e, t) => typeof t == "bigint" ? t.toString() : t;
})(st ||= {});
var ct;
(function(e) {
	e.mergeShapes = (e, t) => ({
		...e,
		...t
	});
})(ct ||= {});
var P = st.arrayToEnum([
	"string",
	"nan",
	"number",
	"integer",
	"float",
	"boolean",
	"date",
	"bigint",
	"symbol",
	"function",
	"undefined",
	"null",
	"array",
	"object",
	"unknown",
	"promise",
	"void",
	"never",
	"map",
	"set"
]), lt = (e) => {
	switch (typeof e) {
		case "undefined": return P.undefined;
		case "string": return P.string;
		case "number": return Number.isNaN(e) ? P.nan : P.number;
		case "boolean": return P.boolean;
		case "function": return P.function;
		case "bigint": return P.bigint;
		case "symbol": return P.symbol;
		case "object": return Array.isArray(e) ? P.array : e === null ? P.null : e.then && typeof e.then == "function" && e.catch && typeof e.catch == "function" ? P.promise : typeof Map < "u" && e instanceof Map ? P.map : typeof Set < "u" && e instanceof Set ? P.set : typeof Date < "u" && e instanceof Date ? P.date : P.object;
		default: return P.unknown;
	}
}, F = st.arrayToEnum([
	"invalid_type",
	"invalid_literal",
	"custom",
	"invalid_union",
	"invalid_union_discriminator",
	"invalid_enum_value",
	"unrecognized_keys",
	"invalid_arguments",
	"invalid_return_type",
	"invalid_date",
	"invalid_string",
	"too_small",
	"too_big",
	"invalid_intersection_types",
	"not_multiple_of",
	"not_finite"
]), ut = class e extends Error {
	get errors() {
		return this.issues;
	}
	constructor(e) {
		super(), this.issues = [], this.addIssue = (e) => {
			this.issues = [...this.issues, e];
		}, this.addIssues = (e = []) => {
			this.issues = [...this.issues, ...e];
		};
		let t = new.target.prototype;
		Object.setPrototypeOf ? Object.setPrototypeOf(this, t) : this.__proto__ = t, this.name = "ZodError", this.issues = e;
	}
	format(e) {
		let t = e || function(e) {
			return e.message;
		}, n = { _errors: [] }, r = (e) => {
			for (let i of e.issues) if (i.code === "invalid_union") i.unionErrors.map(r);
			else if (i.code === "invalid_return_type") r(i.returnTypeError);
			else if (i.code === "invalid_arguments") r(i.argumentsError);
			else if (i.path.length === 0) n._errors.push(t(i));
			else {
				let e = n, r = 0;
				for (; r < i.path.length;) {
					let n = i.path[r];
					r === i.path.length - 1 ? (e[n] = e[n] || { _errors: [] }, e[n]._errors.push(t(i))) : e[n] = e[n] || { _errors: [] }, e = e[n], r++;
				}
			}
		};
		return r(this), n;
	}
	static assert(t) {
		if (!(t instanceof e)) throw Error(`Not a ZodError: ${t}`);
	}
	toString() {
		return this.message;
	}
	get message() {
		return JSON.stringify(this.issues, st.jsonStringifyReplacer, 2);
	}
	get isEmpty() {
		return this.issues.length === 0;
	}
	flatten(e = (e) => e.message) {
		let t = {}, n = [];
		for (let r of this.issues) if (r.path.length > 0) {
			let n = r.path[0];
			t[n] = t[n] || [], t[n].push(e(r));
		} else n.push(e(r));
		return {
			formErrors: n,
			fieldErrors: t
		};
	}
	get formErrors() {
		return this.flatten();
	}
};
ut.create = (e) => new ut(e);
//#endregion
//#region ../../../node_modules/zod/v3/locales/en.js
var dt = (e, t) => {
	let n;
	switch (e.code) {
		case F.invalid_type:
			n = e.received === P.undefined ? "Required" : `Expected ${e.expected}, received ${e.received}`;
			break;
		case F.invalid_literal:
			n = `Invalid literal value, expected ${JSON.stringify(e.expected, st.jsonStringifyReplacer)}`;
			break;
		case F.unrecognized_keys:
			n = `Unrecognized key(s) in object: ${st.joinValues(e.keys, ", ")}`;
			break;
		case F.invalid_union:
			n = "Invalid input";
			break;
		case F.invalid_union_discriminator:
			n = `Invalid discriminator value. Expected ${st.joinValues(e.options)}`;
			break;
		case F.invalid_enum_value:
			n = `Invalid enum value. Expected ${st.joinValues(e.options)}, received '${e.received}'`;
			break;
		case F.invalid_arguments:
			n = "Invalid function arguments";
			break;
		case F.invalid_return_type:
			n = "Invalid function return type";
			break;
		case F.invalid_date:
			n = "Invalid date";
			break;
		case F.invalid_string:
			typeof e.validation == "object" ? "includes" in e.validation ? (n = `Invalid input: must include "${e.validation.includes}"`, typeof e.validation.position == "number" && (n = `${n} at one or more positions greater than or equal to ${e.validation.position}`)) : "startsWith" in e.validation ? n = `Invalid input: must start with "${e.validation.startsWith}"` : "endsWith" in e.validation ? n = `Invalid input: must end with "${e.validation.endsWith}"` : st.assertNever(e.validation) : n = e.validation === "regex" ? "Invalid" : `Invalid ${e.validation}`;
			break;
		case F.too_small:
			n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "more than"} ${e.minimum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at least" : "over"} ${e.minimum} character(s)` : e.type === "number" || e.type === "bigint" ? `Number must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${e.minimum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly equal to " : e.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(e.minimum))}` : "Invalid input";
			break;
		case F.too_big:
			n = e.type === "array" ? `Array must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "less than"} ${e.maximum} element(s)` : e.type === "string" ? `String must contain ${e.exact ? "exactly" : e.inclusive ? "at most" : "under"} ${e.maximum} character(s)` : e.type === "number" ? `Number must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "bigint" ? `BigInt must be ${e.exact ? "exactly" : e.inclusive ? "less than or equal to" : "less than"} ${e.maximum}` : e.type === "date" ? `Date must be ${e.exact ? "exactly" : e.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(e.maximum))}` : "Invalid input";
			break;
		case F.custom:
			n = "Invalid input";
			break;
		case F.invalid_intersection_types:
			n = "Intersection results could not be merged";
			break;
		case F.not_multiple_of:
			n = `Number must be a multiple of ${e.multipleOf}`;
			break;
		case F.not_finite:
			n = "Number must be finite";
			break;
		default: n = t.defaultError, st.assertNever(e);
	}
	return { message: n };
}, ft = dt;
function pt() {
	return ft;
}
//#endregion
//#region ../../../node_modules/zod/v3/helpers/parseUtil.js
var mt = (e) => {
	let { data: t, path: n, errorMaps: r, issueData: i } = e, a = [...n, ...i.path || []], o = {
		...i,
		path: a
	};
	if (i.message !== void 0) return {
		...i,
		path: a,
		message: i.message
	};
	let s = "", c = r.filter((e) => !!e).slice().reverse();
	for (let e of c) s = e(o, {
		data: t,
		defaultError: s
	}).message;
	return {
		...i,
		path: a,
		message: s
	};
};
function I(e, t) {
	let n = pt(), r = mt({
		issueData: t,
		data: e.data,
		path: e.path,
		errorMaps: [
			e.common.contextualErrorMap,
			e.schemaErrorMap,
			n,
			n === dt ? void 0 : dt
		].filter((e) => !!e)
	});
	e.common.issues.push(r);
}
var ht = class e {
	constructor() {
		this.value = "valid";
	}
	dirty() {
		this.value === "valid" && (this.value = "dirty");
	}
	abort() {
		this.value !== "aborted" && (this.value = "aborted");
	}
	static mergeArray(e, t) {
		let n = [];
		for (let r of t) {
			if (r.status === "aborted") return L;
			r.status === "dirty" && e.dirty(), n.push(r.value);
		}
		return {
			status: e.value,
			value: n
		};
	}
	static async mergeObjectAsync(t, n) {
		let r = [];
		for (let e of n) {
			let t = await e.key, n = await e.value;
			r.push({
				key: t,
				value: n
			});
		}
		return e.mergeObjectSync(t, r);
	}
	static mergeObjectSync(e, t) {
		let n = {};
		for (let r of t) {
			let { key: t, value: i } = r;
			if (t.status === "aborted" || i.status === "aborted") return L;
			t.status === "dirty" && e.dirty(), i.status === "dirty" && e.dirty(), t.value !== "__proto__" && (i.value !== void 0 || r.alwaysSet) && (n[t.value] = i.value);
		}
		return {
			status: e.value,
			value: n
		};
	}
}, L = Object.freeze({ status: "aborted" }), gt = (e) => ({
	status: "dirty",
	value: e
}), _t = (e) => ({
	status: "valid",
	value: e
}), vt = (e) => e.status === "aborted", yt = (e) => e.status === "dirty", bt = (e) => e.status === "valid", xt = (e) => typeof Promise < "u" && e instanceof Promise, R;
(function(e) {
	e.errToObj = (e) => typeof e == "string" ? { message: e } : e || {}, e.toString = (e) => typeof e == "string" ? e : e?.message;
})(R ||= {});
//#endregion
//#region ../../../node_modules/zod/v3/types.js
var St = class {
	constructor(e, t, n, r) {
		this._cachedPath = [], this.parent = e, this.data = t, this._path = n, this._key = r;
	}
	get path() {
		return this._cachedPath.length || (Array.isArray(this._key) ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
	}
}, Ct = (e, t) => {
	if (bt(t)) return {
		success: !0,
		data: t.value
	};
	if (!e.common.issues.length) throw Error("Validation failed but no issues detected.");
	return {
		success: !1,
		get error() {
			if (this._error) return this._error;
			let t = new ut(e.common.issues);
			return this._error = t, this._error;
		}
	};
};
function z(e) {
	if (!e) return {};
	let { errorMap: t, invalid_type_error: n, required_error: r, description: i } = e;
	if (t && (n || r)) throw Error("Can't use \"invalid_type_error\" or \"required_error\" in conjunction with custom error map.");
	return t ? {
		errorMap: t,
		description: i
	} : {
		errorMap: (t, i) => {
			let { message: a } = e;
			return t.code === "invalid_enum_value" ? { message: a ?? i.defaultError } : i.data === void 0 ? { message: a ?? r ?? i.defaultError } : t.code === "invalid_type" ? { message: a ?? n ?? i.defaultError } : { message: i.defaultError };
		},
		description: i
	};
}
var B = class {
	get description() {
		return this._def.description;
	}
	_getType(e) {
		return lt(e.data);
	}
	_getOrReturnCtx(e, t) {
		return t || {
			common: e.parent.common,
			data: e.data,
			parsedType: lt(e.data),
			schemaErrorMap: this._def.errorMap,
			path: e.path,
			parent: e.parent
		};
	}
	_processInputParams(e) {
		return {
			status: new ht(),
			ctx: {
				common: e.parent.common,
				data: e.data,
				parsedType: lt(e.data),
				schemaErrorMap: this._def.errorMap,
				path: e.path,
				parent: e.parent
			}
		};
	}
	_parseSync(e) {
		let t = this._parse(e);
		if (xt(t)) throw Error("Synchronous parse encountered promise.");
		return t;
	}
	_parseAsync(e) {
		let t = this._parse(e);
		return Promise.resolve(t);
	}
	parse(e, t) {
		let n = this.safeParse(e, t);
		if (n.success) return n.data;
		throw n.error;
	}
	safeParse(e, t) {
		let n = {
			common: {
				issues: [],
				async: t?.async ?? !1,
				contextualErrorMap: t?.errorMap
			},
			path: t?.path || [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: lt(e)
		};
		return Ct(n, this._parseSync({
			data: e,
			path: n.path,
			parent: n
		}));
	}
	"~validate"(e) {
		let t = {
			common: {
				issues: [],
				async: !!this["~standard"].async
			},
			path: [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: lt(e)
		};
		if (!this["~standard"].async) try {
			let n = this._parseSync({
				data: e,
				path: [],
				parent: t
			});
			return bt(n) ? { value: n.value } : { issues: t.common.issues };
		} catch (e) {
			e?.message?.toLowerCase()?.includes("encountered") && (this["~standard"].async = !0), t.common = {
				issues: [],
				async: !0
			};
		}
		return this._parseAsync({
			data: e,
			path: [],
			parent: t
		}).then((e) => bt(e) ? { value: e.value } : { issues: t.common.issues });
	}
	async parseAsync(e, t) {
		let n = await this.safeParseAsync(e, t);
		if (n.success) return n.data;
		throw n.error;
	}
	async safeParseAsync(e, t) {
		let n = {
			common: {
				issues: [],
				contextualErrorMap: t?.errorMap,
				async: !0
			},
			path: t?.path || [],
			schemaErrorMap: this._def.errorMap,
			parent: null,
			data: e,
			parsedType: lt(e)
		}, r = this._parse({
			data: e,
			path: n.path,
			parent: n
		});
		return Ct(n, await (xt(r) ? r : Promise.resolve(r)));
	}
	refine(e, t) {
		let n = (e) => typeof t == "string" || t === void 0 ? { message: t } : typeof t == "function" ? t(e) : t;
		return this._refinement((t, r) => {
			let i = e(t), a = () => r.addIssue({
				code: F.custom,
				...n(t)
			});
			return typeof Promise < "u" && i instanceof Promise ? i.then((e) => e ? !0 : (a(), !1)) : i ? !0 : (a(), !1);
		});
	}
	refinement(e, t) {
		return this._refinement((n, r) => e(n) ? !0 : (r.addIssue(typeof t == "function" ? t(n, r) : t), !1));
	}
	_refinement(e) {
		return new Dn({
			schema: this,
			typeName: V.ZodEffects,
			effect: {
				type: "refinement",
				refinement: e
			}
		});
	}
	superRefine(e) {
		return this._refinement(e);
	}
	constructor(e) {
		this.spa = this.safeParseAsync, this._def = e, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this), this["~standard"] = {
			version: 1,
			vendor: "zod",
			validate: (e) => this["~validate"](e)
		};
	}
	optional() {
		return On.create(this, this._def);
	}
	nullable() {
		return kn.create(this, this._def);
	}
	nullish() {
		return this.nullable().optional();
	}
	array() {
		return cn.create(this);
	}
	promise() {
		return En.create(this, this._def);
	}
	or(e) {
		return dn.create([this, e], this._def);
	}
	and(e) {
		return hn.create(this, e, this._def);
	}
	transform(e) {
		return new Dn({
			...z(this._def),
			schema: this,
			typeName: V.ZodEffects,
			effect: {
				type: "transform",
				transform: e
			}
		});
	}
	default(e) {
		let t = typeof e == "function" ? e : () => e;
		return new An({
			...z(this._def),
			innerType: this,
			defaultValue: t,
			typeName: V.ZodDefault
		});
	}
	brand() {
		return new Nn({
			typeName: V.ZodBranded,
			type: this,
			...z(this._def)
		});
	}
	catch(e) {
		let t = typeof e == "function" ? e : () => e;
		return new jn({
			...z(this._def),
			innerType: this,
			catchValue: t,
			typeName: V.ZodCatch
		});
	}
	describe(e) {
		let t = this.constructor;
		return new t({
			...this._def,
			description: e
		});
	}
	pipe(e) {
		return Pn.create(this, e);
	}
	readonly() {
		return Fn.create(this);
	}
	isOptional() {
		return this.safeParse(void 0).success;
	}
	isNullable() {
		return this.safeParse(null).success;
	}
}, wt = /^c[^\s-]{8,}$/i, Tt = /^[0-9a-z]+$/, Et = /^[0-9A-HJKMNP-TV-Z]{26}$/i, Dt = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, Ot = /^[a-z0-9_-]{21}$/i, kt = /^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]*$/, At = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, jt = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, Mt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$", Nt, Pt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Ft = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/(3[0-2]|[12]?[0-9])$/, It = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/, Lt = /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Rt = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, zt = /^([0-9a-zA-Z-_]{4})*(([0-9a-zA-Z-_]{2}(==)?)|([0-9a-zA-Z-_]{3}(=)?))?$/, Bt = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", Vt = RegExp(`^${Bt}$`);
function Ht(e) {
	let t = "[0-5]\\d";
	e.precision ? t = `${t}\\.\\d{${e.precision}}` : e.precision ?? (t = `${t}(\\.\\d+)?`);
	let n = e.precision ? "+" : "?";
	return `([01]\\d|2[0-3]):[0-5]\\d(:${t})${n}`;
}
function Ut(e) {
	return RegExp(`^${Ht(e)}$`);
}
function Wt(e) {
	let t = `${Bt}T${Ht(e)}`, n = [];
	return n.push(e.local ? "Z?" : "Z"), e.offset && n.push("([+-]\\d{2}:?\\d{2})"), t = `${t}(${n.join("|")})`, RegExp(`^${t}$`);
}
function Gt(e, t) {
	return !!((t === "v4" || !t) && Pt.test(e) || (t === "v6" || !t) && It.test(e));
}
function Kt(e, t) {
	if (!kt.test(e)) return !1;
	try {
		let [n] = e.split(".");
		if (!n) return !1;
		let r = n.replace(/-/g, "+").replace(/_/g, "/").padEnd(n.length + (4 - n.length % 4) % 4, "="), i = JSON.parse(atob(r));
		return !(typeof i != "object" || !i || "typ" in i && i?.typ !== "JWT" || !i.alg || t && i.alg !== t);
	} catch {
		return !1;
	}
}
function qt(e, t) {
	return !!((t === "v4" || !t) && Ft.test(e) || (t === "v6" || !t) && Lt.test(e));
}
var Jt = class e extends B {
	_parse(e) {
		if (this._def.coerce && (e.data = String(e.data)), this._getType(e) !== P.string) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.string,
				received: t.parsedType
			}), L;
		}
		let t = new ht(), n;
		for (let r of this._def.checks) if (r.kind === "min") e.data.length < r.value && (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.too_small,
			minimum: r.value,
			type: "string",
			inclusive: !0,
			exact: !1,
			message: r.message
		}), t.dirty());
		else if (r.kind === "max") e.data.length > r.value && (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.too_big,
			maximum: r.value,
			type: "string",
			inclusive: !0,
			exact: !1,
			message: r.message
		}), t.dirty());
		else if (r.kind === "length") {
			let i = e.data.length > r.value, a = e.data.length < r.value;
			(i || a) && (n = this._getOrReturnCtx(e, n), i ? I(n, {
				code: F.too_big,
				maximum: r.value,
				type: "string",
				inclusive: !0,
				exact: !0,
				message: r.message
			}) : a && I(n, {
				code: F.too_small,
				minimum: r.value,
				type: "string",
				inclusive: !0,
				exact: !0,
				message: r.message
			}), t.dirty());
		} else if (r.kind === "email") jt.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "email",
			code: F.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "emoji") Nt ||= new RegExp(Mt, "u"), Nt.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "emoji",
			code: F.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "uuid") Dt.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "uuid",
			code: F.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "nanoid") Ot.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "nanoid",
			code: F.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "cuid") wt.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "cuid",
			code: F.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "cuid2") Tt.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "cuid2",
			code: F.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "ulid") Et.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "ulid",
			code: F.invalid_string,
			message: r.message
		}), t.dirty());
		else if (r.kind === "url") try {
			new URL(e.data);
		} catch {
			n = this._getOrReturnCtx(e, n), I(n, {
				validation: "url",
				code: F.invalid_string,
				message: r.message
			}), t.dirty();
		}
		else r.kind === "regex" ? (r.regex.lastIndex = 0, r.regex.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "regex",
			code: F.invalid_string,
			message: r.message
		}), t.dirty())) : r.kind === "trim" ? e.data = e.data.trim() : r.kind === "includes" ? e.data.includes(r.value, r.position) || (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.invalid_string,
			validation: {
				includes: r.value,
				position: r.position
			},
			message: r.message
		}), t.dirty()) : r.kind === "toLowerCase" ? e.data = e.data.toLowerCase() : r.kind === "toUpperCase" ? e.data = e.data.toUpperCase() : r.kind === "startsWith" ? e.data.startsWith(r.value) || (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.invalid_string,
			validation: { startsWith: r.value },
			message: r.message
		}), t.dirty()) : r.kind === "endsWith" ? e.data.endsWith(r.value) || (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.invalid_string,
			validation: { endsWith: r.value },
			message: r.message
		}), t.dirty()) : r.kind === "datetime" ? Wt(r).test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.invalid_string,
			validation: "datetime",
			message: r.message
		}), t.dirty()) : r.kind === "date" ? Vt.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.invalid_string,
			validation: "date",
			message: r.message
		}), t.dirty()) : r.kind === "time" ? Ut(r).test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.invalid_string,
			validation: "time",
			message: r.message
		}), t.dirty()) : r.kind === "duration" ? At.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "duration",
			code: F.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "ip" ? Gt(e.data, r.version) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "ip",
			code: F.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "jwt" ? Kt(e.data, r.alg) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "jwt",
			code: F.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "cidr" ? qt(e.data, r.version) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "cidr",
			code: F.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "base64" ? Rt.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "base64",
			code: F.invalid_string,
			message: r.message
		}), t.dirty()) : r.kind === "base64url" ? zt.test(e.data) || (n = this._getOrReturnCtx(e, n), I(n, {
			validation: "base64url",
			code: F.invalid_string,
			message: r.message
		}), t.dirty()) : st.assertNever(r);
		return {
			status: t.value,
			value: e.data
		};
	}
	_regex(e, t, n) {
		return this.refinement((t) => e.test(t), {
			validation: t,
			code: F.invalid_string,
			...R.errToObj(n)
		});
	}
	_addCheck(t) {
		return new e({
			...this._def,
			checks: [...this._def.checks, t]
		});
	}
	email(e) {
		return this._addCheck({
			kind: "email",
			...R.errToObj(e)
		});
	}
	url(e) {
		return this._addCheck({
			kind: "url",
			...R.errToObj(e)
		});
	}
	emoji(e) {
		return this._addCheck({
			kind: "emoji",
			...R.errToObj(e)
		});
	}
	uuid(e) {
		return this._addCheck({
			kind: "uuid",
			...R.errToObj(e)
		});
	}
	nanoid(e) {
		return this._addCheck({
			kind: "nanoid",
			...R.errToObj(e)
		});
	}
	cuid(e) {
		return this._addCheck({
			kind: "cuid",
			...R.errToObj(e)
		});
	}
	cuid2(e) {
		return this._addCheck({
			kind: "cuid2",
			...R.errToObj(e)
		});
	}
	ulid(e) {
		return this._addCheck({
			kind: "ulid",
			...R.errToObj(e)
		});
	}
	base64(e) {
		return this._addCheck({
			kind: "base64",
			...R.errToObj(e)
		});
	}
	base64url(e) {
		return this._addCheck({
			kind: "base64url",
			...R.errToObj(e)
		});
	}
	jwt(e) {
		return this._addCheck({
			kind: "jwt",
			...R.errToObj(e)
		});
	}
	ip(e) {
		return this._addCheck({
			kind: "ip",
			...R.errToObj(e)
		});
	}
	cidr(e) {
		return this._addCheck({
			kind: "cidr",
			...R.errToObj(e)
		});
	}
	datetime(e) {
		return typeof e == "string" ? this._addCheck({
			kind: "datetime",
			precision: null,
			offset: !1,
			local: !1,
			message: e
		}) : this._addCheck({
			kind: "datetime",
			precision: e?.precision === void 0 ? null : e?.precision,
			offset: e?.offset ?? !1,
			local: e?.local ?? !1,
			...R.errToObj(e?.message)
		});
	}
	date(e) {
		return this._addCheck({
			kind: "date",
			message: e
		});
	}
	time(e) {
		return typeof e == "string" ? this._addCheck({
			kind: "time",
			precision: null,
			message: e
		}) : this._addCheck({
			kind: "time",
			precision: e?.precision === void 0 ? null : e?.precision,
			...R.errToObj(e?.message)
		});
	}
	duration(e) {
		return this._addCheck({
			kind: "duration",
			...R.errToObj(e)
		});
	}
	regex(e, t) {
		return this._addCheck({
			kind: "regex",
			regex: e,
			...R.errToObj(t)
		});
	}
	includes(e, t) {
		return this._addCheck({
			kind: "includes",
			value: e,
			position: t?.position,
			...R.errToObj(t?.message)
		});
	}
	startsWith(e, t) {
		return this._addCheck({
			kind: "startsWith",
			value: e,
			...R.errToObj(t)
		});
	}
	endsWith(e, t) {
		return this._addCheck({
			kind: "endsWith",
			value: e,
			...R.errToObj(t)
		});
	}
	min(e, t) {
		return this._addCheck({
			kind: "min",
			value: e,
			...R.errToObj(t)
		});
	}
	max(e, t) {
		return this._addCheck({
			kind: "max",
			value: e,
			...R.errToObj(t)
		});
	}
	length(e, t) {
		return this._addCheck({
			kind: "length",
			value: e,
			...R.errToObj(t)
		});
	}
	nonempty(e) {
		return this.min(1, R.errToObj(e));
	}
	trim() {
		return new e({
			...this._def,
			checks: [...this._def.checks, { kind: "trim" }]
		});
	}
	toLowerCase() {
		return new e({
			...this._def,
			checks: [...this._def.checks, { kind: "toLowerCase" }]
		});
	}
	toUpperCase() {
		return new e({
			...this._def,
			checks: [...this._def.checks, { kind: "toUpperCase" }]
		});
	}
	get isDatetime() {
		return !!this._def.checks.find((e) => e.kind === "datetime");
	}
	get isDate() {
		return !!this._def.checks.find((e) => e.kind === "date");
	}
	get isTime() {
		return !!this._def.checks.find((e) => e.kind === "time");
	}
	get isDuration() {
		return !!this._def.checks.find((e) => e.kind === "duration");
	}
	get isEmail() {
		return !!this._def.checks.find((e) => e.kind === "email");
	}
	get isURL() {
		return !!this._def.checks.find((e) => e.kind === "url");
	}
	get isEmoji() {
		return !!this._def.checks.find((e) => e.kind === "emoji");
	}
	get isUUID() {
		return !!this._def.checks.find((e) => e.kind === "uuid");
	}
	get isNANOID() {
		return !!this._def.checks.find((e) => e.kind === "nanoid");
	}
	get isCUID() {
		return !!this._def.checks.find((e) => e.kind === "cuid");
	}
	get isCUID2() {
		return !!this._def.checks.find((e) => e.kind === "cuid2");
	}
	get isULID() {
		return !!this._def.checks.find((e) => e.kind === "ulid");
	}
	get isIP() {
		return !!this._def.checks.find((e) => e.kind === "ip");
	}
	get isCIDR() {
		return !!this._def.checks.find((e) => e.kind === "cidr");
	}
	get isBase64() {
		return !!this._def.checks.find((e) => e.kind === "base64");
	}
	get isBase64url() {
		return !!this._def.checks.find((e) => e.kind === "base64url");
	}
	get minLength() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxLength() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
};
Jt.create = (e) => new Jt({
	checks: [],
	typeName: V.ZodString,
	coerce: e?.coerce ?? !1,
	...z(e)
});
function Yt(e, t) {
	let n = (e.toString().split(".")[1] || "").length, r = (t.toString().split(".")[1] || "").length, i = n > r ? n : r;
	return Number.parseInt(e.toFixed(i).replace(".", "")) % Number.parseInt(t.toFixed(i).replace(".", "")) / 10 ** i;
}
var Xt = class e extends B {
	constructor() {
		super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
	}
	_parse(e) {
		if (this._def.coerce && (e.data = Number(e.data)), this._getType(e) !== P.number) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.number,
				received: t.parsedType
			}), L;
		}
		let t, n = new ht();
		for (let r of this._def.checks) r.kind === "int" ? st.isInteger(e.data) || (t = this._getOrReturnCtx(e, t), I(t, {
			code: F.invalid_type,
			expected: "integer",
			received: "float",
			message: r.message
		}), n.dirty()) : r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (t = this._getOrReturnCtx(e, t), I(t, {
			code: F.too_small,
			minimum: r.value,
			type: "number",
			inclusive: r.inclusive,
			exact: !1,
			message: r.message
		}), n.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (t = this._getOrReturnCtx(e, t), I(t, {
			code: F.too_big,
			maximum: r.value,
			type: "number",
			inclusive: r.inclusive,
			exact: !1,
			message: r.message
		}), n.dirty()) : r.kind === "multipleOf" ? Yt(e.data, r.value) !== 0 && (t = this._getOrReturnCtx(e, t), I(t, {
			code: F.not_multiple_of,
			multipleOf: r.value,
			message: r.message
		}), n.dirty()) : r.kind === "finite" ? Number.isFinite(e.data) || (t = this._getOrReturnCtx(e, t), I(t, {
			code: F.not_finite,
			message: r.message
		}), n.dirty()) : st.assertNever(r);
		return {
			status: n.value,
			value: e.data
		};
	}
	gte(e, t) {
		return this.setLimit("min", e, !0, R.toString(t));
	}
	gt(e, t) {
		return this.setLimit("min", e, !1, R.toString(t));
	}
	lte(e, t) {
		return this.setLimit("max", e, !0, R.toString(t));
	}
	lt(e, t) {
		return this.setLimit("max", e, !1, R.toString(t));
	}
	setLimit(t, n, r, i) {
		return new e({
			...this._def,
			checks: [...this._def.checks, {
				kind: t,
				value: n,
				inclusive: r,
				message: R.toString(i)
			}]
		});
	}
	_addCheck(t) {
		return new e({
			...this._def,
			checks: [...this._def.checks, t]
		});
	}
	int(e) {
		return this._addCheck({
			kind: "int",
			message: R.toString(e)
		});
	}
	positive(e) {
		return this._addCheck({
			kind: "min",
			value: 0,
			inclusive: !1,
			message: R.toString(e)
		});
	}
	negative(e) {
		return this._addCheck({
			kind: "max",
			value: 0,
			inclusive: !1,
			message: R.toString(e)
		});
	}
	nonpositive(e) {
		return this._addCheck({
			kind: "max",
			value: 0,
			inclusive: !0,
			message: R.toString(e)
		});
	}
	nonnegative(e) {
		return this._addCheck({
			kind: "min",
			value: 0,
			inclusive: !0,
			message: R.toString(e)
		});
	}
	multipleOf(e, t) {
		return this._addCheck({
			kind: "multipleOf",
			value: e,
			message: R.toString(t)
		});
	}
	finite(e) {
		return this._addCheck({
			kind: "finite",
			message: R.toString(e)
		});
	}
	safe(e) {
		return this._addCheck({
			kind: "min",
			inclusive: !0,
			value: -(2 ** 53 - 1),
			message: R.toString(e)
		})._addCheck({
			kind: "max",
			inclusive: !0,
			value: 2 ** 53 - 1,
			message: R.toString(e)
		});
	}
	get minValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
	get isInt() {
		return !!this._def.checks.find((e) => e.kind === "int" || e.kind === "multipleOf" && st.isInteger(e.value));
	}
	get isFinite() {
		let e = null, t = null;
		for (let n of this._def.checks) if (n.kind === "finite" || n.kind === "int" || n.kind === "multipleOf") return !0;
		else n.kind === "min" ? (t === null || n.value > t) && (t = n.value) : n.kind === "max" && (e === null || n.value < e) && (e = n.value);
		return Number.isFinite(t) && Number.isFinite(e);
	}
};
Xt.create = (e) => new Xt({
	checks: [],
	typeName: V.ZodNumber,
	coerce: e?.coerce || !1,
	...z(e)
});
var Zt = class e extends B {
	constructor() {
		super(...arguments), this.min = this.gte, this.max = this.lte;
	}
	_parse(e) {
		if (this._def.coerce) try {
			e.data = BigInt(e.data);
		} catch {
			return this._getInvalidInput(e);
		}
		if (this._getType(e) !== P.bigint) return this._getInvalidInput(e);
		let t, n = new ht();
		for (let r of this._def.checks) r.kind === "min" ? (r.inclusive ? e.data < r.value : e.data <= r.value) && (t = this._getOrReturnCtx(e, t), I(t, {
			code: F.too_small,
			type: "bigint",
			minimum: r.value,
			inclusive: r.inclusive,
			message: r.message
		}), n.dirty()) : r.kind === "max" ? (r.inclusive ? e.data > r.value : e.data >= r.value) && (t = this._getOrReturnCtx(e, t), I(t, {
			code: F.too_big,
			type: "bigint",
			maximum: r.value,
			inclusive: r.inclusive,
			message: r.message
		}), n.dirty()) : r.kind === "multipleOf" ? e.data % r.value !== BigInt(0) && (t = this._getOrReturnCtx(e, t), I(t, {
			code: F.not_multiple_of,
			multipleOf: r.value,
			message: r.message
		}), n.dirty()) : st.assertNever(r);
		return {
			status: n.value,
			value: e.data
		};
	}
	_getInvalidInput(e) {
		let t = this._getOrReturnCtx(e);
		return I(t, {
			code: F.invalid_type,
			expected: P.bigint,
			received: t.parsedType
		}), L;
	}
	gte(e, t) {
		return this.setLimit("min", e, !0, R.toString(t));
	}
	gt(e, t) {
		return this.setLimit("min", e, !1, R.toString(t));
	}
	lte(e, t) {
		return this.setLimit("max", e, !0, R.toString(t));
	}
	lt(e, t) {
		return this.setLimit("max", e, !1, R.toString(t));
	}
	setLimit(t, n, r, i) {
		return new e({
			...this._def,
			checks: [...this._def.checks, {
				kind: t,
				value: n,
				inclusive: r,
				message: R.toString(i)
			}]
		});
	}
	_addCheck(t) {
		return new e({
			...this._def,
			checks: [...this._def.checks, t]
		});
	}
	positive(e) {
		return this._addCheck({
			kind: "min",
			value: BigInt(0),
			inclusive: !1,
			message: R.toString(e)
		});
	}
	negative(e) {
		return this._addCheck({
			kind: "max",
			value: BigInt(0),
			inclusive: !1,
			message: R.toString(e)
		});
	}
	nonpositive(e) {
		return this._addCheck({
			kind: "max",
			value: BigInt(0),
			inclusive: !0,
			message: R.toString(e)
		});
	}
	nonnegative(e) {
		return this._addCheck({
			kind: "min",
			value: BigInt(0),
			inclusive: !0,
			message: R.toString(e)
		});
	}
	multipleOf(e, t) {
		return this._addCheck({
			kind: "multipleOf",
			value: e,
			message: R.toString(t)
		});
	}
	get minValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e;
	}
	get maxValue() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e;
	}
};
Zt.create = (e) => new Zt({
	checks: [],
	typeName: V.ZodBigInt,
	coerce: e?.coerce ?? !1,
	...z(e)
});
var Qt = class extends B {
	_parse(e) {
		if (this._def.coerce && (e.data = !!e.data), this._getType(e) !== P.boolean) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.boolean,
				received: t.parsedType
			}), L;
		}
		return _t(e.data);
	}
};
Qt.create = (e) => new Qt({
	typeName: V.ZodBoolean,
	coerce: e?.coerce || !1,
	...z(e)
});
var $t = class e extends B {
	_parse(e) {
		if (this._def.coerce && (e.data = new Date(e.data)), this._getType(e) !== P.date) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.date,
				received: t.parsedType
			}), L;
		}
		if (Number.isNaN(e.data.getTime())) return I(this._getOrReturnCtx(e), { code: F.invalid_date }), L;
		let t = new ht(), n;
		for (let r of this._def.checks) r.kind === "min" ? e.data.getTime() < r.value && (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.too_small,
			message: r.message,
			inclusive: !0,
			exact: !1,
			minimum: r.value,
			type: "date"
		}), t.dirty()) : r.kind === "max" ? e.data.getTime() > r.value && (n = this._getOrReturnCtx(e, n), I(n, {
			code: F.too_big,
			message: r.message,
			inclusive: !0,
			exact: !1,
			maximum: r.value,
			type: "date"
		}), t.dirty()) : st.assertNever(r);
		return {
			status: t.value,
			value: new Date(e.data.getTime())
		};
	}
	_addCheck(t) {
		return new e({
			...this._def,
			checks: [...this._def.checks, t]
		});
	}
	min(e, t) {
		return this._addCheck({
			kind: "min",
			value: e.getTime(),
			message: R.toString(t)
		});
	}
	max(e, t) {
		return this._addCheck({
			kind: "max",
			value: e.getTime(),
			message: R.toString(t)
		});
	}
	get minDate() {
		let e = null;
		for (let t of this._def.checks) t.kind === "min" && (e === null || t.value > e) && (e = t.value);
		return e == null ? null : new Date(e);
	}
	get maxDate() {
		let e = null;
		for (let t of this._def.checks) t.kind === "max" && (e === null || t.value < e) && (e = t.value);
		return e == null ? null : new Date(e);
	}
};
$t.create = (e) => new $t({
	checks: [],
	coerce: e?.coerce || !1,
	typeName: V.ZodDate,
	...z(e)
});
var en = class extends B {
	_parse(e) {
		if (this._getType(e) !== P.symbol) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.symbol,
				received: t.parsedType
			}), L;
		}
		return _t(e.data);
	}
};
en.create = (e) => new en({
	typeName: V.ZodSymbol,
	...z(e)
});
var tn = class extends B {
	_parse(e) {
		if (this._getType(e) !== P.undefined) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.undefined,
				received: t.parsedType
			}), L;
		}
		return _t(e.data);
	}
};
tn.create = (e) => new tn({
	typeName: V.ZodUndefined,
	...z(e)
});
var nn = class extends B {
	_parse(e) {
		if (this._getType(e) !== P.null) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.null,
				received: t.parsedType
			}), L;
		}
		return _t(e.data);
	}
};
nn.create = (e) => new nn({
	typeName: V.ZodNull,
	...z(e)
});
var rn = class extends B {
	constructor() {
		super(...arguments), this._any = !0;
	}
	_parse(e) {
		return _t(e.data);
	}
};
rn.create = (e) => new rn({
	typeName: V.ZodAny,
	...z(e)
});
var an = class extends B {
	constructor() {
		super(...arguments), this._unknown = !0;
	}
	_parse(e) {
		return _t(e.data);
	}
};
an.create = (e) => new an({
	typeName: V.ZodUnknown,
	...z(e)
});
var on = class extends B {
	_parse(e) {
		let t = this._getOrReturnCtx(e);
		return I(t, {
			code: F.invalid_type,
			expected: P.never,
			received: t.parsedType
		}), L;
	}
};
on.create = (e) => new on({
	typeName: V.ZodNever,
	...z(e)
});
var sn = class extends B {
	_parse(e) {
		if (this._getType(e) !== P.undefined) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.void,
				received: t.parsedType
			}), L;
		}
		return _t(e.data);
	}
};
sn.create = (e) => new sn({
	typeName: V.ZodVoid,
	...z(e)
});
var cn = class e extends B {
	_parse(e) {
		let { ctx: t, status: n } = this._processInputParams(e), r = this._def;
		if (t.parsedType !== P.array) return I(t, {
			code: F.invalid_type,
			expected: P.array,
			received: t.parsedType
		}), L;
		if (r.exactLength !== null) {
			let e = t.data.length > r.exactLength.value, i = t.data.length < r.exactLength.value;
			(e || i) && (I(t, {
				code: e ? F.too_big : F.too_small,
				minimum: i ? r.exactLength.value : void 0,
				maximum: e ? r.exactLength.value : void 0,
				type: "array",
				inclusive: !0,
				exact: !0,
				message: r.exactLength.message
			}), n.dirty());
		}
		if (r.minLength !== null && t.data.length < r.minLength.value && (I(t, {
			code: F.too_small,
			minimum: r.minLength.value,
			type: "array",
			inclusive: !0,
			exact: !1,
			message: r.minLength.message
		}), n.dirty()), r.maxLength !== null && t.data.length > r.maxLength.value && (I(t, {
			code: F.too_big,
			maximum: r.maxLength.value,
			type: "array",
			inclusive: !0,
			exact: !1,
			message: r.maxLength.message
		}), n.dirty()), t.common.async) return Promise.all([...t.data].map((e, n) => r.type._parseAsync(new St(t, e, t.path, n)))).then((e) => ht.mergeArray(n, e));
		let i = [...t.data].map((e, n) => r.type._parseSync(new St(t, e, t.path, n)));
		return ht.mergeArray(n, i);
	}
	get element() {
		return this._def.type;
	}
	min(t, n) {
		return new e({
			...this._def,
			minLength: {
				value: t,
				message: R.toString(n)
			}
		});
	}
	max(t, n) {
		return new e({
			...this._def,
			maxLength: {
				value: t,
				message: R.toString(n)
			}
		});
	}
	length(t, n) {
		return new e({
			...this._def,
			exactLength: {
				value: t,
				message: R.toString(n)
			}
		});
	}
	nonempty(e) {
		return this.min(1, e);
	}
};
cn.create = (e, t) => new cn({
	type: e,
	minLength: null,
	maxLength: null,
	exactLength: null,
	typeName: V.ZodArray,
	...z(t)
});
function ln(e) {
	if (e instanceof un) {
		let t = {};
		for (let n in e.shape) {
			let r = e.shape[n];
			t[n] = On.create(ln(r));
		}
		return new un({
			...e._def,
			shape: () => t
		});
	} else if (e instanceof cn) return new cn({
		...e._def,
		type: ln(e.element)
	});
	else if (e instanceof On) return On.create(ln(e.unwrap()));
	else if (e instanceof kn) return kn.create(ln(e.unwrap()));
	else if (e instanceof gn) return gn.create(e.items.map((e) => ln(e)));
	else return e;
}
var un = class e extends B {
	constructor() {
		super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
	}
	_getCached() {
		if (this._cached !== null) return this._cached;
		let e = this._def.shape(), t = st.objectKeys(e);
		return this._cached = {
			shape: e,
			keys: t
		}, this._cached;
	}
	_parse(e) {
		if (this._getType(e) !== P.object) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.object,
				received: t.parsedType
			}), L;
		}
		let { status: t, ctx: n } = this._processInputParams(e), { shape: r, keys: i } = this._getCached(), a = [];
		if (!(this._def.catchall instanceof on && this._def.unknownKeys === "strip")) for (let e in n.data) i.includes(e) || a.push(e);
		let o = [];
		for (let e of i) {
			let t = r[e], i = n.data[e];
			o.push({
				key: {
					status: "valid",
					value: e
				},
				value: t._parse(new St(n, i, n.path, e)),
				alwaysSet: e in n.data
			});
		}
		if (this._def.catchall instanceof on) {
			let e = this._def.unknownKeys;
			if (e === "passthrough") for (let e of a) o.push({
				key: {
					status: "valid",
					value: e
				},
				value: {
					status: "valid",
					value: n.data[e]
				}
			});
			else if (e === "strict") a.length > 0 && (I(n, {
				code: F.unrecognized_keys,
				keys: a
			}), t.dirty());
			else if (e !== "strip") throw Error("Internal ZodObject error: invalid unknownKeys value.");
		} else {
			let e = this._def.catchall;
			for (let t of a) {
				let r = n.data[t];
				o.push({
					key: {
						status: "valid",
						value: t
					},
					value: e._parse(new St(n, r, n.path, t)),
					alwaysSet: t in n.data
				});
			}
		}
		return n.common.async ? Promise.resolve().then(async () => {
			let e = [];
			for (let t of o) {
				let n = await t.key, r = await t.value;
				e.push({
					key: n,
					value: r,
					alwaysSet: t.alwaysSet
				});
			}
			return e;
		}).then((e) => ht.mergeObjectSync(t, e)) : ht.mergeObjectSync(t, o);
	}
	get shape() {
		return this._def.shape();
	}
	strict(t) {
		return R.errToObj, new e({
			...this._def,
			unknownKeys: "strict",
			...t === void 0 ? {} : { errorMap: (e, n) => {
				let r = this._def.errorMap?.(e, n).message ?? n.defaultError;
				return e.code === "unrecognized_keys" ? { message: R.errToObj(t).message ?? r } : { message: r };
			} }
		});
	}
	strip() {
		return new e({
			...this._def,
			unknownKeys: "strip"
		});
	}
	passthrough() {
		return new e({
			...this._def,
			unknownKeys: "passthrough"
		});
	}
	extend(t) {
		return new e({
			...this._def,
			shape: () => ({
				...this._def.shape(),
				...t
			})
		});
	}
	merge(t) {
		return new e({
			unknownKeys: t._def.unknownKeys,
			catchall: t._def.catchall,
			shape: () => ({
				...this._def.shape(),
				...t._def.shape()
			}),
			typeName: V.ZodObject
		});
	}
	setKey(e, t) {
		return this.augment({ [e]: t });
	}
	catchall(t) {
		return new e({
			...this._def,
			catchall: t
		});
	}
	pick(t) {
		let n = {};
		for (let e of st.objectKeys(t)) t[e] && this.shape[e] && (n[e] = this.shape[e]);
		return new e({
			...this._def,
			shape: () => n
		});
	}
	omit(t) {
		let n = {};
		for (let e of st.objectKeys(this.shape)) t[e] || (n[e] = this.shape[e]);
		return new e({
			...this._def,
			shape: () => n
		});
	}
	deepPartial() {
		return ln(this);
	}
	partial(t) {
		let n = {};
		for (let e of st.objectKeys(this.shape)) {
			let r = this.shape[e];
			t && !t[e] ? n[e] = r : n[e] = r.optional();
		}
		return new e({
			...this._def,
			shape: () => n
		});
	}
	required(t) {
		let n = {};
		for (let e of st.objectKeys(this.shape)) if (t && !t[e]) n[e] = this.shape[e];
		else {
			let t = this.shape[e];
			for (; t instanceof On;) t = t._def.innerType;
			n[e] = t;
		}
		return new e({
			...this._def,
			shape: () => n
		});
	}
	keyof() {
		return Cn(st.objectKeys(this.shape));
	}
};
un.create = (e, t) => new un({
	shape: () => e,
	unknownKeys: "strip",
	catchall: on.create(),
	typeName: V.ZodObject,
	...z(t)
}), un.strictCreate = (e, t) => new un({
	shape: () => e,
	unknownKeys: "strict",
	catchall: on.create(),
	typeName: V.ZodObject,
	...z(t)
}), un.lazycreate = (e, t) => new un({
	shape: e,
	unknownKeys: "strip",
	catchall: on.create(),
	typeName: V.ZodObject,
	...z(t)
});
var dn = class extends B {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = this._def.options;
		function r(e) {
			for (let t of e) if (t.result.status === "valid") return t.result;
			for (let n of e) if (n.result.status === "dirty") return t.common.issues.push(...n.ctx.common.issues), n.result;
			let n = e.map((e) => new ut(e.ctx.common.issues));
			return I(t, {
				code: F.invalid_union,
				unionErrors: n
			}), L;
		}
		if (t.common.async) return Promise.all(n.map(async (e) => {
			let n = {
				...t,
				common: {
					...t.common,
					issues: []
				},
				parent: null
			};
			return {
				result: await e._parseAsync({
					data: t.data,
					path: t.path,
					parent: n
				}),
				ctx: n
			};
		})).then(r);
		{
			let e, r = [];
			for (let i of n) {
				let n = {
					...t,
					common: {
						...t.common,
						issues: []
					},
					parent: null
				}, a = i._parseSync({
					data: t.data,
					path: t.path,
					parent: n
				});
				if (a.status === "valid") return a;
				a.status === "dirty" && !e && (e = {
					result: a,
					ctx: n
				}), n.common.issues.length && r.push(n.common.issues);
			}
			if (e) return t.common.issues.push(...e.ctx.common.issues), e.result;
			let i = r.map((e) => new ut(e));
			return I(t, {
				code: F.invalid_union,
				unionErrors: i
			}), L;
		}
	}
	get options() {
		return this._def.options;
	}
};
dn.create = (e, t) => new dn({
	options: e,
	typeName: V.ZodUnion,
	...z(t)
});
var fn = (e) => e instanceof xn ? fn(e.schema) : e instanceof Dn ? fn(e.innerType()) : e instanceof Sn ? [e.value] : e instanceof wn ? e.options : e instanceof Tn ? st.objectValues(e.enum) : e instanceof An ? fn(e._def.innerType) : e instanceof tn ? [void 0] : e instanceof nn ? [null] : e instanceof On ? [void 0, ...fn(e.unwrap())] : e instanceof kn ? [null, ...fn(e.unwrap())] : e instanceof Nn || e instanceof Fn ? fn(e.unwrap()) : e instanceof jn ? fn(e._def.innerType) : [], pn = class e extends B {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		if (t.parsedType !== P.object) return I(t, {
			code: F.invalid_type,
			expected: P.object,
			received: t.parsedType
		}), L;
		let n = this.discriminator, r = t.data[n], i = this.optionsMap.get(r);
		return i ? t.common.async ? i._parseAsync({
			data: t.data,
			path: t.path,
			parent: t
		}) : i._parseSync({
			data: t.data,
			path: t.path,
			parent: t
		}) : (I(t, {
			code: F.invalid_union_discriminator,
			options: Array.from(this.optionsMap.keys()),
			path: [n]
		}), L);
	}
	get discriminator() {
		return this._def.discriminator;
	}
	get options() {
		return this._def.options;
	}
	get optionsMap() {
		return this._def.optionsMap;
	}
	static create(t, n, r) {
		let i = /* @__PURE__ */ new Map();
		for (let e of n) {
			let n = fn(e.shape[t]);
			if (!n.length) throw Error(`A discriminator value for key \`${t}\` could not be extracted from all schema options`);
			for (let r of n) {
				if (i.has(r)) throw Error(`Discriminator property ${String(t)} has duplicate value ${String(r)}`);
				i.set(r, e);
			}
		}
		return new e({
			typeName: V.ZodDiscriminatedUnion,
			discriminator: t,
			options: n,
			optionsMap: i,
			...z(r)
		});
	}
};
function mn(e, t) {
	let n = lt(e), r = lt(t);
	if (e === t) return {
		valid: !0,
		data: e
	};
	if (n === P.object && r === P.object) {
		let n = st.objectKeys(t), r = st.objectKeys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = mn(e[n], t[n]);
			if (!r.valid) return { valid: !1 };
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	} else if (n === P.array && r === P.array) {
		if (e.length !== t.length) return { valid: !1 };
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = mn(i, a);
			if (!o.valid) return { valid: !1 };
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	} else if (n === P.date && r === P.date && +e == +t) return {
		valid: !0,
		data: e
	};
	else return { valid: !1 };
}
var hn = class extends B {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e), r = (e, r) => {
			if (vt(e) || vt(r)) return L;
			let i = mn(e.value, r.value);
			return i.valid ? ((yt(e) || yt(r)) && t.dirty(), {
				status: t.value,
				value: i.data
			}) : (I(n, { code: F.invalid_intersection_types }), L);
		};
		return n.common.async ? Promise.all([this._def.left._parseAsync({
			data: n.data,
			path: n.path,
			parent: n
		}), this._def.right._parseAsync({
			data: n.data,
			path: n.path,
			parent: n
		})]).then(([e, t]) => r(e, t)) : r(this._def.left._parseSync({
			data: n.data,
			path: n.path,
			parent: n
		}), this._def.right._parseSync({
			data: n.data,
			path: n.path,
			parent: n
		}));
	}
};
hn.create = (e, t, n) => new hn({
	left: e,
	right: t,
	typeName: V.ZodIntersection,
	...z(n)
});
var gn = class e extends B {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== P.array) return I(n, {
			code: F.invalid_type,
			expected: P.array,
			received: n.parsedType
		}), L;
		if (n.data.length < this._def.items.length) return I(n, {
			code: F.too_small,
			minimum: this._def.items.length,
			inclusive: !0,
			exact: !1,
			type: "array"
		}), L;
		!this._def.rest && n.data.length > this._def.items.length && (I(n, {
			code: F.too_big,
			maximum: this._def.items.length,
			inclusive: !0,
			exact: !1,
			type: "array"
		}), t.dirty());
		let r = [...n.data].map((e, t) => {
			let r = this._def.items[t] || this._def.rest;
			return r ? r._parse(new St(n, e, n.path, t)) : null;
		}).filter((e) => !!e);
		return n.common.async ? Promise.all(r).then((e) => ht.mergeArray(t, e)) : ht.mergeArray(t, r);
	}
	get items() {
		return this._def.items;
	}
	rest(t) {
		return new e({
			...this._def,
			rest: t
		});
	}
};
gn.create = (e, t) => {
	if (!Array.isArray(e)) throw Error("You must pass an array of schemas to z.tuple([ ... ])");
	return new gn({
		items: e,
		typeName: V.ZodTuple,
		rest: null,
		...z(t)
	});
};
var _n = class e extends B {
	get keySchema() {
		return this._def.keyType;
	}
	get valueSchema() {
		return this._def.valueType;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== P.object) return I(n, {
			code: F.invalid_type,
			expected: P.object,
			received: n.parsedType
		}), L;
		let r = [], i = this._def.keyType, a = this._def.valueType;
		for (let e in n.data) r.push({
			key: i._parse(new St(n, e, n.path, e)),
			value: a._parse(new St(n, n.data[e], n.path, e)),
			alwaysSet: e in n.data
		});
		return n.common.async ? ht.mergeObjectAsync(t, r) : ht.mergeObjectSync(t, r);
	}
	get element() {
		return this._def.valueType;
	}
	static create(t, n, r) {
		return n instanceof B ? new e({
			keyType: t,
			valueType: n,
			typeName: V.ZodRecord,
			...z(r)
		}) : new e({
			keyType: Jt.create(),
			valueType: t,
			typeName: V.ZodRecord,
			...z(n)
		});
	}
}, vn = class extends B {
	get keySchema() {
		return this._def.keyType;
	}
	get valueSchema() {
		return this._def.valueType;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== P.map) return I(n, {
			code: F.invalid_type,
			expected: P.map,
			received: n.parsedType
		}), L;
		let r = this._def.keyType, i = this._def.valueType, a = [...n.data.entries()].map(([e, t], a) => ({
			key: r._parse(new St(n, e, n.path, [a, "key"])),
			value: i._parse(new St(n, t, n.path, [a, "value"]))
		}));
		if (n.common.async) {
			let e = /* @__PURE__ */ new Map();
			return Promise.resolve().then(async () => {
				for (let n of a) {
					let r = await n.key, i = await n.value;
					if (r.status === "aborted" || i.status === "aborted") return L;
					(r.status === "dirty" || i.status === "dirty") && t.dirty(), e.set(r.value, i.value);
				}
				return {
					status: t.value,
					value: e
				};
			});
		} else {
			let e = /* @__PURE__ */ new Map();
			for (let n of a) {
				let r = n.key, i = n.value;
				if (r.status === "aborted" || i.status === "aborted") return L;
				(r.status === "dirty" || i.status === "dirty") && t.dirty(), e.set(r.value, i.value);
			}
			return {
				status: t.value,
				value: e
			};
		}
	}
};
vn.create = (e, t, n) => new vn({
	valueType: t,
	keyType: e,
	typeName: V.ZodMap,
	...z(n)
});
var yn = class e extends B {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.parsedType !== P.set) return I(n, {
			code: F.invalid_type,
			expected: P.set,
			received: n.parsedType
		}), L;
		let r = this._def;
		r.minSize !== null && n.data.size < r.minSize.value && (I(n, {
			code: F.too_small,
			minimum: r.minSize.value,
			type: "set",
			inclusive: !0,
			exact: !1,
			message: r.minSize.message
		}), t.dirty()), r.maxSize !== null && n.data.size > r.maxSize.value && (I(n, {
			code: F.too_big,
			maximum: r.maxSize.value,
			type: "set",
			inclusive: !0,
			exact: !1,
			message: r.maxSize.message
		}), t.dirty());
		let i = this._def.valueType;
		function a(e) {
			let n = /* @__PURE__ */ new Set();
			for (let r of e) {
				if (r.status === "aborted") return L;
				r.status === "dirty" && t.dirty(), n.add(r.value);
			}
			return {
				status: t.value,
				value: n
			};
		}
		let o = [...n.data.values()].map((e, t) => i._parse(new St(n, e, n.path, t)));
		return n.common.async ? Promise.all(o).then((e) => a(e)) : a(o);
	}
	min(t, n) {
		return new e({
			...this._def,
			minSize: {
				value: t,
				message: R.toString(n)
			}
		});
	}
	max(t, n) {
		return new e({
			...this._def,
			maxSize: {
				value: t,
				message: R.toString(n)
			}
		});
	}
	size(e, t) {
		return this.min(e, t).max(e, t);
	}
	nonempty(e) {
		return this.min(1, e);
	}
};
yn.create = (e, t) => new yn({
	valueType: e,
	minSize: null,
	maxSize: null,
	typeName: V.ZodSet,
	...z(t)
});
var bn = class e extends B {
	constructor() {
		super(...arguments), this.validate = this.implement;
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		if (t.parsedType !== P.function) return I(t, {
			code: F.invalid_type,
			expected: P.function,
			received: t.parsedType
		}), L;
		function n(e, n) {
			return mt({
				data: e,
				path: t.path,
				errorMaps: [
					t.common.contextualErrorMap,
					t.schemaErrorMap,
					pt(),
					dt
				].filter((e) => !!e),
				issueData: {
					code: F.invalid_arguments,
					argumentsError: n
				}
			});
		}
		function r(e, n) {
			return mt({
				data: e,
				path: t.path,
				errorMaps: [
					t.common.contextualErrorMap,
					t.schemaErrorMap,
					pt(),
					dt
				].filter((e) => !!e),
				issueData: {
					code: F.invalid_return_type,
					returnTypeError: n
				}
			});
		}
		let i = { errorMap: t.common.contextualErrorMap }, a = t.data;
		if (this._def.returns instanceof En) {
			let e = this;
			return _t(async function(...t) {
				let o = new ut([]), s = await e._def.args.parseAsync(t, i).catch((e) => {
					throw o.addIssue(n(t, e)), o;
				}), c = await Reflect.apply(a, this, s);
				return await e._def.returns._def.type.parseAsync(c, i).catch((e) => {
					throw o.addIssue(r(c, e)), o;
				});
			});
		} else {
			let e = this;
			return _t(function(...t) {
				let o = e._def.args.safeParse(t, i);
				if (!o.success) throw new ut([n(t, o.error)]);
				let s = Reflect.apply(a, this, o.data), c = e._def.returns.safeParse(s, i);
				if (!c.success) throw new ut([r(s, c.error)]);
				return c.data;
			});
		}
	}
	parameters() {
		return this._def.args;
	}
	returnType() {
		return this._def.returns;
	}
	args(...t) {
		return new e({
			...this._def,
			args: gn.create(t).rest(an.create())
		});
	}
	returns(t) {
		return new e({
			...this._def,
			returns: t
		});
	}
	implement(e) {
		return this.parse(e);
	}
	strictImplement(e) {
		return this.parse(e);
	}
	static create(t, n, r) {
		return new e({
			args: t || gn.create([]).rest(an.create()),
			returns: n || an.create(),
			typeName: V.ZodFunction,
			...z(r)
		});
	}
}, xn = class extends B {
	get schema() {
		return this._def.getter();
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		return this._def.getter()._parse({
			data: t.data,
			path: t.path,
			parent: t
		});
	}
};
xn.create = (e, t) => new xn({
	getter: e,
	typeName: V.ZodLazy,
	...z(t)
});
var Sn = class extends B {
	_parse(e) {
		if (e.data !== this._def.value) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				received: t.data,
				code: F.invalid_literal,
				expected: this._def.value
			}), L;
		}
		return {
			status: "valid",
			value: e.data
		};
	}
	get value() {
		return this._def.value;
	}
};
Sn.create = (e, t) => new Sn({
	value: e,
	typeName: V.ZodLiteral,
	...z(t)
});
function Cn(e, t) {
	return new wn({
		values: e,
		typeName: V.ZodEnum,
		...z(t)
	});
}
var wn = class e extends B {
	_parse(e) {
		if (typeof e.data != "string") {
			let t = this._getOrReturnCtx(e), n = this._def.values;
			return I(t, {
				expected: st.joinValues(n),
				received: t.parsedType,
				code: F.invalid_type
			}), L;
		}
		if (this._cache ||= new Set(this._def.values), !this._cache.has(e.data)) {
			let t = this._getOrReturnCtx(e), n = this._def.values;
			return I(t, {
				received: t.data,
				code: F.invalid_enum_value,
				options: n
			}), L;
		}
		return _t(e.data);
	}
	get options() {
		return this._def.values;
	}
	get enum() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	get Values() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	get Enum() {
		let e = {};
		for (let t of this._def.values) e[t] = t;
		return e;
	}
	extract(t, n = this._def) {
		return e.create(t, {
			...this._def,
			...n
		});
	}
	exclude(t, n = this._def) {
		return e.create(this.options.filter((e) => !t.includes(e)), {
			...this._def,
			...n
		});
	}
};
wn.create = Cn;
var Tn = class extends B {
	_parse(e) {
		let t = st.getValidEnumValues(this._def.values), n = this._getOrReturnCtx(e);
		if (n.parsedType !== P.string && n.parsedType !== P.number) {
			let e = st.objectValues(t);
			return I(n, {
				expected: st.joinValues(e),
				received: n.parsedType,
				code: F.invalid_type
			}), L;
		}
		if (this._cache ||= new Set(st.getValidEnumValues(this._def.values)), !this._cache.has(e.data)) {
			let e = st.objectValues(t);
			return I(n, {
				received: n.data,
				code: F.invalid_enum_value,
				options: e
			}), L;
		}
		return _t(e.data);
	}
	get enum() {
		return this._def.values;
	}
};
Tn.create = (e, t) => new Tn({
	values: e,
	typeName: V.ZodNativeEnum,
	...z(t)
});
var En = class extends B {
	unwrap() {
		return this._def.type;
	}
	_parse(e) {
		let { ctx: t } = this._processInputParams(e);
		return t.parsedType !== P.promise && t.common.async === !1 ? (I(t, {
			code: F.invalid_type,
			expected: P.promise,
			received: t.parsedType
		}), L) : _t((t.parsedType === P.promise ? t.data : Promise.resolve(t.data)).then((e) => this._def.type.parseAsync(e, {
			path: t.path,
			errorMap: t.common.contextualErrorMap
		})));
	}
};
En.create = (e, t) => new En({
	type: e,
	typeName: V.ZodPromise,
	...z(t)
});
var Dn = class extends B {
	innerType() {
		return this._def.schema;
	}
	sourceType() {
		return this._def.schema._def.typeName === V.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
	}
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e), r = this._def.effect || null, i = {
			addIssue: (e) => {
				I(n, e), e.fatal ? t.abort() : t.dirty();
			},
			get path() {
				return n.path;
			}
		};
		if (i.addIssue = i.addIssue.bind(i), r.type === "preprocess") {
			let e = r.transform(n.data, i);
			if (n.common.async) return Promise.resolve(e).then(async (e) => {
				if (t.value === "aborted") return L;
				let r = await this._def.schema._parseAsync({
					data: e,
					path: n.path,
					parent: n
				});
				return r.status === "aborted" ? L : r.status === "dirty" || t.value === "dirty" ? gt(r.value) : r;
			});
			{
				if (t.value === "aborted") return L;
				let r = this._def.schema._parseSync({
					data: e,
					path: n.path,
					parent: n
				});
				return r.status === "aborted" ? L : r.status === "dirty" || t.value === "dirty" ? gt(r.value) : r;
			}
		}
		if (r.type === "refinement") {
			let e = (e) => {
				let t = r.refinement(e, i);
				if (n.common.async) return Promise.resolve(t);
				if (t instanceof Promise) throw Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
				return e;
			};
			if (n.common.async === !1) {
				let r = this._def.schema._parseSync({
					data: n.data,
					path: n.path,
					parent: n
				});
				return r.status === "aborted" ? L : (r.status === "dirty" && t.dirty(), e(r.value), {
					status: t.value,
					value: r.value
				});
			} else return this._def.schema._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			}).then((n) => n.status === "aborted" ? L : (n.status === "dirty" && t.dirty(), e(n.value).then(() => ({
				status: t.value,
				value: n.value
			}))));
		}
		if (r.type === "transform") if (n.common.async === !1) {
			let e = this._def.schema._parseSync({
				data: n.data,
				path: n.path,
				parent: n
			});
			if (!bt(e)) return L;
			let a = r.transform(e.value, i);
			if (a instanceof Promise) throw Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
			return {
				status: t.value,
				value: a
			};
		} else return this._def.schema._parseAsync({
			data: n.data,
			path: n.path,
			parent: n
		}).then((e) => bt(e) ? Promise.resolve(r.transform(e.value, i)).then((e) => ({
			status: t.value,
			value: e
		})) : L);
		st.assertNever(r);
	}
};
Dn.create = (e, t, n) => new Dn({
	schema: e,
	typeName: V.ZodEffects,
	effect: t,
	...z(n)
}), Dn.createWithPreprocess = (e, t, n) => new Dn({
	schema: t,
	effect: {
		type: "preprocess",
		transform: e
	},
	typeName: V.ZodEffects,
	...z(n)
});
var On = class extends B {
	_parse(e) {
		return this._getType(e) === P.undefined ? _t(void 0) : this._def.innerType._parse(e);
	}
	unwrap() {
		return this._def.innerType;
	}
};
On.create = (e, t) => new On({
	innerType: e,
	typeName: V.ZodOptional,
	...z(t)
});
var kn = class extends B {
	_parse(e) {
		return this._getType(e) === P.null ? _t(null) : this._def.innerType._parse(e);
	}
	unwrap() {
		return this._def.innerType;
	}
};
kn.create = (e, t) => new kn({
	innerType: e,
	typeName: V.ZodNullable,
	...z(t)
});
var An = class extends B {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = t.data;
		return t.parsedType === P.undefined && (n = this._def.defaultValue()), this._def.innerType._parse({
			data: n,
			path: t.path,
			parent: t
		});
	}
	removeDefault() {
		return this._def.innerType;
	}
};
An.create = (e, t) => new An({
	innerType: e,
	typeName: V.ZodDefault,
	defaultValue: typeof t.default == "function" ? t.default : () => t.default,
	...z(t)
});
var jn = class extends B {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = {
			...t,
			common: {
				...t.common,
				issues: []
			}
		}, r = this._def.innerType._parse({
			data: n.data,
			path: n.path,
			parent: { ...n }
		});
		return xt(r) ? r.then((e) => ({
			status: "valid",
			value: e.status === "valid" ? e.value : this._def.catchValue({
				get error() {
					return new ut(n.common.issues);
				},
				input: n.data
			})
		})) : {
			status: "valid",
			value: r.status === "valid" ? r.value : this._def.catchValue({
				get error() {
					return new ut(n.common.issues);
				},
				input: n.data
			})
		};
	}
	removeCatch() {
		return this._def.innerType;
	}
};
jn.create = (e, t) => new jn({
	innerType: e,
	typeName: V.ZodCatch,
	catchValue: typeof t.catch == "function" ? t.catch : () => t.catch,
	...z(t)
});
var Mn = class extends B {
	_parse(e) {
		if (this._getType(e) !== P.nan) {
			let t = this._getOrReturnCtx(e);
			return I(t, {
				code: F.invalid_type,
				expected: P.nan,
				received: t.parsedType
			}), L;
		}
		return {
			status: "valid",
			value: e.data
		};
	}
};
Mn.create = (e) => new Mn({
	typeName: V.ZodNaN,
	...z(e)
});
var Nn = class extends B {
	_parse(e) {
		let { ctx: t } = this._processInputParams(e), n = t.data;
		return this._def.type._parse({
			data: n,
			path: t.path,
			parent: t
		});
	}
	unwrap() {
		return this._def.type;
	}
}, Pn = class e extends B {
	_parse(e) {
		let { status: t, ctx: n } = this._processInputParams(e);
		if (n.common.async) return (async () => {
			let e = await this._def.in._parseAsync({
				data: n.data,
				path: n.path,
				parent: n
			});
			return e.status === "aborted" ? L : e.status === "dirty" ? (t.dirty(), gt(e.value)) : this._def.out._parseAsync({
				data: e.value,
				path: n.path,
				parent: n
			});
		})();
		{
			let e = this._def.in._parseSync({
				data: n.data,
				path: n.path,
				parent: n
			});
			return e.status === "aborted" ? L : e.status === "dirty" ? (t.dirty(), {
				status: "dirty",
				value: e.value
			}) : this._def.out._parseSync({
				data: e.value,
				path: n.path,
				parent: n
			});
		}
	}
	static create(t, n) {
		return new e({
			in: t,
			out: n,
			typeName: V.ZodPipeline
		});
	}
}, Fn = class extends B {
	_parse(e) {
		let t = this._def.innerType._parse(e), n = (e) => (bt(e) && (e.value = Object.freeze(e.value)), e);
		return xt(t) ? t.then((e) => n(e)) : n(t);
	}
	unwrap() {
		return this._def.innerType;
	}
};
Fn.create = (e, t) => new Fn({
	innerType: e,
	typeName: V.ZodReadonly,
	...z(t)
}), un.lazycreate;
var V;
(function(e) {
	e.ZodString = "ZodString", e.ZodNumber = "ZodNumber", e.ZodNaN = "ZodNaN", e.ZodBigInt = "ZodBigInt", e.ZodBoolean = "ZodBoolean", e.ZodDate = "ZodDate", e.ZodSymbol = "ZodSymbol", e.ZodUndefined = "ZodUndefined", e.ZodNull = "ZodNull", e.ZodAny = "ZodAny", e.ZodUnknown = "ZodUnknown", e.ZodNever = "ZodNever", e.ZodVoid = "ZodVoid", e.ZodArray = "ZodArray", e.ZodObject = "ZodObject", e.ZodUnion = "ZodUnion", e.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", e.ZodIntersection = "ZodIntersection", e.ZodTuple = "ZodTuple", e.ZodRecord = "ZodRecord", e.ZodMap = "ZodMap", e.ZodSet = "ZodSet", e.ZodFunction = "ZodFunction", e.ZodLazy = "ZodLazy", e.ZodLiteral = "ZodLiteral", e.ZodEnum = "ZodEnum", e.ZodEffects = "ZodEffects", e.ZodNativeEnum = "ZodNativeEnum", e.ZodOptional = "ZodOptional", e.ZodNullable = "ZodNullable", e.ZodDefault = "ZodDefault", e.ZodCatch = "ZodCatch", e.ZodPromise = "ZodPromise", e.ZodBranded = "ZodBranded", e.ZodPipeline = "ZodPipeline", e.ZodReadonly = "ZodReadonly";
})(V ||= {});
var In = Jt.create, Ln = Xt.create;
Mn.create, Zt.create, Qt.create, $t.create, en.create, tn.create, nn.create, rn.create, an.create, on.create, sn.create;
var Rn = cn.create, zn = un.create;
un.strictCreate, dn.create, pn.create, hn.create, gn.create, _n.create, vn.create, yn.create, bn.create, xn.create, Sn.create, wn.create;
var Bn = Tn.create;
En.create, Dn.create, On.create, kn.create, Dn.createWithPreprocess, Pn.create;
//#endregion
//#region src/components/Modals/articleDraftModalSchema.ts
var Vn = zn({
	id: In().uuid(),
	name: In()
}), Hn = zn({
	id: In(),
	name: In()
}), Un = zn({
	id: Bn(c),
	name: In()
}), Wn = zn({
	conversationId: Ln(),
	collection: Rn(Vn).min(1),
	language: Rn(Un).min(1),
	category: Rn(Hn)
}), Gn = (e = !1) => e ? Wn.extend({ category: Rn(Hn).min(1) }) : Wn;
//#endregion
//#region src/components/Modals/components/draftArticleActions.tsx
function Kn({ onDiscard: e, onSave: t, isGenerating: n, isSaving: r, discardVariant: i = "danger" }) {
	return /* @__PURE__ */ ce(D, {
		justifyContent: "flex-end",
		gap: "200",
		children: [/* @__PURE__ */ j(E, {
			variant: i,
			onClick: e,
			disabled: r || n,
			children: "Discard Draft"
		}), /* @__PURE__ */ j(E, {
			variant: "primary",
			onClick: t,
			disabled: n,
			isLoading: r,
			loadingIndicator: /* @__PURE__ */ j(se.Paragraph, {
				color: "white",
				variant: "3",
				children: "Creating..."
			}),
			children: "Save Draft"
		})]
	});
}
//#endregion
//#region src/components/Modals/components/draftArticleFooter.tsx
function qn({ className: e, ...t }) {
	return /* @__PURE__ */ j(ie, {
		className: e,
		children: /* @__PURE__ */ j(Kn, { ...t })
	});
}
//#endregion
//#region ../../../node_modules/@udecode/plate-core/node_modules/jotai-x/dist/index.mjs
var Jn = Object.defineProperty, Yn = Object.defineProperties, Xn = Object.getOwnPropertyDescriptors, Zn = Object.getOwnPropertySymbols, Qn = Object.prototype.hasOwnProperty, $n = Object.prototype.propertyIsEnumerable, er = (e, t, n) => t in e ? Jn(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, tr = (e, t) => {
	for (var n in t ||= {}) Qn.call(t, n) && er(e, n, t[n]);
	if (Zn) for (var n of Zn(t)) $n.call(t, n) && er(e, n, t[n]);
	return e;
}, nr = (e, t) => Yn(e, Xn(t)), rr = (e, t) => {
	var n = {};
	for (var r in e) Qn.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && Zn) for (var r of Zn(e)) t.indexOf(r) < 0 && $n.call(e, r) && (n[r] = e[r]);
	return n;
}, ir = (e) => typeof e == "function" ? { __fn: e } : e, ar = (e) => e && typeof e == "object" && "__fn" in e ? e.__fn : e, or = (e) => {
	let t = je(ir(e));
	return je((e) => ar(e(t)), (e, n, r) => n(t, ir(r)));
}, sr = (e, t, n = {}) => {
	let r = [];
	for (let n of Object.keys(e)) {
		let i = t[n];
		i !== void 0 && r.push([e[n], i]);
	}
	ze(r, n);
}, cr = (e, t, { store: n } = {}) => {
	for (let r of Object.keys(e)) {
		let i = t[r], a = e[r], o = Ie(a, { store: n });
		N.useEffect(() => {
			i != null && o(i);
		}, [o, i]);
	}
}, lr = (e, t) => `${e}:${t}`, ur = "provider", dr = N.createContext(/* @__PURE__ */ new Map()), fr = (e, t = ur, n = !0) => {
	let r = N.useContext(dr), i = r.get(lr(e, t)) ?? r.get(lr(e, ur));
	return !i && n && console.warn(`Tried to access jotai store '${e}' outside of a matching provider.`), i;
}, pr = (e) => {
	var t = e, { initialValues: n, children: r, store: i, atoms: a } = t, o = rr(t, [
		"initialValues",
		"children",
		"store",
		"atoms"
	]);
	return sr(a, tr(tr({}, n), o), { store: i }), cr(a, o, { store: i }), /* @__PURE__ */ N.createElement(N.Fragment, null, r);
}, mr = (e, t, n = {}) => {
	let r = n.effect;
	return (n) => {
		var i = n, { store: a, scope: o, children: s, resetKey: c } = i, l = rr(i, [
			"store",
			"scope",
			"children",
			"resetKey"
		]);
		let [u, d] = N.useState(Re());
		N.useEffect(() => {
			c && d(Re());
		}, [c]);
		let f = N.useContext(dr), p = N.useMemo(() => {
			let t = new Map(f);
			return o && t.set(lr(e, o), u), t.set(lr(e, ur), u), t;
		}, [
			f,
			o,
			u
		]);
		return /* @__PURE__ */ N.createElement(dr.Provider, { value: p }, /* @__PURE__ */ N.createElement(pr, tr({
			store: u,
			atoms: t
		}, l), !!r && /* @__PURE__ */ N.createElement(r, null), s));
	};
}, hr = (e = "") => e.length > 0 ? e[0].toUpperCase() + e.slice(1) : "", gr = (e = "") => `${hr(e)}Provider`, _r = (e = "") => e.length > 0 ? `${e}Store` : "store", vr = (e = "") => `use${hr(e)}Store`, yr = (e) => !!e && typeof e == "object" && "read" in e && typeof e.read == "function", br = (e, t) => Object.fromEntries(Object.entries(e).map(([e, n]) => [e, (e = {}) => n(tr(tr({}, t), e))])), xr = (e = {}) => typeof e == "string" ? { scope: e } : e, Sr = (e, { name: t, delay: n, effect: r, extend: i }) => {
	let a = gr(t), o = vr(t), s = _r(t), c = {}, l = {}, u = {};
	for (let [t, n] of Object.entries(e)) {
		let e = yr(n) ? n : or(n);
		c[t] = e;
		let r = "write" in e;
		u[t] = r, r && (l[t] = e);
	}
	let d = tr({}, c);
	if (i) {
		let e = i(c);
		for (let [t, n] of Object.entries(e)) d[t] = n, u[t] = "write" in n;
	}
	let f = {}, p = {}, m = {}, h = (e = {}) => {
		let { scope: n, store: r, warnIfNoStore: i = !0 } = xr(e), a = fr(t, n, !r && i);
		return r ?? a;
	}, g = (e, t) => {
		let r = xr(t);
		return Fe(e, {
			store: h(tr({ warnIfNoStore: !1 }, r)),
			delay: r.delay ?? n
		});
	}, _ = (e, t) => Ie(e, { store: h(t) }), v = (e, t) => {
		let r = h(t), { delay: i = n } = xr(t);
		return Pe(e, {
			store: r,
			delay: i
		});
	};
	for (let e of Object.keys(d)) {
		let t = d[e], n = u[e];
		f[e] = (e = {}) => g(t, e), n && (p[e] = (e = {}) => _(t, e), m[e] = (e = {}) => v(t, e));
	}
	let y = mr(t, l, { effect: r }), b = {
		atom: d,
		name: t
	}, x = (e = {}) => ({
		get: nr(tr({}, br(f, xr(e))), { atom: (t, n) => g(t, tr(tr({}, xr(e)), xr(n))) }),
		set: nr(tr({}, br(p, xr(e))), { atom: (t, n) => _(t, tr(tr({}, xr(e)), xr(n))) }),
		use: nr(tr({}, br(m, xr(e))), { atom: (t, n) => v(t, tr(tr({}, xr(e)), xr(n))) }),
		store: (t) => h(tr(tr({}, xr(e)), xr(t)))
	});
	return {
		[a]: y,
		[o]: x,
		[s]: b,
		name: t
	};
}, Cr = Symbol.for("immer-nothing"), wr = Symbol.for("immer-draftable"), Tr = Symbol.for("immer-state"), Er = process.env.NODE_ENV === "production" ? [] : [
	function(e) {
		return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
	},
	function(e) {
		return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
	},
	"This object has been frozen and should not be mutated",
	function(e) {
		return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
	},
	"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
	"Immer forbids circular references",
	"The first or second argument to `produce` must be a function",
	"The third argument to `produce` must be a function or undefined",
	"First argument to `createDraft` must be a plain object, an array, or an immerable object",
	"First argument to `finishDraft` must be a draft returned by `createDraft`",
	function(e) {
		return `'current' expects a draft, got: ${e}`;
	},
	"Object.defineProperty() cannot be used on an Immer draft",
	"Object.setPrototypeOf() cannot be used on an Immer draft",
	"Immer only supports deleting array indices",
	"Immer only supports setting array indices and the 'length' property",
	function(e) {
		return `'original' expects a draft, got: ${e}`;
	}
];
function Dr(e, ...t) {
	if (process.env.NODE_ENV !== "production") {
		let n = Er[e], r = typeof n == "function" ? n.apply(null, t) : n;
		throw Error(`[Immer] ${r}`);
	}
	throw Error(`[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`);
}
var Or = Object.getPrototypeOf;
function kr(e) {
	return !!e && !!e[Tr];
}
function Ar(e) {
	return e ? Nr(e) || Array.isArray(e) || !!e[wr] || !!e.constructor?.[wr] || zr(e) || Br(e) : !1;
}
var jr = Object.prototype.constructor.toString(), Mr = /* @__PURE__ */ new WeakMap();
function Nr(e) {
	if (!e || typeof e != "object") return !1;
	let t = Object.getPrototypeOf(e);
	if (t === null || t === Object.prototype) return !0;
	let n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
	if (n === Object) return !0;
	if (typeof n != "function") return !1;
	let r = Mr.get(n);
	return r === void 0 && (r = Function.toString.call(n), Mr.set(n, r)), r === jr;
}
function Pr(e, t, n = !0) {
	Fr(e) === 0 ? (n ? Reflect.ownKeys(e) : Object.keys(e)).forEach((n) => {
		t(n, e[n], e);
	}) : e.forEach((n, r) => t(r, n, e));
}
function Fr(e) {
	let t = e[Tr];
	return t ? t.type_ : Array.isArray(e) ? 1 : zr(e) ? 2 : Br(e) ? 3 : 0;
}
function Ir(e, t) {
	return Fr(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Lr(e, t, n) {
	let r = Fr(e);
	r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function Rr(e, t) {
	return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
}
function zr(e) {
	return e instanceof Map;
}
function Br(e) {
	return e instanceof Set;
}
function Vr(e) {
	return e.copy_ || e.base_;
}
function Hr(e, t) {
	if (zr(e)) return new Map(e);
	if (Br(e)) return new Set(e);
	if (Array.isArray(e)) return Array.prototype.slice.call(e);
	let n = Nr(e);
	if (t === !0 || t === "class_only" && !n) {
		let t = Object.getOwnPropertyDescriptors(e);
		delete t[Tr];
		let n = Reflect.ownKeys(t);
		for (let r = 0; r < n.length; r++) {
			let i = n[r], a = t[i];
			a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (t[i] = {
				configurable: !0,
				writable: !0,
				enumerable: a.enumerable,
				value: e[i]
			});
		}
		return Object.create(Or(e), t);
	} else {
		let t = Or(e);
		if (t !== null && n) return { ...e };
		let r = Object.create(t);
		return Object.assign(r, e);
	}
}
function Ur(e, t = !1) {
	return Kr(e) || kr(e) || !Ar(e) ? e : (Fr(e) > 1 && Object.defineProperties(e, {
		set: Gr,
		add: Gr,
		clear: Gr,
		delete: Gr
	}), Object.freeze(e), t && Object.values(e).forEach((e) => Ur(e, !0)), e);
}
function Wr() {
	Dr(2);
}
var Gr = { value: Wr };
function Kr(e) {
	return typeof e != "object" || !e || Object.isFrozen(e);
}
var qr = {};
function Jr(e) {
	let t = qr[e];
	return t || Dr(0, e), t;
}
function Yr(e, t) {
	qr[e] || (qr[e] = t);
}
var Xr;
function Zr() {
	return Xr;
}
function Qr(e, t) {
	return {
		drafts_: [],
		parent_: e,
		immer_: t,
		canAutoFreeze_: !0,
		unfinalizedDrafts_: 0
	};
}
function $r(e, t) {
	t && (Jr("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function ei(e) {
	ti(e), e.drafts_.forEach(ri), e.drafts_ = null;
}
function ti(e) {
	e === Xr && (Xr = e.parent_);
}
function ni(e) {
	return Xr = Qr(Xr, e);
}
function ri(e) {
	let t = e[Tr];
	t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function ii(e, t) {
	t.unfinalizedDrafts_ = t.drafts_.length;
	let n = t.drafts_[0];
	return e !== void 0 && e !== n ? (n[Tr].modified_ && (ei(t), Dr(4)), Ar(e) && (e = ai(t, e), t.parent_ || si(t, e)), t.patches_ && Jr("Patches").generateReplacementPatches_(n[Tr].base_, e, t.patches_, t.inversePatches_)) : e = ai(t, n, []), ei(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e === Cr ? void 0 : e;
}
function ai(e, t, n) {
	if (Kr(t)) return t;
	let r = e.immer_.shouldUseStrictIteration(), i = t[Tr];
	if (!i) return Pr(t, (r, a) => oi(e, i, t, r, a, n), r), t;
	if (i.scope_ !== e) return t;
	if (!i.modified_) return si(e, i.base_, !0), i.base_;
	if (!i.finalized_) {
		i.finalized_ = !0, i.scope_.unfinalizedDrafts_--;
		let t = i.copy_, a = t, o = !1;
		i.type_ === 3 && (a = new Set(t), t.clear(), o = !0), Pr(a, (r, a) => oi(e, i, t, r, a, n, o), r), si(e, t, !1), n && e.patches_ && Jr("Patches").generatePatches_(i, n, e.patches_, e.inversePatches_);
	}
	return i.copy_;
}
function oi(e, t, n, r, i, a, o) {
	if (i == null || typeof i != "object" && !o) return;
	let s = Kr(i);
	if (!(s && !o)) {
		if (process.env.NODE_ENV !== "production" && i === n && Dr(5), kr(i)) {
			let o = ai(e, i, a && t && t.type_ !== 3 && !Ir(t.assigned_, r) ? a.concat(r) : void 0);
			if (Lr(n, r, o), kr(o)) e.canAutoFreeze_ = !1;
			else return;
		} else o && n.add(i);
		if (Ar(i) && !s) {
			if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1 || t && t.base_ && t.base_[r] === i && s) return;
			ai(e, i), (!t || !t.scope_.parent_) && typeof r != "symbol" && (zr(n) ? n.has(r) : Object.prototype.propertyIsEnumerable.call(n, r)) && si(e, i);
		}
	}
}
function si(e, t, n = !1) {
	!e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Ur(t, n);
}
function ci(e, t) {
	let n = Array.isArray(e), r = {
		type_: +!!n,
		scope_: t ? t.scope_ : Zr(),
		modified_: !1,
		finalized_: !1,
		assigned_: {},
		parent_: t,
		base_: e,
		draft_: null,
		copy_: null,
		revoke_: null,
		isManual_: !1
	}, i = r, a = li;
	n && (i = [r], a = ui);
	let { revoke: o, proxy: s } = Proxy.revocable(i, a);
	return r.draft_ = s, r.revoke_ = o, s;
}
var li = {
	get(e, t) {
		if (t === Tr) return e;
		let n = Vr(e);
		if (!Ir(n, t)) return fi(e, n, t);
		let r = n[t];
		return e.finalized_ || !Ar(r) ? r : r === di(e.base_, t) ? (hi(e), e.copy_[t] = _i(r, e)) : r;
	},
	has(e, t) {
		return t in Vr(e);
	},
	ownKeys(e) {
		return Reflect.ownKeys(Vr(e));
	},
	set(e, t, n) {
		let r = pi(Vr(e), t);
		if (r?.set) return r.set.call(e.draft_, n), !0;
		if (!e.modified_) {
			let r = di(Vr(e), t), i = r?.[Tr];
			if (i && i.base_ === n) return e.copy_[t] = n, e.assigned_[t] = !1, !0;
			if (Rr(n, r) && (n !== void 0 || Ir(e.base_, t))) return !0;
			hi(e), mi(e);
		}
		return e.copy_[t] === n && (n !== void 0 || t in e.copy_) || Number.isNaN(n) && Number.isNaN(e.copy_[t]) ? !0 : (e.copy_[t] = n, e.assigned_[t] = !0, !0);
	},
	deleteProperty(e, t) {
		return di(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, hi(e), mi(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
	},
	getOwnPropertyDescriptor(e, t) {
		let n = Vr(e), r = Reflect.getOwnPropertyDescriptor(n, t);
		return r && {
			writable: !0,
			configurable: e.type_ !== 1 || t !== "length",
			enumerable: r.enumerable,
			value: n[t]
		};
	},
	defineProperty() {
		Dr(11);
	},
	getPrototypeOf(e) {
		return Or(e.base_);
	},
	setPrototypeOf() {
		Dr(12);
	}
}, ui = {};
Pr(li, (e, t) => {
	ui[e] = function() {
		return arguments[0] = arguments[0][0], t.apply(this, arguments);
	};
}), ui.deleteProperty = function(e, t) {
	return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Dr(13), ui.set.call(this, e, t, void 0);
}, ui.set = function(e, t, n) {
	return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Dr(14), li.set.call(this, e[0], t, n, e[0]);
};
function di(e, t) {
	let n = e[Tr];
	return (n ? Vr(n) : e)[t];
}
function fi(e, t, n) {
	let r = pi(t, n);
	return r ? "value" in r ? r.value : r.get?.call(e.draft_) : void 0;
}
function pi(e, t) {
	if (!(t in e)) return;
	let n = Or(e);
	for (; n;) {
		let e = Object.getOwnPropertyDescriptor(n, t);
		if (e) return e;
		n = Or(n);
	}
}
function mi(e) {
	e.modified_ || (e.modified_ = !0, e.parent_ && mi(e.parent_));
}
function hi(e) {
	e.copy_ ||= Hr(e.base_, e.scope_.immer_.useStrictShallowCopy_);
}
var gi = class {
	constructor(e) {
		this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.useStrictIteration_ = !0, this.produce = (e, t, n) => {
			if (typeof e == "function" && typeof t != "function") {
				let n = t;
				t = e;
				let r = this;
				return function(e = n, ...i) {
					return r.produce(e, (e) => t.call(this, e, ...i));
				};
			}
			typeof t != "function" && Dr(6), n !== void 0 && typeof n != "function" && Dr(7);
			let r;
			if (Ar(e)) {
				let i = ni(this), a = _i(e, void 0), o = !0;
				try {
					r = t(a), o = !1;
				} finally {
					o ? ei(i) : ti(i);
				}
				return $r(i, n), ii(r, i);
			} else if (!e || typeof e != "object") {
				if (r = t(e), r === void 0 && (r = e), r === Cr && (r = void 0), this.autoFreeze_ && Ur(r, !0), n) {
					let t = [], i = [];
					Jr("Patches").generateReplacementPatches_(e, r, t, i), n(t, i);
				}
				return r;
			} else Dr(1, e);
		}, this.produceWithPatches = (e, t) => {
			if (typeof e == "function") return (t, ...n) => this.produceWithPatches(t, (t) => e(t, ...n));
			let n, r;
			return [
				this.produce(e, t, (e, t) => {
					n = e, r = t;
				}),
				n,
				r
			];
		}, typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof e?.useStrictShallowCopy == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy), typeof e?.useStrictIteration == "boolean" && this.setUseStrictIteration(e.useStrictIteration);
	}
	createDraft(e) {
		Ar(e) || Dr(8), kr(e) && (e = vi(e));
		let t = ni(this), n = _i(e, void 0);
		return n[Tr].isManual_ = !0, ti(t), n;
	}
	finishDraft(e, t) {
		let n = e && e[Tr];
		(!n || !n.isManual_) && Dr(9);
		let { scope_: r } = n;
		return $r(r, t), ii(void 0, r);
	}
	setAutoFreeze(e) {
		this.autoFreeze_ = e;
	}
	setUseStrictShallowCopy(e) {
		this.useStrictShallowCopy_ = e;
	}
	setUseStrictIteration(e) {
		this.useStrictIteration_ = e;
	}
	shouldUseStrictIteration() {
		return this.useStrictIteration_;
	}
	applyPatches(e, t) {
		let n;
		for (n = t.length - 1; n >= 0; n--) {
			let r = t[n];
			if (r.path.length === 0 && r.op === "replace") {
				e = r.value;
				break;
			}
		}
		n > -1 && (t = t.slice(n + 1));
		let r = Jr("Patches").applyPatches_;
		return kr(e) ? r(e, t) : this.produce(e, (e) => r(e, t));
	}
};
function _i(e, t) {
	let n = zr(e) ? Jr("MapSet").proxyMap_(e, t) : Br(e) ? Jr("MapSet").proxySet_(e, t) : ci(e, t);
	return (t ? t.scope_ : Zr()).drafts_.push(n), n;
}
function vi(e) {
	return kr(e) || Dr(10, e), yi(e);
}
function yi(e) {
	if (!Ar(e) || Kr(e)) return e;
	let t = e[Tr], n, r = !0;
	if (t) {
		if (!t.modified_) return t.base_;
		t.finalized_ = !0, n = Hr(e, t.scope_.immer_.useStrictShallowCopy_), r = t.scope_.immer_.shouldUseStrictIteration();
	} else n = Hr(e, !0);
	return Pr(n, (e, t) => {
		Lr(n, e, yi(t));
	}, r), t && (t.finalized_ = !1), n;
}
function bi() {
	class e extends Map {
		constructor(e, t) {
			super(), this[Tr] = {
				type_: 2,
				parent_: t,
				scope_: t ? t.scope_ : Zr(),
				modified_: !1,
				finalized_: !1,
				copy_: void 0,
				assigned_: void 0,
				base_: e,
				draft_: this,
				isManual_: !1,
				revoked_: !1
			};
		}
		get size() {
			return Vr(this[Tr]).size;
		}
		has(e) {
			return Vr(this[Tr]).has(e);
		}
		set(e, t) {
			let r = this[Tr];
			return o(r), (!Vr(r).has(e) || Vr(r).get(e) !== t) && (n(r), mi(r), r.assigned_.set(e, !0), r.copy_.set(e, t), r.assigned_.set(e, !0)), this;
		}
		delete(e) {
			if (!this.has(e)) return !1;
			let t = this[Tr];
			return o(t), n(t), mi(t), t.base_.has(e) ? t.assigned_.set(e, !1) : t.assigned_.delete(e), t.copy_.delete(e), !0;
		}
		clear() {
			let e = this[Tr];
			o(e), Vr(e).size && (n(e), mi(e), e.assigned_ = /* @__PURE__ */ new Map(), Pr(e.base_, (t) => {
				e.assigned_.set(t, !1);
			}), e.copy_.clear());
		}
		forEach(e, t) {
			let n = this[Tr];
			Vr(n).forEach((n, r, i) => {
				e.call(t, this.get(r), r, this);
			});
		}
		get(e) {
			let t = this[Tr];
			o(t);
			let r = Vr(t).get(e);
			if (t.finalized_ || !Ar(r) || r !== t.base_.get(e)) return r;
			let i = _i(r, t);
			return n(t), t.copy_.set(e, i), i;
		}
		keys() {
			return Vr(this[Tr]).keys();
		}
		values() {
			let e = this.keys();
			return {
				[Symbol.iterator]: () => this.values(),
				next: () => {
					let t = e.next();
					return t.done ? t : {
						done: !1,
						value: this.get(t.value)
					};
				}
			};
		}
		entries() {
			let e = this.keys();
			return {
				[Symbol.iterator]: () => this.entries(),
				next: () => {
					let t = e.next();
					if (t.done) return t;
					let n = this.get(t.value);
					return {
						done: !1,
						value: [t.value, n]
					};
				}
			};
		}
		[Symbol.iterator]() {
			return this.entries();
		}
	}
	function t(t, n) {
		return new e(t, n);
	}
	function n(e) {
		e.copy_ ||= (e.assigned_ = /* @__PURE__ */ new Map(), new Map(e.base_));
	}
	class r extends Set {
		constructor(e, t) {
			super(), this[Tr] = {
				type_: 3,
				parent_: t,
				scope_: t ? t.scope_ : Zr(),
				modified_: !1,
				finalized_: !1,
				copy_: void 0,
				base_: e,
				draft_: this,
				drafts_: /* @__PURE__ */ new Map(),
				revoked_: !1,
				isManual_: !1
			};
		}
		get size() {
			return Vr(this[Tr]).size;
		}
		has(e) {
			let t = this[Tr];
			return o(t), t.copy_ ? !!(t.copy_.has(e) || t.drafts_.has(e) && t.copy_.has(t.drafts_.get(e))) : t.base_.has(e);
		}
		add(e) {
			let t = this[Tr];
			return o(t), this.has(e) || (a(t), mi(t), t.copy_.add(e)), this;
		}
		delete(e) {
			if (!this.has(e)) return !1;
			let t = this[Tr];
			return o(t), a(t), mi(t), t.copy_.delete(e) || (t.drafts_.has(e) ? t.copy_.delete(t.drafts_.get(e)) : 
			/* istanbul ignore next */
!1);
		}
		clear() {
			let e = this[Tr];
			o(e), Vr(e).size && (a(e), mi(e), e.copy_.clear());
		}
		values() {
			let e = this[Tr];
			return o(e), a(e), e.copy_.values();
		}
		entries() {
			let e = this[Tr];
			return o(e), a(e), e.copy_.entries();
		}
		keys() {
			return this.values();
		}
		[Symbol.iterator]() {
			return this.values();
		}
		forEach(e, t) {
			let n = this.values(), r = n.next();
			for (; !r.done;) e.call(t, r.value, r.value, this), r = n.next();
		}
	}
	function i(e, t) {
		return new r(e, t);
	}
	function a(e) {
		e.copy_ || (e.copy_ = /* @__PURE__ */ new Set(), e.base_.forEach((t) => {
			if (Ar(t)) {
				let n = _i(t, e);
				e.drafts_.set(t, n), e.copy_.add(n);
			} else e.copy_.add(t);
		}));
	}
	function o(e) {
		e.revoked_ && Dr(3, JSON.stringify(Vr(e)));
	}
	Yr("MapSet", {
		proxyMap_: t,
		proxySet_: i
	});
}
var xi = new gi(), Si = xi.produce, Ci = /* @__PURE__ */ xi.setAutoFreeze.bind(xi), wi = (e, t) => {
	let n = xe();
	_e(() => {
		n.current = p(e, t);
	}), ge(e);
}, Ti = (e) => () => {
	let [, t] = be((e) => e + 1, 0), n = /* @__PURE__ */ new WeakMap(), r = xe(), a = xe(), o = xe();
	_e(() => {
		r.current = n, a.current !== o.current && i(a.current, o.current, n, /* @__PURE__ */ new WeakMap()) && (a.current = o.current, t());
	});
	let s = e(me((e) => (o.current = e, a.current && a.current !== e && r.current && !i(a.current, e, r.current, /* @__PURE__ */ new WeakMap()) ? a.current : (a.current = e, e)), []));
	return typeof process == "object" && process.env.NODE_ENV !== "production" && wi(s, n), m(s, n, ye(() => /* @__PURE__ */ new WeakMap(), []));
}, Ei = /* @__PURE__ */ new Map(), Di = (e) => {
	let t = Ei.get(e);
	return t ? Object.fromEntries(Object.entries(t.stores).map(([e, t]) => [e, t.getState()])) : {};
}, Oi = (e, t, n) => {
	if (e === void 0) return {
		type: "untracked",
		connection: t.connect(n)
	};
	let r = Ei.get(n.name);
	if (r) return {
		type: "tracked",
		store: e,
		...r
	};
	let i = {
		connection: t.connect(n),
		stores: {}
	};
	return Ei.set(n.name, i), {
		type: "tracked",
		store: e,
		...i
	};
}, ki = (e, t = {}) => (n, r, i) => {
	let { enabled: a, anonymousActionType: o, store: s, ...c } = t, l;
	try {
		l = (a ?? !1) && window.__REDUX_DEVTOOLS_EXTENSION__;
	} catch {}
	if (!l) return e(n, r, i);
	let { connection: u, ...d } = Oi(s, l, c), f = !0;
	i.setState = (e, t, a) => {
		let l = n(e, t);
		if (!f) return l;
		let d = a === void 0 ? { type: o || "anonymous" } : typeof a == "string" ? { type: a } : a;
		return s === void 0 ? (u?.send(d, r()), l) : (u?.send({
			...d,
			type: `${s}/${d.type}`
		}, {
			...Di(c.name),
			[s]: i.getState()
		}), l);
	};
	let p = (...e) => {
		let t = f;
		f = !1, n(...e), f = t;
	}, m = e(i.setState, r, i);
	if (d.type === "untracked" ? u?.init(m) : (d.stores[d.store] = i, u?.init(Object.fromEntries(Object.entries(d.stores).map(([e, t]) => [e, e === d.store ? m : t.getState()])))), i.dispatchFromDevtools && typeof i.dispatch == "function") {
		let e = i.dispatch;
		i.dispatch = (...t) => {
			e(...t);
		};
	}
	return u.subscribe((e) => {
		switch (e.type) {
			case "ACTION":
				if (typeof e.payload != "string") {
					console.error("[zustand devtools middleware] Unsupported action format");
					return;
				}
				return Ai(e.payload, (e) => {
					if (e.type === "__setState") {
						if (s === void 0) {
							p(e.state);
							return;
						}
						Object.keys(e.state).length !== 1 && console.error("\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { \"type\": \"__setState\", \"state\": { \"abc123Store\": { \"foo\": \"bar\" } } }\n                    ");
						let t = e.state[s];
						if (t == null) return;
						JSON.stringify(i.getState()) !== JSON.stringify(t) && p(t);
						return;
					}
					i.dispatchFromDevtools && typeof i.dispatch == "function" && i.dispatch(e);
				});
			case "DISPATCH":
				switch (e.payload.type) {
					case "RESET": return p(m), s === void 0 ? u?.init(i.getState()) : u?.init(Di(c.name));
					case "COMMIT":
						if (s === void 0) {
							u?.init(i.getState());
							return;
						}
						return u?.init(Di(c.name));
					case "ROLLBACK": return Ai(e.state, (e) => {
						if (s === void 0) {
							p(e), u?.init(i.getState());
							return;
						}
						p(e[s]), u?.init(Di(c.name));
					});
					case "JUMP_TO_STATE":
					case "JUMP_TO_ACTION": return Ai(e.state, (e) => {
						if (s === void 0) {
							p(e);
							return;
						}
						JSON.stringify(i.getState()) !== JSON.stringify(e[s]) && p(e[s]);
					});
					case "IMPORT_STATE": {
						let { nextLiftedState: t } = e.payload, n = t.computedStates.slice(-1)[0]?.state;
						if (!n) return;
						p(s === void 0 ? n : n[s]), u?.send(null, t);
						return;
					}
					case "PAUSE_RECORDING": return f = !f;
				}
				return;
		}
	}), m;
}, Ai = (e, t) => {
	let n;
	try {
		n = JSON.parse(e);
	} catch (e) {
		console.error("[zustand devtools middleware] Could not parse the received json", e);
	}
	n !== void 0 && t(n);
};
function ji(e, t) {
	let n;
	try {
		n = e();
	} catch {
		return;
	}
	return {
		getItem: (e) => {
			let r = (e) => e === null ? null : JSON.parse(e, t?.reviver), i = n.getItem(e) ?? null;
			return i instanceof Promise ? i.then(r) : r(i);
		},
		setItem: (e, r) => n.setItem(e, JSON.stringify(r, t?.replacer)),
		removeItem: (e) => n.removeItem(e)
	};
}
var Mi = (e) => (t) => {
	try {
		let n = e(t);
		return n instanceof Promise ? n : {
			then(e) {
				return Mi(e)(n);
			},
			catch(e) {
				return this;
			}
		};
	} catch (e) {
		return {
			then(e) {
				return this;
			},
			catch(t) {
				return Mi(t)(e);
			}
		};
	}
}, Ni = (e, t) => (n, r, i) => {
	let a = {
		getStorage: () => localStorage,
		serialize: JSON.stringify,
		deserialize: JSON.parse,
		partialize: (e) => e,
		version: 0,
		merge: (e, t) => ({
			...t,
			...e
		}),
		...t
	}, o = !1, s = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), l;
	try {
		l = a.getStorage();
	} catch {}
	if (!l) return e((...e) => {
		console.warn(`[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`), n(...e);
	}, r, i);
	let u = Mi(a.serialize), d = () => {
		let e = a.partialize({ ...r() }), t, n = u({
			state: e,
			version: a.version
		}).then((e) => l.setItem(a.name, e)).catch((e) => {
			t = e;
		});
		if (t) throw t;
		return n;
	}, f = i.setState;
	i.setState = (e, t) => {
		f(e, t), d();
	};
	let p = e((...e) => {
		n(...e), d();
	}, r, i), m, h = () => {
		if (!l) return;
		o = !1, s.forEach((e) => e(r()));
		let e = a.onRehydrateStorage?.call(a, r()) || void 0;
		return Mi(l.getItem.bind(l))(a.name).then((e) => {
			if (e) return a.deserialize(e);
		}).then((e) => {
			if (e) if (typeof e.version == "number" && e.version !== a.version) {
				if (a.migrate) return a.migrate(e.state, e.version);
				console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
			} else return e.state;
		}).then((e) => (m = a.merge(e, r() ?? p), n(m, !0), d())).then(() => {
			e?.(m, void 0), o = !0, c.forEach((e) => e(m));
		}).catch((t) => {
			e?.(void 0, t);
		});
	};
	return i.persist = {
		setOptions: (e) => {
			a = {
				...a,
				...e
			}, e.getStorage && (l = e.getStorage());
		},
		clearStorage: () => {
			l?.removeItem(a.name);
		},
		getOptions: () => a,
		rehydrate: () => h(),
		hasHydrated: () => o,
		onHydrate: (e) => (s.add(e), () => {
			s.delete(e);
		}),
		onFinishHydration: (e) => (c.add(e), () => {
			c.delete(e);
		})
	}, h(), m || p;
}, Pi = (e, t) => (n, r, i) => {
	let a = {
		storage: ji(() => localStorage),
		partialize: (e) => e,
		version: 0,
		merge: (e, t) => ({
			...t,
			...e
		}),
		...t
	}, o = !1, s = /* @__PURE__ */ new Set(), c = /* @__PURE__ */ new Set(), l = a.storage;
	if (!l) return e((...e) => {
		console.warn(`[zustand persist middleware] Unable to update item '${a.name}', the given storage is currently unavailable.`), n(...e);
	}, r, i);
	let u = () => {
		let e = a.partialize({ ...r() });
		return l.setItem(a.name, {
			state: e,
			version: a.version
		});
	}, d = i.setState;
	i.setState = (e, t) => {
		d(e, t), u();
	};
	let f = e((...e) => {
		n(...e), u();
	}, r, i);
	i.getInitialState = () => f;
	let p, m = () => {
		if (!l) return;
		o = !1, s.forEach((e) => e(r() ?? f));
		let e = a.onRehydrateStorage?.call(a, r() ?? f) || void 0;
		return Mi(l.getItem.bind(l))(a.name).then((e) => {
			if (e) if (typeof e.version == "number" && e.version !== a.version) {
				if (a.migrate) return [!0, a.migrate(e.state, e.version)];
				console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
			} else return [!1, e.state];
			return [!1, void 0];
		}).then((e) => {
			let [t, i] = e;
			if (p = a.merge(i, r() ?? f), n(p, !0), t) return u();
		}).then(() => {
			e?.(p, void 0), p = r(), o = !0, c.forEach((e) => e(p));
		}).catch((t) => {
			e?.(void 0, t);
		});
	};
	return i.persist = {
		setOptions: (e) => {
			a = {
				...a,
				...e
			}, e.storage && (l = e.storage);
		},
		clearStorage: () => {
			l?.removeItem(a.name);
		},
		getOptions: () => a,
		rehydrate: () => m(),
		hasHydrated: () => o,
		onHydrate: (e) => (s.add(e), () => {
			s.delete(e);
		}),
		onFinishHydration: (e) => (c.add(e), () => {
			c.delete(e);
		})
	}, a.skipHydration || m(), p || f;
}, Fi = (e, t) => "getStorage" in t || "serialize" in t || "deserialize" in t ? Ni(e, t) : Pi(e, t), Ii = /* @__PURE__ */ t(((e) => {
	var t = o();
	function n(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var r = typeof Object.is == "function" ? Object.is : n, i = t.useState, a = t.useEffect, s = t.useLayoutEffect, c = t.useDebugValue;
	function l(e, t) {
		var n = t(), r = i({ inst: {
			value: n,
			getSnapshot: t
		} }), o = r[0].inst, l = r[1];
		return s(function() {
			o.value = n, o.getSnapshot = t, u(o) && l({ inst: o });
		}, [
			e,
			n,
			t
		]), a(function() {
			return u(o) && l({ inst: o }), e(function() {
				u(o) && l({ inst: o });
			});
		}, [e]), c(n), n;
	}
	function u(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !r(e, n);
		} catch {
			return !0;
		}
	}
	function d(e, t) {
		return t();
	}
	var f = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? d : l;
	e.useSyncExternalStore = t.useSyncExternalStore === void 0 ? f : t.useSyncExternalStore;
})), Li = /* @__PURE__ */ t(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		function n(e, t) {
			f || a.startTransition === void 0 || (f = !0, console.error("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
			var n = t();
			if (!p) {
				var i = t();
				s(n, i) || (console.error("The result of getSnapshot should be cached to avoid an infinite loop"), p = !0);
			}
			i = c({ inst: {
				value: n,
				getSnapshot: t
			} });
			var o = i[0].inst, m = i[1];
			return u(function() {
				o.value = n, o.getSnapshot = t, r(o) && m({ inst: o });
			}, [
				e,
				n,
				t
			]), l(function() {
				return r(o) && m({ inst: o }), e(function() {
					r(o) && m({ inst: o });
				});
			}, [e]), d(n), n;
		}
		function r(e) {
			var t = e.getSnapshot;
			e = e.value;
			try {
				var n = t();
				return !s(e, n);
			} catch {
				return !0;
			}
		}
		function i(e, t) {
			return t();
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var a = o(), s = typeof Object.is == "function" ? Object.is : t, c = a.useState, l = a.useEffect, u = a.useLayoutEffect, d = a.useDebugValue, f = !1, p = !1, m = typeof window > "u" || window.document === void 0 || window.document.createElement === void 0 ? i : n;
		e.useSyncExternalStore = a.useSyncExternalStore === void 0 ? m : a.useSyncExternalStore, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), Ri = /* @__PURE__ */ t(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = Ii() : t.exports = Li();
})), zi = /* @__PURE__ */ t(((e) => {
	var t = o(), n = Ri();
	function r(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var i = typeof Object.is == "function" ? Object.is : r, a = n.useSyncExternalStore, s = t.useRef, c = t.useEffect, l = t.useMemo, u = t.useDebugValue;
	e.useSyncExternalStoreWithSelector = function(e, t, n, r, o) {
		var d = s(null);
		if (d.current === null) {
			var f = {
				hasValue: !1,
				value: null
			};
			d.current = f;
		} else f = d.current;
		d = l(function() {
			function e(e) {
				if (!a) {
					if (a = !0, s = e, e = r(e), o !== void 0 && f.hasValue) {
						var t = f.value;
						if (o(t, e)) return c = t;
					}
					return c = e;
				}
				if (t = c, i(s, e)) return t;
				var n = r(e);
				return o !== void 0 && o(t, n) ? (s = e, t) : (s = e, c = n);
			}
			var a = !1, s, c, l = n === void 0 ? null : n;
			return [function() {
				return e(t());
			}, l === null ? void 0 : function() {
				return e(l());
			}];
		}, [
			t,
			n,
			r,
			o
		]);
		var p = a(e, d[0], d[1]);
		return c(function() {
			f.hasValue = !0, f.value = p;
		}, [p]), u(p), p;
	};
})), Bi = /* @__PURE__ */ t(((e) => {
	process.env.NODE_ENV !== "production" && (function() {
		function t(e, t) {
			return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
		}
		typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
		var n = o(), r = Ri(), i = typeof Object.is == "function" ? Object.is : t, a = r.useSyncExternalStore, s = n.useRef, c = n.useEffect, l = n.useMemo, u = n.useDebugValue;
		e.useSyncExternalStoreWithSelector = function(e, t, n, r, o) {
			var d = s(null);
			if (d.current === null) {
				var f = {
					hasValue: !1,
					value: null
				};
				d.current = f;
			} else f = d.current;
			d = l(function() {
				function e(e) {
					if (!a) {
						if (a = !0, s = e, e = r(e), o !== void 0 && f.hasValue) {
							var t = f.value;
							if (o(t, e)) return c = t;
						}
						return c = e;
					}
					if (t = c, i(s, e)) return t;
					var n = r(e);
					return o !== void 0 && o(t, n) ? (s = e, t) : (s = e, c = n);
				}
				var a = !1, s, c, l = n === void 0 ? null : n;
				return [function() {
					return e(t());
				}, l === null ? void 0 : function() {
					return e(l());
				}];
			}, [
				t,
				n,
				r,
				o
			]);
			var p = a(e, d[0], d[1]);
			return c(function() {
				f.hasValue = !0, f.value = p;
			}, [p]), u(p), p;
		}, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
	})();
})), Vi = /* @__PURE__ */ t(((e, t) => {
	process.env.NODE_ENV === "production" ? t.exports = zi() : t.exports = Bi();
})), Hi = (e) => {
	let t, n = /* @__PURE__ */ new Set(), r = (e, r) => {
		let i = typeof e == "function" ? e(t) : e;
		if (!Object.is(i, t)) {
			let e = t;
			t = r ?? (typeof i != "object" || !i) ? i : Object.assign({}, t, i), n.forEach((n) => n(t, e));
		}
	}, i = () => t, a = {
		setState: r,
		getState: i,
		getInitialState: () => o,
		subscribe: (e) => (n.add(e), () => n.delete(e)),
		destroy: () => {
			n.clear();
		}
	}, o = t = e(r, i, a);
	return a;
}, Ui = (e) => e ? Hi(e) : Hi, Wi = /* @__PURE__ */ r(Vi(), 1), { useDebugValue: Gi } = N, { useSyncExternalStoreWithSelector: Ki } = Wi.default, qi = (e) => e;
function Ji(e, t = qi, n) {
	let r = Ki(e.subscribe, e.getState, e.getServerState || e.getInitialState, t, n);
	return Gi(r), r;
}
(/* @__PURE__ */ t(((e, t) => {
	var n = "__lodash_hash_undefined__", r = 9007199254740991, i = "[object Arguments]", a = "[object Array]", o = "[object Boolean]", s = "[object Date]", c = "[object Error]", l = "[object Function]", u = "[object Map]", d = "[object Number]", f = "[object Object]", p = "[object Promise]", m = "[object RegExp]", h = "[object Set]", g = "[object String]", _ = "[object Symbol]", v = "[object WeakMap]", y = "[object ArrayBuffer]", b = "[object DataView]", x = "[object Float32Array]", S = "[object Float64Array]", C = "[object Int8Array]", w = "[object Int16Array]", T = "[object Int32Array]", E = "[object Uint8Array]", ee = "[object Uint8ClampedArray]", D = "[object Uint16Array]", te = "[object Uint32Array]", ne = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, O = /^\w*$/, re = /^\./, ie = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, k = /[\\^$.*+?()[\]{}|]/g, ae = /\\(\\)?/g, oe = /^\[object .+?Constructor\]$/, se = /^(?:0|[1-9]\d*)$/, A = {};
	A[x] = A[S] = A[C] = A[w] = A[T] = A[E] = A[ee] = A[D] = A[te] = !0, A[i] = A[a] = A[y] = A[o] = A[b] = A[s] = A[c] = A[l] = A[u] = A[d] = A[f] = A[m] = A[h] = A[g] = A[v] = !1;
	var j = typeof global == "object" && global && global.Object === Object && global, ce = typeof self == "object" && self && self.Object === Object && self, M = j || ce || Function("return this")(), N = typeof e == "object" && e && !e.nodeType && e, le = N && typeof t == "object" && t && !t.nodeType && t, ue = le && le.exports === N && j.process, de = function() {
		try {
			return ue && ue.binding("util");
		} catch {}
	}(), fe = de && de.isTypedArray;
	function pe(e, t) {
		for (var n = -1, r = e ? e.length : 0; ++n < r;) if (t(e[n], n, e)) return !0;
		return !1;
	}
	function me(e) {
		return function(t) {
			return t?.[e];
		};
	}
	function he(e, t) {
		for (var n = -1, r = Array(e); ++n < e;) r[n] = t(n);
		return r;
	}
	function ge(e) {
		return function(t) {
			return e(t);
		};
	}
	function _e(e, t) {
		return e?.[t];
	}
	function ve(e) {
		var t = !1;
		if (e != null && typeof e.toString != "function") try {
			t = !!(e + "");
		} catch {}
		return t;
	}
	function ye(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e, r) {
			n[++t] = [r, e];
		}), n;
	}
	function be(e, t) {
		return function(n) {
			return e(t(n));
		};
	}
	function xe(e) {
		var t = -1, n = Array(e.size);
		return e.forEach(function(e) {
			n[++t] = e;
		}), n;
	}
	var Se = Array.prototype, Ce = Function.prototype, we = Object.prototype, Te = M["__core-js_shared__"], Ee = function() {
		var e = /[^.]+$/.exec(Te && Te.keys && Te.keys.IE_PROTO || "");
		return e ? "Symbol(src)_1." + e : "";
	}(), De = Ce.toString, Oe = we.hasOwnProperty, ke = we.toString, Ae = RegExp("^" + De.call(Oe).replace(k, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), je = M.Symbol, Me = M.Uint8Array, Ne = we.propertyIsEnumerable, Pe = Se.splice, Fe = be(Object.keys, Object), Ie = Vt(M, "DataView"), Le = Vt(M, "Map"), Re = Vt(M, "Promise"), ze = Vt(M, "Set"), Be = Vt(M, "WeakMap"), Ve = Vt(Object, "create"), He = $t(Ie), Ue = $t(Le), We = $t(Re), Ge = $t(ze), Ke = $t(Be), qe = je ? je.prototype : void 0, Je = qe ? qe.valueOf : void 0, Ye = qe ? qe.toString : void 0;
	function Xe(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function Ze() {
		this.__data__ = Ve ? Ve(null) : {};
	}
	function Qe(e) {
		return this.has(e) && delete this.__data__[e];
	}
	function $e(e) {
		var t = this.__data__;
		if (Ve) {
			var r = t[e];
			return r === n ? void 0 : r;
		}
		return Oe.call(t, e) ? t[e] : void 0;
	}
	function et(e) {
		var t = this.__data__;
		return Ve ? t[e] !== void 0 : Oe.call(t, e);
	}
	function tt(e, t) {
		var r = this.__data__;
		return r[e] = Ve && t === void 0 ? n : t, this;
	}
	Xe.prototype.clear = Ze, Xe.prototype.delete = Qe, Xe.prototype.get = $e, Xe.prototype.has = et, Xe.prototype.set = tt;
	function nt(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function rt() {
		this.__data__ = [];
	}
	function it(e) {
		var t = this.__data__, n = bt(t, e);
		return n < 0 ? !1 : (n == t.length - 1 ? t.pop() : Pe.call(t, n, 1), !0);
	}
	function at(e) {
		var t = this.__data__, n = bt(t, e);
		return n < 0 ? void 0 : t[n][1];
	}
	function ot(e) {
		return bt(this.__data__, e) > -1;
	}
	function st(e, t) {
		var n = this.__data__, r = bt(n, e);
		return r < 0 ? n.push([e, t]) : n[r][1] = t, this;
	}
	nt.prototype.clear = rt, nt.prototype.delete = it, nt.prototype.get = at, nt.prototype.has = ot, nt.prototype.set = st;
	function ct(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.clear(); ++t < n;) {
			var r = e[t];
			this.set(r[0], r[1]);
		}
	}
	function P() {
		this.__data__ = {
			hash: new Xe(),
			map: new (Le || nt)(),
			string: new Xe()
		};
	}
	function lt(e) {
		return zt(this, e).delete(e);
	}
	function F(e) {
		return zt(this, e).get(e);
	}
	function ut(e) {
		return zt(this, e).has(e);
	}
	function dt(e, t) {
		return zt(this, e).set(e, t), this;
	}
	ct.prototype.clear = P, ct.prototype.delete = lt, ct.prototype.get = F, ct.prototype.has = ut, ct.prototype.set = dt;
	function ft(e) {
		var t = -1, n = e ? e.length : 0;
		for (this.__data__ = new ct(); ++t < n;) this.add(e[t]);
	}
	function pt(e) {
		return this.__data__.set(e, n), this;
	}
	function mt(e) {
		return this.__data__.has(e);
	}
	ft.prototype.add = ft.prototype.push = pt, ft.prototype.has = mt;
	function I(e) {
		this.__data__ = new nt(e);
	}
	function ht() {
		this.__data__ = new nt();
	}
	function L(e) {
		return this.__data__.delete(e);
	}
	function gt(e) {
		return this.__data__.get(e);
	}
	function _t(e) {
		return this.__data__.has(e);
	}
	function vt(e, t) {
		var n = this.__data__;
		if (n instanceof nt) {
			var r = n.__data__;
			if (!Le || r.length < 199) return r.push([e, t]), this;
			n = this.__data__ = new ct(r);
		}
		return n.set(e, t), this;
	}
	I.prototype.clear = ht, I.prototype.delete = L, I.prototype.get = gt, I.prototype.has = _t, I.prototype.set = vt;
	function yt(e, t) {
		var n = rn(e) || nn(e) ? he(e.length, String) : [], r = n.length, i = !!r;
		for (var a in e) (t || Oe.call(e, a)) && !(i && (a == "length" || Wt(a, r))) && n.push(a);
		return n;
	}
	function bt(e, t) {
		for (var n = e.length; n--;) if (tn(e[n][0], t)) return n;
		return -1;
	}
	var xt = Ft();
	function R(e, t) {
		return e && xt(e, t, gn);
	}
	function St(e, t) {
		t = Gt(t, e) ? [t] : Pt(t);
		for (var n = 0, r = t.length; e != null && n < r;) e = e[Qt(t[n++])];
		return n && n == r ? e : void 0;
	}
	function Ct(e) {
		return ke.call(e);
	}
	function z(e, t) {
		return e != null && t in Object(e);
	}
	function B(e, t, n, r, i) {
		return e === t ? !0 : e == null || t == null || !ln(e) && !un(t) ? e !== e && t !== t : wt(e, t, B, n, r, i);
	}
	function wt(e, t, n, r, o, s) {
		var c = rn(e), l = rn(t), u = a, d = a;
		c || (u = Ht(e), u = u == i ? f : u), l || (d = Ht(t), d = d == i ? f : d);
		var p = u == f && !ve(e), m = d == f && !ve(t), h = u == d;
		if (h && !p) return s ||= new I(), c || fn(e) ? It(e, t, n, r, o, s) : Lt(e, t, u, n, r, o, s);
		if (!(o & 2)) {
			var g = p && Oe.call(e, "__wrapped__"), _ = m && Oe.call(t, "__wrapped__");
			if (g || _) {
				var v = g ? e.value() : e, y = _ ? t.value() : t;
				return s ||= new I(), n(v, y, r, o, s);
			}
		}
		return h ? (s ||= new I(), Rt(e, t, n, r, o, s)) : !1;
	}
	function Tt(e, t, n, r) {
		var i = n.length, a = i, o = !r;
		if (e == null) return !a;
		for (e = Object(e); i--;) {
			var s = n[i];
			if (o && s[2] ? s[1] !== e[s[0]] : !(s[0] in e)) return !1;
		}
		for (; ++i < a;) {
			s = n[i];
			var c = s[0], l = e[c], u = s[1];
			if (o && s[2]) {
				if (l === void 0 && !(c in e)) return !1;
			} else {
				var d = new I();
				if (r) var f = r(l, u, c, e, t, d);
				if (!(f === void 0 ? B(u, l, r, 3, d) : f)) return !1;
			}
		}
		return !0;
	}
	function Et(e) {
		return !ln(e) || qt(e) ? !1 : (sn(e) || ve(e) ? Ae : oe).test($t(e));
	}
	function Dt(e) {
		return un(e) && cn(e.length) && !!A[ke.call(e)];
	}
	function Ot(e) {
		return typeof e == "function" ? e : e == null ? vn : typeof e == "object" ? rn(e) ? jt(e[0], e[1]) : At(e) : yn(e);
	}
	function kt(e) {
		if (!Jt(e)) return Fe(e);
		var t = [];
		for (var n in Object(e)) Oe.call(e, n) && n != "constructor" && t.push(n);
		return t;
	}
	function At(e) {
		var t = Bt(e);
		return t.length == 1 && t[0][2] ? Xt(t[0][0], t[0][1]) : function(n) {
			return n === e || Tt(n, e, t);
		};
	}
	function jt(e, t) {
		return Gt(e) && Yt(t) ? Xt(Qt(e), t) : function(n) {
			var r = mn(n, e);
			return r === void 0 && r === t ? hn(n, e) : B(t, r, void 0, 3);
		};
	}
	function Mt(e) {
		return function(t) {
			return St(t, e);
		};
	}
	function Nt(e) {
		if (typeof e == "string") return e;
		if (dn(e)) return Ye ? Ye.call(e) : "";
		var t = e + "";
		return t == "0" && 1 / e == -Infinity ? "-0" : t;
	}
	function Pt(e) {
		return rn(e) ? e : Zt(e);
	}
	function Ft(e) {
		return function(t, n, r) {
			for (var i = -1, a = Object(t), o = r(t), s = o.length; s--;) {
				var c = o[e ? s : ++i];
				if (n(a[c], c, a) === !1) break;
			}
			return t;
		};
	}
	function It(e, t, n, r, i, a) {
		var o = i & 2, s = e.length, c = t.length;
		if (s != c && !(o && c > s)) return !1;
		var l = a.get(e);
		if (l && a.get(t)) return l == t;
		var u = -1, d = !0, f = i & 1 ? new ft() : void 0;
		for (a.set(e, t), a.set(t, e); ++u < s;) {
			var p = e[u], m = t[u];
			if (r) var h = o ? r(m, p, u, t, e, a) : r(p, m, u, e, t, a);
			if (h !== void 0) {
				if (h) continue;
				d = !1;
				break;
			}
			if (f) {
				if (!pe(t, function(e, t) {
					if (!f.has(t) && (p === e || n(p, e, r, i, a))) return f.add(t);
				})) {
					d = !1;
					break;
				}
			} else if (!(p === m || n(p, m, r, i, a))) {
				d = !1;
				break;
			}
		}
		return a.delete(e), a.delete(t), d;
	}
	function Lt(e, t, n, r, i, a, l) {
		switch (n) {
			case b:
				if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
				e = e.buffer, t = t.buffer;
			case y: return !(e.byteLength != t.byteLength || !r(new Me(e), new Me(t)));
			case o:
			case s:
			case d: return tn(+e, +t);
			case c: return e.name == t.name && e.message == t.message;
			case m:
			case g: return e == t + "";
			case u: var f = ye;
			case h:
				var p = a & 2;
				if (f ||= xe, e.size != t.size && !p) return !1;
				var v = l.get(e);
				if (v) return v == t;
				a |= 1, l.set(e, t);
				var x = It(f(e), f(t), r, i, a, l);
				return l.delete(e), x;
			case _: if (Je) return Je.call(e) == Je.call(t);
		}
		return !1;
	}
	function Rt(e, t, n, r, i, a) {
		var o = i & 2, s = gn(e), c = s.length;
		if (c != gn(t).length && !o) return !1;
		for (var l = c; l--;) {
			var u = s[l];
			if (!(o ? u in t : Oe.call(t, u))) return !1;
		}
		var d = a.get(e);
		if (d && a.get(t)) return d == t;
		var f = !0;
		a.set(e, t), a.set(t, e);
		for (var p = o; ++l < c;) {
			u = s[l];
			var m = e[u], h = t[u];
			if (r) var g = o ? r(h, m, u, t, e, a) : r(m, h, u, e, t, a);
			if (!(g === void 0 ? m === h || n(m, h, r, i, a) : g)) {
				f = !1;
				break;
			}
			p ||= u == "constructor";
		}
		if (f && !p) {
			var _ = e.constructor, v = t.constructor;
			_ != v && "constructor" in e && "constructor" in t && !(typeof _ == "function" && _ instanceof _ && typeof v == "function" && v instanceof v) && (f = !1);
		}
		return a.delete(e), a.delete(t), f;
	}
	function zt(e, t) {
		var n = e.__data__;
		return Kt(t) ? n[typeof t == "string" ? "string" : "hash"] : n.map;
	}
	function Bt(e) {
		for (var t = gn(e), n = t.length; n--;) {
			var r = t[n], i = e[r];
			t[n] = [
				r,
				i,
				Yt(i)
			];
		}
		return t;
	}
	function Vt(e, t) {
		var n = _e(e, t);
		return Et(n) ? n : void 0;
	}
	var Ht = Ct;
	(Ie && Ht(new Ie(/* @__PURE__ */ new ArrayBuffer(1))) != b || Le && Ht(new Le()) != u || Re && Ht(Re.resolve()) != p || ze && Ht(new ze()) != h || Be && Ht(new Be()) != v) && (Ht = function(e) {
		var t = ke.call(e), n = t == f ? e.constructor : void 0, r = n ? $t(n) : void 0;
		if (r) switch (r) {
			case He: return b;
			case Ue: return u;
			case We: return p;
			case Ge: return h;
			case Ke: return v;
		}
		return t;
	});
	function Ut(e, t, n) {
		t = Gt(t, e) ? [t] : Pt(t);
		for (var r, i = -1, a = t.length; ++i < a;) {
			var o = Qt(t[i]);
			if (!(r = e != null && n(e, o))) break;
			e = e[o];
		}
		if (r) return r;
		var a = e ? e.length : 0;
		return !!a && cn(a) && Wt(o, a) && (rn(e) || nn(e));
	}
	function Wt(e, t) {
		return t ??= r, !!t && (typeof e == "number" || se.test(e)) && e > -1 && e % 1 == 0 && e < t;
	}
	function Gt(e, t) {
		if (rn(e)) return !1;
		var n = typeof e;
		return n == "number" || n == "symbol" || n == "boolean" || e == null || dn(e) ? !0 : O.test(e) || !ne.test(e) || t != null && e in Object(t);
	}
	function Kt(e) {
		var t = typeof e;
		return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
	}
	function qt(e) {
		return !!Ee && Ee in e;
	}
	function Jt(e) {
		var t = e && e.constructor;
		return e === (typeof t == "function" && t.prototype || we);
	}
	function Yt(e) {
		return e === e && !ln(e);
	}
	function Xt(e, t) {
		return function(n) {
			return n != null && n[e] === t && (t !== void 0 || e in Object(n));
		};
	}
	var Zt = en(function(e) {
		e = pn(e);
		var t = [];
		return re.test(e) && t.push(""), e.replace(ie, function(e, n, r, i) {
			t.push(r ? i.replace(ae, "$1") : n || e);
		}), t;
	});
	function Qt(e) {
		if (typeof e == "string" || dn(e)) return e;
		var t = e + "";
		return t == "0" && 1 / e == -Infinity ? "-0" : t;
	}
	function $t(e) {
		if (e != null) {
			try {
				return De.call(e);
			} catch {}
			try {
				return e + "";
			} catch {}
		}
		return "";
	}
	function en(e, t) {
		if (typeof e != "function" || t && typeof t != "function") throw TypeError("Expected a function");
		var n = function() {
			var r = arguments, i = t ? t.apply(this, r) : r[0], a = n.cache;
			if (a.has(i)) return a.get(i);
			var o = e.apply(this, r);
			return n.cache = a.set(i, o), o;
		};
		return n.cache = new (en.Cache || ct)(), n;
	}
	en.Cache = ct;
	function tn(e, t) {
		return e === t || e !== e && t !== t;
	}
	function nn(e) {
		return on(e) && Oe.call(e, "callee") && (!Ne.call(e, "callee") || ke.call(e) == i);
	}
	var rn = Array.isArray;
	function an(e) {
		return e != null && cn(e.length) && !sn(e);
	}
	function on(e) {
		return un(e) && an(e);
	}
	function sn(e) {
		var t = ln(e) ? ke.call(e) : "";
		return t == l || t == "[object GeneratorFunction]";
	}
	function cn(e) {
		return typeof e == "number" && e > -1 && e % 1 == 0 && e <= r;
	}
	function ln(e) {
		var t = typeof e;
		return !!e && (t == "object" || t == "function");
	}
	function un(e) {
		return !!e && typeof e == "object";
	}
	function dn(e) {
		return typeof e == "symbol" || un(e) && ke.call(e) == _;
	}
	var fn = fe ? ge(fe) : Dt;
	function pn(e) {
		return e == null ? "" : Nt(e);
	}
	function mn(e, t, n) {
		var r = e == null ? void 0 : St(e, t);
		return r === void 0 ? n : r;
	}
	function hn(e, t) {
		return e != null && Ut(e, t, z);
	}
	function gn(e) {
		return an(e) ? yt(e) : kt(e);
	}
	function _n(e, t) {
		var n = {};
		return t = Ot(t, 3), R(e, function(e, r, i) {
			n[r] = t(e, r, i);
		}), n;
	}
	function vn(e) {
		return e;
	}
	function yn(e) {
		return Gt(e) ? me(Qt(e)) : Mt(e);
	}
	t.exports = _n;
})))();
var Yi = Object.defineProperty, Xi = Object.defineProperties, Zi = Object.getOwnPropertyDescriptors, Qi = Object.getOwnPropertySymbols, $i = Object.prototype.hasOwnProperty, ea = Object.prototype.propertyIsEnumerable, ta = (e, t, n) => t in e ? Yi(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, na = (e, t) => {
	for (var n in t ||= {}) $i.call(t, n) && ta(e, n, t[n]);
	if (Qi) for (var n of Qi(t)) ea.call(t, n) && ta(e, n, t[n]);
	return e;
}, ra = (e, t) => Xi(e, Zi(t)), ia = (e) => (t, n, r) => {
	let i = (e, n) => t(Si(e), !0, n);
	return r.setState = i, e(i, n, r);
}, aa = (e, t) => {
	let n = {};
	return Object.keys(e.getState()).forEach((r) => {
		n[r] = (n) => {
			if (e.getState()[r] === n) return;
			let i = r.replace(/^\S/, (e) => e.toUpperCase());
			e.setState((e) => {
				e[r] = n;
			}, `@@${t}/set${i}`);
		};
	}), n;
}, oa = (e) => {
	let t = {};
	return Object.keys(e.getState()).forEach((n) => {
		t[n] = () => e.getState()[n];
	}), t;
}, sa = (e, t) => {
	let n = {};
	return Object.keys(t.getState()).forEach((t) => {
		n[t] = (n) => e((e) => e[t], n);
	}), n;
}, ca = (e, t) => {
	let n = {};
	return Object.keys(t.getState()).forEach((t) => {
		n[t] = () => e()[t];
	}), n;
};
function la(e, ...t) {
	return t.reduce((e, t) => t(e), e);
}
var ua = (e, t) => {
	let n = e(t.set, t.get, t);
	return ra(na({}, t), { set: na(na({}, t.set), n) });
}, da = (e, t) => {
	let n = na({}, t.use), r = na({}, t.useTracked), i = na({}, t.get);
	return Object.keys(e(t.store.getState(), t.get, t)).forEach((a) => {
		n[a] = (...n) => t.useStore((r) => {
			let i = e(r, t.get, t)[a];
			return i(...n);
		}), r[a] = (...n) => {
			let r = e(t.useTrackedStore(), t.get, t)[a];
			return r(...n);
		}, i[a] = (...n) => {
			let r = e(t.store.getState(), t.get, t)[a];
			return r(...n);
		};
	}), ra(na({}, t), {
		get: i,
		use: n,
		useTracked: r
	});
}, fa = (e) => ra(na({}, e), {
	extendSelectors: (t) => fa(da(t, e)),
	extendActions: (t) => fa(ua(t, e))
}), pa = (e) => (t, n = {}) => {
	let { middlewares: r = [], devtools: i, persist: a, immer: o } = n;
	Ci(o?.enabledAutoFreeze ?? !1), o?.enableMapSet && bi();
	let s = [ia, ...r];
	if (a?.enabled) {
		let t = ra(na({}, a), { name: a.name ?? e });
		s.push((e) => Fi(e, t));
	}
	i?.enabled && s.push((t) => ki(t, ra(na({}, i), { name: e }))), s.push(Ui);
	let c = ((e) => la(e, ...s))(() => t), l = (e, t) => Ji(c, e, t), u = aa(c, e), d = (t, n) => {
		c.setState((e) => {
			Object.assign(e, t);
		}, n || `@@${e}/mergeState`);
	}, f = (t, n) => {
		c.setState(t, n || `@@${e}/setState`);
	}, p = sa(l, c), m = oa(c), h = Ti(l), g = ca(h, c), _ = {
		get: na({ state: c.getState }, m),
		name: e,
		set: na({
			state: f,
			mergeState: d
		}, u),
		store: c,
		use: p,
		useTracked: g,
		useStore: l,
		useTrackedStore: h,
		extendSelectors: () => _,
		extendActions: () => _
	};
	return fa(_);
};
//#endregion
//#region ../../../node_modules/react-hotkeys-hook/dist/react-hotkeys-hook.esm.js
function ma() {
	return ma = Object.assign ? Object.assign.bind() : function(e) {
		for (var t = 1; t < arguments.length; t++) {
			var n = arguments[t];
			for (var r in n) ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
		}
		return e;
	}, ma.apply(null, arguments);
}
var ha = [
	"shift",
	"alt",
	"meta",
	"mod",
	"ctrl"
], ga = {
	esc: "escape",
	return: "enter",
	".": "period",
	",": "comma",
	"-": "slash",
	" ": "space",
	"`": "backquote",
	"#": "backslash",
	"+": "bracketright",
	ShiftLeft: "shift",
	ShiftRight: "shift",
	AltLeft: "alt",
	AltRight: "alt",
	MetaLeft: "meta",
	MetaRight: "meta",
	OSLeft: "meta",
	OSRight: "meta",
	ControlLeft: "ctrl",
	ControlRight: "ctrl"
};
function _a(e) {
	return (e && ga[e] || e || "").trim().toLowerCase().replace(/key|digit|numpad|arrow/, "");
}
function va(e) {
	return ha.includes(e);
}
function ya(e, t) {
	return t === void 0 && (t = ","), e.split(t);
}
function ba(e, t, n) {
	t === void 0 && (t = "+");
	var r = e.toLocaleLowerCase().split(t).map(function(e) {
		return _a(e);
	}), i = {
		alt: r.includes("alt"),
		ctrl: r.includes("ctrl") || r.includes("control"),
		shift: r.includes("shift"),
		meta: r.includes("meta"),
		mod: r.includes("mod")
	}, a = r.filter(function(e) {
		return !ha.includes(e);
	});
	return ma({}, i, {
		keys: a,
		description: n,
		hotkey: e
	});
}
(function() {
	typeof document < "u" && (document.addEventListener("keydown", function(e) {
		e.key !== void 0 && wa([_a(e.key), _a(e.code)]);
	}), document.addEventListener("keyup", function(e) {
		e.key !== void 0 && Ta([_a(e.key), _a(e.code)]);
	})), typeof window < "u" && window.addEventListener("blur", function() {
		xa.clear();
	});
})();
var xa = /*#__PURE__*/ new Set();
function Sa(e) {
	return Array.isArray(e);
}
function Ca(e, t) {
	return t === void 0 && (t = ","), (Sa(e) ? e : e.split(t)).every(function(e) {
		return xa.has(e.trim().toLowerCase());
	});
}
function wa(e) {
	var t = Array.isArray(e) ? e : [e];
	xa.has("meta") && xa.forEach(function(e) {
		return !va(e) && xa.delete(e.toLowerCase());
	}), t.forEach(function(e) {
		return xa.add(e.toLowerCase());
	});
}
function Ta(e) {
	e === "meta" ? xa.clear() : (Array.isArray(e) ? e : [e]).forEach(function(e) {
		return xa.delete(e.toLowerCase());
	});
}
function Ea(e, t, n) {
	(typeof n == "function" && n(e, t) || n === !0) && e.preventDefault();
}
function Da(e, t, n) {
	return typeof n == "function" ? n(e, t) : n === !0 || n === void 0;
}
function Oa(e) {
	return ka(e, [
		"input",
		"textarea",
		"select"
	]);
}
function ka(e, t) {
	t === void 0 && (t = !1);
	var n = e.target, r = e.composed, i = null;
	return i = Aa(n) && r ? e.composedPath()[0] && e.composedPath()[0].tagName : n && n.tagName, Sa(t) ? !!(i && t && t.some(function(e) {
		return e.toLowerCase() === i?.toLowerCase();
	})) : !!(i && t && t);
}
function Aa(e) {
	return !!e.tagName && !e.tagName.startsWith("-") && e.tagName.includes("-");
}
function ja(e, t) {
	return e.length === 0 && t ? (console.warn("A hotkey has the \"scopes\" option set, however no active scopes were found. If you want to use the global scopes feature, you need to wrap your app in a <HotkeysProvider>"), !0) : !t || e.some(function(e) {
		return t.includes(e);
	}) || e.includes("*");
}
var Ma = function(e, t, n) {
	n === void 0 && (n = !1);
	var r = t.alt, i = t.meta, a = t.mod, o = t.shift, s = t.ctrl, c = t.keys, l = e.key, u = e.code, d = e.ctrlKey, f = e.metaKey, p = e.shiftKey, m = e.altKey, h = _a(u), g = l.toLowerCase();
	if (!(c != null && c.includes(h)) && !(c != null && c.includes(g)) && ![
		"ctrl",
		"control",
		"unknown",
		"meta",
		"alt",
		"shift",
		"os"
	].includes(h)) return !1;
	if (!n) {
		if (r === !m && g !== "alt" || o === !p && g !== "shift") return !1;
		if (a) {
			if (!f && !d) return !1;
		} else if (i === !f && g !== "meta" && g !== "os" || s === !d && g !== "ctrl" && g !== "control") return !1;
	}
	return c && c.length === 1 && (c.includes(g) || c.includes(h)) ? !0 : c ? Ca(c) : !c;
}, Na = /*#__PURE__*/ ue(void 0), Pa = function() {
	return he(Na);
};
function Fa(e, t) {
	return e && t && typeof e == "object" && typeof t == "object" ? Object.keys(e).length === Object.keys(t).length && Object.keys(e).reduce(function(n, r) {
		return n && Fa(e[r], t[r]);
	}, !0) : e === t;
}
var Ia = /*#__PURE__*/ ue({
	hotkeys: [],
	enabledScopes: [],
	toggleScope: function() {},
	enableScope: function() {},
	disableScope: function() {}
}), La = function() {
	return he(Ia);
};
function Ra(e) {
	var t = xe(void 0);
	return Fa(t.current, e) || (t.current = e), t.current;
}
var za = function(e) {
	e.stopPropagation(), e.preventDefault(), e.stopImmediatePropagation();
}, Ba = typeof window < "u" ? ve : _e;
function Va(e, t, n, r) {
	var i = Se(null), a = i[0], o = i[1], s = xe(!1), c = n instanceof Array ? r instanceof Array ? void 0 : r : n, l = Sa(e) ? e.join(c?.splitKey) : e, u = n instanceof Array ? n : r instanceof Array ? r : void 0, d = me(t, u ?? []), f = xe(d);
	u ? f.current = d : f.current = t;
	var p = Ra(c), m = La().enabledScopes, h = Pa();
	return Ba(function() {
		if (!(p?.enabled === !1 || !ja(m, p?.scopes))) {
			var e = function(e, t) {
				var n;
				if (t === void 0 && (t = !1), !(Oa(e) && !ka(e, p?.enableOnFormTags))) {
					if (a !== null) {
						var r = a.getRootNode();
						if ((r instanceof Document || r instanceof ShadowRoot) && r.activeElement !== a && !a.contains(r.activeElement)) {
							za(e);
							return;
						}
					}
					(n = e.target) != null && n.isContentEditable && !(p != null && p.enableOnContentEditable) || ya(l, p?.splitKey).forEach(function(n) {
						var r, i = ba(n, p?.combinationKey);
						if (Ma(e, i, p?.ignoreModifiers) || (r = i.keys) != null && r.includes("*")) {
							if (p != null && p.ignoreEventWhen != null && p.ignoreEventWhen(e) || t && s.current) return;
							if (Ea(e, i, p?.preventDefault), !Da(e, i, p?.enabled)) {
								za(e);
								return;
							}
							f.current(e, i), t || (s.current = !0);
						}
					});
				}
			}, t = function(t) {
				t.key !== void 0 && (wa(_a(t.code)), (p?.keydown === void 0 && p?.keyup !== !0 || p != null && p.keydown) && e(t));
			}, n = function(t) {
				t.key !== void 0 && (Ta(_a(t.code)), s.current = !1, p != null && p.keyup && e(t, !0));
			}, r = a || c?.document || document;
			return r.addEventListener("keyup", n, c?.eventListenerOptions), r.addEventListener("keydown", t, c?.eventListenerOptions), h && ya(l, p?.splitKey).forEach(function(e) {
				return h.addHotkey(ba(e, p?.combinationKey, p?.description));
			}), function() {
				r.removeEventListener("keyup", n, c?.eventListenerOptions), r.removeEventListener("keydown", t, c?.eventListenerOptions), h && ya(l, p?.splitKey).forEach(function(e) {
					return h.removeHotkey(ba(e, p?.combinationKey, p?.description));
				});
			};
		}
	}, [
		a,
		l,
		p,
		m
	]), o;
}
//#endregion
//#region ../../../node_modules/is-plain-object/dist/is-plain-object.mjs
function Ha(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Ua(e) {
	var t, n;
	return Ha(e) === !1 ? !1 : (t = e.constructor, t === void 0 ? !0 : (n = t.prototype, !(Ha(n) === !1 || n.hasOwnProperty("isPrototypeOf") === !1)));
}
//#endregion
//#region ../../../node_modules/immer/dist/immer.esm.mjs
function Wa(e) {
	var t = [...arguments].slice(1);
	if (process.env.NODE_ENV !== "production") {
		var n = Po[e], r = n ? typeof n == "function" ? n.apply(null, t) : n : "unknown error nr: " + e;
		throw Error("[Immer] " + r);
	}
	throw Error("[Immer] minified error nr: " + e + (t.length ? " " + t.map((function(e) {
		return "'" + e + "'";
	})).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function Ga(e) {
	return !!e && !!e[No];
}
function Ka(e) {
	return !!e && (function(e) {
		if (!e || typeof e != "object") return !1;
		var t = Object.getPrototypeOf(e);
		if (t === null) return !0;
		var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
		return n === Object || typeof n == "function" && Function.toString.call(n) === Fo;
	}(e) || Array.isArray(e) || !!e[Mo] || !!e.constructor?.[Mo] || $a(e) || eo(e));
}
function qa(e, t, n) {
	n === void 0 && (n = !1), Ja(e) === 0 ? (n ? Object.keys : Io)(e).forEach((function(r) {
		n && typeof r == "symbol" || t(r, e[r], e);
	})) : e.forEach((function(n, r) {
		return t(r, n, e);
	}));
}
function Ja(e) {
	var t = e[No];
	return t ? t.i > 3 ? t.i - 4 : t.i : Array.isArray(e) ? 1 : $a(e) ? 2 : eo(e) ? 3 : 0;
}
function Ya(e, t) {
	return Ja(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Xa(e, t) {
	return Ja(e) === 2 ? e.get(t) : e[t];
}
function Za(e, t, n) {
	var r = Ja(e);
	r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function Qa(e, t) {
	return e === t ? e !== 0 || 1 / e == 1 / t : e != e && t != t;
}
function $a(e) {
	return Oo && e instanceof Map;
}
function eo(e) {
	return ko && e instanceof Set;
}
function to(e) {
	return e.o || e.t;
}
function no(e) {
	if (Array.isArray(e)) return Array.prototype.slice.call(e);
	var t = Lo(e);
	delete t[No];
	for (var n = Io(t), r = 0; r < n.length; r++) {
		var i = n[r], a = t[i];
		!1 === a.writable && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (t[i] = {
			configurable: !0,
			writable: !0,
			enumerable: a.enumerable,
			value: e[i]
		});
	}
	return Object.create(Object.getPrototypeOf(e), t);
}
function ro(e, t) {
	return t === void 0 && (t = !1), ao(e) || Ga(e) || !Ka(e) || (Ja(e) > 1 && (e.set = e.add = e.clear = e.delete = io), Object.freeze(e), t && qa(e, (function(e, t) {
		return ro(t, !0);
	}), !0)), e;
}
function io() {
	Wa(2);
}
function ao(e) {
	return typeof e != "object" || !e || Object.isFrozen(e);
}
function oo(e) {
	var t = Ro[e];
	return t || Wa(18, e), t;
}
function so() {
	return process.env.NODE_ENV === "production" || Eo || Wa(0), Eo;
}
function co(e, t) {
	t && (oo("Patches"), e.u = [], e.s = [], e.v = t);
}
function lo(e) {
	uo(e), e.p.forEach(po), e.p = null;
}
function uo(e) {
	e === Eo && (Eo = e.l);
}
function fo(e) {
	return Eo = {
		p: [],
		l: Eo,
		h: e,
		m: !0,
		_: 0
	};
}
function po(e) {
	var t = e[No];
	t.i === 0 || t.i === 1 ? t.j() : t.g = !0;
}
function mo(e, t) {
	t._ = t.p.length;
	var n = t.p[0], r = e !== void 0 && e !== n;
	return t.h.O || oo("ES5").S(t, e, r), r ? (n[No].P && (lo(t), Wa(4)), Ka(e) && (e = ho(t, e), t.l || _o(t, e)), t.u && oo("Patches").M(n[No].t, e, t.u, t.s)) : e = ho(t, n, []), lo(t), t.u && t.v(t.u, t.s), e === jo ? void 0 : e;
}
function ho(e, t, n) {
	if (ao(t)) return t;
	var r = t[No];
	if (!r) return qa(t, (function(i, a) {
		return go(e, r, t, i, a, n);
	}), !0), t;
	if (r.A !== e) return t;
	if (!r.P) return _o(e, r.t, !0), r.t;
	if (!r.I) {
		r.I = !0, r.A._--;
		var i = r.i === 4 || r.i === 5 ? r.o = no(r.k) : r.o, a = i, o = !1;
		r.i === 3 && (a = new Set(i), i.clear(), o = !0), qa(a, (function(t, a) {
			return go(e, r, i, t, a, n, o);
		})), _o(e, i, !1), n && e.u && oo("Patches").N(r, n, e.u, e.s);
	}
	return r.o;
}
function go(e, t, n, r, i, a, o) {
	if (process.env.NODE_ENV !== "production" && i === n && Wa(5), Ga(i)) {
		var s = ho(e, i, a && t && t.i !== 3 && !Ya(t.R, r) ? a.concat(r) : void 0);
		if (Za(n, r, s), !Ga(s)) return;
		e.m = !1;
	} else o && n.add(i);
	if (Ka(i) && !ao(i)) {
		if (!e.h.D && e._ < 1) return;
		ho(e, i), t && t.A.l || _o(e, i);
	}
}
function _o(e, t, n) {
	n === void 0 && (n = !1), !e.l && e.h.D && e.m && ro(t, n);
}
function vo(e, t) {
	var n = e[No];
	return (n ? to(n) : e)[t];
}
function yo(e, t) {
	if (t in e) for (var n = Object.getPrototypeOf(e); n;) {
		var r = Object.getOwnPropertyDescriptor(n, t);
		if (r) return r;
		n = Object.getPrototypeOf(n);
	}
}
function bo(e) {
	e.P || (e.P = !0, e.l && bo(e.l));
}
function xo(e) {
	e.o ||= no(e.t);
}
function So(e, t, n) {
	var r = $a(t) ? oo("MapSet").F(t, n) : eo(t) ? oo("MapSet").T(t, n) : e.O ? function(e, t) {
		var n = Array.isArray(e), r = {
			i: +!!n,
			A: t ? t.A : so(),
			P: !1,
			I: !1,
			R: {},
			l: t,
			t: e,
			k: null,
			o: null,
			j: null,
			C: !1
		}, i = r, a = zo;
		n && (i = [r], a = Bo);
		var o = Proxy.revocable(i, a), s = o.revoke, c = o.proxy;
		return r.k = c, r.j = s, c;
	}(t, n) : oo("ES5").J(t, n);
	return (n ? n.A : so()).p.push(r), r;
}
function Co(e) {
	return Ga(e) || Wa(22, e), function e(t) {
		if (!Ka(t)) return t;
		var n, r = t[No], i = Ja(t);
		if (r) {
			if (!r.P && (r.i < 4 || !oo("ES5").K(r))) return r.t;
			r.I = !0, n = wo(t, i), r.I = !1;
		} else n = wo(t, i);
		return qa(n, (function(t, i) {
			r && Xa(r.t, t) === i || Za(n, t, e(i));
		})), i === 3 ? new Set(n) : n;
	}(e);
}
function wo(e, t) {
	switch (t) {
		case 2: return new Map(e);
		case 3: return Array.from(e);
	}
	return no(e);
}
var To, Eo, Do = typeof Symbol < "u" && typeof Symbol("x") == "symbol", Oo = typeof Map < "u", ko = typeof Set < "u", Ao = typeof Proxy < "u" && Proxy.revocable !== void 0 && typeof Reflect < "u", jo = Do ? Symbol.for("immer-nothing") : ((To = {})["immer-nothing"] = !0, To), Mo = Do ? Symbol.for("immer-draftable") : "__$immer_draftable", No = Do ? Symbol.for("immer-state") : "__$immer_state", Po = {
	0: "Illegal state",
	1: "Immer drafts cannot have computed properties",
	2: "This object has been frozen and should not be mutated",
	3: function(e) {
		return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
	},
	4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
	5: "Immer forbids circular references",
	6: "The first or second argument to `produce` must be a function",
	7: "The third argument to `produce` must be a function or undefined",
	8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
	9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
	10: "The given draft is already finalized",
	11: "Object.defineProperty() cannot be used on an Immer draft",
	12: "Object.setPrototypeOf() cannot be used on an Immer draft",
	13: "Immer only supports deleting array indices",
	14: "Immer only supports setting array indices and the 'length' property",
	15: function(e) {
		return "Cannot apply patch, path doesn't resolve: " + e;
	},
	16: "Sets cannot have \"replace\" patches.",
	17: function(e) {
		return "Unsupported patch operation: " + e;
	},
	18: function(e) {
		return "The plugin for '" + e + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + e + "()` when initializing your application.";
	},
	20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
	21: function(e) {
		return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + e + "'";
	},
	22: function(e) {
		return "'current' expects a draft, got: " + e;
	},
	23: function(e) {
		return "'original' expects a draft, got: " + e;
	},
	24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Fo = "" + Object.prototype.constructor, Io = typeof Reflect < "u" && Reflect.ownKeys ? Reflect.ownKeys : Object.getOwnPropertySymbols === void 0 ? Object.getOwnPropertyNames : function(e) {
	return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
}, Lo = Object.getOwnPropertyDescriptors || function(e) {
	var t = {};
	return Io(e).forEach((function(n) {
		t[n] = Object.getOwnPropertyDescriptor(e, n);
	})), t;
}, Ro = {}, zo = {
	get: function(e, t) {
		if (t === No) return e;
		var n = to(e);
		if (!Ya(n, t)) return function(e, t, n) {
			var r = yo(t, n);
			return r ? "value" in r ? r.value : r.get?.call(e.k) : void 0;
		}(e, n, t);
		var r = n[t];
		return e.I || !Ka(r) ? r : r === vo(e.t, t) ? (xo(e), e.o[t] = So(e.A.h, r, e)) : r;
	},
	has: function(e, t) {
		return t in to(e);
	},
	ownKeys: function(e) {
		return Reflect.ownKeys(to(e));
	},
	set: function(e, t, n) {
		var r = yo(to(e), t);
		if (r?.set) return r.set.call(e.k, n), !0;
		if (!e.P) {
			var i = vo(to(e), t), a = i?.[No];
			if (a && a.t === n) return e.o[t] = n, e.R[t] = !1, !0;
			if (Qa(n, i) && (n !== void 0 || Ya(e.t, t))) return !0;
			xo(e), bo(e);
		}
		return e.o[t] === n && (n !== void 0 || t in e.o) || Number.isNaN(n) && Number.isNaN(e.o[t]) || (e.o[t] = n, e.R[t] = !0), !0;
	},
	deleteProperty: function(e, t) {
		return vo(e.t, t) !== void 0 || t in e.t ? (e.R[t] = !1, xo(e), bo(e)) : delete e.R[t], e.o && delete e.o[t], !0;
	},
	getOwnPropertyDescriptor: function(e, t) {
		var n = to(e), r = Reflect.getOwnPropertyDescriptor(n, t);
		return r && {
			writable: !0,
			configurable: e.i !== 1 || t !== "length",
			enumerable: r.enumerable,
			value: n[t]
		};
	},
	defineProperty: function() {
		Wa(11);
	},
	getPrototypeOf: function(e) {
		return Object.getPrototypeOf(e.t);
	},
	setPrototypeOf: function() {
		Wa(12);
	}
}, Bo = {};
qa(zo, (function(e, t) {
	Bo[e] = function() {
		return arguments[0] = arguments[0][0], t.apply(this, arguments);
	};
})), Bo.deleteProperty = function(e, t) {
	return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Wa(13), Bo.set.call(this, e, t, void 0);
}, Bo.set = function(e, t, n) {
	return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Wa(14), zo.set.call(this, e[0], t, n, e[0]);
};
var Vo = new (function() {
	function e(e) {
		var t = this;
		this.O = Ao, this.D = !0, this.produce = function(e, n, r) {
			if (typeof e == "function" && typeof n != "function") {
				var i = n;
				n = e;
				var a = t;
				return function(e) {
					var t = this;
					e === void 0 && (e = i);
					var r = [...arguments].slice(1);
					return a.produce(e, (function(e) {
						var i;
						return (i = n).call.apply(i, [t, e].concat(r));
					}));
				};
			}
			var o;
			if (typeof n != "function" && Wa(6), r !== void 0 && typeof r != "function" && Wa(7), Ka(e)) {
				var s = fo(t), c = So(t, e, void 0), l = !0;
				try {
					o = n(c), l = !1;
				} finally {
					l ? lo(s) : uo(s);
				}
				return typeof Promise < "u" && o instanceof Promise ? o.then((function(e) {
					return co(s, r), mo(e, s);
				}), (function(e) {
					throw lo(s), e;
				})) : (co(s, r), mo(o, s));
			}
			if (!e || typeof e != "object") {
				if ((o = n(e)) === void 0 && (o = e), o === jo && (o = void 0), t.D && ro(o, !0), r) {
					var u = [], d = [];
					oo("Patches").M(e, o, u, d), r(u, d);
				}
				return o;
			}
			Wa(21, e);
		}, this.produceWithPatches = function(e, n) {
			if (typeof e == "function") return function(n) {
				var r = [...arguments].slice(1);
				return t.produceWithPatches(n, (function(t) {
					return e.apply(void 0, [t].concat(r));
				}));
			};
			var r, i, a = t.produce(e, n, (function(e, t) {
				r = e, i = t;
			}));
			return typeof Promise < "u" && a instanceof Promise ? a.then((function(e) {
				return [
					e,
					r,
					i
				];
			})) : [
				a,
				r,
				i
			];
		}, typeof e?.useProxies == "boolean" && this.setUseProxies(e.useProxies), typeof e?.autoFreeze == "boolean" && this.setAutoFreeze(e.autoFreeze);
	}
	var t = e.prototype;
	return t.createDraft = function(e) {
		Ka(e) || Wa(8), Ga(e) && (e = Co(e));
		var t = fo(this), n = So(this, e, void 0);
		return n[No].C = !0, uo(t), n;
	}, t.finishDraft = function(e, t) {
		var n = e && e[No];
		process.env.NODE_ENV !== "production" && (n && n.C || Wa(9), n.I && Wa(10));
		var r = n.A;
		return co(r, t), mo(void 0, r);
	}, t.setAutoFreeze = function(e) {
		this.D = e;
	}, t.setUseProxies = function(e) {
		e && !Ao && Wa(20), this.O = e;
	}, t.applyPatches = function(e, t) {
		var n;
		for (n = t.length - 1; n >= 0; n--) {
			var r = t[n];
			if (r.path.length === 0 && r.op === "replace") {
				e = r.value;
				break;
			}
		}
		n > -1 && (t = t.slice(n + 1));
		var i = oo("Patches").$;
		return Ga(e) ? i(e, t) : this.produce(e, (function(e) {
			return i(e, t);
		}));
	}, e;
}())(), Ho = Vo.produce;
Vo.produceWithPatches.bind(Vo), Vo.setAutoFreeze.bind(Vo), Vo.setUseProxies.bind(Vo), Vo.applyPatches.bind(Vo);
var Uo = Vo.createDraft.bind(Vo), Wo = Vo.finishDraft.bind(Vo), Go = { transform(e, t) {
	var { current: n, affinity: r } = e;
	if (n != null) {
		var i = H.transform(n, t, { affinity: r });
		e.current = i, i ?? e.unref();
	}
} }, Ko = { transform(e, t) {
	var { current: n, affinity: r } = e;
	if (n != null) {
		var i = q.transform(n, t, { affinity: r });
		e.current = i, i ?? e.unref();
	}
} }, qo = { transform(e, t) {
	var { current: n, affinity: r } = e;
	if (n != null) {
		var i = U.transform(n, t, { affinity: r });
		e.current = i, i ?? e.unref();
	}
} }, Jo = /* @__PURE__ */ new WeakMap(), Yo = /* @__PURE__ */ new WeakMap(), Xo = /* @__PURE__ */ new WeakMap(), Zo = /* @__PURE__ */ new WeakMap(), Qo = /* @__PURE__ */ new WeakMap(), $o = /* @__PURE__ */ new WeakMap(), es = /* @__PURE__ */ new WeakMap(), H = {
	ancestors(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { reverse: n = !1 } = t, r = H.levels(e, t);
		return r = n ? r.slice(1) : r.slice(0, -1), r;
	},
	common(e, t) {
		for (var n = [], r = 0; r < e.length && r < t.length; r++) {
			var i = e[r];
			if (i !== t[r]) break;
			n.push(i);
		}
		return n;
	},
	compare(e, t) {
		for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) {
			if (e[r] < t[r]) return -1;
			if (e[r] > t[r]) return 1;
		}
		return 0;
	},
	endsAfter(e, t) {
		var n = e.length - 1, r = e.slice(0, n), i = t.slice(0, n), a = e[n], o = t[n];
		return H.equals(r, i) && a > o;
	},
	endsAt(e, t) {
		var n = e.length, r = e.slice(0, n), i = t.slice(0, n);
		return H.equals(r, i);
	},
	endsBefore(e, t) {
		var n = e.length - 1, r = e.slice(0, n), i = t.slice(0, n), a = e[n], o = t[n];
		return H.equals(r, i) && a < o;
	},
	equals(e, t) {
		return e.length === t.length && e.every((e, n) => e === t[n]);
	},
	hasPrevious(e) {
		return e[e.length - 1] > 0;
	},
	isAfter(e, t) {
		return H.compare(e, t) === 1;
	},
	isAncestor(e, t) {
		return e.length < t.length && H.compare(e, t) === 0;
	},
	isBefore(e, t) {
		return H.compare(e, t) === -1;
	},
	isChild(e, t) {
		return e.length === t.length + 1 && H.compare(e, t) === 0;
	},
	isCommon(e, t) {
		return e.length <= t.length && H.compare(e, t) === 0;
	},
	isDescendant(e, t) {
		return e.length > t.length && H.compare(e, t) === 0;
	},
	isParent(e, t) {
		return e.length + 1 === t.length && H.compare(e, t) === 0;
	},
	isPath(e) {
		return Array.isArray(e) && (e.length === 0 || typeof e[0] == "number");
	},
	isSibling(e, t) {
		if (e.length !== t.length) return !1;
		var n = e.slice(0, -1), r = t.slice(0, -1);
		return e[e.length - 1] !== t[t.length - 1] && H.equals(n, r);
	},
	levels(e) {
		for (var { reverse: t = !1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = [], r = 0; r <= e.length; r++) n.push(e.slice(0, r));
		return t && n.reverse(), n;
	},
	next(e) {
		if (e.length === 0) throw Error(`Cannot get the next path of a root path [${e}], because it has no next index.`);
		var t = e[e.length - 1];
		return e.slice(0, -1).concat(t + 1);
	},
	operationCanTransformPath(e) {
		switch (e.type) {
			case "insert_node":
			case "remove_node":
			case "merge_node":
			case "split_node":
			case "move_node": return !0;
			default: return !1;
		}
	},
	parent(e) {
		if (e.length === 0) throw Error(`Cannot get the parent path of the root path [${e}].`);
		return e.slice(0, -1);
	},
	previous(e) {
		if (e.length === 0) throw Error(`Cannot get the previous path of a root path [${e}], because it has no previous index.`);
		var t = e[e.length - 1];
		if (t <= 0) throw Error(`Cannot get the previous path of a first child path [${e}] because it would result in a negative index.`);
		return e.slice(0, -1).concat(t - 1);
	},
	relative(e, t) {
		if (!H.isAncestor(t, e) && !H.equals(e, t)) throw Error(`Cannot get the relative path of [${e}] inside ancestor [${t}], because it is not above or equal to the path.`);
		return e.slice(t.length);
	},
	transform(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		if (!e) return null;
		var r = [...e], { affinity: i = "forward" } = n;
		if (e.length === 0) return r;
		switch (t.type) {
			case "insert_node":
				var { path: a } = t;
				(H.equals(a, r) || H.endsBefore(a, r) || H.isAncestor(a, r)) && (r[a.length - 1] += 1);
				break;
			case "remove_node":
				var { path: o } = t;
				if (H.equals(o, r) || H.isAncestor(o, r)) return null;
				H.endsBefore(o, r) && --r[o.length - 1];
				break;
			case "merge_node":
				var { path: s, position: c } = t;
				H.equals(s, r) || H.endsBefore(s, r) ? --r[s.length - 1] : H.isAncestor(s, r) && (--r[s.length - 1], r[s.length] += c);
				break;
			case "split_node":
				var { path: l, position: u } = t;
				if (H.equals(l, r)) {
					if (i === "forward") r[r.length - 1] += 1;
					else if (i !== "backward") return null;
				} else H.endsBefore(l, r) ? r[l.length - 1] += 1 : H.isAncestor(l, r) && e[l.length] >= u && (r[l.length - 1] += 1, r[l.length] -= u);
				break;
			case "move_node":
				var { path: d, newPath: f } = t;
				if (H.equals(d, f)) return r;
				if (H.isAncestor(d, r) || H.equals(d, r)) {
					var p = f.slice();
					return H.endsBefore(d, f) && d.length < f.length && --p[d.length - 1], p.concat(r.slice(d.length));
				} else H.isSibling(d, f) && (H.isAncestor(f, r) || H.equals(f, r)) ? H.endsBefore(d, r) ? --r[d.length - 1] : r[d.length - 1] += 1 : H.endsBefore(f, r) || H.equals(f, r) || H.isAncestor(f, r) ? (H.endsBefore(d, r) && --r[d.length - 1], r[f.length - 1] += 1) : H.endsBefore(d, r) && (H.equals(f, r) && (r[f.length - 1] += 1), --r[d.length - 1]);
				break;
		}
		return r;
	}
};
function ts(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function ns(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function rs(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ns(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ns(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var is = (e, t, n) => {
	switch (n.type) {
		case "insert_node":
			var { path: r, node: i } = n, a = G.parent(e, r), o = r[r.length - 1];
			if (o > a.children.length) throw Error(`Cannot apply an "insert_node" operation at path [${r}] because the destination is past the end of the node.`);
			if (a.children.splice(o, 0, i), t) for (var [s, c] of U.points(t)) t[c] = q.transform(s, n);
			break;
		case "insert_text":
			var { path: l, offset: u, text: d } = n;
			if (d.length === 0) break;
			var f = G.leaf(e, l), p = f.text.slice(0, u), m = f.text.slice(u);
			if (f.text = p + d + m, t) for (var [h, g] of U.points(t)) t[g] = q.transform(h, n);
			break;
		case "merge_node":
			var { path: _ } = n, v = G.get(e, _), y = H.previous(_), b = G.get(e, y), x = G.parent(e, _), S = _[_.length - 1];
			if (J.isText(v) && J.isText(b)) b.text += v.text;
			else if (!J.isText(v) && !J.isText(b)) b.children.push(...v.children);
			else throw Error(`Cannot apply a "merge_node" operation at path [${_}] to nodes of different interfaces: ${Ds.stringify(v)} ${Ds.stringify(b)}`);
			if (x.children.splice(S, 1), t) for (var [C, w] of U.points(t)) t[w] = q.transform(C, n);
			break;
		case "move_node":
			var { path: T, newPath: E } = n;
			if (H.isAncestor(T, E)) throw Error(`Cannot move a path [${T}] to new path [${E}] because the destination is inside itself.`);
			var ee = G.get(e, T), D = G.parent(e, T), te = T[T.length - 1];
			D.children.splice(te, 1);
			var ne = H.transform(T, n), O = G.get(e, H.parent(ne)), re = ne[ne.length - 1];
			if (O.children.splice(re, 0, ee), t) for (var [ie, k] of U.points(t)) t[k] = q.transform(ie, n);
			break;
		case "remove_node":
			var { path: ae } = n, oe = ae[ae.length - 1];
			if (G.parent(e, ae).children.splice(oe, 1), t) for (var [se, A] of U.points(t)) {
				var j = q.transform(se, n);
				if (t != null && j != null) t[A] = j;
				else {
					var ce = void 0, M = void 0;
					for (var [N, le] of G.texts(e)) if (H.compare(le, ae) === -1) ce = [N, le];
					else {
						M = [N, le];
						break;
					}
					var ue = !1;
					ce && M && (ue = H.equals(M[1], ae) ? !H.hasPrevious(M[1]) : H.common(ce[1], ae).length < H.common(M[1], ae).length), ce && !ue ? (se.path = ce[1], se.offset = ce[0].text.length) : M ? (se.path = M[1], se.offset = 0) : t = null;
				}
			}
			break;
		case "remove_text":
			var { path: de, offset: fe, text: pe } = n;
			if (pe.length === 0) break;
			var me = G.leaf(e, de);
			if (me.text = me.text.slice(0, fe) + me.text.slice(fe + pe.length), t) for (var [he, ge] of U.points(t)) t[ge] = q.transform(he, n);
			break;
		case "set_node":
			var { path: _e, properties: ve, newProperties: ye } = n;
			if (_e.length === 0) throw Error("Cannot set properties on the root node!");
			var be = G.get(e, _e);
			for (var xe in ye) {
				if (xe === "children" || xe === "text") throw Error(`Cannot set the "${xe}" property of nodes!`);
				var Se = ye[xe];
				Se == null ? delete be[xe] : be[xe] = Se;
			}
			for (var Ce in ve) ye.hasOwnProperty(Ce) || delete be[Ce];
			break;
		case "set_selection":
			var { newProperties: we } = n;
			if (we == null) t = we;
			else {
				if (t == null) {
					if (!U.isRange(we)) throw Error(`Cannot apply an incomplete "set_selection" operation properties ${Ds.stringify(we)} when there is no current selection.`);
					t = rs({}, we);
				}
				for (var Te in we) {
					var Ee = we[Te];
					if (Ee == null) {
						if (Te === "anchor" || Te === "focus") throw Error(`Cannot remove the "${Te}" selection property`);
						delete t[Te];
					} else t[Te] = Ee;
				}
			}
			break;
		case "split_node":
			var { path: De, position: Oe, properties: ke } = n;
			if (De.length === 0) throw Error(`Cannot apply a "split_node" operation at path [${De}] because the root node cannot be split.`);
			var Ae = G.get(e, De), je = G.parent(e, De), Me = De[De.length - 1], Ne;
			if (J.isText(Ae)) {
				var Pe = Ae.text.slice(0, Oe), Fe = Ae.text.slice(Oe);
				Ae.text = Pe, Ne = rs(rs({}, ke), {}, { text: Fe });
			} else {
				var Ie = Ae.children.slice(0, Oe), Le = Ae.children.slice(Oe);
				Ae.children = Ie, Ne = rs(rs({}, ke), {}, { children: Le });
			}
			if (je.children.splice(Me + 1, 0, Ne), t) for (var [Re, ze] of U.points(t)) t[ze] = q.transform(Re, n);
			break;
	}
	return t;
}, as = { transform(e, t) {
	e.children = Uo(e.children);
	var n = e.selection && Uo(e.selection);
	try {
		n = is(e, n, t);
	} finally {
		e.children = Wo(e.children), n ? e.selection = Ga(n) ? Wo(n) : n : e.selection = null;
	}
} }, os = {
	insertNodes(e, t, n) {
		e.insertNodes(t, n);
	},
	liftNodes(e, t) {
		e.liftNodes(t);
	},
	mergeNodes(e, t) {
		e.mergeNodes(t);
	},
	moveNodes(e, t) {
		e.moveNodes(t);
	},
	removeNodes(e, t) {
		e.removeNodes(t);
	},
	setNodes(e, t, n) {
		e.setNodes(t, n);
	},
	splitNodes(e, t) {
		e.splitNodes(t);
	},
	unsetNodes(e, t, n) {
		e.unsetNodes(t, n);
	},
	unwrapNodes(e, t) {
		e.unwrapNodes(t);
	},
	wrapNodes(e, t, n) {
		e.wrapNodes(t, n);
	}
}, ss = {
	collapse(e, t) {
		e.collapse(t);
	},
	deselect(e) {
		e.deselect();
	},
	move(e, t) {
		e.move(t);
	},
	select(e, t) {
		e.select(t);
	},
	setPoint(e, t, n) {
		e.setPoint(t, n);
	},
	setSelection(e, t) {
		e.setSelection(t);
	}
}, cs = (e, t) => {
	for (var n in e) {
		var r = e[n], i = t[n];
		if (Ua(r) && Ua(i)) {
			if (!cs(r, i)) return !1;
		} else if (Array.isArray(r) && Array.isArray(i)) {
			if (r.length !== i.length) return !1;
			for (var a = 0; a < r.length; a++) if (r[a] !== i[a]) return !1;
		} else if (r !== i) return !1;
	}
	for (var o in t) if (e[o] === void 0 && t[o] !== void 0) return !1;
	return !0;
};
function ls(e, t) {
	if (e == null) return {};
	var n = {}, r = Object.keys(e), i, a;
	for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
	return n;
}
function us(e, t) {
	if (e == null) return {};
	var n = ls(e, t), r, i;
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (i = 0; i < a.length; i++) r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
	}
	return n;
}
var ds = ["anchor", "focus"];
function fs(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ps(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? fs(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fs(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var U = {
	edges(e) {
		var { reverse: t = !1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { anchor: n, focus: r } = e;
		return U.isBackward(e) === t ? [n, r] : [r, n];
	},
	end(e) {
		var [, t] = U.edges(e);
		return t;
	},
	equals(e, t) {
		return q.equals(e.anchor, t.anchor) && q.equals(e.focus, t.focus);
	},
	includes(e, t) {
		if (U.isRange(t)) {
			if (U.includes(e, t.anchor) || U.includes(e, t.focus)) return !0;
			var [n, r] = U.edges(e), [i, a] = U.edges(t);
			return q.isBefore(n, i) && q.isAfter(r, a);
		}
		var [o, s] = U.edges(e), c = !1, l = !1;
		return q.isPoint(t) ? (c = q.compare(t, o) >= 0, l = q.compare(t, s) <= 0) : (c = H.compare(t, o.path) >= 0, l = H.compare(t, s.path) <= 0), c && l;
	},
	intersection(e, t) {
		var n = us(e, ds), [r, i] = U.edges(e), [a, o] = U.edges(t), s = q.isBefore(r, a) ? a : r, c = q.isBefore(i, o) ? i : o;
		return q.isBefore(c, s) ? null : ps({
			anchor: s,
			focus: c
		}, n);
	},
	isBackward(e) {
		var { anchor: t, focus: n } = e;
		return q.isAfter(t, n);
	},
	isCollapsed(e) {
		var { anchor: t, focus: n } = e;
		return q.equals(t, n);
	},
	isExpanded(e) {
		return !U.isCollapsed(e);
	},
	isForward(e) {
		return !U.isBackward(e);
	},
	isRange(e) {
		return Ua(e) && q.isPoint(e.anchor) && q.isPoint(e.focus);
	},
	*points(e) {
		yield [e.anchor, "anchor"], yield [e.focus, "focus"];
	},
	start(e) {
		var [t] = U.edges(e);
		return t;
	},
	transform(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		return Ho(e, (e) => {
			if (e === null) return null;
			var { affinity: r = "inward" } = n, i, a;
			if (r === "inward") {
				var o = U.isCollapsed(e);
				U.isForward(e) ? (i = "forward", a = o ? i : "backward") : (i = "backward", a = o ? i : "forward");
			} else r === "outward" ? U.isForward(e) ? (i = "backward", a = "forward") : (i = "forward", a = "backward") : (i = r, a = r);
			var s = q.transform(e.anchor, t, { affinity: i }), c = q.transform(e.focus, t, { affinity: a });
			if (!s || !c) return null;
			e.anchor = s, e.focus = c;
		});
	}
}, ms = (e) => Ua(e) && G.isNodeList(e.children) && !K.isEditor(e), W = {
	isAncestor(e) {
		return Ua(e) && G.isNodeList(e.children);
	},
	isElement: ms,
	isElementList(e) {
		return Array.isArray(e) && e.every((e) => W.isElement(e));
	},
	isElementProps(e) {
		return e.children !== void 0;
	},
	isElementType: function(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "type";
		return ms(e) && e[n] === t;
	},
	matches(e, t) {
		for (var n in t) if (n !== "children" && e[n] !== t[n]) return !1;
		return !0;
	}
}, hs = ["children"], gs = ["text"], _s = /* @__PURE__ */ new WeakMap(), G = {
	ancestor(e, t) {
		var n = G.get(e, t);
		if (J.isText(n)) throw Error(`Cannot get the ancestor node at path [${t}] because it refers to a text node instead: ${Ds.stringify(n)}`);
		return n;
	},
	*ancestors(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		for (var r of H.ancestors(t, n)) yield [G.ancestor(e, r), r];
	},
	child(e, t) {
		if (J.isText(e)) throw Error(`Cannot get the child of a text node: ${Ds.stringify(e)}`);
		var n = e.children[t];
		if (n == null) throw Error(`Cannot get child at index \`${t}\` in node: ${Ds.stringify(e)}`);
		return n;
	},
	*children(e, t) {
		for (var { reverse: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = G.ancestor(e, t), { children: i } = r, a = n ? i.length - 1 : 0; n ? a >= 0 : a < i.length;) yield [G.child(r, a), t.concat(a)], a = n ? a - 1 : a + 1;
	},
	common(e, t, n) {
		var r = H.common(t, n);
		return [G.get(e, r), r];
	},
	descendant(e, t) {
		var n = G.get(e, t);
		if (K.isEditor(n)) throw Error(`Cannot get the descendant node at path [${t}] because it refers to the root editor node instead: ${Ds.stringify(n)}`);
		return n;
	},
	*descendants(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		for (var [n, r] of G.nodes(e, t)) r.length !== 0 && (yield [n, r]);
	},
	*elements(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		for (var [n, r] of G.nodes(e, t)) W.isElement(n) && (yield [n, r]);
	},
	extractProps(e) {
		if (W.isAncestor(e)) {
			var t = us(e, hs);
			return t;
		} else {
			var t = us(e, gs);
			return t;
		}
	},
	first(e, t) {
		for (var n = t.slice(), r = G.get(e, n); r && !(J.isText(r) || r.children.length === 0);) r = r.children[0], n.push(0);
		return [r, n];
	},
	fragment(e, t) {
		if (J.isText(e)) throw Error(`Cannot get a fragment starting from a root text node: ${Ds.stringify(e)}`);
		return Ho({ children: e.children }, (e) => {
			var [n, r] = U.edges(t);
			for (var [, i] of G.nodes(e, {
				reverse: !0,
				pass: (e) => {
					var [, n] = e;
					return !U.includes(t, n);
				}
			})) {
				if (!U.includes(t, i)) {
					var a = G.parent(e, i), o = i[i.length - 1];
					a.children.splice(o, 1);
				}
				if (H.equals(i, r.path)) {
					var s = G.leaf(e, i);
					s.text = s.text.slice(0, r.offset);
				}
				if (H.equals(i, n.path)) {
					var c = G.leaf(e, i);
					c.text = c.text.slice(n.offset);
				}
			}
			K.isEditor(e) && (e.selection = null);
		}).children;
	},
	get(e, t) {
		for (var n = e, r = 0; r < t.length; r++) {
			var i = t[r];
			if (J.isText(n) || !n.children[i]) throw Error(`Cannot find a descendant at path [${t}] in node: ${Ds.stringify(e)}`);
			n = n.children[i];
		}
		return n;
	},
	has(e, t) {
		for (var n = e, r = 0; r < t.length; r++) {
			var i = t[r];
			if (J.isText(n) || !n.children[i]) return !1;
			n = n.children[i];
		}
		return !0;
	},
	isNode(e) {
		return J.isText(e) || W.isElement(e) || K.isEditor(e);
	},
	isNodeList(e) {
		if (!Array.isArray(e)) return !1;
		var t = _s.get(e);
		if (t !== void 0) return t;
		var n = e.every((e) => G.isNode(e));
		return _s.set(e, n), n;
	},
	last(e, t) {
		for (var n = t.slice(), r = G.get(e, n); r && !(J.isText(r) || r.children.length === 0);) {
			var i = r.children.length - 1;
			r = r.children[i], n.push(i);
		}
		return [r, n];
	},
	leaf(e, t) {
		var n = G.get(e, t);
		if (!J.isText(n)) throw Error(`Cannot get the leaf node at path [${t}] because it refers to a non-leaf node: ${Ds.stringify(n)}`);
		return n;
	},
	*levels(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		for (var r of H.levels(t, n)) yield [G.get(e, r), r];
	},
	matches(e, t) {
		return W.isElement(e) && W.isElementProps(t) && W.matches(e, t) || J.isText(e) && J.isTextProps(t) && J.matches(e, t);
	},
	*nodes(e) {
		for (var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { pass: n, reverse: r = !1 } = t, { from: i = [], to: a } = t, o = /* @__PURE__ */ new Set(), s = [], c = e; !(a && (r ? H.isBefore(s, a) : H.isAfter(s, a)));) {
			if (o.has(c) || (yield [c, s]), !o.has(c) && !J.isText(c) && c.children.length !== 0 && (n == null || n([c, s]) === !1)) {
				o.add(c);
				var l = r ? c.children.length - 1 : 0;
				H.isAncestor(s, i) && (l = i[s.length]), s = s.concat(l), c = G.get(e, s);
				continue;
			}
			if (s.length === 0) break;
			if (!r) {
				var u = H.next(s);
				if (G.has(e, u)) {
					s = u, c = G.get(e, s);
					continue;
				}
			}
			if (r && s[s.length - 1] !== 0) {
				s = H.previous(s), c = G.get(e, s);
				continue;
			}
			s = H.parent(s), c = G.get(e, s), o.add(c);
		}
	},
	parent(e, t) {
		var n = H.parent(t), r = G.get(e, n);
		if (J.isText(r)) throw Error(`Cannot get the parent of path [${t}] because it does not exist in the root.`);
		return r;
	},
	string(e) {
		return J.isText(e) ? e.text : e.children.map(G.string).join("");
	},
	*texts(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		for (var [n, r] of G.nodes(e, t)) J.isText(n) && (yield [n, r]);
	}
};
function vs(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ys(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? vs(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : vs(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var bs = {
	isNodeOperation(e) {
		return bs.isOperation(e) && e.type.endsWith("_node");
	},
	isOperation(e) {
		if (!Ua(e)) return !1;
		switch (e.type) {
			case "insert_node": return H.isPath(e.path) && G.isNode(e.node);
			case "insert_text": return typeof e.offset == "number" && typeof e.text == "string" && H.isPath(e.path);
			case "merge_node": return typeof e.position == "number" && H.isPath(e.path) && Ua(e.properties);
			case "move_node": return H.isPath(e.path) && H.isPath(e.newPath);
			case "remove_node": return H.isPath(e.path) && G.isNode(e.node);
			case "remove_text": return typeof e.offset == "number" && typeof e.text == "string" && H.isPath(e.path);
			case "set_node": return H.isPath(e.path) && Ua(e.properties) && Ua(e.newProperties);
			case "set_selection": return e.properties === null && U.isRange(e.newProperties) || e.newProperties === null && U.isRange(e.properties) || Ua(e.properties) && Ua(e.newProperties);
			case "split_node": return H.isPath(e.path) && typeof e.position == "number" && Ua(e.properties);
			default: return !1;
		}
	},
	isOperationList(e) {
		return Array.isArray(e) && e.every((e) => bs.isOperation(e));
	},
	isSelectionOperation(e) {
		return bs.isOperation(e) && e.type.endsWith("_selection");
	},
	isTextOperation(e) {
		return bs.isOperation(e) && e.type.endsWith("_text");
	},
	inverse(e) {
		switch (e.type) {
			case "insert_node": return ys(ys({}, e), {}, { type: "remove_node" });
			case "insert_text": return ys(ys({}, e), {}, { type: "remove_text" });
			case "merge_node": return ys(ys({}, e), {}, {
				type: "split_node",
				path: H.previous(e.path)
			});
			case "move_node":
				var { newPath: t, path: n } = e;
				if (H.equals(t, n)) return e;
				if (H.isSibling(n, t)) return ys(ys({}, e), {}, {
					path: t,
					newPath: n
				});
				var r = H.transform(n, e), i = H.transform(H.next(n), e);
				return ys(ys({}, e), {}, {
					path: r,
					newPath: i
				});
			case "remove_node": return ys(ys({}, e), {}, { type: "insert_node" });
			case "remove_text": return ys(ys({}, e), {}, { type: "insert_text" });
			case "set_node":
				var { properties: a, newProperties: o } = e;
				return ys(ys({}, e), {}, {
					properties: o,
					newProperties: a
				});
			case "set_selection":
				var { properties: s, newProperties: c } = e;
				return s == null ? ys(ys({}, e), {}, {
					properties: c,
					newProperties: null
				}) : c == null ? ys(ys({}, e), {}, {
					properties: null,
					newProperties: s
				}) : ys(ys({}, e), {}, {
					properties: c,
					newProperties: s
				});
			case "split_node": return ys(ys({}, e), {}, {
				type: "merge_node",
				path: H.next(e.path)
			});
		}
	}
}, xs = /* @__PURE__ */ new WeakMap(), Ss = (e) => {
	var t = xs.get(e);
	if (t !== void 0) return t;
	if (!Ua(e)) return !1;
	var n = typeof e.addMark == "function" && typeof e.apply == "function" && typeof e.deleteFragment == "function" && typeof e.insertBreak == "function" && typeof e.insertSoftBreak == "function" && typeof e.insertFragment == "function" && typeof e.insertNode == "function" && typeof e.insertText == "function" && typeof e.isElementReadOnly == "function" && typeof e.isInline == "function" && typeof e.isSelectable == "function" && typeof e.isVoid == "function" && typeof e.normalizeNode == "function" && typeof e.onChange == "function" && typeof e.removeMark == "function" && typeof e.getDirtyPaths == "function" && (e.marks === null || Ua(e.marks)) && (e.selection === null || U.isRange(e.selection)) && G.isNodeList(e.children) && bs.isOperationList(e.operations);
	return xs.set(e, n), n;
}, K = {
	above(e, t) {
		return e.above(t);
	},
	addMark(e, t, n) {
		e.addMark(t, n);
	},
	after(e, t, n) {
		return e.after(t, n);
	},
	before(e, t, n) {
		return e.before(t, n);
	},
	deleteBackward(e) {
		var { unit: t = "character" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		e.deleteBackward(t);
	},
	deleteForward(e) {
		var { unit: t = "character" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		e.deleteForward(t);
	},
	deleteFragment(e, t) {
		e.deleteFragment(t);
	},
	edges(e, t) {
		return e.edges(t);
	},
	elementReadOnly(e) {
		var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		return e.elementReadOnly(t);
	},
	end(e, t) {
		return e.end(t);
	},
	first(e, t) {
		return e.first(t);
	},
	fragment(e, t) {
		return e.fragment(t);
	},
	hasBlocks(e, t) {
		return e.hasBlocks(t);
	},
	hasInlines(e, t) {
		return e.hasInlines(t);
	},
	hasPath(e, t) {
		return e.hasPath(t);
	},
	hasTexts(e, t) {
		return e.hasTexts(t);
	},
	insertBreak(e) {
		e.insertBreak();
	},
	insertFragment(e, t, n) {
		e.insertFragment(t, n);
	},
	insertNode(e, t) {
		e.insertNode(t);
	},
	insertSoftBreak(e) {
		e.insertSoftBreak();
	},
	insertText(e, t) {
		e.insertText(t);
	},
	isBlock(e, t) {
		return e.isBlock(t);
	},
	isEdge(e, t, n) {
		return e.isEdge(t, n);
	},
	isEditor(e) {
		return Ss(e);
	},
	isElementReadOnly(e, t) {
		return e.isElementReadOnly(t);
	},
	isEmpty(e, t) {
		return e.isEmpty(t);
	},
	isEnd(e, t, n) {
		return e.isEnd(t, n);
	},
	isInline(e, t) {
		return e.isInline(t);
	},
	isNormalizing(e) {
		return e.isNormalizing();
	},
	isSelectable(e, t) {
		return e.isSelectable(t);
	},
	isStart(e, t, n) {
		return e.isStart(t, n);
	},
	isVoid(e, t) {
		return e.isVoid(t);
	},
	last(e, t) {
		return e.last(t);
	},
	leaf(e, t, n) {
		return e.leaf(t, n);
	},
	levels(e, t) {
		return e.levels(t);
	},
	marks(e) {
		return e.getMarks();
	},
	next(e, t) {
		return e.next(t);
	},
	node(e, t, n) {
		return e.node(t, n);
	},
	nodes(e, t) {
		return e.nodes(t);
	},
	normalize(e, t) {
		e.normalize(t);
	},
	parent(e, t, n) {
		return e.parent(t, n);
	},
	path(e, t, n) {
		return e.path(t, n);
	},
	pathRef(e, t, n) {
		return e.pathRef(t, n);
	},
	pathRefs(e) {
		return e.pathRefs();
	},
	point(e, t, n) {
		return e.point(t, n);
	},
	pointRef(e, t, n) {
		return e.pointRef(t, n);
	},
	pointRefs(e) {
		return e.pointRefs();
	},
	positions(e, t) {
		return e.positions(t);
	},
	previous(e, t) {
		return e.previous(t);
	},
	range(e, t, n) {
		return e.range(t, n);
	},
	rangeRef(e, t, n) {
		return e.rangeRef(t, n);
	},
	rangeRefs(e) {
		return e.rangeRefs();
	},
	removeMark(e, t) {
		e.removeMark(t);
	},
	setNormalizing(e, t) {
		e.setNormalizing(t);
	},
	start(e, t) {
		return e.start(t);
	},
	string(e, t, n) {
		return e.string(t, n);
	},
	unhangRange(e, t, n) {
		return e.unhangRange(t, n);
	},
	void(e, t) {
		return e.void(t);
	},
	withoutNormalizing(e, t) {
		e.withoutNormalizing(t);
	}
}, Cs = { isSpan(e) {
	return Array.isArray(e) && e.length === 2 && e.every(H.isPath);
} };
function ws(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Ts(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ws(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ws(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var q = {
	compare(e, t) {
		var n = H.compare(e.path, t.path);
		return n === 0 ? e.offset < t.offset ? -1 : +(e.offset > t.offset) : n;
	},
	isAfter(e, t) {
		return q.compare(e, t) === 1;
	},
	isBefore(e, t) {
		return q.compare(e, t) === -1;
	},
	equals(e, t) {
		return e.offset === t.offset && H.equals(e.path, t.path);
	},
	isPoint(e) {
		return Ua(e) && typeof e.offset == "number" && H.isPath(e.path);
	},
	transform(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		return Ho(e, (e) => {
			if (e === null) return null;
			var { affinity: r = "forward" } = n, { path: i, offset: a } = e;
			switch (t.type) {
				case "insert_node":
				case "move_node":
					e.path = H.transform(i, t, n);
					break;
				case "insert_text":
					H.equals(t.path, i) && (t.offset < a || t.offset === a && r === "forward") && (e.offset += t.text.length);
					break;
				case "merge_node":
					H.equals(t.path, i) && (e.offset += t.position), e.path = H.transform(i, t, n);
					break;
				case "remove_text":
					H.equals(t.path, i) && t.offset <= a && (e.offset -= Math.min(a - t.offset, t.text.length));
					break;
				case "remove_node":
					if (H.equals(t.path, i) || H.isAncestor(t.path, i)) return null;
					e.path = H.transform(i, t, n);
					break;
				case "split_node":
					if (H.equals(t.path, i)) {
						if (t.position === a && r == null) return null;
						(t.position < a || t.position === a && r === "forward") && (e.offset -= t.position, e.path = H.transform(i, t, Ts(Ts({}, n), {}, { affinity: "forward" })));
					} else e.path = H.transform(i, t, n);
					break;
			}
		});
	}
}, Es = void 0, Ds = {
	setScrubber(e) {
		Es = e;
	},
	stringify(e) {
		return JSON.stringify(e, Es);
	}
}, Os = ["text"], ks = ["anchor", "focus"];
function As(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function js(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? As(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : As(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var J = {
	equals(e, t) {
		var { loose: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		function r(e) {
			return us(e, Os);
		}
		return cs(n ? r(e) : e, n ? r(t) : t);
	},
	isText(e) {
		return Ua(e) && typeof e.text == "string";
	},
	isTextList(e) {
		return Array.isArray(e) && e.every((e) => J.isText(e));
	},
	isTextProps(e) {
		return e.text !== void 0;
	},
	matches(e, t) {
		for (var n in t) if (n !== "text" && (!e.hasOwnProperty(n) || e[n] !== t[n])) return !1;
		return !0;
	},
	decorations(e, t) {
		var n = [js({}, e)];
		for (var r of t) {
			var i = us(r, ks), [a, o] = U.edges(r), s = [], c = 0, l = a.offset, u = o.offset;
			for (var d of n) {
				var { length: f } = d.text, p = c;
				if (c += f, l <= p && c <= u) {
					Object.assign(d, i), s.push(d);
					continue;
				}
				if (l !== u && (l === c || u === p) || l > c || u < p || u === p && p !== 0) {
					s.push(d);
					continue;
				}
				var m = d, h = void 0, g = void 0;
				if (u < c) {
					var _ = u - p;
					g = js(js({}, m), {}, { text: m.text.slice(_) }), m = js(js({}, m), {}, { text: m.text.slice(0, _) });
				}
				if (l > p) {
					var v = l - p;
					h = js(js({}, m), {}, { text: m.text.slice(0, v) }), m = js(js({}, m), {}, { text: m.text.slice(v) });
				}
				Object.assign(m, i), h && s.push(h), s.push(m), g && s.push(g);
			}
			n = s;
		}
		return n;
	}
}, Ms = (e) => e.selection ? e.selection : e.children.length > 0 ? K.end(e, []) : [0], Ns = (e, t) => {
	var [n] = K.node(e, t);
	return (e) => e === n;
}, Ps = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = !t, r = t ? Vs(e) : e, i = Y.None, a = Y.None, o = 0, s = null, c = null;
	for (var l of r) {
		var u = l.codePointAt(0);
		if (!u) break;
		var d = $s(l, u);
		if ([i, a] = n ? [a, d] : [d, i], ec(i, Y.ZWJ) && ec(a, Y.ExtPict) && (s = ic(n ? e.substring(0, o) : e.substring(0, e.length - o)), !s) || ec(i, Y.RI) && ec(a, Y.RI) && (c = c === null ? n ? !0 : oc(e.substring(0, e.length - o)) : !c, !c) || i !== Y.None && a !== Y.None && nc(i, a)) break;
		o += l.length;
	}
	return o || 1;
}, Fs = /\s/, Is = /[\u0021-\u0023\u0025-\u002A\u002C-\u002F\u003A\u003B\u003F\u0040\u005B-\u005D\u005F\u007B\u007D\u00A1\u00A7\u00AB\u00B6\u00B7\u00BB\u00BF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E3B\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Ls = /['\u2018\u2019]/, Rs = function(e) {
	for (var t = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], n = 0, r = !1; e.length > 0;) {
		var i = Ps(e, t), [a, o] = zs(e, i, t);
		if (Bs(a, o, t)) r = !0, n += i;
		else if (!r) n += i;
		else break;
		e = o;
	}
	return n;
}, zs = (e, t, n) => {
	if (n) {
		var r = e.length - t;
		return [e.slice(r, e.length), e.slice(0, r)];
	}
	return [e.slice(0, t), e.slice(t)];
}, Bs = function e(t, n) {
	var r = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
	if (Fs.test(t)) return !1;
	if (Ls.test(t)) {
		var [i, a] = zs(n, Ps(n, r), r);
		if (e(i, a, r)) return !0;
	}
	return !Is.test(t);
}, Vs = function* (e) {
	for (var t = e.length - 1, n = 0; n < e.length; n++) {
		var r = e.charAt(t - n);
		if (Us(r.charCodeAt(0))) {
			var i = e.charAt(t - n - 1);
			if (Hs(i.charCodeAt(0))) {
				yield i + r, n++;
				continue;
			}
		}
		yield r;
	}
}, Hs = (e) => e >= 55296 && e <= 56319, Us = (e) => e >= 56320 && e <= 57343, Y;
(function(e) {
	e[e.None = 0] = "None", e[e.Extend = 1] = "Extend", e[e.ZWJ = 2] = "ZWJ", e[e.RI = 4] = "RI", e[e.Prepend = 8] = "Prepend", e[e.SpacingMark = 16] = "SpacingMark", e[e.L = 32] = "L", e[e.V = 64] = "V", e[e.T = 128] = "T", e[e.LV = 256] = "LV", e[e.LVT = 512] = "LVT", e[e.ExtPict = 1024] = "ExtPict", e[e.Any = 2048] = "Any";
})(Y ||= {});
var Ws = /^(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])$/, Gs = /^(?:[\u0600-\u0605\u06DD\u070F\u0890\u0891\u08E2\u0D4E]|\uD804[\uDCBD\uDCCD\uDDC2\uDDC3]|\uD806[\uDD3F\uDD41\uDE3A\uDE84-\uDE89]|\uD807\uDD46)$/, Ks = /^(?:[\u0903\u093B\u093E-\u0940\u0949-\u094C\u094E\u094F\u0982\u0983\u09BF\u09C0\u09C7\u09C8\u09CB\u09CC\u0A03\u0A3E-\u0A40\u0A83\u0ABE-\u0AC0\u0AC9\u0ACB\u0ACC\u0B02\u0B03\u0B40\u0B47\u0B48\u0B4B\u0B4C\u0BBF\u0BC1\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0C01-\u0C03\u0C41-\u0C44\u0C82\u0C83\u0CBE\u0CC0\u0CC1\u0CC3\u0CC4\u0CC7\u0CC8\u0CCA\u0CCB\u0D02\u0D03\u0D3F\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D82\u0D83\u0DD0\u0DD1\u0DD8-\u0DDE\u0DF2\u0DF3\u0E33\u0EB3\u0F3E\u0F3F\u0F7F\u1031\u103B\u103C\u1056\u1057\u1084\u1715\u1734\u17B6\u17BE-\u17C5\u17C7\u17C8\u1923-\u1926\u1929-\u192B\u1930\u1931\u1933-\u1938\u1A19\u1A1A\u1A55\u1A57\u1A6D-\u1A72\u1B04\u1B3B\u1B3D-\u1B41\u1B43\u1B44\u1B82\u1BA1\u1BA6\u1BA7\u1BAA\u1BE7\u1BEA-\u1BEC\u1BEE\u1BF2\u1BF3\u1C24-\u1C2B\u1C34\u1C35\u1CE1\u1CF7\uA823\uA824\uA827\uA880\uA881\uA8B4-\uA8C3\uA952\uA953\uA983\uA9B4\uA9B5\uA9BA\uA9BB\uA9BE-\uA9C0\uAA2F\uAA30\uAA33\uAA34\uAA4D\uAAEB\uAAEE\uAAEF\uAAF5\uABE3\uABE4\uABE6\uABE7\uABE9\uABEA\uABEC]|\uD804[\uDC00\uDC02\uDC82\uDCB0-\uDCB2\uDCB7\uDCB8\uDD2C\uDD45\uDD46\uDD82\uDDB3-\uDDB5\uDDBF\uDDC0\uDDCE\uDE2C-\uDE2E\uDE32\uDE33\uDE35\uDEE0-\uDEE2\uDF02\uDF03\uDF3F\uDF41-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF62\uDF63]|\uD805[\uDC35-\uDC37\uDC40\uDC41\uDC45\uDCB1\uDCB2\uDCB9\uDCBB\uDCBC\uDCBE\uDCC1\uDDB0\uDDB1\uDDB8-\uDDBB\uDDBE\uDE30-\uDE32\uDE3B\uDE3C\uDE3E\uDEAC\uDEAE\uDEAF\uDEB6\uDF26]|\uD806[\uDC2C-\uDC2E\uDC38\uDD31-\uDD35\uDD37\uDD38\uDD3D\uDD40\uDD42\uDDD1-\uDDD3\uDDDC-\uDDDF\uDDE4\uDE39\uDE57\uDE58\uDE97]|\uD807[\uDC2F\uDC3E\uDCA9\uDCB1\uDCB4\uDD8A-\uDD8E\uDD93\uDD94\uDD96\uDEF5\uDEF6]|\uD81B[\uDF51-\uDF87\uDFF0\uDFF1]|\uD834[\uDD66\uDD6D])$/, qs = /^[\u1100-\u115F\uA960-\uA97C]$/, Js = /^[\u1160-\u11A7\uD7B0-\uD7C6]$/, Ys = /^[\u11A8-\u11FF\uD7CB-\uD7FB]$/, Xs = /^[\uAC00\uAC1C\uAC38\uAC54\uAC70\uAC8C\uACA8\uACC4\uACE0\uACFC\uAD18\uAD34\uAD50\uAD6C\uAD88\uADA4\uADC0\uADDC\uADF8\uAE14\uAE30\uAE4C\uAE68\uAE84\uAEA0\uAEBC\uAED8\uAEF4\uAF10\uAF2C\uAF48\uAF64\uAF80\uAF9C\uAFB8\uAFD4\uAFF0\uB00C\uB028\uB044\uB060\uB07C\uB098\uB0B4\uB0D0\uB0EC\uB108\uB124\uB140\uB15C\uB178\uB194\uB1B0\uB1CC\uB1E8\uB204\uB220\uB23C\uB258\uB274\uB290\uB2AC\uB2C8\uB2E4\uB300\uB31C\uB338\uB354\uB370\uB38C\uB3A8\uB3C4\uB3E0\uB3FC\uB418\uB434\uB450\uB46C\uB488\uB4A4\uB4C0\uB4DC\uB4F8\uB514\uB530\uB54C\uB568\uB584\uB5A0\uB5BC\uB5D8\uB5F4\uB610\uB62C\uB648\uB664\uB680\uB69C\uB6B8\uB6D4\uB6F0\uB70C\uB728\uB744\uB760\uB77C\uB798\uB7B4\uB7D0\uB7EC\uB808\uB824\uB840\uB85C\uB878\uB894\uB8B0\uB8CC\uB8E8\uB904\uB920\uB93C\uB958\uB974\uB990\uB9AC\uB9C8\uB9E4\uBA00\uBA1C\uBA38\uBA54\uBA70\uBA8C\uBAA8\uBAC4\uBAE0\uBAFC\uBB18\uBB34\uBB50\uBB6C\uBB88\uBBA4\uBBC0\uBBDC\uBBF8\uBC14\uBC30\uBC4C\uBC68\uBC84\uBCA0\uBCBC\uBCD8\uBCF4\uBD10\uBD2C\uBD48\uBD64\uBD80\uBD9C\uBDB8\uBDD4\uBDF0\uBE0C\uBE28\uBE44\uBE60\uBE7C\uBE98\uBEB4\uBED0\uBEEC\uBF08\uBF24\uBF40\uBF5C\uBF78\uBF94\uBFB0\uBFCC\uBFE8\uC004\uC020\uC03C\uC058\uC074\uC090\uC0AC\uC0C8\uC0E4\uC100\uC11C\uC138\uC154\uC170\uC18C\uC1A8\uC1C4\uC1E0\uC1FC\uC218\uC234\uC250\uC26C\uC288\uC2A4\uC2C0\uC2DC\uC2F8\uC314\uC330\uC34C\uC368\uC384\uC3A0\uC3BC\uC3D8\uC3F4\uC410\uC42C\uC448\uC464\uC480\uC49C\uC4B8\uC4D4\uC4F0\uC50C\uC528\uC544\uC560\uC57C\uC598\uC5B4\uC5D0\uC5EC\uC608\uC624\uC640\uC65C\uC678\uC694\uC6B0\uC6CC\uC6E8\uC704\uC720\uC73C\uC758\uC774\uC790\uC7AC\uC7C8\uC7E4\uC800\uC81C\uC838\uC854\uC870\uC88C\uC8A8\uC8C4\uC8E0\uC8FC\uC918\uC934\uC950\uC96C\uC988\uC9A4\uC9C0\uC9DC\uC9F8\uCA14\uCA30\uCA4C\uCA68\uCA84\uCAA0\uCABC\uCAD8\uCAF4\uCB10\uCB2C\uCB48\uCB64\uCB80\uCB9C\uCBB8\uCBD4\uCBF0\uCC0C\uCC28\uCC44\uCC60\uCC7C\uCC98\uCCB4\uCCD0\uCCEC\uCD08\uCD24\uCD40\uCD5C\uCD78\uCD94\uCDB0\uCDCC\uCDE8\uCE04\uCE20\uCE3C\uCE58\uCE74\uCE90\uCEAC\uCEC8\uCEE4\uCF00\uCF1C\uCF38\uCF54\uCF70\uCF8C\uCFA8\uCFC4\uCFE0\uCFFC\uD018\uD034\uD050\uD06C\uD088\uD0A4\uD0C0\uD0DC\uD0F8\uD114\uD130\uD14C\uD168\uD184\uD1A0\uD1BC\uD1D8\uD1F4\uD210\uD22C\uD248\uD264\uD280\uD29C\uD2B8\uD2D4\uD2F0\uD30C\uD328\uD344\uD360\uD37C\uD398\uD3B4\uD3D0\uD3EC\uD408\uD424\uD440\uD45C\uD478\uD494\uD4B0\uD4CC\uD4E8\uD504\uD520\uD53C\uD558\uD574\uD590\uD5AC\uD5C8\uD5E4\uD600\uD61C\uD638\uD654\uD670\uD68C\uD6A8\uD6C4\uD6E0\uD6FC\uD718\uD734\uD750\uD76C\uD788]$/, Zs = /^[\uAC01-\uAC1B\uAC1D-\uAC37\uAC39-\uAC53\uAC55-\uAC6F\uAC71-\uAC8B\uAC8D-\uACA7\uACA9-\uACC3\uACC5-\uACDF\uACE1-\uACFB\uACFD-\uAD17\uAD19-\uAD33\uAD35-\uAD4F\uAD51-\uAD6B\uAD6D-\uAD87\uAD89-\uADA3\uADA5-\uADBF\uADC1-\uADDB\uADDD-\uADF7\uADF9-\uAE13\uAE15-\uAE2F\uAE31-\uAE4B\uAE4D-\uAE67\uAE69-\uAE83\uAE85-\uAE9F\uAEA1-\uAEBB\uAEBD-\uAED7\uAED9-\uAEF3\uAEF5-\uAF0F\uAF11-\uAF2B\uAF2D-\uAF47\uAF49-\uAF63\uAF65-\uAF7F\uAF81-\uAF9B\uAF9D-\uAFB7\uAFB9-\uAFD3\uAFD5-\uAFEF\uAFF1-\uB00B\uB00D-\uB027\uB029-\uB043\uB045-\uB05F\uB061-\uB07B\uB07D-\uB097\uB099-\uB0B3\uB0B5-\uB0CF\uB0D1-\uB0EB\uB0ED-\uB107\uB109-\uB123\uB125-\uB13F\uB141-\uB15B\uB15D-\uB177\uB179-\uB193\uB195-\uB1AF\uB1B1-\uB1CB\uB1CD-\uB1E7\uB1E9-\uB203\uB205-\uB21F\uB221-\uB23B\uB23D-\uB257\uB259-\uB273\uB275-\uB28F\uB291-\uB2AB\uB2AD-\uB2C7\uB2C9-\uB2E3\uB2E5-\uB2FF\uB301-\uB31B\uB31D-\uB337\uB339-\uB353\uB355-\uB36F\uB371-\uB38B\uB38D-\uB3A7\uB3A9-\uB3C3\uB3C5-\uB3DF\uB3E1-\uB3FB\uB3FD-\uB417\uB419-\uB433\uB435-\uB44F\uB451-\uB46B\uB46D-\uB487\uB489-\uB4A3\uB4A5-\uB4BF\uB4C1-\uB4DB\uB4DD-\uB4F7\uB4F9-\uB513\uB515-\uB52F\uB531-\uB54B\uB54D-\uB567\uB569-\uB583\uB585-\uB59F\uB5A1-\uB5BB\uB5BD-\uB5D7\uB5D9-\uB5F3\uB5F5-\uB60F\uB611-\uB62B\uB62D-\uB647\uB649-\uB663\uB665-\uB67F\uB681-\uB69B\uB69D-\uB6B7\uB6B9-\uB6D3\uB6D5-\uB6EF\uB6F1-\uB70B\uB70D-\uB727\uB729-\uB743\uB745-\uB75F\uB761-\uB77B\uB77D-\uB797\uB799-\uB7B3\uB7B5-\uB7CF\uB7D1-\uB7EB\uB7ED-\uB807\uB809-\uB823\uB825-\uB83F\uB841-\uB85B\uB85D-\uB877\uB879-\uB893\uB895-\uB8AF\uB8B1-\uB8CB\uB8CD-\uB8E7\uB8E9-\uB903\uB905-\uB91F\uB921-\uB93B\uB93D-\uB957\uB959-\uB973\uB975-\uB98F\uB991-\uB9AB\uB9AD-\uB9C7\uB9C9-\uB9E3\uB9E5-\uB9FF\uBA01-\uBA1B\uBA1D-\uBA37\uBA39-\uBA53\uBA55-\uBA6F\uBA71-\uBA8B\uBA8D-\uBAA7\uBAA9-\uBAC3\uBAC5-\uBADF\uBAE1-\uBAFB\uBAFD-\uBB17\uBB19-\uBB33\uBB35-\uBB4F\uBB51-\uBB6B\uBB6D-\uBB87\uBB89-\uBBA3\uBBA5-\uBBBF\uBBC1-\uBBDB\uBBDD-\uBBF7\uBBF9-\uBC13\uBC15-\uBC2F\uBC31-\uBC4B\uBC4D-\uBC67\uBC69-\uBC83\uBC85-\uBC9F\uBCA1-\uBCBB\uBCBD-\uBCD7\uBCD9-\uBCF3\uBCF5-\uBD0F\uBD11-\uBD2B\uBD2D-\uBD47\uBD49-\uBD63\uBD65-\uBD7F\uBD81-\uBD9B\uBD9D-\uBDB7\uBDB9-\uBDD3\uBDD5-\uBDEF\uBDF1-\uBE0B\uBE0D-\uBE27\uBE29-\uBE43\uBE45-\uBE5F\uBE61-\uBE7B\uBE7D-\uBE97\uBE99-\uBEB3\uBEB5-\uBECF\uBED1-\uBEEB\uBEED-\uBF07\uBF09-\uBF23\uBF25-\uBF3F\uBF41-\uBF5B\uBF5D-\uBF77\uBF79-\uBF93\uBF95-\uBFAF\uBFB1-\uBFCB\uBFCD-\uBFE7\uBFE9-\uC003\uC005-\uC01F\uC021-\uC03B\uC03D-\uC057\uC059-\uC073\uC075-\uC08F\uC091-\uC0AB\uC0AD-\uC0C7\uC0C9-\uC0E3\uC0E5-\uC0FF\uC101-\uC11B\uC11D-\uC137\uC139-\uC153\uC155-\uC16F\uC171-\uC18B\uC18D-\uC1A7\uC1A9-\uC1C3\uC1C5-\uC1DF\uC1E1-\uC1FB\uC1FD-\uC217\uC219-\uC233\uC235-\uC24F\uC251-\uC26B\uC26D-\uC287\uC289-\uC2A3\uC2A5-\uC2BF\uC2C1-\uC2DB\uC2DD-\uC2F7\uC2F9-\uC313\uC315-\uC32F\uC331-\uC34B\uC34D-\uC367\uC369-\uC383\uC385-\uC39F\uC3A1-\uC3BB\uC3BD-\uC3D7\uC3D9-\uC3F3\uC3F5-\uC40F\uC411-\uC42B\uC42D-\uC447\uC449-\uC463\uC465-\uC47F\uC481-\uC49B\uC49D-\uC4B7\uC4B9-\uC4D3\uC4D5-\uC4EF\uC4F1-\uC50B\uC50D-\uC527\uC529-\uC543\uC545-\uC55F\uC561-\uC57B\uC57D-\uC597\uC599-\uC5B3\uC5B5-\uC5CF\uC5D1-\uC5EB\uC5ED-\uC607\uC609-\uC623\uC625-\uC63F\uC641-\uC65B\uC65D-\uC677\uC679-\uC693\uC695-\uC6AF\uC6B1-\uC6CB\uC6CD-\uC6E7\uC6E9-\uC703\uC705-\uC71F\uC721-\uC73B\uC73D-\uC757\uC759-\uC773\uC775-\uC78F\uC791-\uC7AB\uC7AD-\uC7C7\uC7C9-\uC7E3\uC7E5-\uC7FF\uC801-\uC81B\uC81D-\uC837\uC839-\uC853\uC855-\uC86F\uC871-\uC88B\uC88D-\uC8A7\uC8A9-\uC8C3\uC8C5-\uC8DF\uC8E1-\uC8FB\uC8FD-\uC917\uC919-\uC933\uC935-\uC94F\uC951-\uC96B\uC96D-\uC987\uC989-\uC9A3\uC9A5-\uC9BF\uC9C1-\uC9DB\uC9DD-\uC9F7\uC9F9-\uCA13\uCA15-\uCA2F\uCA31-\uCA4B\uCA4D-\uCA67\uCA69-\uCA83\uCA85-\uCA9F\uCAA1-\uCABB\uCABD-\uCAD7\uCAD9-\uCAF3\uCAF5-\uCB0F\uCB11-\uCB2B\uCB2D-\uCB47\uCB49-\uCB63\uCB65-\uCB7F\uCB81-\uCB9B\uCB9D-\uCBB7\uCBB9-\uCBD3\uCBD5-\uCBEF\uCBF1-\uCC0B\uCC0D-\uCC27\uCC29-\uCC43\uCC45-\uCC5F\uCC61-\uCC7B\uCC7D-\uCC97\uCC99-\uCCB3\uCCB5-\uCCCF\uCCD1-\uCCEB\uCCED-\uCD07\uCD09-\uCD23\uCD25-\uCD3F\uCD41-\uCD5B\uCD5D-\uCD77\uCD79-\uCD93\uCD95-\uCDAF\uCDB1-\uCDCB\uCDCD-\uCDE7\uCDE9-\uCE03\uCE05-\uCE1F\uCE21-\uCE3B\uCE3D-\uCE57\uCE59-\uCE73\uCE75-\uCE8F\uCE91-\uCEAB\uCEAD-\uCEC7\uCEC9-\uCEE3\uCEE5-\uCEFF\uCF01-\uCF1B\uCF1D-\uCF37\uCF39-\uCF53\uCF55-\uCF6F\uCF71-\uCF8B\uCF8D-\uCFA7\uCFA9-\uCFC3\uCFC5-\uCFDF\uCFE1-\uCFFB\uCFFD-\uD017\uD019-\uD033\uD035-\uD04F\uD051-\uD06B\uD06D-\uD087\uD089-\uD0A3\uD0A5-\uD0BF\uD0C1-\uD0DB\uD0DD-\uD0F7\uD0F9-\uD113\uD115-\uD12F\uD131-\uD14B\uD14D-\uD167\uD169-\uD183\uD185-\uD19F\uD1A1-\uD1BB\uD1BD-\uD1D7\uD1D9-\uD1F3\uD1F5-\uD20F\uD211-\uD22B\uD22D-\uD247\uD249-\uD263\uD265-\uD27F\uD281-\uD29B\uD29D-\uD2B7\uD2B9-\uD2D3\uD2D5-\uD2EF\uD2F1-\uD30B\uD30D-\uD327\uD329-\uD343\uD345-\uD35F\uD361-\uD37B\uD37D-\uD397\uD399-\uD3B3\uD3B5-\uD3CF\uD3D1-\uD3EB\uD3ED-\uD407\uD409-\uD423\uD425-\uD43F\uD441-\uD45B\uD45D-\uD477\uD479-\uD493\uD495-\uD4AF\uD4B1-\uD4CB\uD4CD-\uD4E7\uD4E9-\uD503\uD505-\uD51F\uD521-\uD53B\uD53D-\uD557\uD559-\uD573\uD575-\uD58F\uD591-\uD5AB\uD5AD-\uD5C7\uD5C9-\uD5E3\uD5E5-\uD5FF\uD601-\uD61B\uD61D-\uD637\uD639-\uD653\uD655-\uD66F\uD671-\uD68B\uD68D-\uD6A7\uD6A9-\uD6C3\uD6C5-\uD6DF\uD6E1-\uD6FB\uD6FD-\uD717\uD719-\uD733\uD735-\uD74F\uD751-\uD76B\uD76D-\uD787\uD789-\uD7A3]$/, Qs = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])$/, $s = (e, t) => {
	var n = Y.Any;
	return e.search(Ws) !== -1 && (n |= Y.Extend), t === 8205 && (n |= Y.ZWJ), t >= 127462 && t <= 127487 && (n |= Y.RI), e.search(Gs) !== -1 && (n |= Y.Prepend), e.search(Ks) !== -1 && (n |= Y.SpacingMark), e.search(qs) !== -1 && (n |= Y.L), e.search(Js) !== -1 && (n |= Y.V), e.search(Ys) !== -1 && (n |= Y.T), e.search(Xs) !== -1 && (n |= Y.LV), e.search(Zs) !== -1 && (n |= Y.LVT), e.search(Qs) !== -1 && (n |= Y.ExtPict), n;
};
function ec(e, t) {
	return (e & t) !== 0;
}
var tc = [
	[Y.L, Y.L | Y.V | Y.LV | Y.LVT],
	[Y.LV | Y.V, Y.V | Y.T],
	[Y.LVT | Y.T, Y.T],
	[Y.Any, Y.Extend | Y.ZWJ],
	[Y.Any, Y.SpacingMark],
	[Y.Prepend, Y.Any],
	[Y.ZWJ, Y.ExtPict],
	[Y.RI, Y.RI]
];
function nc(e, t) {
	return tc.findIndex((n) => ec(e, n[0]) && ec(t, n[1])) === -1;
}
var rc = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])(?:[\u0300-\u036F\u0483-\u0489\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u07FD\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08D3-\u08E1\u08E3-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2\u09E3\u09FE\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0AFA-\u0AFF\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B55-\u0B57\u0B62\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C04\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC\u0CCD\u0CD5\u0CD6\u0CE2\u0CE3\u0D00\u0D01\u0D3B\u0D3C\u0D3E\u0D41-\u0D44\u0D4D\u0D57\u0D62\u0D63\u0D81\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u1885\u1886\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1AC0\u1B00-\u1B03\u1B34-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8\u1CF9\u1DC0-\u1DF9\u1DFB-\u1DFF\u200C\u20D0-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302F\u3099\u309A\uA66F-\uA672\uA674-\uA67D\uA69E\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA82C\uA8C4\uA8C5\uA8E0-\uA8F1\uA8FF\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uA9BD\uA9E5\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E\uFF9F]|\uD800[\uDDFD\uDEE0\uDF76-\uDF7A]|\uD802[\uDE01-\uDE03\uDE05\uDE06\uDE0C-\uDE0F\uDE38-\uDE3A\uDE3F\uDEE5\uDEE6]|\uD803[\uDD24-\uDD27\uDEAB\uDEAC\uDF46-\uDF50]|\uD804[\uDC01\uDC38-\uDC46\uDC7F-\uDC81\uDCB3-\uDCB6\uDCB9\uDCBA\uDD00-\uDD02\uDD27-\uDD2B\uDD2D-\uDD34\uDD73\uDD80\uDD81\uDDB6-\uDDBE\uDDC9-\uDDCC\uDDCF\uDE2F-\uDE31\uDE34\uDE36\uDE37\uDE3E\uDEDF\uDEE3-\uDEEA\uDF00\uDF01\uDF3B\uDF3C\uDF3E\uDF40\uDF57\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC38-\uDC3F\uDC42-\uDC44\uDC46\uDC5E\uDCB0\uDCB3-\uDCB8\uDCBA\uDCBD\uDCBF\uDCC0\uDCC2\uDCC3\uDDAF\uDDB2-\uDDB5\uDDBC\uDDBD\uDDBF\uDDC0\uDDDC\uDDDD\uDE33-\uDE3A\uDE3D\uDE3F\uDE40\uDEAB\uDEAD\uDEB0-\uDEB5\uDEB7\uDF1D-\uDF1F\uDF22-\uDF25\uDF27-\uDF2B]|\uD806[\uDC2F-\uDC37\uDC39\uDC3A\uDD30\uDD3B\uDD3C\uDD3E\uDD43\uDDD4-\uDDD7\uDDDA\uDDDB\uDDE0\uDE01-\uDE0A\uDE33-\uDE38\uDE3B-\uDE3E\uDE47\uDE51-\uDE56\uDE59-\uDE5B\uDE8A-\uDE96\uDE98\uDE99]|\uD807[\uDC30-\uDC36\uDC38-\uDC3D\uDC3F\uDC92-\uDCA7\uDCAA-\uDCB0\uDCB2\uDCB3\uDCB5\uDCB6\uDD31-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD45\uDD47\uDD90\uDD91\uDD95\uDD97\uDEF3\uDEF4]|\uD81A[\uDEF0-\uDEF4\uDF30-\uDF36]|\uD81B[\uDF4F\uDF8F-\uDF92\uDFE4]|\uD82F[\uDC9D\uDC9E]|\uD834[\uDD65\uDD67-\uDD69\uDD6E-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A\uDD30-\uDD36\uDEEC-\uDEEF]|\uD83A[\uDCD0-\uDCD6\uDD44-\uDD4A]|\uD83C[\uDFFB-\uDFFF]|\uDB40[\uDC20-\uDC7F\uDD00-\uDDEF])*\u200D$/, ic = (e) => e.search(rc) !== -1, ac = /(?:\uD83C[\uDDE6-\uDDFF])+$/g, oc = (e) => {
	var t = e.match(ac);
	return t !== null && t[0].length / 2 % 2 == 1;
}, sc = {
	delete(e, t) {
		e.delete(t);
	},
	insertFragment(e, t, n) {
		e.insertFragment(t, n);
	},
	insertText(e, t) {
		var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
		K.withoutNormalizing(e, () => {
			var { voids: r = !1 } = n, { at: i = Ms(e) } = n;
			if (H.isPath(i) && (i = K.range(e, i)), U.isRange(i)) if (U.isCollapsed(i)) i = i.anchor;
			else {
				var a = U.end(i);
				if (!r && K.void(e, { at: a })) return;
				var o = U.start(i), s = K.pointRef(e, o), c = K.pointRef(e, a);
				X.delete(e, {
					at: i,
					voids: r
				});
				var l = s.unref(), u = c.unref();
				i = l || u, X.setSelection(e, {
					anchor: i,
					focus: i
				});
			}
			if (!(!r && K.void(e, { at: i }) || K.elementReadOnly(e, { at: i }))) {
				var { path: d, offset: f } = i;
				t.length > 0 && e.apply({
					type: "insert_text",
					path: d,
					offset: f,
					text: t
				});
			}
		});
	}
};
function cc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function lc(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? cc(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : cc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var X = lc(lc(lc(lc({}, as), os), ss), sc), uc = (e, t) => {
	for (var n of K.pathRefs(e)) Go.transform(n, t);
	for (var r of K.pointRefs(e)) Ko.transform(r, t);
	for (var i of K.rangeRefs(e)) qo.transform(i, t);
	var a = Jo.get(e) || [], o = Yo.get(e) || /* @__PURE__ */ new Set(), s, c, l = (e) => {
		if (e) {
			var t = e.join(",");
			c.has(t) || (c.add(t), s.push(e));
		}
	};
	if (H.operationCanTransformPath(t)) {
		s = [], c = /* @__PURE__ */ new Set();
		for (var u of a) l(H.transform(u, t));
	} else s = a, c = o;
	for (var d of e.getDirtyPaths(t)) l(d);
	Jo.set(e, s), Yo.set(e, c), X.transform(e, t), e.operations.push(t), K.normalize(e, { operation: t }), t.type === "set_selection" && (e.marks = null), Xo.get(e) || (Xo.set(e, !0), Promise.resolve().then(() => {
		Xo.set(e, !1), e.onChange({ operation: t }), e.operations = [];
	}));
}, dc = (e, t) => {
	switch (t.type) {
		case "insert_text":
		case "remove_text":
		case "set_node":
			var { path: n } = t;
			return H.levels(n);
		case "insert_node":
			var { node: r, path: i } = t, a = H.levels(i), o = J.isText(r) ? [] : Array.from(G.nodes(r), (e) => {
				var [, t] = e;
				return i.concat(t);
			});
			return [...a, ...o];
		case "merge_node":
			var { path: s } = t, c = H.ancestors(s), l = H.previous(s);
			return [...c, l];
		case "move_node":
			var { path: u, newPath: d } = t;
			if (H.equals(u, d)) return [];
			var f = [], p = [];
			for (var m of H.ancestors(u)) {
				var h = H.transform(m, t);
				f.push(h);
			}
			for (var g of H.ancestors(d)) {
				var _ = H.transform(g, t);
				p.push(_);
			}
			var v = p[p.length - 1], y = d[d.length - 1], b = v.concat(y);
			return [
				...f,
				...p,
				b
			];
		case "remove_node":
			var { path: x } = t;
			return [...H.ancestors(x)];
		case "split_node":
			var { path: S } = t, C = H.levels(S), w = H.next(S);
			return [...C, w];
		default: return [];
	}
}, fc = (e) => {
	var { selection: t } = e;
	return t ? G.fragment(e, t) : [];
}, pc = (e, t) => {
	var [n, r] = t;
	if (!J.isText(n)) {
		if (W.isElement(n) && n.children.length === 0) {
			X.insertNodes(e, { text: "" }, {
				at: r.concat(0),
				voids: !0
			});
			return;
		}
		for (var i = !K.isEditor(n) && W.isElement(n) && (e.isInline(n) || n.children.length === 0 || J.isText(n.children[0]) || e.isInline(n.children[0])), a = 0, o = 0; o < n.children.length; o++, a++) {
			var s = G.get(e, r);
			if (!J.isText(s)) {
				var c = s.children[a], l = s.children[a - 1], u = o === n.children.length - 1;
				(J.isText(c) || W.isElement(c) && e.isInline(c)) === i ? W.isElement(c) ? e.isInline(c) && (l == null || !J.isText(l) ? (X.insertNodes(e, { text: "" }, {
					at: r.concat(a),
					voids: !0
				}), a++) : u && (X.insertNodes(e, { text: "" }, {
					at: r.concat(a + 1),
					voids: !0
				}), a++)) : l != null && J.isText(l) && (J.equals(c, l, { loose: !0 }) ? (X.mergeNodes(e, {
					at: r.concat(a),
					voids: !0
				}), a--) : l.text === "" ? (X.removeNodes(e, {
					at: r.concat(a - 1),
					voids: !0
				}), a--) : c.text === "" && (X.removeNodes(e, {
					at: r.concat(a),
					voids: !0
				}), a--)) : (X.removeNodes(e, {
					at: r.concat(a),
					voids: !0
				}), a--);
			}
		}
	}
}, mc = (e, t) => {
	var { iteration: n, initialDirtyPathsLength: r } = t, i = r * 42;
	if (n > i) throw Error(`Could not completely normalize the editor after ${i} iterations! This is usually due to incorrect normalization logic that leaves a node in an invalid state.`);
	return !0;
}, hc = function(e) {
	var { voids: t = !1, mode: n = "lowest", at: r = e.selection, match: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	if (r) {
		var a = K.path(e, r), o = n === "lowest";
		for (var [s, c] of K.levels(e, {
			at: a,
			voids: t,
			match: i,
			reverse: o
		})) if (!J.isText(s)) {
			if (U.isRange(r)) {
				if (H.isAncestor(c, r.anchor.path) && H.isAncestor(c, r.focus.path)) return [s, c];
			} else if (!H.equals(a, c)) return [s, c];
		}
	}
};
function gc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function _c(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? gc(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : gc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var vc = (e, t, n) => {
	var { selection: r } = e;
	if (r) {
		var i = (t, n) => {
			if (!J.isText(t)) return !1;
			var [r, i] = K.parent(e, n);
			return !e.isVoid(r) || e.markableVoid(r);
		}, a = U.isExpanded(r), o = !1;
		if (!a) {
			var [s, c] = K.node(e, r);
			if (s && i(s, c)) {
				var [l] = K.parent(e, c);
				o = l && e.markableVoid(l);
			}
		}
		a || o ? X.setNodes(e, { [t]: n }, {
			match: i,
			split: !0,
			voids: !0
		}) : (e.marks = _c(_c({}, K.marks(e) || {}), {}, { [t]: n }), Xo.get(e) || e.onChange());
	}
};
function yc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function bc(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? yc(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : yc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var xc = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		anchor: K.point(e, t, { edge: "end" }),
		focus: K.end(e, [])
	}, { distance: i = 1 } = n, a = 0, o;
	for (var s of K.positions(e, bc(bc({}, n), {}, { at: r }))) {
		if (a > i) break;
		a !== 0 && (o = s), a++;
	}
	return o;
};
function Sc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Cc(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Sc(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var wc = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		anchor: K.start(e, []),
		focus: K.point(e, t, { edge: "start" })
	}, { distance: i = 1 } = n, a = 0, o;
	for (var s of K.positions(e, Cc(Cc({}, n), {}, {
		at: r,
		reverse: !0
	}))) {
		if (a > i) break;
		a !== 0 && (o = s), a++;
	}
	return o;
}, Tc = (e, t) => {
	var { selection: n } = e;
	n && U.isCollapsed(n) && X.delete(e, {
		unit: t,
		reverse: !0
	});
}, Ec = (e, t) => {
	var { selection: n } = e;
	n && U.isCollapsed(n) && X.delete(e, { unit: t });
}, Dc = function(e) {
	var { direction: t = "forward" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { selection: n } = e;
	n && U.isExpanded(n) && X.delete(e, { reverse: t === "backward" });
}, Oc = (e, t) => [K.start(e, t), K.end(e, t)];
function kc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Ac(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? kc(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : kc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var jc = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	return K.above(e, Ac(Ac({}, t), {}, { match: (t) => W.isElement(t) && K.isElementReadOnly(e, t) }));
}, Mc = (e, t) => K.point(e, t, { edge: "end" }), Nc = (e, t) => {
	var n = K.path(e, t, { edge: "start" });
	return K.node(e, n);
}, Pc = (e, t) => {
	var n = K.range(e, t);
	return G.fragment(e, n);
};
function Fc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Ic(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Fc(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var Lc = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	return K.above(e, Ic(Ic({}, t), {}, { match: (t) => W.isElement(t) && K.isVoid(e, t) }));
}, Rc = (e, t) => t.children.some((t) => W.isElement(t) && K.isBlock(e, t)), zc = (e, t) => t.children.some((t) => J.isText(t) || K.isInline(e, t)), Bc = (e, t) => G.has(e, t), Vc = (e, t) => t.children.every((e) => J.isText(e)), Hc = (e) => {
	X.splitNodes(e, { always: !0 });
}, Uc = (e, t, n) => {
	X.insertNodes(e, t, n);
}, Wc = (e) => {
	X.splitNodes(e, { always: !0 });
};
function Gc(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Kc(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Gc(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Gc(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var qc = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, { selection: r, marks: i } = e;
	if (r) {
		if (i) {
			var a = Kc({ text: t }, i);
			X.insertNodes(e, a, {
				at: n.at,
				voids: n.voids
			});
		} else X.insertText(e, t, n);
		e.marks = null;
	}
}, Jc = (e, t) => !e.isInline(t), Yc = (e, t, n) => K.isStart(e, t, n) || K.isEnd(e, t, n), Xc = (e, t) => {
	var { children: n } = t, [r] = n;
	return n.length === 0 || n.length === 1 && J.isText(r) && r.text === "" && !e.isVoid(t);
}, Zc = (e, t, n) => {
	var r = K.end(e, n);
	return q.equals(t, r);
}, Qc = (e) => {
	var t = Zo.get(e);
	return t === void 0 || t;
}, $c = (e, t, n) => {
	if (t.offset !== 0) return !1;
	var r = K.start(e, n);
	return q.equals(t, r);
}, el = (e, t) => {
	var n = K.path(e, t, { edge: "end" });
	return K.node(e, n);
}, tl = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = K.path(e, t, n);
	return [G.leaf(e, r), r];
};
function* nl(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { at: n = e.selection, reverse: r = !1, voids: i = !1 } = t, { match: a } = t;
	if (a ??= () => !0, n) {
		var o = [], s = K.path(e, n);
		for (var [c, l] of G.levels(e, s)) if (a(c, l) && (o.push([c, l]), !i && W.isElement(c) && K.isVoid(e, c))) break;
		r && o.reverse(), yield* o;
	}
}
var rl = ["text"], il = ["text"], al = function(e) {
	var { marks: t, selection: n } = e;
	if (!n) return null;
	if (t) return t;
	if (U.isExpanded(n)) {
		var [r] = K.nodes(e, { match: J.isText });
		if (r) {
			var [i] = r;
			return us(i, rl);
		} else return {};
	}
	var { anchor: a } = n, { path: o } = a, [s] = K.leaf(e, o);
	if (a.offset === 0) {
		var c = K.previous(e, {
			at: o,
			match: J.isText
		});
		if (!K.above(e, { match: (t) => W.isElement(t) && K.isVoid(e, t) && e.markableVoid(t) })) {
			var l = K.above(e, { match: (t) => W.isElement(t) && K.isBlock(e, t) });
			if (c && l) {
				var [u, d] = c, [, f] = l;
				H.isAncestor(f, d) && (s = u);
			}
		}
	}
	return us(s, il);
}, ol = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { mode: n = "lowest", voids: r = !1 } = t, { match: i, at: a = e.selection } = t;
	if (a) {
		var o = K.after(e, a, { voids: r });
		if (o) {
			var [, s] = K.last(e, []), c = [o.path, s];
			if (H.isPath(a) && a.length === 0) throw Error("Cannot get the next node from the root node!");
			if (i == null) if (H.isPath(a)) {
				var [l] = K.parent(e, a);
				i = (e) => l.children.includes(e);
			} else i = () => !0;
			var [u] = K.nodes(e, {
				at: c,
				match: i,
				mode: n,
				voids: r
			});
			return u;
		}
	}
}, sl = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = K.path(e, t, n);
	return [G.get(e, r), r];
};
function* cl(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { at: n = e.selection, mode: r = "all", universal: i = !1, reverse: a = !1, voids: o = !1, ignoreNonSelectable: s = !1 } = t, { match: c } = t;
	if (c ||= () => !0, n) {
		var l, u;
		if (Cs.isSpan(n)) l = n[0], u = n[1];
		else {
			var d = K.path(e, n, { edge: "start" }), f = K.path(e, n, { edge: "end" });
			l = a ? f : d, u = a ? d : f;
		}
		var p = G.nodes(e, {
			reverse: a,
			from: l,
			to: u,
			pass: (t) => {
				var [n] = t;
				return W.isElement(n) ? !!(!o && (K.isVoid(e, n) || K.isElementReadOnly(e, n)) || s && !K.isSelectable(e, n)) : !1;
			}
		}), m = [], h;
		for (var [g, _] of p) if (!(s && W.isElement(g) && !K.isSelectable(e, g))) {
			var v = h && H.compare(_, h[1]) === 0;
			if (!(r === "highest" && v)) {
				if (!c(g, _)) {
					if (i && !v && J.isText(g)) return;
					continue;
				}
				if (r === "lowest" && v) {
					h = [g, _];
					continue;
				}
				var y = r === "lowest" ? h : [g, _];
				y && (i ? m.push(y) : yield y), h = [g, _];
			}
		}
		r === "lowest" && h && (i ? m.push(h) : yield h), i && (yield* m);
	}
}
var ll = function(e) {
	var { force: t = !1, operation: n } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = (e) => Jo.get(e) || [], i = (e) => Yo.get(e) || /* @__PURE__ */ new Set(), a = (e) => {
		var t = r(e).pop(), n = t.join(",");
		return i(e).delete(n), t;
	};
	if (K.isNormalizing(e)) {
		if (t) {
			var o = Array.from(G.nodes(e), (e) => {
				var [, t] = e;
				return t;
			}), s = new Set(o.map((e) => e.join(",")));
			Jo.set(e, o), Yo.set(e, s);
		}
		r(e).length !== 0 && K.withoutNormalizing(e, () => {
			for (var t of r(e)) if (G.has(e, t)) {
				var i = K.node(e, t), [o, s] = i;
				W.isElement(o) && o.children.length === 0 && e.normalizeNode(i, { operation: n });
			}
			for (var c = r(e), l = c.length, u = 0; c.length !== 0;) {
				if (!e.shouldNormalize({
					dirtyPaths: c,
					iteration: u,
					initialDirtyPathsLength: l,
					operation: n
				})) return;
				var d = a(e);
				if (G.has(e, d)) {
					var f = K.node(e, d);
					e.normalizeNode(f, { operation: n });
				}
				u++, c = r(e);
			}
		});
	}
}, ul = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = K.path(e, t, n), i = H.parent(r);
	return K.node(e, i);
}, dl = function(e, t) {
	var { affinity: n = "forward" } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		current: t,
		affinity: n,
		unref() {
			var { current: t } = r;
			return K.pathRefs(e).delete(r), r.current = null, t;
		}
	};
	return K.pathRefs(e).add(r), r;
}, fl = (e) => {
	var t = Qo.get(e);
	return t || (t = /* @__PURE__ */ new Set(), Qo.set(e, t)), t;
}, pl = function(e, t) {
	var { depth: n, edge: r } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	if (H.isPath(t)) {
		if (r === "start") {
			var [, i] = G.first(e, t);
			t = i;
		} else if (r === "end") {
			var [, a] = G.last(e, t);
			t = a;
		}
	}
	return U.isRange(t) && (t = r === "start" ? U.start(t) : r === "end" ? U.end(t) : H.common(t.anchor.path, t.focus.path)), q.isPoint(t) && (t = t.path), n != null && (t = t.slice(0, n)), t;
}, ml = function(e, t) {
	var { affinity: n = "forward" } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		current: t,
		affinity: n,
		unref() {
			var { current: t } = r;
			return K.pointRefs(e).delete(r), r.current = null, t;
		}
	};
	return K.pointRefs(e).add(r), r;
}, hl = (e) => {
	var t = $o.get(e);
	return t || (t = /* @__PURE__ */ new Set(), $o.set(e, t)), t;
}, gl = function(e, t) {
	var { edge: n = "start" } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	if (H.isPath(t)) {
		var r;
		if (n === "end") {
			var [, i] = G.last(e, t);
			r = i;
		} else {
			var [, a] = G.first(e, t);
			r = a;
		}
		var o = G.get(e, r);
		if (!J.isText(o)) throw Error(`Cannot get the ${n} point in the node at path [${t}] because it has no ${n} text node.`);
		return {
			path: r,
			offset: n === "end" ? o.text.length : 0
		};
	}
	if (U.isRange(t)) {
		var [s, c] = U.edges(t);
		return n === "start" ? s : c;
	}
	return t;
};
function* _l(e) {
	var { at: t = e.selection, unit: n = "offset", reverse: r = !1, voids: i = !1, ignoreNonSelectable: a = !1 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	if (!t) return;
	var o = K.range(e, t), [s, c] = U.edges(o), l = r ? c : s, u = !1, d = "", f = 0, p = 0, m = 0;
	for (var [h, g] of K.nodes(e, {
		at: t,
		reverse: r,
		voids: i,
		ignoreNonSelectable: a
	})) {
		if (W.isElement(h)) {
			if (!i && (e.isVoid(h) || e.isElementReadOnly(h))) {
				yield K.start(e, g);
				continue;
			}
			if (e.isInline(h)) continue;
			if (K.hasInlines(e, h)) {
				var _ = H.isAncestor(g, c.path) ? c : K.end(e, g), v = H.isAncestor(g, s.path) ? s : K.start(e, g);
				d = K.string(e, {
					anchor: v,
					focus: _
				}, { voids: i }), u = !0;
			}
		}
		if (J.isText(h)) {
			var y = H.equals(g, l.path);
			for (y ? (p = r ? l.offset : h.text.length - l.offset, m = l.offset) : (p = h.text.length, m = r ? p : 0), (y || u || n === "offset") && (yield {
				path: g,
				offset: m
			}, u = !1);;) {
				if (f === 0) {
					if (d === "") break;
					f = b(d, n, r), d = zs(d, f, r)[1];
				}
				if (m = r ? m - f : m + f, p -= f, p < 0) {
					f = -p;
					break;
				}
				f = 0, yield {
					path: g,
					offset: m
				};
			}
		}
	}
	function b(e, t, n) {
		return t === "character" ? Ps(e, n) : t === "word" ? Rs(e, n) : t === "line" || t === "block" ? e.length : 1;
	}
}
var vl = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { mode: n = "lowest", voids: r = !1 } = t, { match: i, at: a = e.selection } = t;
	if (a) {
		var o = K.before(e, a, { voids: r });
		if (o) {
			var [, s] = K.first(e, []), c = [o.path, s];
			if (H.isPath(a) && a.length === 0) throw Error("Cannot get the previous node from the root node!");
			if (i == null) if (H.isPath(a)) {
				var [l] = K.parent(e, a);
				i = (e) => l.children.includes(e);
			} else i = () => !0;
			var [u] = K.nodes(e, {
				reverse: !0,
				at: c,
				match: i,
				mode: n,
				voids: r
			});
			return u;
		}
	}
}, yl = function(e, t) {
	var { affinity: n = "forward" } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = {
		current: t,
		affinity: n,
		unref() {
			var { current: t } = r;
			return K.rangeRefs(e).delete(r), r.current = null, t;
		}
	};
	return K.rangeRefs(e).add(r), r;
}, bl = (e) => {
	var t = es.get(e);
	return t || (t = /* @__PURE__ */ new Set(), es.set(e, t)), t;
}, xl = (e, t, n) => U.isRange(t) && !n ? t : {
	anchor: K.start(e, t),
	focus: K.end(e, n || t)
};
function Sl(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Cl(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Sl(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Sl(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var wl = (e, t) => {
	var { selection: n } = e;
	if (n) {
		var r = (t, n) => {
			if (!J.isText(t)) return !1;
			var [r, i] = K.parent(e, n);
			return !e.isVoid(r) || e.markableVoid(r);
		}, i = U.isExpanded(n), a = !1;
		if (!i) {
			var [o, s] = K.node(e, n);
			if (o && r(o, s)) {
				var [c] = K.parent(e, s);
				a = c && e.markableVoid(c);
			}
		}
		if (i || a) X.unsetNodes(e, t, {
			match: r,
			split: !0,
			voids: !0
		});
		else {
			var l = Cl({}, K.marks(e) || {});
			delete l[t], e.marks = l, Xo.get(e) || e.onChange();
		}
	}
}, Tl = (e, t) => {
	Zo.set(e, t);
}, El = (e, t) => K.point(e, t, { edge: "start" }), Dl = function(e, t) {
	var { voids: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = K.range(e, t), [i, a] = U.edges(r), o = "";
	for (var [s, c] of K.nodes(e, {
		at: r,
		match: J.isText,
		voids: n
	})) {
		var l = s.text;
		H.equals(c, a.path) && (l = l.slice(0, a.offset)), H.equals(c, i.path) && (l = l.slice(i.offset)), o += l;
	}
	return o;
}, Ol = function(e, t) {
	var { voids: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, [r, i] = U.edges(t);
	if (r.offset !== 0 || i.offset !== 0 || U.isCollapsed(t) || H.hasPrevious(i.path)) return t;
	var a = K.above(e, {
		at: i,
		match: (t) => W.isElement(t) && K.isBlock(e, t),
		voids: n
	}), o = a ? a[1] : [], s = {
		anchor: K.start(e, r),
		focus: i
	}, c = !0;
	for (var [l, u] of K.nodes(e, {
		at: s,
		match: J.isText,
		reverse: !0,
		voids: n
	})) {
		if (c) {
			c = !1;
			continue;
		}
		if (l.text !== "" || H.isBefore(u, o)) {
			i = {
				path: u,
				offset: l.text.length
			};
			break;
		}
	}
	return {
		anchor: r,
		focus: i
	};
}, kl = (e, t) => {
	var n = K.isNormalizing(e);
	K.setNormalizing(e, !1);
	try {
		t();
	} finally {
		K.setNormalizing(e, n);
	}
	K.normalize(e);
}, Al = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	K.withoutNormalizing(e, () => {
		var { reverse: n = !1, unit: r = "character", distance: i = 1, voids: a = !1 } = t, { at: o = e.selection, hanging: s = !1 } = t;
		if (o) {
			var c = !1;
			if (U.isRange(o) && U.isCollapsed(o) && (c = !0, o = o.anchor), q.isPoint(o)) {
				var l = K.void(e, {
					at: o,
					mode: "highest"
				});
				if (!a && l) {
					var [, u] = l;
					o = u;
				} else {
					var d = {
						unit: r,
						distance: i
					}, f = n ? K.before(e, o, d) || K.start(e, []) : K.after(e, o, d) || K.end(e, []);
					o = {
						anchor: o,
						focus: f
					}, s = !0;
				}
			}
			if (H.isPath(o)) {
				X.removeNodes(e, {
					at: o,
					voids: a
				});
				return;
			}
			if (!U.isCollapsed(o)) {
				if (!s) {
					var [, p] = U.edges(o), m = K.end(e, []);
					q.equals(p, m) || (o = K.unhangRange(e, o, { voids: a }));
				}
				var [h, g] = U.edges(o), _ = K.above(e, {
					match: (t) => W.isElement(t) && K.isBlock(e, t),
					at: h,
					voids: a
				}), v = K.above(e, {
					match: (t) => W.isElement(t) && K.isBlock(e, t),
					at: g,
					voids: a
				}), y = _ && v && !H.equals(_[1], v[1]), b = H.equals(h.path, g.path), x = a ? null : K.void(e, {
					at: h,
					mode: "highest"
				}) ?? K.elementReadOnly(e, {
					at: h,
					mode: "highest"
				}), S = a ? null : K.void(e, {
					at: g,
					mode: "highest"
				}) ?? K.elementReadOnly(e, {
					at: g,
					mode: "highest"
				});
				if (x) {
					var C = K.before(e, h);
					C && _ && H.isAncestor(_[1], C.path) && (h = C);
				}
				if (S) {
					var w = K.after(e, g);
					w && v && H.isAncestor(v[1], w.path) && (g = w);
				}
				var T = [], E;
				for (var ee of K.nodes(e, {
					at: o,
					voids: a
				})) {
					var [D, te] = ee;
					E && H.compare(te, E) === 0 || (!a && W.isElement(D) && (K.isVoid(e, D) || K.isElementReadOnly(e, D)) || !H.isCommon(te, h.path) && !H.isCommon(te, g.path)) && (T.push(ee), E = te);
				}
				var ne = Array.from(T, (t) => {
					var [, n] = t;
					return K.pathRef(e, n);
				}), O = K.pointRef(e, h), re = K.pointRef(e, g), ie = "";
				if (!b && !x) {
					var k = O.current, [ae] = K.leaf(e, k), { path: oe } = k, { offset: se } = h, A = ae.text.slice(se);
					A.length > 0 && (e.apply({
						type: "remove_text",
						path: oe,
						offset: se,
						text: A
					}), ie = A);
				}
				if (ne.reverse().map((e) => e.unref()).filter((e) => e !== null).forEach((t) => X.removeNodes(e, {
					at: t,
					voids: a
				})), !S) {
					var j = re.current, [ce] = K.leaf(e, j), { path: M } = j, N = b ? h.offset : 0, le = ce.text.slice(N, g.offset);
					le.length > 0 && (e.apply({
						type: "remove_text",
						path: M,
						offset: N,
						text: le
					}), ie = le);
				}
				!b && y && re.current && O.current && X.mergeNodes(e, {
					at: re.current,
					hanging: !0,
					voids: a
				}), c && n && r === "character" && ie.length > 1 && ie.match(/[\u0E00-\u0E7F]+/) && X.insertText(e, ie.slice(0, ie.length - i));
				var ue = O.unref(), de = re.unref(), fe = n ? ue || de : de || ue;
				t.at == null && fe && X.select(e, fe);
			}
		}
	});
}, jl = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	K.withoutNormalizing(e, () => {
		var { hanging: r = !1, voids: i = !1 } = n, { at: a = Ms(e) } = n;
		if (t.length) {
			if (U.isRange(a)) if (r || (a = K.unhangRange(e, a, { voids: i })), U.isCollapsed(a)) a = a.anchor;
			else {
				var [, o] = U.edges(a);
				if (!i && K.void(e, { at: o })) return;
				var s = K.pointRef(e, o);
				X.delete(e, { at: a }), a = s.unref();
			}
			else H.isPath(a) && (a = K.start(e, a));
			if (!(!i && K.void(e, { at: a }))) {
				var c = K.above(e, {
					at: a,
					match: (t) => W.isElement(t) && K.isInline(e, t),
					mode: "highest",
					voids: i
				});
				if (c) {
					var [, l] = c;
					K.isEnd(e, a, l) ? a = K.after(e, l) : K.isStart(e, a, l) && (a = K.before(e, l));
				}
				var [, u] = K.above(e, {
					match: (t) => W.isElement(t) && K.isBlock(e, t),
					at: a,
					voids: i
				}), d = K.isStart(e, a, u), f = K.isEnd(e, a, u), p = d && f, m = !d || d && f, h = !f, [, g] = G.first({ children: t }, []), [, _] = G.last({ children: t }, []), v = [], y = (t) => {
					var [n, r] = t;
					return r.length === 0 ? !1 : p ? !0 : !(m && H.isAncestor(r, g) && W.isElement(n) && !e.isVoid(n) && !e.isInline(n) || h && H.isAncestor(r, _) && W.isElement(n) && !e.isVoid(n) && !e.isInline(n));
				};
				for (var b of G.nodes({ children: t }, { pass: y })) y(b) && v.push(b);
				var x = [], S = [], C = [], w = !0, T = !1;
				for (var [E] of v) W.isElement(E) && !e.isInline(E) ? (w = !1, T = !0, S.push(E)) : w ? x.push(E) : C.push(E);
				var [ee] = K.nodes(e, {
					at: a,
					match: (t) => J.isText(t) || K.isInline(e, t),
					mode: "highest",
					voids: i
				}), [, D] = ee, te = K.isStart(e, a, D), ne = K.isEnd(e, a, D), O = K.pathRef(e, f && !C.length ? H.next(u) : u), re = K.pathRef(e, ne ? H.next(D) : D);
				X.splitNodes(e, {
					at: a,
					match: (t) => T ? W.isElement(t) && K.isBlock(e, t) : J.isText(t) || K.isInline(e, t),
					mode: T ? "lowest" : "highest",
					always: T && (!d || x.length > 0) && (!f || C.length > 0),
					voids: i
				});
				var ie = K.pathRef(e, !te || te && ne ? H.next(D) : D);
				if (X.insertNodes(e, x, {
					at: ie.current,
					match: (t) => J.isText(t) || K.isInline(e, t),
					mode: "highest",
					voids: i
				}), p && !x.length && S.length && !C.length && X.delete(e, {
					at: u,
					voids: i
				}), X.insertNodes(e, S, {
					at: O.current,
					match: (t) => W.isElement(t) && K.isBlock(e, t),
					mode: "lowest",
					voids: i
				}), X.insertNodes(e, C, {
					at: re.current,
					match: (t) => J.isText(t) || K.isInline(e, t),
					mode: "highest",
					voids: i
				}), !n.at) {
					var k;
					if (C.length > 0 && re.current ? k = H.previous(re.current) : S.length > 0 && O.current ? k = H.previous(O.current) : ie.current && (k = H.previous(ie.current)), k) {
						var ae = K.end(e, k);
						X.select(e, ae);
					}
				}
				ie.unref(), O.unref(), re.unref();
			}
		}
	});
}, Ml = function(e) {
	var { edge: t = "anchor" } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { selection: n } = e;
	if (n) {
		if (t === "anchor") X.select(e, n.anchor);
		else if (t === "focus") X.select(e, n.focus);
		else if (t === "start") {
			var [r] = U.edges(n);
			X.select(e, r);
		} else if (t === "end") {
			var [, i] = U.edges(n);
			X.select(e, i);
		}
	}
}, Nl = (e) => {
	var { selection: t } = e;
	t && e.apply({
		type: "set_selection",
		properties: t,
		newProperties: null
	});
}, Pl = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, { selection: n } = e, { distance: r = 1, unit: i = "character", reverse: a = !1 } = t, { edge: o = null } = t;
	if (n) {
		o === "start" && (o = U.isBackward(n) ? "focus" : "anchor"), o === "end" && (o = U.isBackward(n) ? "anchor" : "focus");
		var { anchor: s, focus: c } = n, l = {
			distance: r,
			unit: i,
			ignoreNonSelectable: !0
		}, u = {};
		if (o == null || o === "anchor") {
			var d = a ? K.before(e, s, l) : K.after(e, s, l);
			d && (u.anchor = d);
		}
		if (o == null || o === "focus") {
			var f = a ? K.before(e, c, l) : K.after(e, c, l);
			f && (u.focus = f);
		}
		X.setSelection(e, u);
	}
}, Fl = (e, t) => {
	var { selection: n } = e;
	if (t = K.range(e, t), n) {
		X.setSelection(e, t);
		return;
	}
	if (!U.isRange(t)) throw Error(`When setting the selection and the current selection is \`null\` you must provide at least an \`anchor\` and \`focus\`, but you passed: ${Ds.stringify(t)}`);
	e.apply({
		type: "set_selection",
		properties: n,
		newProperties: t
	});
};
function Il(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Ll(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? Il(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Il(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var Rl = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, { selection: r } = e, { edge: i = "both" } = n;
	if (r) {
		i === "start" && (i = U.isBackward(r) ? "focus" : "anchor"), i === "end" && (i = U.isBackward(r) ? "anchor" : "focus");
		var { anchor: a, focus: o } = r, s = i === "anchor" ? a : o;
		X.setSelection(e, { [i === "anchor" ? "anchor" : "focus"]: Ll(Ll({}, s), t) });
	}
}, zl = (e, t) => {
	var { selection: n } = e, r = {}, i = {};
	if (n) {
		for (var a in t) (a === "anchor" && t.anchor != null && !q.equals(t.anchor, n.anchor) || a === "focus" && t.focus != null && !q.equals(t.focus, n.focus) || a !== "anchor" && a !== "focus" && t[a] !== n[a]) && (r[a] = n[a], i[a] = t[a]);
		Object.keys(r).length > 0 && e.apply({
			type: "set_selection",
			properties: r,
			newProperties: i
		});
	}
}, Bl = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	K.withoutNormalizing(e, () => {
		var { hanging: r = !1, voids: i = !1, mode: a = "lowest" } = n, { at: o, match: s, select: c } = n;
		if (G.isNode(t) && (t = [t]), t.length !== 0) {
			var [l] = t;
			if (o || (o = Ms(e), c = !0), c ??= !1, U.isRange(o)) if (r || (o = K.unhangRange(e, o, { voids: i })), U.isCollapsed(o)) o = o.anchor;
			else {
				var [, u] = U.edges(o), d = K.pointRef(e, u);
				X.delete(e, { at: o }), o = d.unref();
			}
			if (q.isPoint(o)) {
				s ??= J.isText(l) ? (e) => J.isText(e) : e.isInline(l) ? (t) => J.isText(t) || K.isInline(e, t) : (t) => W.isElement(t) && K.isBlock(e, t);
				var [f] = K.nodes(e, {
					at: o.path,
					match: s,
					mode: a,
					voids: i
				});
				if (f) {
					var [, p] = f, m = K.pathRef(e, p), h = K.isEnd(e, o, p);
					X.splitNodes(e, {
						at: o,
						match: s,
						mode: a,
						voids: i
					});
					var g = m.unref();
					o = h ? H.next(g) : g;
				} else return;
			}
			var _ = H.parent(o), v = o[o.length - 1];
			if (!(!i && K.void(e, { at: _ }))) {
				for (var y of t) {
					var b = _.concat(v);
					v++, e.apply({
						type: "insert_node",
						path: b,
						node: y
					}), o = H.next(o);
				}
				if (o = H.previous(o), c) {
					var x = K.end(e, o);
					x && X.select(e, x);
				}
			}
		}
	});
}, Vl = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	K.withoutNormalizing(e, () => {
		var { at: n = e.selection, mode: r = "lowest", voids: i = !1 } = t, { match: a } = t;
		if (a ??= H.isPath(n) ? Ns(e, n) : (t) => W.isElement(t) && K.isBlock(e, t), n) {
			var o = K.nodes(e, {
				at: n,
				match: a,
				mode: r,
				voids: i
			});
			for (var s of Array.from(o, (t) => {
				var [, n] = t;
				return K.pathRef(e, n);
			})) {
				var c = s.unref();
				if (c.length < 2) throw Error(`Cannot lift node at a path [${c}] because it has a depth of less than \`2\`.`);
				var [l, u] = K.node(e, H.parent(c)), d = c[c.length - 1], { length: f } = l.children;
				if (f === 1) {
					var p = H.next(u);
					X.moveNodes(e, {
						at: c,
						to: p,
						voids: i
					}), X.removeNodes(e, {
						at: u,
						voids: i
					});
				} else if (d === 0) X.moveNodes(e, {
					at: c,
					to: u,
					voids: i
				});
				else if (d === f - 1) {
					var m = H.next(u);
					X.moveNodes(e, {
						at: c,
						to: m,
						voids: i
					});
				} else {
					var h = H.next(c), g = H.next(u);
					X.splitNodes(e, {
						at: h,
						voids: i
					}), X.moveNodes(e, {
						at: c,
						to: g,
						voids: i
					});
				}
			}
		}
	});
}, Hl = ["text"], Ul = ["children"], Wl = (e, t) => {
	if (W.isElement(t)) {
		var n = t;
		return K.isVoid(e, t) ? !0 : n.children.length === 1 && Wl(e, n.children[0]);
	} else if (K.isEditor(t)) return !1;
	else return !0;
}, Gl = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	K.withoutNormalizing(e, () => {
		var { match: n, at: r = e.selection } = t, { hanging: i = !1, voids: a = !1, mode: o = "lowest" } = t;
		if (r) {
			if (n == null) if (H.isPath(r)) {
				var [s] = K.parent(e, r);
				n = (e) => s.children.includes(e);
			} else n = (t) => W.isElement(t) && K.isBlock(e, t);
			if (!i && U.isRange(r) && (r = K.unhangRange(e, r, { voids: a })), U.isRange(r)) if (U.isCollapsed(r)) r = r.anchor;
			else {
				var [, c] = U.edges(r), l = K.pointRef(e, c);
				X.delete(e, { at: r }), r = l.unref(), t.at ?? X.select(e, r);
			}
			var [u] = K.nodes(e, {
				at: r,
				match: n,
				voids: a,
				mode: o
			}), d = K.previous(e, {
				at: r,
				match: n,
				voids: a,
				mode: o
			});
			if (!(!u || !d)) {
				var [f, p] = u, [m, h] = d;
				if (!(p.length === 0 || h.length === 0)) {
					var g = H.next(h), _ = H.common(p, h), v = H.isSibling(p, h), y = Array.from(K.levels(e, { at: p }), (e) => {
						var [t] = e;
						return t;
					}).slice(_.length).slice(0, -1), b = K.above(e, {
						at: p,
						mode: "highest",
						match: (t) => y.includes(t) && Wl(e, t)
					}), x = b && K.pathRef(e, b[1]), S, C;
					if (J.isText(f) && J.isText(m)) {
						var w = us(f, Hl);
						C = m.text.length, S = w;
					} else if (W.isElement(f) && W.isElement(m)) {
						var w = us(f, Ul);
						C = m.children.length, S = w;
					} else throw Error(`Cannot merge the node at path [${p}] with the previous sibling because it is not the same kind: ${Ds.stringify(f)} ${Ds.stringify(m)}`);
					v || X.moveNodes(e, {
						at: p,
						to: g,
						voids: a
					}), x && X.removeNodes(e, {
						at: x.current,
						voids: a
					}), W.isElement(m) && K.isEmpty(e, m) || J.isText(m) && m.text === "" && h[h.length - 1] !== 0 ? X.removeNodes(e, {
						at: h,
						voids: a
					}) : e.apply({
						type: "merge_node",
						path: g,
						position: C,
						properties: S
					}), x && x.unref();
				}
			}
		}
	});
}, Kl = (e, t) => {
	K.withoutNormalizing(e, () => {
		var { to: n, at: r = e.selection, mode: i = "lowest", voids: a = !1 } = t, { match: o } = t;
		if (r) {
			o ??= H.isPath(r) ? Ns(e, r) : (t) => W.isElement(t) && K.isBlock(e, t);
			var s = K.pathRef(e, n), c = K.nodes(e, {
				at: r,
				match: o,
				mode: i,
				voids: a
			});
			for (var l of Array.from(c, (t) => {
				var [, n] = t;
				return K.pathRef(e, n);
			})) {
				var u = l.unref(), d = s.current;
				u.length !== 0 && e.apply({
					type: "move_node",
					path: u,
					newPath: d
				}), s.current && H.isSibling(d, u) && H.isAfter(d, u) && (s.current = H.next(s.current));
			}
			s.unref();
		}
	});
}, ql = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	K.withoutNormalizing(e, () => {
		var { hanging: n = !1, voids: r = !1, mode: i = "lowest" } = t, { at: a = e.selection, match: o } = t;
		if (a) {
			o ??= H.isPath(a) ? Ns(e, a) : (t) => W.isElement(t) && K.isBlock(e, t), !n && U.isRange(a) && (a = K.unhangRange(e, a, { voids: r }));
			var s = K.nodes(e, {
				at: a,
				match: o,
				mode: i,
				voids: r
			});
			for (var c of Array.from(s, (t) => {
				var [, n] = t;
				return K.pathRef(e, n);
			})) {
				var l = c.unref();
				if (l) {
					var [u] = K.node(e, l);
					e.apply({
						type: "remove_node",
						path: l,
						node: u
					});
				}
			}
		}
	});
}, Jl = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	K.withoutNormalizing(e, () => {
		var { match: r, at: i = e.selection, compare: a, merge: o } = n, { hanging: s = !1, mode: c = "lowest", split: l = !1, voids: u = !1 } = n;
		if (i) {
			if (r ??= H.isPath(i) ? Ns(e, i) : (t) => W.isElement(t) && K.isBlock(e, t), !s && U.isRange(i) && (i = K.unhangRange(e, i, { voids: u })), l && U.isRange(i)) {
				if (U.isCollapsed(i) && K.leaf(e, i.anchor)[0].text.length > 0) return;
				var d = K.rangeRef(e, i, { affinity: "inward" }), [f, p] = U.edges(i), m = c === "lowest" ? "lowest" : "highest", h = K.isEnd(e, p, p.path);
				X.splitNodes(e, {
					at: p,
					match: r,
					mode: m,
					voids: u,
					always: !h
				});
				var g = K.isStart(e, f, f.path);
				X.splitNodes(e, {
					at: f,
					match: r,
					mode: m,
					voids: u,
					always: !g
				}), i = d.unref(), n.at ?? X.select(e, i);
			}
			a ||= (e, t) => e !== t;
			for (var [_, v] of K.nodes(e, {
				at: i,
				match: r,
				mode: c,
				voids: u
			})) {
				var y = {}, b = {};
				if (v.length !== 0) {
					var x = !1;
					for (var S in t) S === "children" || S === "text" || a(t[S], _[S]) && (x = !0, _.hasOwnProperty(S) && (y[S] = _[S]), o ? t[S] != null && (b[S] = o(_[S], t[S])) : t[S] != null && (b[S] = t[S]));
					x && e.apply({
						type: "set_node",
						path: v,
						properties: y,
						newProperties: b
					});
				}
			}
		}
	});
}, Yl = (e, t) => {
	if (U.isCollapsed(t)) return t.anchor;
	var [, n] = U.edges(t), r = K.pointRef(e, n);
	return X.delete(e, { at: t }), r.unref();
}, Xl = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	K.withoutNormalizing(e, () => {
		var { mode: n = "lowest", voids: r = !1 } = t, { match: i, at: a = e.selection, height: o = 0, always: s = !1 } = t;
		if (i ??= (t) => W.isElement(t) && K.isBlock(e, t), U.isRange(a) && (a = Yl(e, a)), H.isPath(a)) {
			var c = a, l = K.point(e, c), [u] = K.parent(e, c);
			i = (e) => e === u, o = l.path.length - c.length + 1, a = l, s = !0;
		}
		if (a) {
			var d = K.pointRef(e, a, { affinity: "backward" }), f;
			try {
				var [p] = K.nodes(e, {
					at: a,
					match: i,
					mode: n,
					voids: r
				});
				if (!p) return;
				var m = K.void(e, {
					at: a,
					mode: "highest"
				}), h = 0;
				if (!r && m) {
					var [g, _] = m;
					if (W.isElement(g) && e.isInline(g)) {
						var v = K.after(e, _);
						if (!v) {
							var y = { text: "" }, b = H.next(_);
							X.insertNodes(e, y, {
								at: b,
								voids: r
							}), v = K.point(e, b);
						}
						a = v, s = !0;
					}
					o = a.path.length - _.length + 1, s = !0;
				}
				f = K.pointRef(e, a);
				var x = a.path.length - o, [, S] = p, C = a.path.slice(0, x), w = o === 0 ? a.offset : a.path[x] + h;
				for (var [T, E] of K.levels(e, {
					at: C,
					reverse: !0,
					voids: r
				})) {
					var ee = !1;
					if (E.length < S.length || E.length === 0 || !r && W.isElement(T) && K.isVoid(e, T)) break;
					var D = d.current, te = K.isEnd(e, D, E);
					if (s || !d || !K.isEdge(e, D, E)) {
						ee = !0;
						var ne = G.extractProps(T);
						e.apply({
							type: "split_node",
							path: E,
							position: w,
							properties: ne
						});
					}
					w = E[E.length - 1] + (ee || te ? 1 : 0);
				}
				if (t.at == null) {
					var O = f.current || K.end(e, []);
					X.select(e, O);
				}
			} finally {
				var re;
				d.unref(), (re = f) == null || re.unref();
			}
		}
	});
}, Zl = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	Array.isArray(t) || (t = [t]);
	var r = {};
	for (var i of t) r[i] = null;
	X.setNodes(e, r, n);
}, Ql = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	K.withoutNormalizing(e, () => {
		var { mode: n = "lowest", split: r = !1, voids: i = !1 } = t, { at: a = e.selection, match: o } = t;
		if (a) {
			o ??= H.isPath(a) ? Ns(e, a) : (t) => W.isElement(t) && K.isBlock(e, t), H.isPath(a) && (a = K.range(e, a));
			var s = U.isRange(a) ? K.rangeRef(e, a) : null, c = K.nodes(e, {
				at: a,
				match: o,
				mode: n,
				voids: i
			}), l = Array.from(c, (t) => {
				var [, n] = t;
				return K.pathRef(e, n);
			}).reverse(), u = function(t) {
				var n = t.unref(), [a] = K.node(e, n), o = K.range(e, n);
				r && s && (o = U.intersection(s.current, o)), X.liftNodes(e, {
					at: o,
					match: (e) => W.isAncestor(a) && a.children.includes(e),
					voids: i
				});
			};
			for (var d of l) u(d);
			s && s.unref();
		}
	});
};
function $l(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function eu(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? $l(Object(n), !0).forEach(function(t) {
			ts(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $l(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var tu = function(e, t) {
	var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
	K.withoutNormalizing(e, () => {
		var { mode: r = "lowest", split: i = !1, voids: a = !1 } = n, { match: o, at: s = e.selection } = n;
		if (s) {
			if (o ??= H.isPath(s) ? Ns(e, s) : e.isInline(t) ? (t) => W.isElement(t) && K.isInline(e, t) || J.isText(t) : (t) => W.isElement(t) && K.isBlock(e, t), i && U.isRange(s)) {
				var [c, l] = U.edges(s), u = K.rangeRef(e, s, { affinity: "inward" });
				X.splitNodes(e, {
					at: l,
					match: o,
					voids: a
				}), X.splitNodes(e, {
					at: c,
					match: o,
					voids: a
				}), s = u.unref(), n.at ?? X.select(e, s);
			}
			for (var [, d] of Array.from(K.nodes(e, {
				at: s,
				match: e.isInline(t) ? (t) => W.isElement(t) && K.isBlock(e, t) : (e) => K.isEditor(e),
				mode: "lowest",
				voids: a
			}))) {
				var f = U.isRange(s) ? U.intersection(s, K.range(e, d)) : s;
				if (f) {
					var p = Array.from(K.nodes(e, {
						at: f,
						match: o,
						mode: r,
						voids: a
					}));
					p.length > 0 && function() {
						var [n] = p, r = p[p.length - 1], [, i] = n, [, o] = r;
						if (i.length === 0 && o.length === 0) return "continue";
						var s = H.equals(i, o) ? H.parent(i) : H.common(i, o), c = K.range(e, i, o), [l] = K.node(e, s), u = s.length + 1, d = H.next(o.slice(0, u)), f = eu(eu({}, t), {}, { children: [] });
						X.insertNodes(e, f, {
							at: d,
							voids: a
						}), X.moveNodes(e, {
							at: c,
							match: (e) => W.isAncestor(l) && l.children.includes(e),
							to: d.concat(0),
							voids: a
						});
					}();
				}
			}
		}
	});
}, nu = () => {
	var e = {
		children: [],
		operations: [],
		selection: null,
		marks: null,
		isElementReadOnly: () => !1,
		isInline: () => !1,
		isSelectable: () => !0,
		isVoid: () => !1,
		markableVoid: () => !1,
		onChange: () => {},
		apply: function() {
			return uc(e, ...arguments);
		},
		addMark: function() {
			return vc(e, ...arguments);
		},
		deleteBackward: function() {
			return Tc(e, ...arguments);
		},
		deleteForward: function() {
			return Ec(e, ...arguments);
		},
		deleteFragment: function() {
			return Dc(e, ...arguments);
		},
		getFragment: function() {
			return fc(e, ...arguments);
		},
		insertBreak: function() {
			return Hc(e, ...arguments);
		},
		insertSoftBreak: function() {
			return Wc(e, ...arguments);
		},
		insertFragment: function() {
			return jl(e, ...arguments);
		},
		insertNode: function() {
			return Uc(e, ...arguments);
		},
		insertText: function() {
			return qc(e, ...arguments);
		},
		normalizeNode: function() {
			return pc(e, ...arguments);
		},
		removeMark: function() {
			return wl(e, ...arguments);
		},
		getDirtyPaths: function() {
			return dc(e, ...arguments);
		},
		shouldNormalize: function() {
			return mc(e, ...arguments);
		},
		above: function() {
			return hc(e, ...arguments);
		},
		after: function() {
			return xc(e, ...arguments);
		},
		before: function() {
			return wc(e, ...arguments);
		},
		collapse: function() {
			return Ml(e, ...arguments);
		},
		delete: function() {
			return Al(e, ...arguments);
		},
		deselect: function() {
			return Nl(e, ...arguments);
		},
		edges: function() {
			return Oc(e, ...arguments);
		},
		elementReadOnly: function() {
			return jc(e, ...arguments);
		},
		end: function() {
			return Mc(e, ...arguments);
		},
		first: function() {
			return Nc(e, ...arguments);
		},
		fragment: function() {
			return Pc(e, ...arguments);
		},
		getMarks: function() {
			return al(e, ...arguments);
		},
		hasBlocks: function() {
			return Rc(e, ...arguments);
		},
		hasInlines: function() {
			return zc(e, ...arguments);
		},
		hasPath: function() {
			return Bc(e, ...arguments);
		},
		hasTexts: function() {
			return Vc(e, ...arguments);
		},
		insertNodes: function() {
			return Bl(e, ...arguments);
		},
		isBlock: function() {
			return Jc(e, ...arguments);
		},
		isEdge: function() {
			return Yc(e, ...arguments);
		},
		isEmpty: function() {
			return Xc(e, ...arguments);
		},
		isEnd: function() {
			return Zc(e, ...arguments);
		},
		isNormalizing: function() {
			return Qc(e, ...arguments);
		},
		isStart: function() {
			return $c(e, ...arguments);
		},
		last: function() {
			return el(e, ...arguments);
		},
		leaf: function() {
			return tl(e, ...arguments);
		},
		levels: function() {
			return nl(e, ...arguments);
		},
		liftNodes: function() {
			return Vl(e, ...arguments);
		},
		mergeNodes: function() {
			return Gl(e, ...arguments);
		},
		move: function() {
			return Pl(e, ...arguments);
		},
		moveNodes: function() {
			return Kl(e, ...arguments);
		},
		next: function() {
			return ol(e, ...arguments);
		},
		node: function() {
			return sl(e, ...arguments);
		},
		nodes: function() {
			return cl(e, ...arguments);
		},
		normalize: function() {
			return ll(e, ...arguments);
		},
		parent: function() {
			return ul(e, ...arguments);
		},
		path: function() {
			return pl(e, ...arguments);
		},
		pathRef: function() {
			return dl(e, ...arguments);
		},
		pathRefs: function() {
			return fl(e, ...arguments);
		},
		point: function() {
			return gl(e, ...arguments);
		},
		pointRef: function() {
			return ml(e, ...arguments);
		},
		pointRefs: function() {
			return hl(e, ...arguments);
		},
		positions: function() {
			return _l(e, ...arguments);
		},
		previous: function() {
			return vl(e, ...arguments);
		},
		range: function() {
			return xl(e, ...arguments);
		},
		rangeRef: function() {
			return yl(e, ...arguments);
		},
		rangeRefs: function() {
			return bl(e, ...arguments);
		},
		removeNodes: function() {
			return ql(e, ...arguments);
		},
		select: function() {
			return Fl(e, ...arguments);
		},
		setNodes: function() {
			return Jl(e, ...arguments);
		},
		setNormalizing: function() {
			return Tl(e, ...arguments);
		},
		setPoint: function() {
			return Rl(e, ...arguments);
		},
		setSelection: function() {
			return zl(e, ...arguments);
		},
		splitNodes: function() {
			return Xl(e, ...arguments);
		},
		start: function() {
			return El(e, ...arguments);
		},
		string: function() {
			return Dl(e, ...arguments);
		},
		unhangRange: function() {
			return Ol(e, ...arguments);
		},
		unsetNodes: function() {
			return Zl(e, ...arguments);
		},
		unwrapNodes: function() {
			return Ql(e, ...arguments);
		},
		void: function() {
			return Lc(e, ...arguments);
		},
		withoutNormalizing: function() {
			return kl(e, ...arguments);
		},
		wrapNodes: function() {
			return tu(e, ...arguments);
		}
	};
	return e;
}, ru = { isHistory(e) {
	return Ua(e) && Array.isArray(e.redos) && Array.isArray(e.undos) && (e.redos.length === 0 || bs.isOperationList(e.redos[0].operations)) && (e.undos.length === 0 || bs.isOperationList(e.undos[0].operations));
} }, iu = /* @__PURE__ */ new WeakMap(), au = /* @__PURE__ */ new WeakMap(), ou = {
	isHistoryEditor(e) {
		return ru.isHistory(e.history) && K.isEditor(e);
	},
	isMerging(e) {
		return au.get(e);
	},
	isSaving(e) {
		return iu.get(e);
	},
	redo(e) {
		e.redo();
	},
	undo(e) {
		e.undo();
	},
	withoutMerging(e, t) {
		var n = ou.isMerging(e);
		au.set(e, !1), t(), au.set(e, n);
	},
	withoutSaving(e, t) {
		var n = ou.isSaving(e);
		iu.set(e, !1), t(), iu.set(e, n);
	}
}, su = (e) => {
	var t = e, { apply: n } = t;
	return t.history = {
		undos: [],
		redos: []
	}, t.redo = () => {
		var { history: e } = t, { redos: n } = e;
		if (n.length > 0) {
			var r = n[n.length - 1];
			r.selectionBefore && X.setSelection(t, r.selectionBefore), ou.withoutSaving(t, () => {
				K.withoutNormalizing(t, () => {
					for (var e of r.operations) t.apply(e);
				});
			}), e.redos.pop(), t.writeHistory("undos", r);
		}
	}, t.undo = () => {
		var { history: e } = t, { undos: n } = e;
		if (n.length > 0) {
			var r = n[n.length - 1];
			ou.withoutSaving(t, () => {
				K.withoutNormalizing(t, () => {
					for (var e of r.operations.map(bs.inverse).reverse()) t.apply(e);
					r.selectionBefore && X.setSelection(t, r.selectionBefore);
				});
			}), t.writeHistory("redos", r), e.undos.pop();
		}
	}, t.apply = (e) => {
		var { operations: r, history: i } = t, { undos: a } = i, o = a[a.length - 1], s = o && o.operations[o.operations.length - 1], c = ou.isSaving(t), l = ou.isMerging(t);
		if (c ??= lu(e), c) {
			if (l ??= o == null ? !1 : r.length !== 0 || cu(e, s), o && l) o.operations.push(e);
			else {
				var u = {
					operations: [e],
					selectionBefore: t.selection
				};
				t.writeHistory("undos", u);
			}
			for (; a.length > 100;) a.shift();
			i.redos = [];
		}
		n(e);
	}, t.writeHistory = (e, n) => {
		t.history[e].push(n);
	}, t;
}, cu = (e, t) => !!(t && e.type === "insert_text" && t.type === "insert_text" && e.offset === t.offset + t.text.length && H.equals(e.path, t.path) || t && e.type === "remove_text" && t.type === "remove_text" && e.offset + e.text.length === t.offset && H.equals(e.path, t.path)), lu = (e, t) => e.type !== "set_selection", uu = Object.defineProperty, du = Object.defineProperties, fu = Object.getOwnPropertyDescriptors, pu = Object.getOwnPropertySymbols, mu = Object.prototype.hasOwnProperty, hu = Object.prototype.propertyIsEnumerable, gu = (e, t, n) => t in e ? uu(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, _u = (e, t) => {
	for (var n in t ||= {}) mu.call(t, n) && gu(e, n, t[n]);
	if (pu) for (var n of pu(t)) hu.call(t, n) && gu(e, n, t[n]);
	return e;
}, vu = (e, t) => du(e, fu(t)), yu = (e, t) => {
	var n = {};
	for (var r in e) mu.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && pu) for (var r of pu(e)) t.indexOf(r) < 0 && hu.call(e, r) && (n[r] = e[r]);
	return n;
}, bu = () => nu(), xu = (e) => e, Su = (e, t, n) => K.pathRef(e, t, n), Cu = (e, t, n) => K.pointRef(e, t, n), wu = (e) => W.isElement(e), Tu = (e, t) => wu(t) && K.isBlock(e, t);
function Eu(e) {
	return Array.isArray(e) ? e : [e];
}
var Du = (e, t, n) => n ? typeof n == "object" ? Object.entries(n).every(([t, n]) => Eu(n).includes(e[t])) : n(e, t) : !0, Ou = (e, t = {}) => {
	let { block: n, match: r } = t;
	return vu(_u({}, t), { match: r || n ? (t, i) => Du(t, i, r) && (!n || Tu(e, t)) : void 0 });
}, ku = (e, t) => K.above(e, Ou(e, t)), Au = (e, t, n = {}) => {
	let { unhang: r = !0, voids: i } = n;
	return U.isRange(t) && r ? K.unhangRange(e, t, { voids: i }) : t;
}, ju = (e, t) => (Au(e, t?.at, t), K.nodes(e, Ou(e, t))), Mu = (e, t, n) => {
	try {
		return K.parent(e, t, n);
	} catch {}
}, Nu = (e, t) => K.previous(e, t), Pu = (e, t) => K.isEmpty(e, t), Fu = (e, t) => {
	let n = !1;
	return K.withoutNormalizing(e, () => {
		n = !!t();
	}), n;
}, Iu = (e) => J.isText(e), Lu = (e) => Iu(e) ? !0 : e.children.length === 1 && Lu(e.children[0]), Ru = (e, t) => {
	X.delete(e, t);
}, zu = (e, t) => X.moveNodes(e, t), Bu = (e, t) => X.removeNodes(e, t), Vu = (e, t) => {
	X.select(e, t);
}, Hu = (e, t = {}) => {
	Fu(e, () => {
		let { at: n = e.selection, match: r } = t, { hanging: i = !1, mergeNode: a, mode: o = "lowest", removeEmptyAncestor: s, voids: c = !1 } = t;
		if (!n) return;
		if (r == null) if (H.isPath(n)) {
			let [t] = Mu(e, n);
			r = (e) => t.children.includes(e);
		} else r = (t) => Tu(e, t);
		if (!i && U.isRange(n) && (n = K.unhangRange(e, n)), U.isRange(n)) if (U.isCollapsed(n)) n = n.anchor;
		else {
			let [, r] = U.edges(n), i = Cu(e, r);
			Ru(e, { at: n }), n = i.unref(), t.at ?? Vu(e, n);
		}
		let l = ju(e, {
			at: n,
			match: r,
			mode: o,
			voids: c
		}), [u] = Array.from(l), d = Nu(e, {
			at: n,
			match: r,
			mode: o,
			voids: c
		});
		if (!u || !d) return;
		let [f, p] = u, [m, h] = d;
		if (p.length === 0 || h.length === 0) return;
		let g = H.next(h), _ = H.common(p, h), v = H.isSibling(p, h), y = K.levels(e, { at: p }), b = new Set(Array.from(y, ([e]) => e).slice(_.length).slice(0, -1)), x = ku(e, {
			at: p,
			match: (e) => b.has(e) && wu(e) && Lu(e),
			mode: "highest"
		}), S = x && Su(e, x[1]), C, w;
		if (Iu(f) && Iu(m)) {
			let e = f, { text: t } = e, n = yu(e, ["text"]);
			w = m.text.length, C = n;
		} else if (wu(f) && wu(m)) {
			let e = f, { children: t } = e, n = yu(e, ["children"]);
			w = m.children.length, C = n;
		} else throw Error(`Cannot merge the node at path [${p}] with the previous sibling because it is not the same kind: ${JSON.stringify(f)} ${JSON.stringify(m)}`);
		if (!v && !a && zu(e, {
			at: p,
			to: g,
			voids: c
		}), S) if (s) {
			let t = S.current;
			t && s(e, { at: t });
		} else Bu(e, {
			at: S.current,
			voids: c
		});
		a ? a(e, {
			at: p,
			to: g
		}) : wu(m) && Pu(e, m) || Iu(m) && m.text === "" ? Bu(e, {
			at: h,
			voids: c
		}) : e.apply({
			path: g,
			position: w,
			properties: C,
			type: "merge_node"
		}), S && S.unref();
	});
}, Uu = (e, t) => K.end(e, t), Wu = (e, t, n) => K.leaf(e, t, n), Gu = (e, t, n) => K.after(e, t, n), Ku = (e, t, n) => K.before(e, t, n), qu = (e, t) => K.start(e, t), Ju = (e, t) => K.void(e, t), Yu = (e, t) => wu(t) && K.isVoid(e, t), Xu = (e, t = {}) => {
	Fu(e, () => {
		let { distance: n = 1, reverse: r = !1, unit: i = "character", voids: a = !1 } = t, { at: o = e.selection, hanging: s = !1 } = t;
		if (!o) return;
		if (U.isRange(o) && U.isCollapsed(o) && (o = o.anchor), q.isPoint(o)) {
			let t = Ju(e, {
				at: o,
				mode: "highest"
			});
			if (!a && t) {
				let [, e] = t;
				o = e;
			} else {
				let t = {
					distance: n,
					unit: i
				}, a = r ? Ku(e, o, t) || qu(e, []) : Gu(e, o, t) || Uu(e, []);
				o = {
					anchor: o,
					focus: a
				}, s = !0;
			}
		}
		if (H.isPath(o)) {
			Bu(e, {
				at: o,
				voids: a
			});
			return;
		}
		if (U.isCollapsed(o)) return;
		s || (o = K.unhangRange(e, o, { voids: a }));
		let [c, l] = U.edges(o), u = ku(e, {
			at: c,
			match: (t) => Tu(e, t),
			voids: a
		}), d = ku(e, {
			at: l,
			match: (t) => Tu(e, t),
			voids: a
		}), f = u && d && !H.equals(u[1], d[1]), p = H.equals(c.path, l.path), m = a ? null : Ju(e, {
			at: c,
			mode: "highest"
		}), h = a ? null : Ju(e, {
			at: l,
			mode: "highest"
		});
		if (m) {
			let t = Ku(e, c);
			t && u && H.isAncestor(u[1], t.path) && (c = t);
		}
		if (h) {
			let t = Gu(e, l);
			t && d && H.isAncestor(d[1], t.path) && (l = t);
		}
		let g = [], _, v = ju(e, {
			at: o,
			voids: a
		});
		for (let t of v) {
			let [n, r] = t;
			_ && H.compare(r, _) === 0 || (!a && Yu(e, n) || !H.isCommon(r, c.path) && !H.isCommon(r, l.path)) && (g.push(t), _ = r);
		}
		let y = Array.from(g, ([, t]) => Su(e, t)), b = Cu(e, c), x = Cu(e, l);
		if (!p && !m) {
			let t = b.current, [n] = Wu(e, t), { path: r } = t, { offset: i } = c, a = n.text.slice(i);
			e.apply({
				offset: i,
				path: r,
				text: a,
				type: "remove_text"
			});
		}
		for (let t of y) Bu(e, {
			at: t.unref(),
			voids: a
		});
		if (!h) {
			let t = x.current, [n] = Wu(e, t), { path: r } = t, i = p ? c.offset : 0, a = n.text.slice(i, l.offset);
			e.apply({
				offset: i,
				path: r,
				text: a,
				type: "remove_text"
			});
		}
		!p && f && x.current && b.current && Hu(e, {
			at: x.current,
			hanging: !0,
			voids: a
		});
		let S = x.unref() || b.unref();
		t.at == null && S && Vu(e, S);
	});
}, Zu = (e, t) => K.edges(e, t), Qu = (e, t, n) => {
	if (!t) return "";
	try {
		return K.string(e, t, n);
	} catch {
		return "";
	}
}, $u = (e, t) => K.last(e, t), ed = (e) => K.marks(e), td = (e, t) => K.next(e, t), nd = (e, t, n) => {
	try {
		return K.node(e, t, n);
	} catch {}
}, rd = (e, t, n) => K.path(e, t, n), id = (e, t, n) => K.point(e, t, n), ad = (e, t, n) => !!t && K.isEnd(e, t, n), od = (e, t) => wu(t) && K.isInline(e, t), sd = (e, t, n) => !!t && K.isStart(e, t, n), cd = (e, t) => K.normalize(e, t), ld = (e, t) => K.removeMark(e, t), ud = (e, t, n) => G.common(e, t, n), dd = (e, t) => {
	try {
		for (let n = 0; n < t.length; n++) {
			let r = t[n];
			if (Iu(e) || !e.children[r]) return null;
			e = e.children[r];
		}
		return e;
	} catch {
		return null;
	}
}, fd = (e, t, n) => G.children(e, t, n), pd = (e, t) => G.descendants(e, t), md = (e, t) => G.leaf(e, t), hd = (e) => G.extractProps(e), gd = (e) => G.string(e), _d = (e, t) => G.texts(e, t), vd = (e, t) => G.nodes(e, t), yd = (e, t) => G.has(e, t), bd = (e) => W.isAncestor(e), xd = (e) => !!e && U.isCollapsed(e), Sd = (e) => !!e && U.isExpanded(e), Cd = (e, t) => {
	X.collapse(e, t);
}, wd = (e) => {
	X.deselect(e);
};
function Td(e) {
	return Array.isArray(e) ? e : [e];
}
var Ed = (e, { allow: t, exclude: n, filter: r, level: i, maxLevel: a } = {}) => {
	if (!e) return !1;
	let [o, s] = e;
	if (i && !Td(i).includes(s.length) || a && s.length > a || r && !r(e)) return !1;
	if (t) {
		let e = Td(t);
		if (e.length > 0 && !e.includes(o.type)) return !1;
	}
	if (n) {
		let e = Td(n);
		if (e.length > 0 && e.includes(o.type)) return !1;
	}
	return !0;
}, Dd = (e, t, n = {}) => {
	var r = n, { nextBlock: i, removeEmpty: a } = r, o = yu(r, ["nextBlock", "removeEmpty"]);
	kl(e, () => {
		if (a) {
			let t = ku(e, { at: o.at });
			if (t) {
				let n = a === !0 ? { allow: ["p"] } : a, { filter: r } = n;
				n.filter = ([t, n]) => gd(t) || t.children.some((t) => od(e, t)) ? !1 : !r || r([t, n]), Ed(t, n) && (ql(e, { at: t[1] }), i = !1);
			}
		}
		if (i) {
			let { at: t = e.selection } = o;
			if (t) {
				let n = ku(e, {
					at: Uu(e, t),
					block: !0
				});
				n && (o.at = H.next(n[1]));
			}
		}
		X.insertNodes(e, t, o);
	});
}, Od = (e, t) => X.liftNodes(e, t), kd = (e, t) => {
	X.move(e, t);
}, Ad = (e, t, n) => X.setNodes(e, t, n), jd = (e, t) => X.splitNodes(e, t), Md = (e, t, n) => X.unsetNodes(e, t, n), Nd = (e, t) => {
	X.unwrapNodes(e, Ou(e, t));
}, Pd = (e, t, n) => {
	Au(e, n?.at, n), X.wrapNodes(e, t, n);
}, Fd = (e, t = {}) => {
	try {
		let n = ju(e, _u({ at: e.selection || [] }, Ou(e, t)));
		for (let [e, t] of n) return [e, t];
	} catch {
		return;
	}
}, Id = (e, t) => !!Fd(e, t), Ld = (e, t, n) => Ad(e, t, n), Rd = Be, zd = Ve, Bd = He, Vd = Ue, Hd = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), Ud = (e, t) => !e || e.nodeName === t ? e : Ud(e.parentElement, t), Wd = /^(?:\w+:)?\/\/(\S+)$/, Gd = /mailto:([^?\\]+)/, Kd = /^localhost[\d:?]*(?:[^\d:?]\S*)?$/, qd = /^[^\s.]+\.\S{2,}$/, Jd = (e) => {
	if (typeof e != "string") return !1;
	let t = e.match(Wd), n = e.match(Gd), r = t || n;
	if (!r) return !1;
	let i = r[1];
	if (!i) return !1;
	try {
		new URL(e);
	} catch {
		return !1;
	}
	return Kd.test(i) || qd.test(i);
}, Yd = (e, { allowedSchemes: t, permitInvalid: n = !1 }) => {
	if (!e) return null;
	let r = null;
	try {
		r = new URL(e);
	} catch {
		return n ? e : null;
	}
	return t && !t.includes(r.protocol.slice(0, -1)) ? null : r.href;
}, Xd = (e) => e === void 0, Zd = (e) => e === null, Qd = (e) => Xd(e) || Zd(e), $d = (e) => !Qd(e), ef = Object.defineProperty, tf = Object.defineProperties, nf = Object.getOwnPropertyDescriptors, rf = Object.getOwnPropertySymbols, af = Object.prototype.hasOwnProperty, of = Object.prototype.propertyIsEnumerable, sf = (e, t, n) => t in e ? ef(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, cf = (e, t) => {
	for (var n in t ||= {}) af.call(t, n) && sf(e, n, t[n]);
	if (rf) for (var n of rf(t)) of.call(t, n) && sf(e, n, t[n]);
	return e;
}, lf = (e, t) => tf(e, nf(t)), uf = (e, t) => {
	var n = {};
	for (var r in e) af.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && rf) for (var r of rf(e)) t.indexOf(r) < 0 && of.call(e, r) && (n[r] = e[r]);
	return n;
}, df = (e, t) => {
	try {
		let { at: n = e.selection, match: r, reverse: i = !1, voids: a = !1 } = t;
		if (!n) return;
		let o, s;
		if (Cs.isSpan(n)) [o, s] = n;
		else if (U.isRange(n)) {
			let t = rd(e, n, { edge: "start" }), r = rd(e, n, { edge: "end" });
			o = i ? r : t, s = i ? t : r;
		}
		let c = [e, []];
		H.isPath(n) && (c = nd(e, n));
		let l = pd(c[0], {
			from: o,
			pass: ([t]) => !a && Yu(e, t),
			reverse: i,
			to: s
		});
		for (let [e, t] of l) if (Du(e, t, r)) return [e, n.concat(t)];
	} catch {
		return;
	}
}, ff = (e, t = {}) => ku(e, lf(cf({}, t), { block: !0 })), pf = (e) => {
	let [t, n] = e;
	if (bd(t)) {
		let { children: e } = t;
		return e.map((e, t) => [e, n.concat([t])]);
	}
	return [];
}, mf = (e, t = {}) => {
	var n = t, { at: r } = n, i = uf(n, ["at"]);
	let a = r ?? e.selection;
	if (!a) return null;
	let [o, s] = Zu(e, a ?? e.selection), c = ff(e, cf({ at: o }, i));
	if (!c) return null;
	let l = ff(e, cf({ at: s }, i));
	return l ? [c, l] : null;
}, hf = (e) => {
	let [t, n] = e;
	if (Iu(t) || t.children.length === 0) return null;
	let r = t.children;
	return [r.at(-1), n.concat([r.length - 1])];
}, gf = (e) => {
	let t = hf(e);
	return t ? t[1] : e[1].concat([-1]);
}, _f = (e, t) => {
	let n = gf(e);
	return H.equals(n, t);
}, vf = (e, t) => {
	if (!(t + 1) || !bd(e)) return e;
	let { children: n } = e;
	return vf(n.at(-1), t - 1);
}, yf = (e, t) => {
	let { children: n } = e, r = n.at(-1);
	if (!r) return;
	let [, i] = $u(e, []);
	return [vf(r, t - 1), i.slice(0, t + 1)];
}, bf = (e, t) => e ? ed(e)?.[t] : void 0, xf = (e, t) => {
	let n = td(e, { at: t });
	if (n) return qu(e, n[1]);
}, Sf = (e, t) => {
	let [n, r] = e, i = t[r.length], a = [], o = n.children;
	if (i + 1 < n.children.length) for (let e = i + 1; e < n.children.length; e++) a.push(o[e]);
	return a;
}, Cf = (e, t = {}) => {
	var n = t, { at: r } = n, i = uf(n, ["at"]);
	if (r ||= e.selection, !r) return;
	let [a, o] = U.edges(r), s = ff(e, cf({ at: a }, i)), c = ff(e, cf({ at: o }, i));
	if (!(!s && !c)) return !s || !c || !H.equals(s[1], c[1]);
}, wf = (e, t, n) => {
	if (!n || !n.match && !n.matchString) return Ku(e, t, n);
	let r = !n.unit || n.unit === "offset", i = n.matchString ? Bd(n.matchString) : [""], a = n.matchByRegex ?? !1, o;
	return i.some((i) => {
		let s = t, c = id(e, t, { edge: "end" }), l = i.length + 1, u = Array.from({ length: l }), d = 0;
		for (;;) {
			let f = Ku(e, s, n);
			if (!f || Cf(e, { at: {
				anchor: f,
				focus: c
			} })) return;
			let p = Qu(e, {
				anchor: f,
				focus: c
			}), m = p;
			if (r && l && (u.unshift({
				point: f,
				text: p
			}), u.pop(), m = Vd(u.slice(0, -1), "text").join("")), (a ? i.match(m) : m === i) || n.match?.call(n, {
				at: t,
				beforePoint: f,
				beforeString: m
			})) return n.afterMatch ? l && r ? (o = u.at(-1)?.point, !!o) : (o = c, !0) : (o = f, !0);
			if (c = f, s = f, d += 1, !n.skipInvalid && (!i || d >= i.length)) return;
		}
	}), o;
}, Tf = (e, { at: t = e.selection, focus: n } = {}) => {
	let r;
	return U.isRange(t) && (r = n ? t.focus : t.anchor), q.isPoint(t) && (r = t), H.isPath(t) && (r = {
		offset: 0,
		path: t
	}), r;
}, Ef = (e, t) => {
	let n = Nu(e, { at: t });
	if (n) return Uu(e, n[1]);
}, Df = (e) => {
	if (e.length === 0) return;
	let t = e.at(-1);
	if (!(t <= 0)) return e.slice(0, -1).concat(t - 1);
}, Of = (e, t, n) => {
	let r = wf(e, t, n);
	if (r) return {
		anchor: r,
		focus: id(e, t, { edge: "end" })
	};
}, kf = (e, t = {}) => {
	let n = ff(e, t)?.[1];
	if (!n) return;
	let r = qu(e, n), i = Tf(e, t);
	if (i) return {
		anchor: r,
		focus: i
	};
}, Af = (e, t) => !gd(t) && !t.children.some((t) => od(e, t)), jf = (e) => {
	let t = ff(e)?.[0];
	return t ? Af(e, t) : !1;
}, Mf = (e) => {
	if (!e.selection) return !1;
	let t = ff(e);
	if (!t) return !1;
	let n = e.selection.focus, r = Mu(e, e.selection);
	if (!r) return !1;
	let [, i] = r;
	if (!ad(e, n, i)) return !1;
	let a = Sf(t, n.path);
	if (a.length > 0) {
		for (let e of a) if (Iu(e) && e.text) return !1;
	} else return ad(e, n, t[1]);
	return !0;
}, Nf = (e) => e.at(-1) === 0, Pf = (e, t) => $d(bf(e, t)), Ff = (e, t = {}) => {
	var n = t, { at: r } = n, i = uf(n, ["at"]);
	if (r ||= e.selection, !r) return;
	let [a, o] = U.edges(r), s = ff(e, cf({ at: a }, i)), c = ff(e, cf({ at: o }, i));
	if (!(!s || !c)) return H.equals(s[1], c[1]);
}, If = (e, t) => {
	let n = ff(e, t)?.[1];
	return !!n && ad(e, e.selection?.focus, n);
}, Lf = (e, t) => {
	let { selection: n } = e;
	if (!n) return !1;
	let r = ff(e, t)?.[1];
	return r ? sd(e, n.focus, r) || Sd(e.selection) && sd(e, n.anchor, r) : !1;
}, Rf = (e, t, n) => {
	Dd(e, t, n);
}, zf = (e, t, n) => {
	Rf(e, {
		children: [{ text: "" }],
		type: t
	}, Ou(e, n));
}, Bf = (e, { at: t, fromStartIndex: n = 0, match: r, to: i }) => {
	let a = 0, o = H.isPath(t) ? t : t[1], s = H.isPath(t) ? dd(e, o) : t[0];
	if (!s || !Tu(e, s)) return a;
	for (let t = s.children.length - 1; t >= n; t--) {
		let n = [...o, t], s = dd(e, n);
		(!r || s && r([s, n])) && (zu(e, {
			at: n,
			to: i
		}), a++);
	}
	return a;
}, Vf = (e, t) => {
	var n = t, { at: r, key: i, shouldChange: a = !0 } = n, o = uf(n, [
		"at",
		"key",
		"shouldChange"
	]);
	let s = r ?? e.selection;
	if (i = Bd(i), s) {
		if (U.isRange(s) && U.isExpanded(s)) Md(e, i, cf({
			at: s,
			match: Iu,
			split: !0
		}, o));
		else if (e.selection) {
			let t = ed(e) ?? {};
			i.forEach((e) => {
				delete t[e];
			}), e.marks = t, a && e.onChange();
		}
	}
}, Hf = (e, t, n) => {
	Fu(e, () => {
		for (let [, r] of fd(e, t, { reverse: !0 })) Bu(e, lf(cf({}, n), { at: r }));
	});
}, Uf = (e, { at: t, insertOptions: n, nodes: r, removeOptions: i }) => {
	Fu(e, () => {
		Hf(e, t, i), Dd(e, r, lf(cf({}, n), { at: t.concat([0]) }));
	});
}, Wf = (e, { clear: t, key: n }) => {
	e.selection && Fu(e, () => {
		if (Pf(e, n)) {
			e.removeMark(n);
			return;
		}
		t && Vf(e, { key: Bd(t) }), e.addMark(n, !0);
	});
}, Gf = (e, t, n) => {
	let r = n?.at, i = dd(e, r);
	i?.children && Fu(e, () => {
		let a = r.concat([0]);
		Pd(e, t, lf(cf({}, n), { at: a })), !(i.children.length < 2) && Bf(e, {
			at: r,
			fromStartIndex: 1,
			to: a.concat([1])
		});
	});
}, Kf = We, qf = Ge, Jf = Ke;
//#endregion
//#region ../../../node_modules/@udecode/plate-core/node_modules/clsx/dist/clsx.m.js
function Yf(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = Yf(e[t])) && (r && (r += " "), r += n);
	else for (t in e) e[t] && (r && (r += " "), r += t);
	return r;
}
function Xf() {
	for (var e, t, n = 0, r = ""; n < arguments.length;) (e = arguments[n++]) && (t = Yf(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region \0callable-external:lodash/pick.js
var Zf = qe, Qf = /* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	for (var t = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
		alt: "altKey",
		control: "ctrlKey",
		meta: "metaKey",
		shift: "shiftKey"
	}, r = {
		add: "+",
		break: "pause",
		cmd: "meta",
		command: "meta",
		ctl: "control",
		ctrl: "control",
		del: "delete",
		down: "arrowdown",
		esc: "escape",
		ins: "insert",
		left: "arrowleft",
		mod: t ? "meta" : "control",
		opt: "alt",
		option: "alt",
		return: "enter",
		right: "arrowright",
		space: " ",
		spacebar: " ",
		up: "arrowup",
		win: "meta",
		windows: "meta"
	}, i = {
		backspace: 8,
		tab: 9,
		enter: 13,
		shift: 16,
		control: 17,
		alt: 18,
		pause: 19,
		capslock: 20,
		escape: 27,
		" ": 32,
		pageup: 33,
		pagedown: 34,
		end: 35,
		home: 36,
		arrowleft: 37,
		arrowup: 38,
		arrowright: 39,
		arrowdown: 40,
		insert: 45,
		delete: 46,
		meta: 91,
		numlock: 144,
		scrolllock: 145,
		";": 186,
		"=": 187,
		",": 188,
		"-": 189,
		".": 190,
		"/": 191,
		"`": 192,
		"[": 219,
		"\\": 220,
		"]": 221,
		"'": 222
	}, a = 1; a < 20; a++) i["f" + a] = 111 + a;
	function o(e, t, n) {
		t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
		var r = e.map(function(e) {
			return c(e, t);
		}), i = function(e) {
			return r.some(function(t) {
				return l(t, e);
			});
		};
		return n == null ? i : i(n);
	}
	function s(e, t) {
		return o(e, { byKey: !0 }, t);
	}
	function c(e, t) {
		var a = t && t.byKey, o = {};
		e = e.replace("++", "+add");
		var s = e.split("+"), c = s.length;
		for (var l in n) o[n[l]] = !1;
		var f = !0, p = !1, m = void 0;
		try {
			for (var h = s[Symbol.iterator](), g; !(f = (g = h.next()).done); f = !0) {
				var _ = g.value, v = _.endsWith("?") && _.length > 1;
				v && (_ = _.slice(0, -1));
				var y = d(_), b = n[y];
				if (_.length > 1 && !b && !r[_] && !i[y]) throw TypeError("Unknown modifier: \"" + _ + "\"");
				(c === 1 || !b) && (a ? o.key = y : o.which = u(_)), b && (o[b] = !v || null);
			}
		} catch (e) {
			p = !0, m = e;
		} finally {
			try {
				!f && h.return && h.return();
			} finally {
				if (p) throw m;
			}
		}
		return o;
	}
	function l(e, t) {
		for (var n in e) {
			var r = e[n], i = void 0;
			if (r != null && (i = n === "key" && t.key != null ? t.key.toLowerCase() : n === "which" ? r === 91 && t.which === 93 ? 91 : t.which : t[n], !(i == null && r === !1) && i !== r)) return !1;
		}
		return !0;
	}
	function u(e) {
		return e = d(e), i[e] || e.toUpperCase().charCodeAt(0);
	}
	function d(e) {
		return e = e.toLowerCase(), e = r[e] || e, e;
	}
	e.isHotkey = o, e.isKeyHotkey = s;
}));
//#endregion
//#region ../../../node_modules/slate-hyperscript/dist/index.es.js
function $f(e) {
	"@babel/helpers - typeof";
	return $f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
		return typeof e;
	} : function(e) {
		return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
	}, $f(e);
}
function ep(e, t) {
	if ($f(e) !== "object" || e === null) return e;
	var n = e[Symbol.toPrimitive];
	if (n !== void 0) {
		var r = n.call(e, t || "default");
		if ($f(r) !== "object") return r;
		throw TypeError("@@toPrimitive must return a primitive value.");
	}
	return (t === "string" ? String : Number)(e);
}
function tp(e) {
	var t = ep(e, "string");
	return $f(t) === "symbol" ? t : String(t);
}
function np(e, t, n) {
	return t = tp(t), t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
var rp = /* @__PURE__ */ new WeakMap(), ip = /* @__PURE__ */ new WeakMap(), ap = class {}, op = class extends ap {
	constructor() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		super(), np(this, "offset", void 0), np(this, "path", void 0);
		var { offset: t, path: n } = e;
		this.offset = t, this.path = n;
	}
}, sp = class extends ap {
	constructor() {
		var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
		super(), np(this, "offset", void 0), np(this, "path", void 0);
		var { offset: t, path: n } = e;
		this.offset = t, this.path = n;
	}
}, cp = (e, t) => {
	var n = e.text.length;
	rp.set(e, [n, t]);
}, lp = (e) => rp.get(e), up = (e, t) => {
	var n = e.text.length;
	ip.set(e, [n, t]);
}, dp = (e) => ip.get(e);
function fp(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function pp(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? fp(Object(n), !0).forEach(function(t) {
			np(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fp(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var mp = /* @__PURE__ */ new WeakSet(), hp = (e) => {
	var t = [], n = (e) => {
		if (e != null) {
			var r = t[t.length - 1];
			if (typeof e == "string") {
				var i = { text: e };
				mp.add(i), e = i;
			}
			if (J.isText(e)) {
				var a = e;
				J.isText(r) && mp.has(r) && mp.has(a) && J.equals(r, a, { loose: !0 }) ? r.text += a.text : t.push(a);
			} else if (W.isElement(e)) t.push(e);
			else if (e instanceof ap) {
				var o = t[t.length - 1];
				J.isText(o) || (n(""), o = t[t.length - 1]), e instanceof op ? cp(o, e) : e instanceof sp && up(o, e);
			} else throw Error(`Unexpected hyperscript child object: ${e}`);
		}
	};
	for (var r of e.flat(Infinity)) n(r);
	return t;
};
function gp(e, t, n) {
	return new op(t);
}
function _p(e, t, n) {
	return [new op(t), new sp(t)];
}
function vp(e, t, n) {
	return pp(pp({}, t), {}, { children: hp(n) });
}
function yp(e, t, n) {
	return new sp(t);
}
function bp(e, t, n) {
	return hp(n);
}
function xp(e, t, n) {
	var r = n.find((e) => e instanceof op), i = n.find((e) => e instanceof sp);
	if (!r || r.offset == null || r.path == null) throw Error("The <selection> hyperscript tag must have an <anchor> tag as a child with `path` and `offset` attributes defined.");
	if (!i || i.offset == null || i.path == null) throw Error("The <selection> hyperscript tag must have a <focus> tag as a child with `path` and `offset` attributes defined.");
	return pp({
		anchor: {
			offset: r.offset,
			path: r.path
		},
		focus: {
			offset: i.offset,
			path: i.path
		}
	}, t);
}
function Sp(e, t, n) {
	var r = hp(n);
	if (r.length > 1) throw Error("The <text> hyperscript tag must only contain a single node's worth of children.");
	var [i] = r;
	if (i ??= { text: "" }, !J.isText(i)) throw Error("\n    The <text> hyperscript tag can only contain text content as children.");
	return mp.delete(i), Object.assign(i, t), i;
}
var Cp = (e) => (t, n, r) => {
	var i = [], a;
	for (var o of r) U.isRange(o) ? a = o : i.push(o);
	var s = hp(i), c = {}, l = e();
	Object.assign(l, n), l.children = s;
	for (var [u, d] of G.texts(l)) {
		var f = lp(u), p = dp(u);
		if (f != null) {
			var [m] = f;
			c.anchor = {
				path: d,
				offset: m
			};
		}
		if (p != null) {
			var [h] = p;
			c.focus = {
				path: d,
				offset: h
			};
		}
	}
	if (c.anchor && !c.focus) throw Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<anchor />`. For collapsed selections, use `<cursor />` instead.");
	if (!c.anchor && c.focus) throw Error("Slate hyperscript ranges must have both `<anchor />` and `<focus />` defined if one is defined, but you only defined `<focus />`. For collapsed selections, use `<cursor />` instead.");
	return a == null ? U.isRange(c) && (l.selection = c) : l.selection = a, l;
};
function wp(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function Tp(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? wp(Object(n), !0).forEach(function(t) {
			np(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : wp(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var Ep = {
	anchor: gp,
	cursor: _p,
	editor: Cp(nu),
	element: vp,
	focus: yp,
	fragment: bp,
	selection: xp,
	text: Sp
}, Dp = function() {
	var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, { elements: t = {} } = e, n = kp(t);
	return Op(Tp(Tp(Tp({}, Ep), n), e.creators));
}, Op = (e) => function(t, n) {
	var r = [...arguments].slice(2), i = e[t];
	if (!i) throw Error(`No hyperscript creator found for tag: <${t}>`);
	return n ??= {}, Ua(n) || (r = [n].concat(r), n = {}), r = r.filter((e) => !!e).flat(), i(t, n, r);
}, kp = (e) => {
	var t = {}, n = function() {
		var n = e[r];
		if (typeof n != "object") throw Error(`Properties specified for a hyperscript shorthand should be an object, but for the custom element <${r}>  tag you passed: ${n}`);
		t[r] = (e, t, r) => vp("element", Tp(Tp({}, n), t), r);
	};
	for (var r in e) n();
	return t;
}, Ap = Dp(), jp = /* @__PURE__ */ r((/* @__PURE__ */ t(((e, t) => {
	t.exports = o;
	var n = "֑-߿יִ-﷽ﹰ-ﻼ", r = "A-Za-zÀ-ÖØ-öø-ʸ̀-֐ࠀ-῿‎Ⰰ-﬜︀-﹯﻽-￿", i = RegExp("^[^" + r + "]*[" + n + "]"), a = RegExp("^[^" + n + "]*[" + r + "]");
	function o(e) {
		return e = String(e || ""), i.test(e) ? "rtl" : a.test(e) ? "ltr" : "neutral";
	}
})))()), Mp = Je, Np = Ye;
//#endregion
//#region ../../../node_modules/compute-scroll-into-view/dist/index.mjs
function Pp(e) {
	return typeof e == "object" && !!e && e.nodeType === 1;
}
function Fp(e, t) {
	return (!t || e !== "hidden") && e !== "visible" && e !== "clip";
}
function Ip(e, t) {
	if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
		var n = getComputedStyle(e, null);
		return Fp(n.overflowY, t) || Fp(n.overflowX, t) || function(e) {
			var t = function(e) {
				if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
				try {
					return e.ownerDocument.defaultView.frameElement;
				} catch {
					return null;
				}
			}(e);
			return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
		}(e);
	}
	return !1;
}
function Lp(e, t, n, r, i, a, o, s) {
	return a < e && o > t || a > e && o < t ? 0 : a <= e && s <= n || o >= t && s >= n ? a - e - r : o > t && s < n || a < e && s > n ? o - t + i : 0;
}
var Rp = function(e, t) {
	var n = window, r = t.scrollMode, i = t.block, a = t.inline, o = t.boundary, s = t.skipOverflowHiddenElements, c = typeof o == "function" ? o : function(e) {
		return e !== o;
	};
	if (!Pp(e)) throw TypeError("Invalid target");
	for (var l, u = document.scrollingElement || document.documentElement, d = [], f = e; Pp(f) && c(f);) {
		if ((f = (l = f).parentElement ?? (l.getRootNode().host || null)) === u) {
			d.push(f);
			break;
		}
		f != null && f === document.body && Ip(f) && !Ip(document.documentElement) || f != null && Ip(f, s) && d.push(f);
	}
	for (var p = n.visualViewport ? n.visualViewport.width : innerWidth, m = n.visualViewport ? n.visualViewport.height : innerHeight, h = window.scrollX || pageXOffset, g = window.scrollY || pageYOffset, _ = e.getBoundingClientRect(), v = _.height, y = _.width, b = _.top, x = _.right, S = _.bottom, C = _.left, w = i === "start" || i === "nearest" ? b : i === "end" ? S : b + v / 2, T = a === "center" ? C + y / 2 : a === "end" ? x : C, E = [], ee = 0; ee < d.length; ee++) {
		var D = d[ee], te = D.getBoundingClientRect(), ne = te.height, O = te.width, re = te.top, ie = te.right, k = te.bottom, ae = te.left;
		if (r === "if-needed" && b >= 0 && C >= 0 && S <= m && x <= p && b >= re && S <= k && C >= ae && x <= ie) return E;
		var oe = getComputedStyle(D), se = parseInt(oe.borderLeftWidth, 10), A = parseInt(oe.borderTopWidth, 10), j = parseInt(oe.borderRightWidth, 10), ce = parseInt(oe.borderBottomWidth, 10), M = 0, N = 0, le = "offsetWidth" in D ? D.offsetWidth - D.clientWidth - se - j : 0, ue = "offsetHeight" in D ? D.offsetHeight - D.clientHeight - A - ce : 0, de = "offsetWidth" in D ? D.offsetWidth === 0 ? 0 : O / D.offsetWidth : 0, fe = "offsetHeight" in D ? D.offsetHeight === 0 ? 0 : ne / D.offsetHeight : 0;
		if (u === D) M = i === "start" ? w : i === "end" ? w - m : i === "nearest" ? Lp(g, g + m, m, A, ce, g + w, g + w + v, v) : w - m / 2, N = a === "start" ? T : a === "center" ? T - p / 2 : a === "end" ? T - p : Lp(h, h + p, p, se, j, h + T, h + T + y, y), M = Math.max(0, M + g), N = Math.max(0, N + h);
		else {
			M = i === "start" ? w - re - A : i === "end" ? w - k + ce + ue : i === "nearest" ? Lp(re, k, ne, A, ce + ue, w, w + v, v) : w - (re + ne / 2) + ue / 2, N = a === "start" ? T - ae - se : a === "center" ? T - (ae + O / 2) + le / 2 : a === "end" ? T - ie + j + le : Lp(ae, ie, O, se, j + le, T, T + y, y);
			var pe = D.scrollLeft, me = D.scrollTop;
			w += me - (M = Math.max(0, Math.min(me + M / fe, D.scrollHeight - ne / fe + ue))), T += pe - (N = Math.max(0, Math.min(pe + N / de, D.scrollWidth - O / de + le)));
		}
		E.push({
			el: D,
			top: M,
			left: N
		});
	}
	return E;
};
//#endregion
//#region ../../../node_modules/slate-react/node_modules/scroll-into-view-if-needed/es/index.js
function zp(e) {
	return e === Object(e) && Object.keys(e).length !== 0;
}
function Bp(e, t) {
	t === void 0 && (t = "auto");
	var n = "scrollBehavior" in document.body.style;
	e.forEach(function(e) {
		var r = e.el, i = e.top, a = e.left;
		r.scroll && n ? r.scroll({
			top: i,
			left: a,
			behavior: t
		}) : (r.scrollTop = i, r.scrollLeft = a);
	});
}
function Vp(e) {
	return e === !1 ? {
		block: "end",
		inline: "nearest"
	} : zp(e) ? e : {
		block: "start",
		inline: "nearest"
	};
}
function Hp(e, t) {
	var n = e.isConnected || e.ownerDocument.documentElement.contains(e);
	if (zp(t) && typeof t.behavior == "function") return t.behavior(n ? Rp(e, t) : []);
	if (n) {
		var r = Vp(t);
		return Bp(Rp(e, r), r.behavior);
	}
}
//#endregion
//#region ../../../node_modules/@juggle/resize-observer/lib/utils/resizeObservers.js
var Up = [], Wp = function() {
	return Up.some(function(e) {
		return e.activeTargets.length > 0;
	});
}, Gp = function() {
	return Up.some(function(e) {
		return e.skippedTargets.length > 0;
	});
}, Kp = "ResizeObserver loop completed with undelivered notifications.", qp = function() {
	var e;
	typeof ErrorEvent == "function" ? e = new ErrorEvent("error", { message: Kp }) : (e = document.createEvent("Event"), e.initEvent("error", !1, !1), e.message = Kp), window.dispatchEvent(e);
}, Jp;
(function(e) {
	e.BORDER_BOX = "border-box", e.CONTENT_BOX = "content-box", e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(Jp ||= {});
//#endregion
//#region ../../../node_modules/@juggle/resize-observer/lib/utils/freeze.js
var Yp = function(e) {
	return Object.freeze(e);
}, Xp = function() {
	function e(e, t) {
		this.inlineSize = e, this.blockSize = t, Yp(this);
	}
	return e;
}(), Zp = function() {
	function e(e, t, n, r) {
		return this.x = e, this.y = t, this.width = n, this.height = r, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Yp(this);
	}
	return e.prototype.toJSON = function() {
		var e = this;
		return {
			x: e.x,
			y: e.y,
			top: e.top,
			right: e.right,
			bottom: e.bottom,
			left: e.left,
			width: e.width,
			height: e.height
		};
	}, e.fromRect = function(t) {
		return new e(t.x, t.y, t.width, t.height);
	}, e;
}(), Qp = function(e) {
	return e instanceof SVGElement && "getBBox" in e;
}, $p = function(e) {
	if (Qp(e)) {
		var t = e.getBBox(), n = t.width, r = t.height;
		return !n && !r;
	}
	var i = e, a = i.offsetWidth, o = i.offsetHeight;
	return !(a || o || e.getClientRects().length);
}, em = function(e) {
	if (e instanceof Element) return !0;
	var t = e?.ownerDocument?.defaultView;
	return !!(t && e instanceof t.Element);
}, tm = function(e) {
	switch (e.tagName) {
		case "INPUT": if (e.type !== "image") break;
		case "VIDEO":
		case "AUDIO":
		case "EMBED":
		case "OBJECT":
		case "CANVAS":
		case "IFRAME":
		case "IMG": return !0;
	}
	return !1;
}, nm = typeof window < "u" ? window : {}, rm = /* @__PURE__ */ new WeakMap(), im = /auto|scroll/, am = /^tb|vertical/, om = /msie|trident/i.test(nm.navigator && nm.navigator.userAgent), sm = function(e) {
	return parseFloat(e || "0");
}, cm = function(e, t, n) {
	return e === void 0 && (e = 0), t === void 0 && (t = 0), n === void 0 && (n = !1), new Xp((n ? t : e) || 0, (n ? e : t) || 0);
}, lm = Yp({
	devicePixelContentBoxSize: cm(),
	borderBoxSize: cm(),
	contentBoxSize: cm(),
	contentRect: new Zp(0, 0, 0, 0)
}), um = function(e, t) {
	if (t === void 0 && (t = !1), rm.has(e) && !t) return rm.get(e);
	if ($p(e)) return rm.set(e, lm), lm;
	var n = getComputedStyle(e), r = Qp(e) && e.ownerSVGElement && e.getBBox(), i = !om && n.boxSizing === "border-box", a = am.test(n.writingMode || ""), o = !r && im.test(n.overflowY || ""), s = !r && im.test(n.overflowX || ""), c = r ? 0 : sm(n.paddingTop), l = r ? 0 : sm(n.paddingRight), u = r ? 0 : sm(n.paddingBottom), d = r ? 0 : sm(n.paddingLeft), f = r ? 0 : sm(n.borderTopWidth), p = r ? 0 : sm(n.borderRightWidth), m = r ? 0 : sm(n.borderBottomWidth), h = r ? 0 : sm(n.borderLeftWidth), g = d + l, _ = c + u, v = h + p, y = f + m, b = s ? e.offsetHeight - y - e.clientHeight : 0, x = o ? e.offsetWidth - v - e.clientWidth : 0, S = i ? g + v : 0, C = i ? _ + y : 0, w = r ? r.width : sm(n.width) - S - x, T = r ? r.height : sm(n.height) - C - b, E = w + g + x + v, ee = T + _ + b + y, D = Yp({
		devicePixelContentBoxSize: cm(Math.round(w * devicePixelRatio), Math.round(T * devicePixelRatio), a),
		borderBoxSize: cm(E, ee, a),
		contentBoxSize: cm(w, T, a),
		contentRect: new Zp(d, c, w, T)
	});
	return rm.set(e, D), D;
}, dm = function(e, t, n) {
	var r = um(e, n), i = r.borderBoxSize, a = r.contentBoxSize, o = r.devicePixelContentBoxSize;
	switch (t) {
		case Jp.DEVICE_PIXEL_CONTENT_BOX: return o;
		case Jp.BORDER_BOX: return i;
		default: return a;
	}
}, fm = function() {
	function e(e) {
		var t = um(e);
		this.target = e, this.contentRect = t.contentRect, this.borderBoxSize = Yp([t.borderBoxSize]), this.contentBoxSize = Yp([t.contentBoxSize]), this.devicePixelContentBoxSize = Yp([t.devicePixelContentBoxSize]);
	}
	return e;
}(), pm = function(e) {
	if ($p(e)) return Infinity;
	for (var t = 0, n = e.parentNode; n;) t += 1, n = n.parentNode;
	return t;
}, mm = function() {
	var e = Infinity, t = [];
	Up.forEach(function(n) {
		if (n.activeTargets.length !== 0) {
			var r = [];
			n.activeTargets.forEach(function(t) {
				var n = new fm(t.target), i = pm(t.target);
				r.push(n), t.lastReportedSize = dm(t.target, t.observedBox), i < e && (e = i);
			}), t.push(function() {
				n.callback.call(n.observer, r, n.observer);
			}), n.activeTargets.splice(0, n.activeTargets.length);
		}
	});
	for (var n = 0, r = t; n < r.length; n++) {
		var i = r[n];
		i();
	}
	return e;
}, hm = function(e) {
	Up.forEach(function(t) {
		t.activeTargets.splice(0, t.activeTargets.length), t.skippedTargets.splice(0, t.skippedTargets.length), t.observationTargets.forEach(function(n) {
			n.isActive() && (pm(n.target) > e ? t.activeTargets.push(n) : t.skippedTargets.push(n));
		});
	});
}, gm = function() {
	var e = 0;
	for (hm(e); Wp();) e = mm(), hm(e);
	return Gp() && qp(), e > 0;
}, _m, vm = [], ym = function() {
	return vm.splice(0).forEach(function(e) {
		return e();
	});
}, bm = function(e) {
	if (!_m) {
		var t = 0, n = document.createTextNode("");
		new MutationObserver(function() {
			return ym();
		}).observe(n, { characterData: !0 }), _m = function() {
			n.textContent = `${t ? t-- : t++}`;
		};
	}
	vm.push(e), _m();
}, xm = function(e) {
	bm(function() {
		requestAnimationFrame(e);
	});
}, Sm = 0, Cm = function() {
	return !!Sm;
}, wm = 250, Tm = {
	attributes: !0,
	characterData: !0,
	childList: !0,
	subtree: !0
}, Em = [
	"resize",
	"load",
	"transitionend",
	"animationend",
	"animationstart",
	"animationiteration",
	"keyup",
	"keydown",
	"mouseup",
	"mousedown",
	"mouseover",
	"mouseout",
	"blur",
	"focus"
], Dm = function(e) {
	return e === void 0 && (e = 0), Date.now() + e;
}, Om = !1, km = new (function() {
	function e() {
		var e = this;
		this.stopped = !0, this.listener = function() {
			return e.schedule();
		};
	}
	return e.prototype.run = function(e) {
		var t = this;
		if (e === void 0 && (e = wm), !Om) {
			Om = !0;
			var n = Dm(e);
			xm(function() {
				var r = !1;
				try {
					r = gm();
				} finally {
					if (Om = !1, e = n - Dm(), !Cm()) return;
					r ? t.run(1e3) : e > 0 ? t.run(e) : t.start();
				}
			});
		}
	}, e.prototype.schedule = function() {
		this.stop(), this.run();
	}, e.prototype.observe = function() {
		var e = this, t = function() {
			return e.observer && e.observer.observe(document.body, Tm);
		};
		document.body ? t() : nm.addEventListener("DOMContentLoaded", t);
	}, e.prototype.start = function() {
		var e = this;
		this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), Em.forEach(function(t) {
			return nm.addEventListener(t, e.listener, !0);
		}));
	}, e.prototype.stop = function() {
		var e = this;
		this.stopped ||= (this.observer && this.observer.disconnect(), Em.forEach(function(t) {
			return nm.removeEventListener(t, e.listener, !0);
		}), !0);
	}, e;
}())(), Am = function(e) {
	!Sm && e > 0 && km.start(), Sm += e, !Sm && km.stop();
}, jm = function(e) {
	return !Qp(e) && !tm(e) && getComputedStyle(e).display === "inline";
}, Mm = function() {
	function e(e, t) {
		this.target = e, this.observedBox = t || Jp.CONTENT_BOX, this.lastReportedSize = {
			inlineSize: 0,
			blockSize: 0
		};
	}
	return e.prototype.isActive = function() {
		var e = dm(this.target, this.observedBox, !0);
		return jm(this.target) && (this.lastReportedSize = e), this.lastReportedSize.inlineSize !== e.inlineSize || this.lastReportedSize.blockSize !== e.blockSize;
	}, e;
}(), Nm = function() {
	function e(e, t) {
		this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = e, this.callback = t;
	}
	return e;
}(), Pm = /* @__PURE__ */ new WeakMap(), Fm = function(e, t) {
	for (var n = 0; n < e.length; n += 1) if (e[n].target === t) return n;
	return -1;
}, Im = function() {
	function e() {}
	return e.connect = function(e, t) {
		var n = new Nm(e, t);
		Pm.set(e, n);
	}, e.observe = function(e, t, n) {
		var r = Pm.get(e), i = r.observationTargets.length === 0;
		Fm(r.observationTargets, t) < 0 && (i && Up.push(r), r.observationTargets.push(new Mm(t, n && n.box)), Am(1), km.schedule());
	}, e.unobserve = function(e, t) {
		var n = Pm.get(e), r = Fm(n.observationTargets, t), i = n.observationTargets.length === 1;
		r >= 0 && (i && Up.splice(Up.indexOf(n), 1), n.observationTargets.splice(r, 1), Am(-1));
	}, e.disconnect = function(e) {
		var t = this, n = Pm.get(e);
		n.observationTargets.slice().forEach(function(n) {
			return t.unobserve(e, n.target);
		}), n.activeTargets.splice(0, n.activeTargets.length);
	}, e;
}(), Lm = function() {
	function e(e) {
		if (arguments.length === 0) throw TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
		if (typeof e != "function") throw TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
		Im.connect(this, e);
	}
	return e.prototype.observe = function(e, t) {
		if (arguments.length === 0) throw TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
		if (!em(e)) throw TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
		Im.observe(this, e, t);
	}, e.prototype.unobserve = function(e) {
		if (arguments.length === 0) throw TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
		if (!em(e)) throw TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
		Im.unobserve(this, e);
	}, e.prototype.disconnect = function() {
		Im.disconnect(this);
	}, e.toString = function() {
		return "function ResizeObserver () { [polyfill code] }";
	}, e;
}(), Rm = (/* @__PURE__ */ t(((e) => {
	Object.defineProperty(e, "__esModule", { value: !0 });
	for (var t = typeof window < "u" && /Mac|iPod|iPhone|iPad/.test(window.navigator.platform), n = {
		alt: "altKey",
		control: "ctrlKey",
		meta: "metaKey",
		shift: "shiftKey"
	}, r = {
		add: "+",
		break: "pause",
		cmd: "meta",
		command: "meta",
		ctl: "control",
		ctrl: "control",
		del: "delete",
		down: "arrowdown",
		esc: "escape",
		ins: "insert",
		left: "arrowleft",
		mod: t ? "meta" : "control",
		opt: "alt",
		option: "alt",
		return: "enter",
		right: "arrowright",
		space: " ",
		spacebar: " ",
		up: "arrowup",
		win: "meta",
		windows: "meta"
	}, i = {
		backspace: 8,
		tab: 9,
		enter: 13,
		shift: 16,
		control: 17,
		alt: 18,
		pause: 19,
		capslock: 20,
		escape: 27,
		" ": 32,
		pageup: 33,
		pagedown: 34,
		end: 35,
		home: 36,
		arrowleft: 37,
		arrowup: 38,
		arrowright: 39,
		arrowdown: 40,
		insert: 45,
		delete: 46,
		meta: 91,
		numlock: 144,
		scrolllock: 145,
		";": 186,
		"=": 187,
		",": 188,
		"-": 189,
		".": 190,
		"/": 191,
		"`": 192,
		"[": 219,
		"\\": 220,
		"]": 221,
		"'": 222
	}, a = 1; a < 20; a++) i["f" + a] = 111 + a;
	function o(e, t, n) {
		t && !("byKey" in t) && (n = t, t = null), Array.isArray(e) || (e = [e]);
		var r = e.map(function(e) {
			return s(e, t);
		}), i = function(e) {
			return r.some(function(t) {
				return c(t, e);
			});
		};
		return n == null ? i : i(n);
	}
	function s(e, t) {
		var r = t && t.byKey, i = {};
		e = e.replace("++", "+add");
		var a = e.split("+"), o = a.length;
		for (var s in n) i[n[s]] = !1;
		var c = !0, d = !1, f = void 0;
		try {
			for (var p = a[Symbol.iterator](), m; !(c = (m = p.next()).done); c = !0) {
				var h = m.value, g = h.endsWith("?") && h.length > 1;
				g && (h = h.slice(0, -1));
				var _ = u(h), v = n[_];
				(o === 1 || !v) && (r ? i.key = _ : i.which = l(h)), v && (i[v] = !g || null);
			}
		} catch (e) {
			d = !0, f = e;
		} finally {
			try {
				!c && p.return && p.return();
			} finally {
				if (d) throw f;
			}
		}
		return i;
	}
	function c(e, t) {
		for (var n in e) {
			var r = e[n], i = void 0;
			if (r != null && (i = n === "key" && t.key != null ? t.key.toLowerCase() : n === "which" ? r === 91 && t.which === 93 ? 91 : t.which : t[n], !(i == null && r === !1) && i !== r)) return !1;
		}
		return !0;
	}
	function l(e) {
		return e = u(e), i[e] || e.toUpperCase().charCodeAt(0);
	}
	function u(e) {
		return e = e.toLowerCase(), e = r[e] || e, e;
	}
	e.isHotkey = o;
})))();
function zm(e, t, n) {
	return t in e ? Object.defineProperty(e, t, {
		value: n,
		enumerable: !0,
		configurable: !0,
		writable: !0
	}) : e[t] = n, e;
}
function Bm(e, t) {
	if (e == null) return {};
	var n = {}, r = Object.keys(e), i, a;
	for (a = 0; a < r.length; a++) i = r[a], !(t.indexOf(i) >= 0) && (n[i] = e[i]);
	return n;
}
function Vm(e, t) {
	if (e == null) return {};
	var n = Bm(e, t), r, i;
	if (Object.getOwnPropertySymbols) {
		var a = Object.getOwnPropertySymbols(e);
		for (i = 0; i < a.length; i++) r = a[i], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
	}
	return n;
}
var Hm = /*#__PURE__*/ ue(null), Um = () => {
	var e = he(Hm);
	if (!e) throw Error("The `useSlateStatic` hook must be used inside the <Slate> component's context.");
	return e;
}, Wm = parseInt(N.version.split(".")[0], 10), Gm = typeof navigator < "u" && typeof window < "u" && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, Km = typeof navigator < "u" && /Mac OS X/.test(navigator.userAgent), qm = typeof navigator < "u" && /Android/.test(navigator.userAgent), Jm = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), Ym = typeof navigator < "u" && /AppleWebKit(?!.*Chrome)/i.test(navigator.userAgent), Xm = typeof navigator < "u" && /Edge?\/(?:[0-6][0-9]|[0-7][0-8])(?:\.)/i.test(navigator.userAgent), Zm = typeof navigator < "u" && /Chrome/i.test(navigator.userAgent), Qm = typeof navigator < "u" && /Chrome?\/(?:[0-7][0-5]|[0-6][0-9])(?:\.)/i.test(navigator.userAgent), $m = qm && typeof navigator < "u" && /Chrome?\/(?:[0-5]?\d)(?:\.)/i.test(navigator.userAgent), eh = typeof navigator < "u" && /^(?!.*Seamonkey)(?=.*Firefox\/(?:[0-7][0-9]|[0-8][0-6])(?:\.)).*/i.test(navigator.userAgent), th = typeof navigator < "u" && /.*UCBrowser/.test(navigator.userAgent), nh = typeof navigator < "u" && /.*Wechat/.test(navigator.userAgent) && !/.*MacWechat/.test(navigator.userAgent), rh = typeof window < "u" && window.document !== void 0 && window.document.createElement !== void 0, ih = (!Qm || !$m) && !Xm && typeof globalThis < "u" && globalThis.InputEvent && typeof globalThis.InputEvent.prototype.getTargetRanges == "function", ah = /* @__PURE__ */ new WeakMap(), oh = /* @__PURE__ */ new WeakMap(), sh = /* @__PURE__ */ new WeakMap(), ch = /* @__PURE__ */ new WeakMap(), lh = /* @__PURE__ */ new WeakMap(), uh = /* @__PURE__ */ new WeakMap(), dh = /* @__PURE__ */ new WeakMap(), fh = /* @__PURE__ */ new WeakMap(), ph = /* @__PURE__ */ new WeakMap(), mh = /* @__PURE__ */ new WeakMap(), hh = /* @__PURE__ */ new WeakMap(), gh = /* @__PURE__ */ new WeakMap(), _h = /* @__PURE__ */ new WeakMap(), vh = /* @__PURE__ */ new WeakMap(), yh = /* @__PURE__ */ new WeakMap(), bh = /* @__PURE__ */ new WeakMap(), xh = /* @__PURE__ */ new WeakMap(), Sh = /* @__PURE__ */ new WeakMap(), Ch = /* @__PURE__ */ new WeakMap(), wh = /* @__PURE__ */ new WeakMap(), Th = /* @__PURE__ */ new WeakMap(), Eh = Symbol("placeholder"), Dh = Symbol("mark-placeholder"), Oh = globalThis.Text, kh = (e) => e && e.ownerDocument && e.ownerDocument.defaultView || null, Ah = (e) => Mh(e) && e.nodeType === 8, jh = (e) => Mh(e) && e.nodeType === 1, Mh = (e) => {
	var t = kh(e);
	return !!t && e instanceof t.Node;
}, Nh = (e) => {
	var t = e && e.anchorNode && kh(e.anchorNode);
	return !!t && e instanceof t.Selection;
}, Ph = (e) => Mh(e) && e.nodeType === 3, Fh = (e) => e.clipboardData && e.clipboardData.getData("text/plain") !== "" && e.clipboardData.types.length === 1, Ih = (e) => {
	var [t, n] = e;
	if (jh(t) && t.childNodes.length) {
		var r = n === t.childNodes.length, i = r ? n - 1 : n;
		for ([t, i] = Rh(t, i, r ? "backward" : "forward"), r = i < n; jh(t) && t.childNodes.length;) {
			var a = r ? t.childNodes.length - 1 : 0;
			t = zh(t, a, r ? "backward" : "forward");
		}
		n = r && t.textContent != null ? t.textContent.length : 0;
	}
	return [t, n];
}, Lh = (e) => {
	for (var t = e && e.parentNode; t;) {
		if (t.toString() === "[object ShadowRoot]") return !0;
		t = t.parentNode;
	}
	return !1;
}, Rh = (e, t, n) => {
	for (var { childNodes: r } = e, i = r[t], a = t, o = !1, s = !1; (Ah(i) || jh(i) && i.childNodes.length === 0 || jh(i) && i.getAttribute("contenteditable") === "false") && !(o && s);) {
		if (a >= r.length) {
			o = !0, a = t - 1, n = "backward";
			continue;
		}
		if (a < 0) {
			s = !0, a = t + 1, n = "forward";
			continue;
		}
		i = r[a], t = a, a += n === "forward" ? 1 : -1;
	}
	return [i, t];
}, zh = (e, t, n) => {
	var [r] = Rh(e, t, n);
	return r;
}, Bh = (e) => {
	var t = "";
	if (Ph(e) && e.nodeValue) return e.nodeValue;
	if (jh(e)) {
		for (var n of Array.from(e.childNodes)) t += Bh(n);
		var r = getComputedStyle(e).getPropertyValue("display");
		(r === "block" || r === "list" || e.tagName === "BR") && (t += "\n");
	}
	return t;
}, Vh = /data-slate-fragment="(.+?)"/m, Hh = (e) => {
	var [, t] = e.getData("text/html").match(Vh) || [];
	return t;
}, Uh = (e, t, n) => {
	var { target: r } = t;
	if (jh(r) && r.matches("[contentEditable=\"false\"]")) return !1;
	var { document: i } = Z.getWindow(e);
	if (i.contains(r)) return Z.hasDOMNode(e, r, { editable: !0 });
	var a = n.find((e) => {
		var { addedNodes: t, removedNodes: n } = e;
		for (var i of t) if (i === r || i.contains(r)) return !0;
		for (var a of n) if (a === r || a.contains(r)) return !0;
	});
	return !a || a === t ? !1 : Uh(e, a, n);
}, Wh = 0, Gh = class {
	constructor() {
		this.id = `${Wh++}`;
	}
}, Z = {
	androidPendingDiffs: (e) => Sh.get(e),
	androidScheduleFlush: (e) => {
		var t;
		(t = yh.get(e)) == null || t();
	},
	blur: (e) => {
		var t = Z.toDOMNode(e, e), n = Z.findDocumentOrShadowRoot(e);
		hh.set(e, !1), n.activeElement === t && t.blur();
	},
	deselect: (e) => {
		var { selection: t } = e, n = Z.findDocumentOrShadowRoot(e).getSelection();
		n && n.rangeCount > 0 && n.removeAllRanges(), t && X.deselect(e);
	},
	findDocumentOrShadowRoot: (e) => {
		var t = Z.toDOMNode(e, e), n = t.getRootNode();
		return (n instanceof Document || n instanceof ShadowRoot) && n.getSelection != null ? n : t.ownerDocument;
	},
	findEventRange: (e, t) => {
		"nativeEvent" in t && (t = t.nativeEvent);
		var { clientX: n, clientY: r, target: i } = t;
		if (n == null || r == null) throw Error(`Cannot resolve a Slate range from a DOM event: ${t}`);
		var a = Z.toSlateNode(e, t.target), o = Z.findPath(e, a);
		if (W.isElement(a) && K.isVoid(e, a)) {
			var s = i.getBoundingClientRect(), c = e.isInline(a) ? n - s.left < s.left + s.width - n : r - s.top < s.top + s.height - r, l = K.point(e, o, { edge: c ? "start" : "end" }), u = c ? K.before(e, l) : K.after(e, l);
			if (u) return K.range(e, u);
		}
		var d, { document: f } = Z.getWindow(e);
		if (f.caretRangeFromPoint) d = f.caretRangeFromPoint(n, r);
		else {
			var p = f.caretPositionFromPoint(n, r);
			p && (d = f.createRange(), d.setStart(p.offsetNode, p.offset), d.setEnd(p.offsetNode, p.offset));
		}
		if (!d) throw Error(`Cannot resolve a Slate range from a DOM event: ${t}`);
		return Z.toSlateRange(e, d, {
			exactMatch: !1,
			suppressThrow: !1
		});
	},
	findKey: (e, t) => {
		var n = fh.get(t);
		return n || (n = new Gh(), fh.set(t, n)), n;
	},
	findPath: (e, t) => {
		for (var n = [], r = t;;) {
			var i = oh.get(r);
			if (i == null) {
				if (K.isEditor(r)) return n;
				break;
			}
			var a = ah.get(r);
			if (a == null) break;
			n.unshift(a), r = i;
		}
		throw Error(`Unable to find the path for Slate node: ${Ds.stringify(t)}`);
	},
	focus: (e) => {
		var t = Z.toDOMNode(e, e), n = Z.findDocumentOrShadowRoot(e);
		if (hh.set(e, !0), n.activeElement !== t) {
			if (e.selection && n instanceof Document) {
				var r = n.getSelection(), i = Z.toDOMRange(e, e.selection);
				r?.removeAllRanges(), r?.addRange(i);
			}
			t.focus({ preventScroll: !0 });
		}
	},
	getWindow: (e) => {
		var t = sh.get(e);
		if (!t) throw Error("Unable to find a host window element for this editor");
		return t;
	},
	hasDOMNode: function(e, t) {
		var { editable: n = !1 } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = Z.toDOMNode(e, e), i;
		try {
			i = jh(t) ? t : t.parentElement;
		} catch (e) {
			if (!e.message.includes("Permission denied to access property \"nodeType\"")) throw e;
		}
		return i ? i.closest("[data-slate-editor]") === r && (!n || i.isContentEditable ? !0 : typeof i.isContentEditable == "boolean" && i.closest("[contenteditable=\"false\"]") === r || !!i.getAttribute("data-slate-zero-width")) : !1;
	},
	hasEditableTarget: (e, t) => Mh(t) && Z.hasDOMNode(e, t, { editable: !0 }),
	hasRange: (e, t) => {
		var { anchor: n, focus: r } = t;
		return K.hasPath(e, n.path) && K.hasPath(e, r.path);
	},
	hasSelectableTarget: (e, t) => Z.hasEditableTarget(e, t) || Z.isTargetInsideNonReadonlyVoid(e, t),
	hasTarget: (e, t) => Mh(t) && Z.hasDOMNode(e, t),
	insertData: (e, t) => {
		e.insertData(t);
	},
	insertFragmentData: (e, t) => e.insertFragmentData(t),
	insertTextData: (e, t) => e.insertTextData(t),
	isComposing: (e) => !!gh.get(e),
	isFocused: (e) => !!hh.get(e),
	isReadOnly: (e) => !!mh.get(e),
	isTargetInsideNonReadonlyVoid: (e, t) => {
		if (mh.get(e)) return !1;
		var n = Z.hasTarget(e, t) && Z.toSlateNode(e, t);
		return W.isElement(n) && K.isVoid(e, n);
	},
	setFragmentData: (e, t, n) => e.setFragmentData(t, n),
	toDOMNode: (e, t) => {
		var n = ph.get(e), r = K.isEditor(t) ? ch.get(e) : n?.get(Z.findKey(e, t));
		if (!r) throw Error(`Cannot resolve a DOM node from Slate node: ${Ds.stringify(t)}`);
		return r;
	},
	toDOMPoint: (e, t) => {
		var [n] = K.node(e, t.path), r = Z.toDOMNode(e, n), i;
		K.void(e, { at: t }) && (t = {
			path: t.path,
			offset: 0
		});
		for (var a = Array.from(r.querySelectorAll("[data-slate-string], [data-slate-zero-width]")), o = 0, s = 0; s < a.length; s++) {
			var c = a[s], l = c.childNodes[0];
			if (!(l == null || l.textContent == null)) {
				var { length: u } = l.textContent, d = c.getAttribute("data-slate-length"), f = o + (d == null ? u : parseInt(d, 10)), p = a[s + 1];
				if (t.offset === f && p != null && p.hasAttribute("data-slate-mark-placeholder")) {
					var m, h = p.childNodes[0];
					i = [h instanceof Oh ? h : p, (m = p.textContent) != null && m.startsWith("﻿") ? 1 : 0];
					break;
				}
				if (t.offset <= f) {
					i = [l, Math.min(u, Math.max(0, t.offset - o))];
					break;
				}
				o = f;
			}
		}
		if (!i) throw Error(`Cannot resolve a DOM point from Slate point: ${Ds.stringify(t)}`);
		return i;
	},
	toDOMRange: (e, t) => {
		var { anchor: n, focus: r } = t, i = U.isBackward(t), a = Z.toDOMPoint(e, n), o = U.isCollapsed(t) ? a : Z.toDOMPoint(e, r), s = Z.getWindow(e).document.createRange(), [c, l] = i ? o : a, [u, d] = i ? a : o, f = !!(jh(c) ? c : c.parentElement).getAttribute("data-slate-zero-width"), p = !!(jh(u) ? u : u.parentElement).getAttribute("data-slate-zero-width");
		return s.setStart(c, f ? 1 : l), s.setEnd(u, p ? 1 : d), s;
	},
	toSlateNode: (e, t) => {
		var n = jh(t) ? t : t.parentElement;
		n && !n.hasAttribute("data-slate-node") && (n = n.closest("[data-slate-node]"));
		var r = n ? uh.get(n) : null;
		if (!r) throw Error(`Cannot resolve a Slate node from DOM node: ${n}`);
		return r;
	},
	toSlatePoint: (e, t, n) => {
		var { exactMatch: r, suppressThrow: i } = n, [a, o] = r ? t : Ih(t), s = a.parentNode, c = null, l = 0;
		if (s) {
			var u, d, f = Z.toDOMNode(e, e), p = s.closest("[data-slate-void=\"true\"]"), m = p && f.contains(p) ? p : null, h = s.closest("[data-slate-leaf]"), g = null;
			if (h) {
				if (c = h.closest("[data-slate-node=\"text\"]"), c) {
					var _ = Z.getWindow(e).document.createRange();
					_.setStart(c, 0), _.setEnd(a, o);
					var v = _.cloneContents();
					[...Array.prototype.slice.call(v.querySelectorAll("[data-slate-zero-width]")), ...Array.prototype.slice.call(v.querySelectorAll("[contenteditable=false]"))].forEach((e) => {
						if (qm && !r && e.hasAttribute("data-slate-zero-width") && e.textContent.length > 0 && e.textContext !== "﻿") {
							e.textContent.startsWith("﻿") && (e.textContent = e.textContent.slice(1));
							return;
						}
						e.parentNode.removeChild(e);
					}), l = v.textContent.length, g = c;
				}
			} else if (m) {
				for (var y = m.querySelectorAll("[data-slate-leaf]"), b = 0; b < y.length; b++) {
					var x = y[b];
					if (Z.hasDOMNode(e, x)) {
						h = x;
						break;
					}
				}
				h ? (c = h.closest("[data-slate-node=\"text\"]"), g = h, l = g.textContent.length, g.querySelectorAll("[data-slate-zero-width]").forEach((e) => {
					l -= e.textContent.length;
				})) : l = 1;
			}
			g && l === g.textContent.length && qm && g.getAttribute("data-slate-zero-width") === "z" && (u = g.textContent) != null && u.startsWith("﻿") && (s.hasAttribute("data-slate-zero-width") || Jm && (d = g.textContent) != null && d.endsWith("\n\n")) && l--;
		}
		if (qm && !c && !r) {
			var S = s.hasAttribute("data-slate-node") ? s : s.closest("[data-slate-node]");
			if (S && Z.hasDOMNode(e, S, { editable: !0 })) {
				var C = Z.toSlateNode(e, S), { path: w, offset: T } = K.start(e, Z.findPath(e, C));
				return S.querySelector("[data-slate-leaf]") || (T = o), {
					path: w,
					offset: T
				};
			}
		}
		if (!c) {
			if (i) return null;
			throw Error(`Cannot resolve a Slate point from DOM point: ${t}`);
		}
		var E = Z.toSlateNode(e, c);
		return {
			path: Z.findPath(e, E),
			offset: l
		};
	},
	toSlateRange: (e, t, n) => {
		var { exactMatch: r, suppressThrow: i } = n, a = Nh(t) ? t.anchorNode : t.startContainer, o, s, c, l, u;
		if (a) if (Nh(t)) {
			if (Jm && t.rangeCount > 1) {
				c = t.focusNode;
				var d = t.getRangeAt(0), f = t.getRangeAt(t.rangeCount - 1);
				if (c instanceof HTMLTableRowElement && d.startContainer instanceof HTMLTableRowElement && f.startContainer instanceof HTMLTableRowElement) {
					function e(t) {
						return t.childElementCount > 0 ? e(t.children[0]) : t;
					}
					var p = d.startContainer, m = f.startContainer, h = e(p.children[d.startOffset]), g = e(m.children[f.startOffset]);
					l = 0, o = g.childNodes.length > 0 ? g.childNodes[0] : g, c = h.childNodes.length > 0 ? h.childNodes[0] : h, s = g instanceof HTMLElement ? g.innerHTML.length : 0;
				} else d.startContainer === c ? (o = f.endContainer, s = f.endOffset, l = d.startOffset) : (o = d.startContainer, s = d.endOffset, l = f.startOffset);
			} else o = t.anchorNode, s = t.anchorOffset, c = t.focusNode, l = t.focusOffset;
			u = Zm && Lh(o) || Jm ? t.anchorNode === t.focusNode && t.anchorOffset === t.focusOffset : t.isCollapsed;
		} else o = t.startContainer, s = t.startOffset, c = t.endContainer, l = t.endOffset, u = t.collapsed;
		if (o == null || c == null || s == null || l == null) throw Error(`Cannot resolve a Slate range from DOM range: ${t}`);
		"getAttribute" in c && c.getAttribute("contenteditable") === "false" && c.getAttribute("data-slate-void") !== "true" && (c = o, l = o.textContent?.length || 0);
		var _ = Z.toSlatePoint(e, [o, s], {
			exactMatch: r,
			suppressThrow: i
		});
		if (!_) return null;
		var v = u ? _ : Z.toSlatePoint(e, [c, l], {
			exactMatch: r,
			suppressThrow: i
		});
		if (!v) return null;
		var y = {
			anchor: _,
			focus: v
		};
		return U.isExpanded(y) && U.isForward(y) && jh(c) && K.void(e, {
			at: y.focus,
			mode: "highest"
		}) && (y = K.unhangRange(e, y, { voids: !0 })), y;
	}
};
function Kh(e, t) {
	var { path: n, diff: r } = t;
	if (!K.hasPath(e, n)) return !1;
	var i = G.get(e, n);
	if (!J.isText(i)) return !1;
	if (r.start !== i.text.length || r.text.length === 0) return i.text.slice(r.start, r.start + r.text.length) === r.text;
	var a = H.next(n);
	if (!K.hasPath(e, a)) return !1;
	var o = G.get(e, a);
	return J.isText(o) && o.text.startsWith(r.text);
}
function qh(e) {
	return [...arguments].slice(1).reduce((e, t) => e.slice(0, t.start) + t.text + e.slice(t.end), e);
}
function Jh(e, t) {
	for (var n = Math.min(e.length, t.length), r = 0; r < n; r++) if (e.charAt(r) !== t.charAt(r)) return r;
	return n;
}
function Yh(e, t, n) {
	for (var r = Math.min(e.length, t.length, n), i = 0; i < r; i++) if (e.charAt(e.length - i - 1) !== t.charAt(t.length - i - 1)) return i;
	return r;
}
function Xh(e, t) {
	var { start: n, end: r, text: i } = t, a = e.slice(n, r), o = Jh(a, i), s = Yh(a, i, Math.min(a.length - o, i.length - o)), c = {
		start: n + o,
		end: r - s,
		text: i.slice(o, i.length - s)
	};
	return c.start === c.end && c.text.length === 0 ? null : c;
}
function Zh(e, t, n) {
	var r = Math.min(t.start, n.start), i = Math.max(0, Math.min(t.start + t.text.length, n.end) - n.start), a = qh(e, t, n), o = Math.max(n.start + n.text.length, t.start + t.text.length + (t.start + t.text.length > n.start ? n.text.length : 0) - i), s = a.slice(r, o);
	return Xh(e, {
		start: r,
		end: Math.max(t.end, n.end - t.text.length + (t.end - t.start)),
		text: s
	});
}
function Qh(e) {
	var { path: t, diff: n } = e;
	return {
		anchor: {
			path: t,
			offset: n.start
		},
		focus: {
			path: t,
			offset: n.end
		}
	};
}
function $h(e, t) {
	var { path: n, offset: r } = t;
	if (!K.hasPath(e, n)) return null;
	var i = G.get(e, n);
	if (!J.isText(i)) return null;
	var a = K.above(e, {
		match: (t) => W.isElement(t) && K.isBlock(e, t),
		at: n
	});
	if (!a) return null;
	for (; r > i.text.length;) {
		var o = K.next(e, {
			at: n,
			match: J.isText
		});
		if (!o || !H.isDescendant(o[1], a[1])) return null;
		r -= i.text.length, i = o[0], n = o[1];
	}
	return {
		path: n,
		offset: r
	};
}
function eg(e, t) {
	var n = $h(e, t.anchor);
	if (!n) return null;
	if (U.isCollapsed(t)) return {
		anchor: n,
		focus: n
	};
	var r = $h(e, t.focus);
	return r ? {
		anchor: n,
		focus: r
	} : null;
}
function tg(e, t, n) {
	var r = Sh.get(e)?.find((e) => {
		var { path: n } = e;
		return H.equals(n, t.path);
	});
	if (!r || t.offset <= r.diff.start) return q.transform(t, n, { affinity: "backward" });
	var { diff: i } = r;
	if (t.offset <= i.start + i.text.length) {
		var a = {
			path: t.path,
			offset: i.start
		}, o = q.transform(a, n, { affinity: "backward" });
		return o ? {
			path: o.path,
			offset: o.offset + t.offset - i.start
		} : null;
	}
	var s = {
		path: t.path,
		offset: t.offset - i.text.length + i.end - i.start
	}, c = q.transform(s, n, { affinity: "backward" });
	return c ? n.type === "split_node" && H.equals(n.path, t.path) && s.offset < n.position && i.start < n.position ? c : {
		path: c.path,
		offset: c.offset + i.text.length - i.end + i.start
	} : null;
}
function ng(e, t, n) {
	var r = tg(e, t.anchor, n);
	if (!r) return null;
	if (U.isCollapsed(t)) return {
		anchor: r,
		focus: r
	};
	var i = tg(e, t.focus, n);
	return i ? {
		anchor: r,
		focus: i
	} : null;
}
function rg(e, t) {
	var { path: n, diff: r, id: i } = e;
	switch (t.type) {
		case "insert_text": return !H.equals(t.path, n) || t.offset >= r.end ? e : t.offset <= r.start ? {
			diff: {
				start: t.text.length + r.start,
				end: t.text.length + r.end,
				text: r.text
			},
			id: i,
			path: n
		} : {
			diff: {
				start: r.start,
				end: r.end + t.text.length,
				text: r.text
			},
			id: i,
			path: n
		};
		case "remove_text": return !H.equals(t.path, n) || t.offset >= r.end ? e : t.offset + t.text.length <= r.start ? {
			diff: {
				start: r.start - t.text.length,
				end: r.end - t.text.length,
				text: r.text
			},
			id: i,
			path: n
		} : {
			diff: {
				start: r.start,
				end: r.end - t.text.length,
				text: r.text
			},
			id: i,
			path: n
		};
		case "split_node": return !H.equals(t.path, n) || t.position >= r.end ? {
			diff: r,
			id: i,
			path: H.transform(n, t, { affinity: "backward" })
		} : t.position > r.start ? {
			diff: {
				start: r.start,
				end: Math.min(t.position, r.end),
				text: r.text
			},
			id: i,
			path: n
		} : {
			diff: {
				start: r.start - t.position,
				end: r.end - t.position,
				text: r.text
			},
			id: i,
			path: H.transform(n, t, { affinity: "forward" })
		};
		case "merge_node": return H.equals(t.path, n) ? {
			diff: {
				start: r.start + t.position,
				end: r.end + t.position,
				text: r.text
			},
			id: i,
			path: H.transform(n, t)
		} : {
			diff: r,
			id: i,
			path: H.transform(n, t)
		};
	}
	var a = H.transform(n, t);
	return a ? {
		diff: r,
		path: a,
		id: i
	} : null;
}
function ig(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function ag(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? ig(Object(n), !0).forEach(function(t) {
			zm(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ig(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var og = 25, sg = 200, cg = (e) => e?.constructor.name === "DataTransfer";
function lg(e) {
	var { editor: t, scheduleOnDOMSelectionChange: n, onDOMSelectionChange: r } = e, i = !1, a = null, o = null, s = null, c = 0, l = !1, u = () => {
		var e = wh.get(t);
		if (wh.delete(t), e) {
			var { selection: n } = t, r = eg(t, e);
			r && (!n || !U.equals(r, n)) && X.select(t, r);
		}
	}, d = () => {
		var e = Ch.get(t);
		if (Ch.delete(t), e) {
			if (e.at) {
				var n = q.isPoint(e.at) ? $h(t, e.at) : eg(t, e.at);
				if (!n) return;
				var r = K.range(t, n);
				(!t.selection || !U.equals(t.selection, r)) && X.select(t, n);
			}
			e.run();
		}
	}, f = () => {
		if (o &&= (clearTimeout(o), null), s &&= (clearTimeout(s), null), !b() && !y()) {
			u();
			return;
		}
		i || (i = !0, setTimeout(() => i = !1)), y() && (i = "action");
		var e = t.selection && K.rangeRef(t, t.selection, { affinity: "forward" });
		xh.set(t, t.marks), Ch.get(t), Sh.get(t);
		for (var a = b(), c; c = (f = Sh.get(t))?.[0];) {
			var f, p = bh.get(t);
			p !== void 0 && (bh.delete(t), t.marks = p), p && l === !1 && (l = null);
			var m = Qh(c);
			(!t.selection || !U.equals(t.selection, m)) && X.select(t, m), c.diff.text ? K.insertText(t, c.diff.text) : K.deleteFragment(t), Sh.set(t, Sh.get(t)?.filter((e) => {
				var { id: t } = e;
				return t !== c.id;
			})), Kh(t, c) || (a = !1, Ch.delete(t), xh.delete(t), i = "action", wh.delete(t), n.cancel(), r.cancel(), e?.unref());
		}
		var h = e?.unref();
		if (h && !wh.get(t) && (!t.selection || !U.equals(h, t.selection)) && X.select(t, h), y()) {
			d();
			return;
		}
		a && n(), n.flush(), r.flush(), u();
		var g = xh.get(t);
		xh.delete(t), g !== void 0 && (t.marks = g, t.onChange());
	}, p = (e) => {
		a && clearTimeout(a), a = setTimeout(() => {
			gh.set(t, !1), f();
		}, og);
	}, m = (e) => {
		gh.set(t, !0), a &&= (clearTimeout(a), null);
	}, h = function() {
		var e = arguments.length > 0 && arguments[0] !== void 0 && arguments[0], n = lh.get(t);
		if (n) {
			if (b() || e) {
				n.style.display = "none";
				return;
			}
			n.style.removeProperty("display");
		}
	}, g = (e, n) => {
		var r = Sh.get(t) ?? [];
		Sh.set(t, r);
		var i = G.leaf(t, e), a = r.findIndex((t) => H.equals(t.path, e));
		if (a < 0) {
			Xh(i.text, n) && r.push({
				path: e,
				diff: n,
				id: c++
			}), h();
			return;
		}
		var o = Zh(i.text, r[a].diff, n);
		if (!o) {
			r.splice(a, 1), h();
			return;
		}
		r[a] = ag(ag({}, r[a]), {}, { diff: o });
	}, _ = function(e) {
		var { at: i } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
		l = !1, wh.delete(t), n.cancel(), r.cancel(), y() && f(), Ch.set(t, {
			at: i,
			run: e
		}), s = setTimeout(f);
	}, v = (e) => {
		o &&= (clearTimeout(o), null);
		var { inputType: n } = e, r = null, i = e.dataTransfer || e.data || void 0;
		l !== !1 && n !== "insertText" && n !== "insertCompositionText" && (l = !1);
		var [a] = e.getTargetRanges();
		a && (r = Z.toSlateRange(t, a, {
			exactMatch: !1,
			suppressThrow: !0
		}));
		var s = Z.getWindow(t).getSelection();
		if (!r && s && (a = s, r = Z.toSlateRange(t, s, {
			exactMatch: !1,
			suppressThrow: !0
		})), r ??= t.selection, r) {
			var c = !0;
			if (n.startsWith("delete")) {
				if (U.isExpanded(r)) {
					var [u, d] = U.edges(r);
					if (G.leaf(t, u.path).text.length === u.offset && d.offset === 0) {
						var f = K.next(t, {
							at: u.path,
							match: J.isText
						});
						f && H.equals(f[1], d.path) && (r = {
							anchor: d,
							focus: d
						});
					}
				}
				var p = n.endsWith("Backward") ? "backward" : "forward", [m, h] = U.edges(r), [v, y] = K.leaf(t, m.path), b = {
					text: "",
					start: m.offset,
					end: h.offset
				}, x = Sh.get(t)?.find((e) => H.equals(e.path, y)), S = x ? [x.diff, b] : [b];
				if (qh(v.text, ...S).length === 0 && (c = !1), U.isExpanded(r)) {
					if (c && H.equals(r.anchor.path, r.focus.path)) {
						var w = {
							path: r.anchor.path,
							offset: m.offset
						};
						return C(K.range(t, w, w)), g(r.anchor.path, {
							text: "",
							end: h.offset,
							start: m.offset
						});
					}
					return _(() => K.deleteFragment(t, { direction: p }), { at: r });
				}
			}
			switch (n) {
				case "deleteByComposition":
				case "deleteByCut":
				case "deleteByDrag": return _(() => K.deleteFragment(t), { at: r });
				case "deleteContent":
				case "deleteContentForward":
					var { anchor: T } = r;
					if (c && U.isCollapsed(r)) {
						var ee = G.leaf(t, T.path);
						if (T.offset < ee.text.length) return g(T.path, {
							text: "",
							start: T.offset,
							end: T.offset + 1
						});
					}
					return _(() => K.deleteForward(t), { at: r });
				case "deleteContentBackward":
					var D, { anchor: te } = r, ne = Nh(a) ? a.isCollapsed : !!((D = a) != null && D.collapsed);
					return c && ne && U.isCollapsed(r) && te.offset > 0 ? g(te.path, {
						text: "",
						start: te.offset - 1,
						end: te.offset
					}) : _(() => K.deleteBackward(t), { at: r });
				case "deleteEntireSoftLine": return _(() => {
					K.deleteBackward(t, { unit: "line" }), K.deleteForward(t, { unit: "line" });
				}, { at: r });
				case "deleteHardLineBackward": return _(() => K.deleteBackward(t, { unit: "block" }), { at: r });
				case "deleteSoftLineBackward": return _(() => K.deleteBackward(t, { unit: "line" }), { at: r });
				case "deleteHardLineForward": return _(() => K.deleteForward(t, { unit: "block" }), { at: r });
				case "deleteSoftLineForward": return _(() => K.deleteForward(t, { unit: "line" }), { at: r });
				case "deleteWordBackward": return _(() => K.deleteBackward(t, { unit: "word" }), { at: r });
				case "deleteWordForward": return _(() => K.deleteForward(t, { unit: "word" }), { at: r });
				case "insertLineBreak": return _(() => K.insertSoftBreak(t), { at: r });
				case "insertParagraph": return _(() => K.insertBreak(t), { at: r });
				case "insertCompositionText":
				case "deleteCompositionText":
				case "insertFromComposition":
				case "insertFromDrop":
				case "insertFromPaste":
				case "insertFromYank":
				case "insertReplacementText":
				case "insertText":
					if (cg(i)) return _(() => Z.insertData(t, i), { at: r });
					var O = i ?? "";
					if (bh.get(t) && (O = O.replace("﻿", "")), n === "insertText" && /.*\n.*\n$/.test(O) && (O = O.slice(0, -1)), O.includes("\n")) return _(() => {
						var e = O.split("\n");
						e.forEach((n, r) => {
							n && K.insertText(t, n), r !== e.length - 1 && K.insertSoftBreak(t);
						});
					}, { at: r });
					if (H.equals(r.anchor.path, r.focus.path)) {
						var [re, ie] = U.edges(r), k = {
							start: re.offset,
							end: ie.offset,
							text: O
						};
						if (O && l && n === "insertCompositionText") {
							var ae = l.start + l.text.search(/\S|$/);
							k.start + k.text.search(/\S|$/) === ae + 1 && k.end === l.start + l.text.length ? (--k.start, l = null, E()) : l = !1;
						} else l = n === "insertText" ? l === null ? k : l && U.isCollapsed(r) && l.end + l.text.length === re.offset ? ag(ag({}, l), {}, { text: l.text + O }) : !1 : !1;
						if (c) {
							g(re.path, k);
							return;
						}
					}
					return _(() => K.insertText(t, O), { at: r });
			}
		}
	}, y = () => !!Ch.get(t), b = () => {
		var e;
		return !!((e = Sh.get(t)) != null && e.length);
	}, x = () => y() || b(), S = () => i, C = (e) => {
		wh.set(t, e), o &&= (clearTimeout(o), null);
		var { selection: n } = t;
		if (e) {
			var r = !n || !H.equals(n.anchor.path, e.anchor.path), i = !n || !H.equals(n.anchor.path.slice(0, -1), e.anchor.path.slice(0, -1));
			(r && l || i) && (l = !1), (r || b()) && (o = setTimeout(f, sg));
		}
	}, w = () => {
		(y() || !b()) && f();
	}, T = (e) => {
		b() || (h(!0), setTimeout(h));
	}, E = () => {
		y() || (s = setTimeout(f));
	};
	return {
		flush: f,
		scheduleFlush: E,
		hasPendingDiffs: b,
		hasPendingAction: y,
		hasPendingChanges: x,
		isFlushing: S,
		handleUserSelect: C,
		handleCompositionEnd: p,
		handleCompositionStart: m,
		handleDOMBeforeInput: v,
		handleKeyDown: T,
		handleDomMutations: (e) => {
			if (!(b() || y()) && e.some((n) => Uh(t, n, e))) {
				var n;
				(n = Th.get(t)) == null || n();
			}
		},
		handleInput: w
	};
}
function ug() {
	var e = xe(!1);
	return _e(() => (e.current = !0, () => {
		e.current = !1;
	}), []), e.current;
}
var dg = rh ? ve : _e;
function fg(e, t, n) {
	var [r] = Se(() => new MutationObserver(t));
	dg(() => {
		r.takeRecords();
	}), _e(() => {
		if (!e.current) throw Error("Failed to attach MutationObserver, `node` is undefined");
		return r.observe(e.current, n), () => r.disconnect();
	}, [
		r,
		e,
		n
	]);
}
var pg = ["node"];
function mg(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function hg(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? mg(Object(n), !0).forEach(function(t) {
			zm(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : mg(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var gg = {
	subtree: !0,
	childList: !0,
	characterData: !0
}, _g = qm ? (e) => {
	var { node: t } = e, n = Vm(e, pg);
	if (!qm) return null;
	var r = Um(), i = ug(), [a] = Se(() => lg(hg({ editor: r }, n)));
	return fg(t, a.handleDomMutations, gg), yh.set(r, a.scheduleFlush), i && a.flush(), a;
} : () => null, vg = ["anchor", "focus"], yg = ["anchor", "focus"], bg = (e, t) => Object.keys(e).length === Object.keys(t).length && Object.keys(e).every((n) => t.hasOwnProperty(n) && e[n] === t[n]), xg = (e, t) => {
	var n = Vm(e, vg), r = Vm(t, yg);
	return e[Eh] === t[Eh] && bg(n, r);
}, Sg = (e, t) => {
	if (e.length !== t.length) return !1;
	for (var n = 0; n < e.length; n++) {
		var r = e[n], i = t[n];
		if (!U.equals(r, i) || !xg(r, i)) return !1;
	}
	return !0;
}, Cg = (e, t) => {
	if (e.length !== t.length) return !1;
	for (var n = 0; n < e.length; n++) {
		var r = e[n], i = t[n];
		if (r.anchor.offset !== i.anchor.offset || r.focus.offset !== i.focus.offset || !xg(r, i)) return !1;
	}
	return !0;
}, wg = (e) => {
	var { isLast: t, leaf: n, parent: r, text: i } = e, a = Um(), o = Z.findPath(a, i), s = H.parent(o), c = n[Dh] === !0;
	return a.isVoid(r) ? /*#__PURE__*/ N.createElement(Dg, { length: G.string(r).length }) : n.text === "" && r.children[r.children.length - 1] === i && !a.isInline(r) && K.string(a, s) === "" ? /*#__PURE__*/ N.createElement(Dg, {
		isLineBreak: !0,
		isMarkPlaceholder: c
	}) : n.text === "" ? /*#__PURE__*/ N.createElement(Dg, { isMarkPlaceholder: c }) : t && n.text.slice(-1) === "\n" ? /*#__PURE__*/ N.createElement(Tg, {
		isTrailing: !0,
		text: n.text
	}) : /*#__PURE__*/ N.createElement(Tg, { text: n.text });
}, Tg = (e) => {
	var { text: t, isTrailing: n = !1 } = e, r = xe(null), i = () => `${t ?? ""}${n ? "\n" : ""}`, [a] = Se(i);
	return dg(() => {
		var e = i();
		r.current && r.current.textContent !== e && (r.current.textContent = e);
	}), /*#__PURE__*/ N.createElement(Eg, { ref: r }, a);
}, Eg = /*#__PURE__*/ pe(/*#__PURE__*/ de((e, t) => /*#__PURE__*/ N.createElement("span", {
	"data-slate-string": !0,
	ref: t
}, e.children))), Dg = (e) => {
	var { length: t = 0, isLineBreak: n = !1, isMarkPlaceholder: r = !1 } = e, i = {
		"data-slate-zero-width": n ? "n" : "z",
		"data-slate-length": t
	};
	return r && (i["data-slate-mark-placeholder"] = !0), /*#__PURE__*/ N.createElement("span", Object.assign({}, i), !qm || !n ? "﻿" : null, n ? /*#__PURE__*/ N.createElement("br", null) : null);
};
function Og(e, t) {
	e.current && (e.current.disconnect(), t && (e.current = null));
}
function kg(e) {
	e.current &&= (clearTimeout(e.current), null);
}
var Ag = /*#__PURE__*/ N.memo((e) => {
	var { leaf: t, isLast: n, text: r, parent: i, renderPlaceholder: a, renderLeaf: o = (e) => /*#__PURE__*/ N.createElement(jg, Object.assign({}, e)) } = e, s = Um(), c = xe(null), l = xe(null), [u, d] = Se(!1), f = xe(null), p = me((e) => {
		if (Og(c, e == null), e == null) {
			var n;
			lh.delete(s), (n = t.onPlaceholderResize) == null || n.call(t, null);
		} else lh.set(s, e), c.current ||= new (window.ResizeObserver || Lm)(() => {
			var n;
			(n = t.onPlaceholderResize) == null || n.call(t, e);
		}), c.current.observe(e), l.current = e;
	}, [
		l,
		t,
		s
	]), m = /*#__PURE__*/ N.createElement(wg, {
		isLast: n,
		leaf: t,
		parent: i,
		text: r
	}), h = t[Eh];
	if (_e(() => (h ? f.current ||= setTimeout(() => {
		d(!0), f.current = null;
	}, 300) : (kg(f), d(!1)), () => kg(f)), [h, d]), h && u) {
		var g = {
			children: t.placeholder,
			attributes: {
				"data-slate-placeholder": !0,
				style: {
					position: "absolute",
					top: 0,
					pointerEvents: "none",
					width: "100%",
					maxWidth: "100%",
					display: "block",
					opacity: "0.333",
					userSelect: "none",
					textDecoration: "none",
					WebkitUserModify: Ym ? "inherit" : void 0
				},
				contentEditable: !1,
				ref: p
			}
		};
		m = /*#__PURE__*/ N.createElement(N.Fragment, null, a(g), m);
	}
	return o({
		attributes: { "data-slate-leaf": !0 },
		children: m,
		leaf: t,
		text: r
	});
}, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && J.equals(t.leaf, e.leaf) && t.leaf[Eh] === e.leaf[Eh]), jg = (e) => {
	var { attributes: t, children: n } = e;
	return /*#__PURE__*/ N.createElement("span", Object.assign({}, t), n);
}, Mg = /*#__PURE__*/ N.memo((e) => {
	for (var { decorations: t, isLast: n, parent: r, renderPlaceholder: i, renderLeaf: a, text: o } = e, s = Um(), c = xe(null), l = J.decorations(o, t), u = Z.findKey(s, o), d = [], f = 0; f < l.length; f++) {
		var p = l[f];
		d.push(/*#__PURE__*/ N.createElement(Ag, {
			isLast: n && f === l.length - 1,
			key: `${u.id}-${f}`,
			renderPlaceholder: i,
			leaf: p,
			text: o,
			parent: r,
			renderLeaf: a
		}));
	}
	var m = me((e) => {
		var t = ph.get(s);
		e ? (t?.set(u, e), dh.set(o, e), uh.set(e, o)) : (t?.delete(u), dh.delete(o), c.current && uh.delete(c.current)), c.current = e;
	}, [
		c,
		s,
		u,
		o
	]);
	return /*#__PURE__*/ N.createElement("span", {
		"data-slate-node": "text",
		ref: m
	}, d);
}, (e, t) => t.parent === e.parent && t.isLast === e.isLast && t.renderLeaf === e.renderLeaf && t.renderPlaceholder === e.renderPlaceholder && t.text === e.text && Cg(t.decorations, e.decorations)), Ng = /*#__PURE__*/ N.memo((e) => {
	var { decorations: t, element: n, renderElement: r = (e) => /*#__PURE__*/ N.createElement(Pg, Object.assign({}, e)), renderPlaceholder: i, renderLeaf: a, selection: o } = e, s = Um(), c = Bg(), l = s.isInline(n), u = Z.findKey(s, n), d = me((e) => {
		var t = ph.get(s);
		e ? (t?.set(u, e), dh.set(n, e), uh.set(e, n)) : (t?.delete(u), dh.delete(n));
	}, [
		s,
		u,
		n
	]), f = Rg({
		decorations: t,
		node: n,
		renderElement: r,
		renderPlaceholder: i,
		renderLeaf: a,
		selection: o
	}), p = {
		"data-slate-node": "element",
		ref: d
	};
	if (l && (p["data-slate-inline"] = !0), !l && K.hasInlines(s, n)) {
		var m = (0, jp.default)(G.string(n));
		m === "rtl" && (p.dir = m);
	}
	if (K.isVoid(s, n)) {
		p["data-slate-void"] = !0, !c && l && (p.contentEditable = !1);
		var h = l ? "span" : "div", [[g]] = G.texts(n);
		f = /*#__PURE__*/ N.createElement(h, {
			"data-slate-spacer": !0,
			style: {
				height: "0",
				color: "transparent",
				outline: "none",
				position: "absolute"
			}
		}, /*#__PURE__*/ N.createElement(Mg, {
			renderPlaceholder: i,
			decorations: [],
			isLast: !1,
			parent: n,
			text: g
		})), ah.set(g, 0), oh.set(g, n);
	}
	return r({
		attributes: p,
		children: f,
		element: n
	});
}, (e, t) => e.element === t.element && e.renderElement === t.renderElement && e.renderLeaf === t.renderLeaf && e.renderPlaceholder === t.renderPlaceholder && Sg(e.decorations, t.decorations) && (e.selection === t.selection || !!e.selection && !!t.selection && U.equals(e.selection, t.selection))), Pg = (e) => {
	var { attributes: t, children: n, element: r } = e, i = Um().isInline(r) ? "span" : "div";
	return /*#__PURE__*/ N.createElement(i, Object.assign({}, t, { style: { position: "relative" } }), n);
}, Fg = /*#__PURE__*/ ue(() => []), Ig = () => he(Fg), Lg = /*#__PURE__*/ ue(!1), Rg = (e) => {
	for (var { decorations: t, node: n, renderElement: r, renderPlaceholder: i, renderLeaf: a, selection: o } = e, s = Ig(), c = Um(), l = Z.findPath(c, n), u = [], d = W.isElement(n) && !c.isInline(n) && K.hasInlines(c, n), f = 0; f < n.children.length; f++) {
		var p = l.concat(f), m = n.children[f], h = Z.findKey(c, m), g = K.range(c, p), _ = o && U.intersection(g, o), v = s([m, p]);
		for (var y of t) {
			var b = U.intersection(y, g);
			b && v.push(b);
		}
		W.isElement(m) ? u.push(/*#__PURE__*/ N.createElement(Lg.Provider, {
			key: `provider-${h.id}`,
			value: !!_
		}, /*#__PURE__*/ N.createElement(Ng, {
			decorations: v,
			element: m,
			key: h.id,
			renderElement: r,
			renderPlaceholder: i,
			renderLeaf: a,
			selection: _
		}))) : u.push(/*#__PURE__*/ N.createElement(Mg, {
			decorations: v,
			key: h.id,
			isLast: d && f === n.children.length - 1,
			parent: n,
			renderPlaceholder: i,
			renderLeaf: a,
			text: m
		})), ah.set(m, f), oh.set(m, n);
	}
	return u;
}, zg = /*#__PURE__*/ ue(!1), Bg = () => he(zg), Vg = /*#__PURE__*/ ue(null), Hg = () => {
	var e = he(Vg);
	if (!e) throw Error("The `useSlate` hook must be used inside the <Slate> component's context.");
	var { editor: t } = e;
	return t;
};
function Ug() {
	var e = Um(), t = xe(!1), n = xe(0), r = me(() => {
		if (!t.current) {
			t.current = !0;
			var r = Z.getWindow(e);
			r.cancelAnimationFrame(n.current), n.current = r.requestAnimationFrame(() => {
				t.current = !1;
			});
		}
	}, [e]);
	return _e(() => () => cancelAnimationFrame(n.current), []), {
		receivedUserInput: t,
		onUserInput: r
	};
}
var Wg = 3, Gg = {
	bold: "mod+b",
	compose: [
		"down",
		"left",
		"right",
		"up",
		"backspace",
		"enter"
	],
	moveBackward: "left",
	moveForward: "right",
	moveWordBackward: "ctrl+left",
	moveWordForward: "ctrl+right",
	deleteBackward: "shift?+backspace",
	deleteForward: "shift?+delete",
	extendBackward: "shift+left",
	extendForward: "shift+right",
	italic: "mod+i",
	insertSoftBreak: "shift+enter",
	splitBlock: "enter",
	undo: "mod+z"
}, Kg = {
	moveLineBackward: "opt+up",
	moveLineForward: "opt+down",
	moveWordBackward: "opt+left",
	moveWordForward: "opt+right",
	deleteBackward: ["ctrl+backspace", "ctrl+h"],
	deleteForward: ["ctrl+delete", "ctrl+d"],
	deleteLineBackward: "cmd+shift?+backspace",
	deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
	deleteWordBackward: "opt+shift?+backspace",
	deleteWordForward: "opt+shift?+delete",
	extendLineBackward: "opt+shift+up",
	extendLineForward: "opt+shift+down",
	redo: "cmd+shift+z",
	transposeCharacter: "ctrl+t"
}, qg = {
	deleteWordBackward: "ctrl+shift?+backspace",
	deleteWordForward: "ctrl+shift?+delete",
	redo: ["ctrl+y", "ctrl+shift+z"]
}, Jg = (e) => {
	var t = Gg[e], n = Kg[e], r = qg[e], i = t && (0, Rm.isHotkey)(t), a = n && (0, Rm.isHotkey)(n), o = r && (0, Rm.isHotkey)(r);
	return (e) => !!(i && i(e) || Km && a && a(e) || !Km && o && o(e));
}, Yg = {
	isBold: Jg("bold"),
	isCompose: Jg("compose"),
	isMoveBackward: Jg("moveBackward"),
	isMoveForward: Jg("moveForward"),
	isDeleteBackward: Jg("deleteBackward"),
	isDeleteForward: Jg("deleteForward"),
	isDeleteLineBackward: Jg("deleteLineBackward"),
	isDeleteLineForward: Jg("deleteLineForward"),
	isDeleteWordBackward: Jg("deleteWordBackward"),
	isDeleteWordForward: Jg("deleteWordForward"),
	isExtendBackward: Jg("extendBackward"),
	isExtendForward: Jg("extendForward"),
	isExtendLineBackward: Jg("extendLineBackward"),
	isExtendLineForward: Jg("extendLineForward"),
	isItalic: Jg("italic"),
	isMoveLineBackward: Jg("moveLineBackward"),
	isMoveLineForward: Jg("moveLineForward"),
	isMoveWordBackward: Jg("moveWordBackward"),
	isMoveWordForward: Jg("moveWordForward"),
	isRedo: Jg("redo"),
	isSoftBreak: Jg("insertSoftBreak"),
	isSplitBlock: Jg("splitBlock"),
	isTransposeCharacter: Jg("transposeCharacter"),
	isUndo: Jg("undo")
}, Xg = (e, t) => {
	var n = [], r = () => {
		n = [];
	}, i = (r) => {
		if (t.current) {
			var i = r.filter((t) => Uh(e, t, r));
			n.push(...i);
		}
	};
	function a() {
		n.length > 0 && (n.reverse().forEach((e) => {
			e.type !== "characterData" && (e.removedNodes.forEach((t) => {
				e.target.insertBefore(t, e.nextSibling);
			}), e.addedNodes.forEach((t) => {
				e.target.removeChild(t);
			}));
		}), r());
	}
	return {
		registerMutations: i,
		restoreDOM: a,
		clear: r
	};
}, Zg = {
	subtree: !0,
	childList: !0,
	characterData: !0,
	characterDataOldValue: !0
}, Qg = class extends le {
	constructor() {
		super(...arguments), this.context = null, this.manager = null, this.mutationObserver = null;
	}
	observe() {
		var e, { node: t } = this.props;
		if (!t.current) throw Error("Failed to attach MutationObserver, `node` is undefined");
		(e = this.mutationObserver) == null || e.observe(t.current, Zg);
	}
	componentDidMount() {
		var { receivedUserInput: e } = this.props, t = this.context;
		this.manager = Xg(t, e), this.mutationObserver = new MutationObserver(this.manager.registerMutations), this.observe();
	}
	getSnapshotBeforeUpdate() {
		var e, t, n = this.mutationObserver?.takeRecords();
		if (n != null && n.length) {
			var r;
			(r = this.manager) == null || r.registerMutations(n);
		}
		return (e = this.mutationObserver) == null || e.disconnect(), (t = this.manager) == null || t.restoreDOM(), null;
	}
	componentDidUpdate() {
		var e;
		(e = this.manager) == null || e.clear(), this.observe();
	}
	componentWillUnmount() {
		var e;
		(e = this.mutationObserver) == null || e.disconnect();
	}
	render() {
		return this.props.children;
	}
};
Qg.contextType = Hm;
var $g = qm ? Qg : (e) => {
	var { children: t } = e;
	return /*#__PURE__*/ N.createElement(N.Fragment, null, t);
}, e_ = [
	"autoFocus",
	"decorate",
	"onDOMBeforeInput",
	"placeholder",
	"readOnly",
	"renderElement",
	"renderLeaf",
	"renderPlaceholder",
	"scrollSelectionIntoView",
	"style",
	"as",
	"disableDefaultStyles"
], t_ = ["text"];
function n_(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function r_(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? n_(Object(n), !0).forEach(function(t) {
			zm(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : n_(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var i_ = (e) => /*#__PURE__*/ N.createElement(N.Fragment, null, Rg(e)), a_ = (e) => {
	var t = me((e) => /*#__PURE__*/ N.createElement(o_, Object.assign({}, e)), []), { autoFocus: n, decorate: r = s_, onDOMBeforeInput: i, placeholder: a, readOnly: o = !1, renderElement: s, renderLeaf: c, renderPlaceholder: l = t, scrollSelectionIntoView: u = c_, style: d = {}, as: f = "div", disableDefaultStyles: p = !1 } = e, m = Vm(e, e_), h = Hg(), [g, _] = Se(!1), v = xe(null), y = xe([]), [b, x] = Se(), { onUserInput: S, receivedUserInput: C } = Ug(), [, w] = be((e) => e + 1, 0);
	Th.set(h, w), mh.set(h, o);
	var T = ye(() => ({
		isDraggingInternally: !1,
		isUpdatingSelection: !1,
		latestElement: null,
		hasMarkPlaceholder: !1
	}), []);
	_e(() => {
		v.current && n && v.current.focus();
	}, [n]);
	var E = xe(), ee = ye(() => Np(() => {
		var e = E.current;
		if ((qm || !Z.isComposing(h)) && (!T.isUpdatingSelection || e != null && e.isFlushing()) && !T.isDraggingInternally) {
			var t = Z.findDocumentOrShadowRoot(h), { activeElement: n } = t, r = Z.toDOMNode(h, h), i = t.getSelection();
			if (n === r ? (T.latestElement = n, hh.set(h, !0)) : hh.delete(h), !i) return X.deselect(h);
			var { anchorNode: a, focusNode: s } = i, c = Z.hasEditableTarget(h, a) || Z.isTargetInsideNonReadonlyVoid(h, a), l = Z.hasEditableTarget(h, s) || Z.isTargetInsideNonReadonlyVoid(h, s);
			if (c && l) {
				var u = Z.toSlateRange(h, i, {
					exactMatch: !1,
					suppressThrow: !0
				});
				u && (!Z.isComposing(h) && !(e != null && e.hasPendingChanges()) && !(e != null && e.isFlushing()) ? X.select(h, u) : e?.handleUserSelect(u));
			}
			o && (!c || !l) && X.deselect(h);
		}
	}, 100), [
		h,
		o,
		T
	]), D = ye(() => Mp(ee, 0), [ee]);
	E.current = _g({
		node: v,
		onDOMSelectionChange: ee,
		scheduleOnDOMSelectionChange: D
	}), dg(() => {
		var e, t;
		v.current && (t = kh(v.current)) ? (sh.set(h, t), ch.set(h, v.current), dh.set(h, v.current), uh.set(v.current, h)) : dh.delete(h);
		var { selection: n } = h, r = Z.findDocumentOrShadowRoot(h).getSelection();
		if (!(!r || !Z.isFocused(h) || (e = E.current) != null && e.hasPendingAction())) {
			var i = (e) => {
				var t = r.type !== "None";
				if (!(!n && !t)) {
					var i = r.focusNode, a;
					if (Jm && r.rangeCount > 1) {
						var o = r.getRangeAt(0), s = r.getRangeAt(r.rangeCount - 1);
						a = o.startContainer === i ? s.endContainer : o.startContainer;
					} else a = r.anchorNode;
					var c = ch.get(h), l = !1;
					if (c.contains(a) && c.contains(i) && (l = !0), t && l && n && !e) {
						var d = Z.toSlateRange(h, r, {
							exactMatch: !0,
							suppressThrow: !0
						});
						if (d && U.equals(d, n)) {
							var f, p;
							if (!T.hasMarkPlaceholder || (f = a) != null && (p = f.parentElement) != null && p.hasAttribute("data-slate-mark-placeholder")) return;
						}
					}
					if (n && !Z.hasRange(h, n)) {
						h.selection = Z.toSlateRange(h, r, {
							exactMatch: !1,
							suppressThrow: !0
						});
						return;
					}
					T.isUpdatingSelection = !0;
					var m = n && Z.toDOMRange(h, n);
					return m ? (Z.isComposing(h) && !qm ? r.collapseToEnd() : U.isBackward(n) ? r.setBaseAndExtent(m.endContainer, m.endOffset, m.startContainer, m.startOffset) : r.setBaseAndExtent(m.startContainer, m.startOffset, m.endContainer, m.endOffset), u(h, m)) : r.removeAllRanges(), m;
				}
			};
			r.rangeCount <= 1 && i();
			var a = E.current?.isFlushing() === "action";
			if (!qm || !a) {
				setTimeout(() => {
					T.isUpdatingSelection = !1;
				});
				return;
			}
			var o = null, s = requestAnimationFrame(() => {
				if (a) {
					var e = (e) => {
						try {
							Z.toDOMNode(h, h).focus(), i(e);
						} catch {}
					};
					e(), o = setTimeout(() => {
						e(!0), T.isUpdatingSelection = !1;
					});
				}
			});
			return () => {
				cancelAnimationFrame(s), o && clearTimeout(o);
			};
		}
	});
	var te = me((e) => {
		if (S(), !o && Z.hasEditableTarget(h, e.target) && !d_(e, i)) {
			if (E.current) return E.current.handleDOMBeforeInput(e);
			D.flush(), ee.flush();
			var { selection: t } = h, { inputType: n } = e, r = e.dataTransfer || e.data || void 0, a = n === "insertCompositionText" || n === "deleteCompositionText";
			if (a && Z.isComposing(h)) return;
			var s = !1;
			if (n === "insertText" && t && U.isCollapsed(t) && e.data && e.data.length === 1 && /[a-z ]/i.test(e.data) && t.anchor.offset !== 0) {
				s = !0, h.marks && (s = !1);
				var { anchor: c } = t, [l, u] = Z.toDOMPoint(h, c), d = l.parentElement?.closest("a"), f = Z.getWindow(h);
				if (s && d && Z.hasDOMNode(h, d)) {
					var p = f?.document.createTreeWalker(d, NodeFilter.SHOW_TEXT).lastChild();
					p === l && p.textContent?.length === u && (s = !1);
				}
				if (s && l.parentElement && f?.getComputedStyle(l.parentElement)?.whiteSpace === "pre") {
					var m = K.above(h, {
						at: c.path,
						match: (e) => W.isElement(e) && K.isBlock(h, e)
					});
					m && G.string(m[0]).includes("	") && (s = !1);
				}
			}
			if (!n.startsWith("delete") || n.startsWith("deleteBy")) {
				var [g] = e.getTargetRanges();
				if (g) {
					var v = Z.toSlateRange(h, g, {
						exactMatch: !1,
						suppressThrow: !1
					});
					if (!t || !U.equals(t, v)) {
						s = !1;
						var b = !a && h.selection && K.rangeRef(h, h.selection);
						X.select(h, v), b && _h.set(h, b);
					}
				}
			}
			if (a) return;
			if (s || e.preventDefault(), t && U.isExpanded(t) && n.startsWith("delete")) {
				var x = n.endsWith("Backward") ? "backward" : "forward";
				K.deleteFragment(h, { direction: x });
				return;
			}
			switch (n) {
				case "deleteByComposition":
				case "deleteByCut":
				case "deleteByDrag":
					K.deleteFragment(h);
					break;
				case "deleteContent":
				case "deleteContentForward":
					K.deleteForward(h);
					break;
				case "deleteContentBackward":
					K.deleteBackward(h);
					break;
				case "deleteEntireSoftLine":
					K.deleteBackward(h, { unit: "line" }), K.deleteForward(h, { unit: "line" });
					break;
				case "deleteHardLineBackward":
					K.deleteBackward(h, { unit: "block" });
					break;
				case "deleteSoftLineBackward":
					K.deleteBackward(h, { unit: "line" });
					break;
				case "deleteHardLineForward":
					K.deleteForward(h, { unit: "block" });
					break;
				case "deleteSoftLineForward":
					K.deleteForward(h, { unit: "line" });
					break;
				case "deleteWordBackward":
					K.deleteBackward(h, { unit: "word" });
					break;
				case "deleteWordForward":
					K.deleteForward(h, { unit: "word" });
					break;
				case "insertLineBreak":
					K.insertSoftBreak(h);
					break;
				case "insertParagraph":
					K.insertBreak(h);
					break;
				case "insertFromComposition":
				case "insertFromDrop":
				case "insertFromPaste":
				case "insertFromYank":
				case "insertReplacementText":
				case "insertText":
					n === "insertFromComposition" && Z.isComposing(h) && (_(!1), gh.set(h, !1)), r?.constructor.name === "DataTransfer" ? Z.insertData(h, r) : typeof r == "string" && (s ? y.current.push(() => K.insertText(h, r)) : K.insertText(h, r));
					break;
			}
			var C = _h.get(h)?.unref();
			_h.delete(h), C && (!h.selection || !U.equals(h.selection, C)) && X.select(h, C);
		}
	}, [
		h,
		ee,
		S,
		i,
		o,
		D
	]), ne = me((e) => {
		e == null ? (ee.cancel(), D.cancel(), ch.delete(h), dh.delete(h), v.current && ih && v.current.removeEventListener("beforeinput", te)) : ih && e.addEventListener("beforeinput", te), v.current = e;
	}, [
		ee,
		D,
		h,
		te
	]);
	dg(() => {
		var e = Z.getWindow(h);
		return e.document.addEventListener("selectionchange", D), () => {
			e.document.removeEventListener("selectionchange", D);
		};
	}, [D]);
	var O = r([h, []]), re = a && h.children.length === 1 && Array.from(G.texts(h)).length === 1 && G.string(h) === "" && !g, ie = me((e) => {
		x(e && re ? e.getBoundingClientRect()?.height : void 0);
	}, [re]);
	if (re) {
		var k = K.start(h, []);
		O.push({
			[Eh]: !0,
			placeholder: a,
			onPlaceholderResize: ie,
			anchor: k,
			focus: k
		});
	}
	var { marks: ae } = h;
	if (T.hasMarkPlaceholder = !1, h.selection && U.isCollapsed(h.selection) && ae) {
		var { anchor: oe } = h.selection, se = G.leaf(h, oe.path), A = Vm(se, t_);
		if (!J.equals(se, ae, { loose: !0 })) {
			T.hasMarkPlaceholder = !0;
			var j = Object.fromEntries(Object.keys(A).map((e) => [e, null]));
			O.push(r_(r_(r_({ [Dh]: !0 }, j), ae), {}, {
				anchor: oe,
				focus: oe
			}));
		}
	}
	return _e(() => {
		setTimeout(() => {
			var { selection: e } = h;
			if (e) {
				var { anchor: t } = e, n = G.leaf(h, t.path);
				if (ae && !J.equals(n, ae, { loose: !0 })) {
					bh.set(h, ae);
					return;
				}
			}
			bh.delete(h);
		});
	}), /*#__PURE__*/ N.createElement(zg.Provider, { value: o }, /*#__PURE__*/ N.createElement(Fg.Provider, { value: r }, /*#__PURE__*/ N.createElement($g, {
		node: v,
		receivedUserInput: C
	}, /*#__PURE__*/ N.createElement(f, Object.assign({
		role: o ? void 0 : "textbox",
		"aria-multiline": !o || void 0
	}, m, {
		spellCheck: ih || !rh ? m.spellCheck : !1,
		autoCorrect: ih || !rh ? m.autoCorrect : "false",
		autoCapitalize: ih || !rh ? m.autoCapitalize : "false",
		"data-slate-editor": !0,
		"data-slate-node": "value",
		contentEditable: !o,
		zindex: -1,
		suppressContentEditableWarning: !0,
		ref: ne,
		style: r_(r_({}, p ? {} : r_({
			position: "relative",
			whiteSpace: "pre-wrap",
			wordWrap: "break-word"
		}, b ? { minHeight: b } : {})), d),
		onBeforeInput: me((e) => {
			if (!ih && !o && !l_(e, m.onBeforeInput) && Z.hasSelectableTarget(h, e.target) && (e.preventDefault(), !Z.isComposing(h))) {
				var t = e.data;
				K.insertText(h, t);
			}
		}, [
			m.onBeforeInput,
			h,
			o
		]),
		onInput: me((e) => {
			if (!l_(e, m.onInput)) {
				if (E.current) {
					E.current.handleInput();
					return;
				}
				for (var t of y.current) t();
				y.current = [];
			}
		}, [m.onInput]),
		onBlur: me((e) => {
			if (!(o || T.isUpdatingSelection || !Z.hasSelectableTarget(h, e.target) || l_(e, m.onBlur))) {
				var t = Z.findDocumentOrShadowRoot(h);
				if (T.latestElement !== t.activeElement) {
					var { relatedTarget: n } = e;
					if (n !== Z.toDOMNode(h, h) && !(jh(n) && n.hasAttribute("data-slate-spacer"))) {
						if (n != null && Mh(n) && Z.hasDOMNode(h, n)) {
							var r = Z.toSlateNode(h, n);
							if (W.isElement(r) && !h.isVoid(r)) return;
						}
						Ym && t.getSelection()?.removeAllRanges(), hh.delete(h);
					}
				}
			}
		}, [
			o,
			T.isUpdatingSelection,
			T.latestElement,
			h,
			m.onBlur
		]),
		onClick: me((e) => {
			if (Z.hasTarget(h, e.target) && !l_(e, m.onClick) && Mh(e.target)) {
				var t = Z.toSlateNode(h, e.target), n = Z.findPath(h, t);
				if (!K.hasPath(h, n) || G.get(h, n) !== t) return;
				if (e.detail === Wg && n.length >= 1) {
					var r = n;
					W.isElement(t) && K.isBlock(h, t) || (r = K.above(h, {
						match: (e) => W.isElement(e) && K.isBlock(h, e),
						at: n
					})?.[1] ?? n.slice(0, 1));
					var i = K.range(h, r);
					X.select(h, i);
					return;
				}
				if (o) return;
				var a = K.start(h, n), s = K.end(h, n), c = K.void(h, { at: a }), l = K.void(h, { at: s });
				if (c && l && H.equals(c[1], l[1])) {
					var u = K.range(h, a);
					X.select(h, u);
				}
			}
		}, [
			h,
			m.onClick,
			o
		]),
		onCompositionEnd: me((e) => {
			if (Z.hasSelectableTarget(h, e.target)) {
				var t;
				if (Z.isComposing(h) && (_(!1), gh.set(h, !1)), (t = E.current) == null || t.handleCompositionEnd(e), l_(e, m.onCompositionEnd) || qm) return;
				if (!Ym && !eh && !Gm && !nh && !th && e.data) {
					var n = bh.get(h);
					bh.delete(h), n !== void 0 && (xh.set(h, h.marks), h.marks = n), K.insertText(h, e.data);
					var r = xh.get(h);
					xh.delete(h), r !== void 0 && (h.marks = r);
				}
			}
		}, [m.onCompositionEnd, h]),
		onCompositionUpdate: me((e) => {
			Z.hasSelectableTarget(h, e.target) && !l_(e, m.onCompositionUpdate) && (Z.isComposing(h) || (_(!0), gh.set(h, !0)));
		}, [m.onCompositionUpdate, h]),
		onCompositionStart: me((e) => {
			if (Z.hasSelectableTarget(h, e.target)) {
				var t;
				if ((t = E.current) == null || t.handleCompositionStart(e), l_(e, m.onCompositionStart) || qm) return;
				_(!0);
				var { selection: n } = h;
				if (n) {
					if (U.isExpanded(n)) {
						K.deleteFragment(h);
						return;
					}
					var r = K.above(h, {
						match: (e) => W.isElement(e) && K.isInline(h, e),
						mode: "highest"
					});
					if (r) {
						var [, i] = r;
						if (K.isEnd(h, n.anchor, i)) {
							var a = K.after(h, i);
							X.setSelection(h, {
								anchor: a,
								focus: a
							});
						}
					}
				}
			}
		}, [m.onCompositionStart, h]),
		onCopy: me((e) => {
			Z.hasSelectableTarget(h, e.target) && !l_(e, m.onCopy) && !u_(e) && (e.preventDefault(), Z.setFragmentData(h, e.clipboardData, "copy"));
		}, [m.onCopy, h]),
		onCut: me((e) => {
			if (!o && Z.hasSelectableTarget(h, e.target) && !l_(e, m.onCut) && !u_(e)) {
				e.preventDefault(), Z.setFragmentData(h, e.clipboardData, "cut");
				var { selection: t } = h;
				if (t) if (U.isExpanded(t)) K.deleteFragment(h);
				else {
					var n = G.parent(h, t.anchor.path);
					K.isVoid(h, n) && X.delete(h);
				}
			}
		}, [
			o,
			h,
			m.onCut
		]),
		onDragOver: me((e) => {
			if (Z.hasTarget(h, e.target) && !l_(e, m.onDragOver)) {
				var t = Z.toSlateNode(h, e.target);
				W.isElement(t) && K.isVoid(h, t) && e.preventDefault();
			}
		}, [m.onDragOver, h]),
		onDragStart: me((e) => {
			if (!o && Z.hasTarget(h, e.target) && !l_(e, m.onDragStart)) {
				var t = Z.toSlateNode(h, e.target), n = Z.findPath(h, t);
				if (W.isElement(t) && K.isVoid(h, t) || K.void(h, {
					at: n,
					voids: !0
				})) {
					var r = K.range(h, n);
					X.select(h, r);
				}
				T.isDraggingInternally = !0, Z.setFragmentData(h, e.dataTransfer, "drag");
			}
		}, [
			o,
			h,
			m.onDragStart,
			T
		]),
		onDrop: me((e) => {
			if (!o && Z.hasTarget(h, e.target) && !l_(e, m.onDrop)) {
				e.preventDefault();
				var t = h.selection, n = Z.findEventRange(h, e), r = e.dataTransfer;
				X.select(h, n), T.isDraggingInternally && t && !U.equals(t, n) && !K.void(h, {
					at: n,
					voids: !0
				}) && X.delete(h, { at: t }), Z.insertData(h, r), Z.isFocused(h) || Z.focus(h);
			}
			T.isDraggingInternally = !1;
		}, [
			o,
			h,
			m.onDrop,
			T
		]),
		onDragEnd: me((e) => {
			!o && T.isDraggingInternally && m.onDragEnd && Z.hasTarget(h, e.target) && m.onDragEnd(e), T.isDraggingInternally = !1;
		}, [
			o,
			T,
			m,
			h
		]),
		onFocus: me((e) => {
			if (!o && !T.isUpdatingSelection && Z.hasEditableTarget(h, e.target) && !l_(e, m.onFocus)) {
				var t = Z.toDOMNode(h, h);
				if (T.latestElement = Z.findDocumentOrShadowRoot(h).activeElement, Jm && e.target !== t) {
					t.focus();
					return;
				}
				hh.set(h, !0);
			}
		}, [
			o,
			T,
			h,
			m.onFocus
		]),
		onKeyDown: me((e) => {
			if (!o && Z.hasEditableTarget(h, e.target)) {
				var t;
				(t = E.current) == null || t.handleKeyDown(e);
				var { nativeEvent: n } = e;
				if (Z.isComposing(h) && n.isComposing === !1 && (gh.set(h, !1), _(!1)), l_(e, m.onKeyDown) || Z.isComposing(h)) return;
				var { selection: r } = h, i = h.children[r === null ? 0 : r.focus.path[0]], a = (0, jp.default)(G.string(i)) === "rtl";
				if (Yg.isRedo(n)) {
					e.preventDefault();
					var s = h;
					typeof s.redo == "function" && s.redo();
					return;
				}
				if (Yg.isUndo(n)) {
					e.preventDefault();
					var c = h;
					typeof c.undo == "function" && c.undo();
					return;
				}
				if (Yg.isMoveLineBackward(n)) {
					e.preventDefault(), X.move(h, {
						unit: "line",
						reverse: !0
					});
					return;
				}
				if (Yg.isMoveLineForward(n)) {
					e.preventDefault(), X.move(h, { unit: "line" });
					return;
				}
				if (Yg.isExtendLineBackward(n)) {
					e.preventDefault(), X.move(h, {
						unit: "line",
						edge: "focus",
						reverse: !0
					});
					return;
				}
				if (Yg.isExtendLineForward(n)) {
					e.preventDefault(), X.move(h, {
						unit: "line",
						edge: "focus"
					});
					return;
				}
				if (Yg.isMoveBackward(n)) {
					e.preventDefault(), r && U.isCollapsed(r) ? X.move(h, { reverse: !a }) : X.collapse(h, { edge: "start" });
					return;
				}
				if (Yg.isMoveForward(n)) {
					e.preventDefault(), r && U.isCollapsed(r) ? X.move(h, { reverse: a }) : X.collapse(h, { edge: "end" });
					return;
				}
				if (Yg.isMoveWordBackward(n)) {
					e.preventDefault(), r && U.isExpanded(r) && X.collapse(h, { edge: "focus" }), X.move(h, {
						unit: "word",
						reverse: !a
					});
					return;
				}
				if (Yg.isMoveWordForward(n)) {
					e.preventDefault(), r && U.isExpanded(r) && X.collapse(h, { edge: "focus" }), X.move(h, {
						unit: "word",
						reverse: a
					});
					return;
				}
				if (!ih) {
					if (Yg.isBold(n) || Yg.isItalic(n) || Yg.isTransposeCharacter(n)) {
						e.preventDefault();
						return;
					}
					if (Yg.isSoftBreak(n)) {
						e.preventDefault(), K.insertSoftBreak(h);
						return;
					}
					if (Yg.isSplitBlock(n)) {
						e.preventDefault(), K.insertBreak(h);
						return;
					}
					if (Yg.isDeleteBackward(n)) {
						e.preventDefault(), r && U.isExpanded(r) ? K.deleteFragment(h, { direction: "backward" }) : K.deleteBackward(h);
						return;
					}
					if (Yg.isDeleteForward(n)) {
						e.preventDefault(), r && U.isExpanded(r) ? K.deleteFragment(h, { direction: "forward" }) : K.deleteForward(h);
						return;
					}
					if (Yg.isDeleteLineBackward(n)) {
						e.preventDefault(), r && U.isExpanded(r) ? K.deleteFragment(h, { direction: "backward" }) : K.deleteBackward(h, { unit: "line" });
						return;
					}
					if (Yg.isDeleteLineForward(n)) {
						e.preventDefault(), r && U.isExpanded(r) ? K.deleteFragment(h, { direction: "forward" }) : K.deleteForward(h, { unit: "line" });
						return;
					}
					if (Yg.isDeleteWordBackward(n)) {
						e.preventDefault(), r && U.isExpanded(r) ? K.deleteFragment(h, { direction: "backward" }) : K.deleteBackward(h, { unit: "word" });
						return;
					}
					if (Yg.isDeleteWordForward(n)) {
						e.preventDefault(), r && U.isExpanded(r) ? K.deleteFragment(h, { direction: "forward" }) : K.deleteForward(h, { unit: "word" });
						return;
					}
				} else if ((Zm || Ym) && r && (Yg.isDeleteBackward(n) || Yg.isDeleteForward(n)) && U.isCollapsed(r)) {
					var l = G.parent(h, r.anchor.path);
					if (W.isElement(l) && K.isVoid(h, l) && (K.isInline(h, l) || K.isBlock(h, l))) {
						e.preventDefault(), K.deleteBackward(h, { unit: "block" });
						return;
					}
				}
			}
		}, [
			o,
			h,
			m.onKeyDown
		]),
		onPaste: me((e) => {
			!o && Z.hasEditableTarget(h, e.target) && !l_(e, m.onPaste) && (!ih || Fh(e.nativeEvent) || Ym) && (e.preventDefault(), Z.insertData(h, e.clipboardData));
		}, [
			o,
			h,
			m.onPaste
		])
	}), /*#__PURE__*/ N.createElement(i_, {
		decorations: O,
		node: h,
		renderElement: s,
		renderPlaceholder: l,
		renderLeaf: c,
		selection: h.selection
	})))));
}, o_ = (e) => {
	var { attributes: t, children: n } = e;
	return /*#__PURE__*/ N.createElement("span", Object.assign({}, t), n, qm && /*#__PURE__*/ N.createElement("br", null));
}, s_ = () => [], c_ = (e, t) => {
	if (t.getBoundingClientRect && (!e.selection || e.selection && U.isCollapsed(e.selection))) {
		var n = t.startContainer.parentElement;
		n.getBoundingClientRect = t.getBoundingClientRect.bind(t), Hp(n, { scrollMode: "if-needed" }), delete n.getBoundingClientRect;
	}
}, l_ = (e, t) => t ? t(e) ?? (e.isDefaultPrevented() || e.isPropagationStopped()) : !1, u_ = (e) => Mh(e.target) && (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement), d_ = (e, t) => t ? t(e) ?? e.defaultPrevented : !1, f_ = /*#__PURE__*/ ue(!1), p_ = () => he(f_), m_ = /*#__PURE__*/ ue({});
function h_(e) {
	var t = xe([]).current, n = xe({ editor: e }).current, r = me((e) => {
		n.editor = e, t.forEach((t) => t(e));
	}, [t, n]);
	return {
		selectorContext: ye(() => ({
			getSlate: () => n.editor,
			addEventListener: (e) => (t.push(e), () => {
				t.splice(t.indexOf(e), 1);
			})
		}), [t, n]),
		onChange: r
	};
}
var g_ = [
	"editor",
	"children",
	"onChange",
	"initialValue"
], __ = (e) => {
	var { editor: t, children: n, onChange: r, initialValue: i } = e, a = Vm(e, g_), [o, s] = N.useState(() => {
		if (!G.isNodeList(i)) throw Error(`[Slate] initialValue is invalid! Expected a list of elements but got: ${Ds.stringify(i)}`);
		if (!K.isEditor(t)) throw Error(`[Slate] editor is invalid! You passed: ${Ds.stringify(t)}`);
		return t.children = i, Object.assign(t, a), {
			v: 0,
			editor: t
		};
	}), { selectorContext: c, onChange: l } = h_(t), u = me(() => {
		r && r(t.children), s((e) => ({
			v: e.v + 1,
			editor: t
		})), l(t);
	}, [
		t,
		l,
		r
	]);
	_e(() => (vh.set(t, u), () => {
		vh.set(t, () => {});
	}), [t, u]);
	var [d, f] = Se(Z.isFocused(t));
	return _e(() => {
		f(Z.isFocused(t));
	}, [t]), dg(() => {
		var e = () => f(Z.isFocused(t));
		return Wm >= 17 ? (document.addEventListener("focusin", e), document.addEventListener("focusout", e), () => {
			document.removeEventListener("focusin", e), document.removeEventListener("focusout", e);
		}) : (document.addEventListener("focus", e, !0), document.addEventListener("blur", e, !0), () => {
			document.removeEventListener("focus", e, !0), document.removeEventListener("blur", e, !0);
		});
	}, []), /*#__PURE__*/ N.createElement(m_.Provider, { value: c }, /*#__PURE__*/ N.createElement(Vg.Provider, { value: o }, /*#__PURE__*/ N.createElement(Hm.Provider, { value: o.editor }, /*#__PURE__*/ N.createElement(f_.Provider, { value: d }, n))));
}, v_ = (e, t) => {
	var n = (t.top + t.bottom) / 2;
	return e.top <= n && e.bottom >= n;
}, y_ = (e, t, n) => {
	var r = Z.toDOMRange(e, t).getBoundingClientRect(), i = Z.toDOMRange(e, n).getBoundingClientRect();
	return v_(r, i) && v_(i, r);
}, b_ = (e, t) => {
	var n = K.range(e, U.end(t)), r = Array.from(K.positions(e, { at: t })), i = 0, a = r.length, o = Math.floor(a / 2);
	if (y_(e, K.range(e, r[i]), n)) return K.range(e, r[i], n);
	if (r.length < 2) return K.range(e, r[r.length - 1], n);
	for (; o !== r.length && o !== i;) y_(e, K.range(e, r[o]), n) ? a = o : i = o, o = Math.floor((i + a) / 2);
	return K.range(e, r[a], n);
};
function x_(e, t) {
	var n = Object.keys(e);
	if (Object.getOwnPropertySymbols) {
		var r = Object.getOwnPropertySymbols(e);
		t && (r = r.filter(function(t) {
			return Object.getOwnPropertyDescriptor(e, t).enumerable;
		})), n.push.apply(n, r);
	}
	return n;
}
function S_(e) {
	for (var t = 1; t < arguments.length; t++) {
		var n = arguments[t] == null ? {} : arguments[t];
		t % 2 ? x_(Object(n), !0).forEach(function(t) {
			zm(e, t, n[t]);
		}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : x_(Object(n)).forEach(function(t) {
			Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
		});
	}
	return e;
}
var C_ = function(e) {
	var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x-slate-fragment", n = e, { apply: r, onChange: i, deleteBackward: a, addMark: o, removeMark: s } = n;
	return ph.set(n, /* @__PURE__ */ new WeakMap()), n.addMark = (e, t) => {
		var r, i;
		(r = yh.get(n)) == null || r(), !bh.get(n) && (i = Sh.get(n)) != null && i.length && bh.set(n, null), xh.delete(n), o(e, t);
	}, n.removeMark = (e) => {
		var t;
		!bh.get(n) && (t = Sh.get(n)) != null && t.length && bh.set(n, null), xh.delete(n), s(e);
	}, n.deleteBackward = (e) => {
		if (e !== "line") return a(e);
		if (n.selection && U.isCollapsed(n.selection)) {
			var t = K.above(n, {
				match: (e) => W.isElement(e) && K.isBlock(n, e),
				at: n.selection
			});
			if (t) {
				var [, r] = t, i = b_(n, K.range(n, r, n.selection.anchor));
				U.isCollapsed(i) || X.delete(n, { at: i });
			}
		}
	}, n.apply = (t) => {
		var i = [], a = [], o = Sh.get(n);
		if (o != null && o.length) {
			var s = o.map((e) => rg(e, t)).filter(Boolean);
			Sh.set(n, s);
		}
		var c = wh.get(n);
		c && wh.set(n, ng(n, c, t));
		var l = Ch.get(n);
		if (l != null && l.at) {
			var u = q.isPoint(l?.at) ? tg(n, l.at, t) : ng(n, l.at, t);
			Ch.set(n, u ? S_(S_({}, l), {}, { at: u }) : null);
		}
		switch (t.type) {
			case "insert_text":
			case "remove_text":
			case "set_node":
			case "split_node":
				i.push(...w_(n, t.path));
				break;
			case "set_selection":
				var d;
				(d = _h.get(n)) == null || d.unref(), _h.delete(n);
				break;
			case "insert_node":
			case "remove_node":
				i.push(...w_(n, H.parent(t.path)));
				break;
			case "merge_node":
				var f = H.previous(t.path);
				i.push(...w_(n, f));
				break;
			case "move_node":
				var p = H.common(H.parent(t.path), H.parent(t.newPath));
				i.push(...w_(n, p));
				var m;
				H.isBefore(t.path, t.newPath) ? (i.push(...w_(n, H.parent(t.path))), m = t.newPath) : (i.push(...w_(n, H.parent(t.newPath))), m = t.path);
				var h = G.get(e, H.parent(m)), g = Z.findKey(n, h), _ = K.pathRef(n, H.parent(m));
				a.push([_, g]);
				break;
		}
		r(t);
		for (var [v, y] of i) {
			var [b] = K.node(n, v);
			fh.set(b, y);
		}
		for (var [x, S] of a) if (x.current) {
			var [C] = K.node(n, x.current);
			fh.set(C, S);
		}
	}, n.setFragmentData = (e) => {
		var { selection: r } = n;
		if (r) {
			var [i, a] = U.edges(r), o = K.void(n, { at: i.path }), s = K.void(n, { at: a.path });
			if (!(U.isCollapsed(r) && !o)) {
				var c = Z.toDOMRange(n, r), l = c.cloneContents(), u = l.childNodes[0];
				if (l.childNodes.forEach((e) => {
					e.textContent && e.textContent.trim() !== "" && (u = e);
				}), s) {
					var [d] = s, f = c.cloneRange(), p = Z.toDOMNode(n, d);
					f.setEndAfter(p), l = f.cloneContents();
				}
				if (o && (u = l.querySelector("[data-slate-spacer]")), Array.from(l.querySelectorAll("[data-slate-zero-width]")).forEach((e) => {
					e.textContent = e.getAttribute("data-slate-zero-width") === "n" ? "\n" : "";
				}), Ph(u)) {
					var m = u.ownerDocument.createElement("span");
					m.style.whiteSpace = "pre", m.appendChild(u), l.appendChild(m), u = m;
				}
				var h = n.getFragment(), g = JSON.stringify(h), _ = window.btoa(encodeURIComponent(g));
				u.setAttribute("data-slate-fragment", _), e.setData(`application/${t}`, _);
				var v = l.ownerDocument.createElement("div");
				return v.appendChild(l), v.setAttribute("hidden", "true"), l.ownerDocument.body.appendChild(v), e.setData("text/html", v.innerHTML), e.setData("text/plain", Bh(v)), l.ownerDocument.body.removeChild(v), e;
			}
		}
	}, n.insertData = (e) => {
		n.insertFragmentData(e) || n.insertTextData(e);
	}, n.insertFragmentData = (e) => {
		var r = e.getData(`application/${t}`) || Hh(e);
		if (r) {
			var i = decodeURIComponent(window.atob(r)), a = JSON.parse(i);
			return n.insertFragment(a), !0;
		}
		return !1;
	}, n.insertTextData = (e) => {
		var t = e.getData("text/plain");
		if (t) {
			var r = t.split(/\r\n|\r|\n/), i = !1;
			for (var a of r) i && X.splitNodes(n, { always: !0 }), n.insertText(a), i = !0;
			return !0;
		}
		return !1;
	}, n.onChange = (e) => {
		(Wm < 18 ? we.unstable_batchedUpdates : (e) => e())(() => {
			var t = vh.get(n);
			t && t(), i(e);
		});
	}, n;
}, w_ = (e, t) => {
	var n = [];
	for (var [r, i] of K.levels(e, { at: t })) {
		var a = Z.findKey(e, r);
		n.push([i, a]);
	}
	return n;
}, T_ = (e, t) => {
	try {
		return Z.findPath(e, t);
	} catch {}
}, E_ = (e, t) => {
	t && Fu(e, () => {
		wd(e), Vu(e, t);
	}), Z.focus(e);
}, D_ = (e) => Z.isComposing(e), O_ = (e) => Z.isFocused(e), k_ = (e, { edge: t = "start" } = {}) => {
	E_(e, t === "start" ? qu(e, []) : Uu(e, []));
}, A_ = Xe, j_ = Object.prototype.hasOwnProperty;
function M_(e, t, n) {
	for (n of e.keys()) if (N_(n, t)) return n;
}
function N_(e, t) {
	var n, r, i;
	if (e === t) return !0;
	if (e && t && (n = e.constructor) === t.constructor) {
		if (n === Date) return e.getTime() === t.getTime();
		if (n === RegExp) return e.toString() === t.toString();
		if (n === Array) {
			if ((r = e.length) === t.length) for (; r-- && N_(e[r], t[r]););
			return r === -1;
		}
		if (n === Set) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r, i && typeof i == "object" && (i = M_(t, i), !i) || !t.has(i)) return !1;
			return !0;
		}
		if (n === Map) {
			if (e.size !== t.size) return !1;
			for (r of e) if (i = r[0], i && typeof i == "object" && (i = M_(t, i), !i) || !N_(r[1], t.get(i))) return !1;
			return !0;
		}
		if (n === ArrayBuffer) e = new Uint8Array(e), t = new Uint8Array(t);
		else if (n === DataView) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e.getInt8(r) === t.getInt8(r););
			return r === -1;
		}
		if (ArrayBuffer.isView(e)) {
			if ((r = e.byteLength) === t.byteLength) for (; r-- && e[r] === t[r];);
			return r === -1;
		}
		if (!n || typeof e == "object") {
			for (n in r = 0, e) if (j_.call(e, n) && ++r && !j_.call(t, n) || !(n in t) || !N_(e[n], t[n])) return !1;
			return Object.keys(t).length === r;
		}
	}
	return e !== e && t !== t;
}
//#endregion
//#region ../../../node_modules/use-deep-compare/dist-web/index.js
function P_(e) {
	let t = N.useRef(e), n = N.useRef(0);
	return N_(e, t.current) || (t.current = e, n.current += 1), N.useMemo(() => t.current, [n.current]);
}
function F_(e, t) {
	return N.useMemo(e, P_(t));
}
var I_ = (e) => e, L_ = (e) => ({
	_tag: "Left",
	value: e
}), R_ = (e) => ({
	_tag: "Right",
	value: e
}), z_ = (e, t, n) => n._tag === "Left" ? e(n.value) : t(n.value), B_ = {
	dimap: (e, t, n) => (r) => t(n(e(r))),
	first: (e) => ([t, n]) => [e(t), n],
	right: (e) => (t) => t._tag === "Left" ? t : R_(e(t.value)),
	wander: (e) => (t) => t.map(e)
}, V_ = {
	empty: () => void 0,
	foldMap: (e, t) => {
		for (let n = 0; n < t.length; n++) {
			let r = e(t[n]);
			if (r != null) return r;
		}
	}
}, H_ = {
	empty: () => [],
	foldMap: (e, t) => {
		let n = [];
		return t.forEach((t) => {
			n = n.concat(e(t));
		}), n;
	}
}, U_ = (e) => ({
	dimap: (e, t, n) => (t) => n(e(t)),
	first: (e) => ([t, n]) => e(t),
	right: (t) => (n) => n._tag === "Left" ? e.empty() : t(n.value),
	wander: (t) => (n) => e.foldMap(t, n)
}), W_ = {
	Equivalence: {
		Equivalence: "Equivalence",
		Iso: "Iso",
		Lens: "Lens",
		Prism: "Prism",
		Traversal: "Traversal",
		Getter: "Getter",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Iso: {
		Equivalence: "Iso",
		Iso: "Iso",
		Lens: "Lens",
		Prism: "Prism",
		Traversal: "Traversal",
		Getter: "Getter",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Lens: {
		Equivalence: "Lens",
		Iso: "Lens",
		Lens: "Lens",
		Prism: "Prism",
		Traversal: "Traversal",
		Getter: "Getter",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Prism: {
		Equivalence: "Prism",
		Iso: "Prism",
		Lens: "Prism",
		Prism: "Prism",
		Traversal: "Traversal",
		Getter: "AffineFold",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Traversal: {
		Equivalence: "Traversal",
		Iso: "Traversal",
		Lens: "Traversal",
		Prism: "Traversal",
		Traversal: "Traversal",
		Getter: "Fold",
		AffineFold: "Fold",
		Fold: "Fold",
		Setter: "Setter"
	},
	Getter: {
		Equivalence: "Getter",
		Iso: "Getter",
		Lens: "Getter",
		Prism: "AffineFold",
		Traversal: "Fold",
		Getter: "Getter",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: void 0
	},
	AffineFold: {
		Equivalence: "AffineFold",
		Iso: "AffineFold",
		Lens: "AffineFold",
		Prism: "AffineFold",
		Traversal: "Fold",
		Getter: "AffineFold",
		AffineFold: "AffineFold",
		Fold: "Fold",
		Setter: void 0
	},
	Fold: {
		Equivalence: "Fold",
		Iso: "Fold",
		Lens: "Fold",
		Prism: "Fold",
		Traversal: "Fold",
		Getter: "Fold",
		AffineFold: "Fold",
		Fold: "Fold",
		Setter: void 0
	},
	Setter: {
		Equivalence: void 0,
		Iso: void 0,
		Lens: void 0,
		Prism: void 0,
		Traversal: void 0,
		Getter: void 0,
		AffineFold: void 0,
		Fold: void 0,
		Setter: void 0
	}
}, G_ = (e, t) => {
	let n = t;
	return n._tag = e, n;
}, K_ = (e) => (e._removable = !0, e);
function q_(e, t, n) {
	switch (arguments.length) {
		case 2: {
			let n = (n, r) => e(n, t(n, r));
			return n._tag = W_[e._tag][t._tag], n._removable = t._removable || !1, n;
		}
		default: {
			let r = W_[e._tag][t._tag], i = (r, i) => e(r, t(r, n(r, i)));
			return i._tag = W_[r][n._tag], i._removable = n._removable || !1, i;
		}
	}
}
var J_ = /* @__PURE__ */ G_("Equivalence", (e, t) => t), Y_ = (e, t) => G_("Iso", (n, r) => n.dimap(e, t, r)), X_ = (e, t) => G_("Lens", (n, r) => n.dimap((t) => [e(t), t], t, n.first(r))), Z_ = (e, t) => G_("Prism", (n, r) => n.dimap(e, (e) => z_(I_, t, e), n.right(r))), Q_ = /* @__PURE__ */ G_("Traversal", (e, t) => e.dimap(I_, I_, e.wander(t))), $_ = (e) => G_("Getter", (t, n) => t.dimap(e, I_, n)), ev = (e, t, n) => e(B_, t)(n), tv = (e, t, n) => e(B_, () => t)(n), nv = (e, t) => e(U_({}), I_)(t), rv = (e, t) => e(U_(V_), I_)(t), iv = (e, t) => e(U_(H_), (e) => [e])(t), av = /* @__PURE__ */ Y_((e) => e.map((e, t) => [t, e]), (e) => {
	let t = [...e].sort((e, t) => e[0] - t[0]), n = [];
	for (let e = 0; e < t.length; ++e) (e === t.length - 1 || t[e][0] !== t[e + 1][0]) && n.push(t[e][1]);
	return n;
}), ov = (e) => X_((t) => t[e], ([t, n]) => Object.assign(Object.assign({}, n), { [e]: t })), sv = (e) => X_((t) => {
	let n = {};
	for (let r of e) n[r] = t[r];
	return n;
}, ([t, n]) => {
	let r = Object.assign({}, n);
	for (let t of e) delete r[t];
	return Object.assign(r, t);
}), cv = (e) => X_((t) => t[e], ([t, n]) => {
	let r = n.slice();
	return r[e] = t, r;
}), lv = /* @__PURE__ */ cv(0), uv = (e) => Z_((t) => e(t) ? R_(t) : L_(t), I_), dv = /* @__PURE__ */ Symbol("__no_match__"), fv = /* @__PURE__ */ uv((e) => e !== dv), pv = /* @__PURE__ */ Symbol("__remove_me__"), mv = (e) => K_(q_(X_((t) => 0 <= e && e < t.length ? t[e] : dv, ([t, n]) => {
	if (t === dv) return n;
	if (t === pv) return typeof n == "string" ? n.substring(0, e) + n.substring(e + 1) : [...n.slice(0, e), ...n.slice(e + 1)];
	if (typeof n == "string") return e === 0 ? t + n.substring(1) : e === n.length ? n.substring(0, e - 1) + t : n.substring(0, e) + t + n.substring(e + 1);
	{
		let r = n.slice();
		return r[e] = t, r;
	}
}), fv)), hv = /* @__PURE__ */ Z_((e) => e === void 0 ? L_(void 0) : R_(e), I_), gv = (e) => Z_((t) => e(t) ? R_(t) : L_(t), I_), _v = (e) => K_(q_(X_((t) => {
	let n = t.findIndex(e);
	return n === -1 ? [dv, -1] : [t[n], n];
}, ([[e, t], n]) => {
	if (e === dv) return n;
	if (e === pv) return [...n.slice(0, t), ...n.slice(t + 1)];
	let r = n.slice();
	return r[t] = e, r;
}), lv, fv)), vv = (e) => q_(X_((t) => {
	let n = t.map((t, n) => e(t) ? n : null).filter((e) => e != null);
	return [n.map((e) => t[e]), n];
}, ([[e, t], n]) => {
	let r = n.length, i = e.length, a = 0, o = 0, s = 0, c = [];
	for (; a < r;) t[o] === a ? (++o, s < i && (c.push(e[s]), ++s)) : c.push(n[a]), ++a;
	for (; s < i;) c.push(e[s++]);
	return c;
}), lv), yv = (e) => X_((t) => t === void 0 ? e : t, ([e, t]) => e), bv = (e) => q_(X_((t) => {
	let n = iv(e, t);
	return [n, n.length];
}, ([[t, n], r]) => {
	if (t.length !== n) throw Error("cannot add/remove elements through partsOf");
	let i = 0;
	return ev(e, () => t[i++], r);
}), lv), xv = (e) => X_((t) => e(t), ([e, t]) => e), Sv = (e) => X_((e) => e, ([t, n]) => e(t)), Cv = /* @__PURE__ */ X_((e) => void 0, ([e, t]) => e === void 0 ? t : [e, ...t]), wv = /* @__PURE__ */ X_((e) => void 0, ([e, t]) => e === void 0 ? t : [...t, e]), Tv = /* @__PURE__ */ q_(Y_((e) => e.split(""), (e) => e.join("")), Q_), Ev = /* @__PURE__ */ q_(Y_((e) => e.split(/\b/), (e) => e.join("")), Q_, uv((e) => !/\s+/.test(e))), Dv = /* @__PURE__ */ new class e {
	constructor(e) {
		this._ref = e;
	}
	get _tag() {
		return this._ref._tag;
	}
	get _removable() {
		return this._ref._removable;
	}
	compose(t) {
		return new e(q_(this._ref, t._ref));
	}
	iso(t, n) {
		return new e(q_(this._ref, Y_(t, n)));
	}
	lens(t, n) {
		return new e(q_(this._ref, X_(t, ([e, t]) => n(t, e))));
	}
	indexed() {
		return new e(q_(this._ref, av));
	}
	prop(t) {
		return new e(q_(this._ref, ov(t)));
	}
	path(...t) {
		return t.length === 1 && (t = t[0].split(".")), new e(t.reduce((e, t) => q_(e, ov(t)), this._ref));
	}
	pick(t) {
		return new e(q_(this._ref, sv(t)));
	}
	nth(t) {
		return new e(q_(this._ref, cv(t)));
	}
	filter(t) {
		return new e(q_(this._ref, vv(t)));
	}
	valueOr(t) {
		return new e(q_(this._ref, yv(t)));
	}
	partsOf(t) {
		let n = typeof t == "function" ? t(Dv) : t;
		return new e(q_(this._ref, bv(n._ref)));
	}
	reread(t) {
		return new e(q_(this._ref, xv(t)));
	}
	rewrite(t) {
		return new e(q_(this._ref, Sv(t)));
	}
	optional() {
		return new e(q_(this._ref, hv));
	}
	guard_() {
		return (e) => this.guard(e);
	}
	guard(t) {
		return new e(q_(this._ref, gv(t)));
	}
	at(t) {
		return new e(q_(this._ref, mv(t)));
	}
	head() {
		return new e(q_(this._ref, mv(0)));
	}
	index(t) {
		return new e(q_(this._ref, mv(t)));
	}
	find(t) {
		return new e(q_(this._ref, _v(t)));
	}
	elems() {
		return new e(q_(this._ref, Q_));
	}
	to(t) {
		return new e(q_(this._ref, $_(t)));
	}
	when(t) {
		return new e(q_(this._ref, uv(t)));
	}
	chars() {
		return new e(q_(this._ref, Tv));
	}
	words() {
		return new e(q_(this._ref, Ev));
	}
	prependTo() {
		return new e(q_(this._ref, Cv));
	}
	appendTo() {
		return new e(q_(this._ref, wv));
	}
}(J_);
//#endregion
//#region ../../../node_modules/optics-ts/dist/mjs/index.js
function Ov() {
	return Dv;
}
function kv(e) {
	return (t) => nv(e._ref, t);
}
function Av(e) {
	return (t) => rv(e._ref, t);
}
function jv(e) {
	return (t) => iv(e._ref, t);
}
function Mv(e) {
	return (t) => (n) => ev(e._ref, t, n);
}
function Nv(e) {
	return (t) => (n) => tv(e._ref, t, n);
}
//#endregion
//#region ../../../node_modules/@udecode/plate-core/node_modules/jotai-optics/dist/index.modern.mjs
var Pv = (e, t, n) => (t.has(n) ? t : t.set(n, e())).get(n), Fv = /* @__PURE__ */ new WeakMap();
function Iv(e, t) {
	return ((n, r, i) => Pv(() => {
		let n = t(Ov());
		return Le((t) => {
			let r = t(e);
			return r instanceof Promise ? r.then((e) => Lv(n, e)) : Lv(n, r);
		}, (t, r, i) => {
			let a = typeof i == "function" ? Mv(n)(i) : Nv(n)(i), o = t(e);
			return r(e, o instanceof Promise ? o.then(a) : a(o));
		});
	}, Pv(() => /* @__PURE__ */ new WeakMap(), Fv, r), i))(0, e, t);
}
var Lv = (e, t) => e._tag === "Traversal" ? jv(e)(t) : e._tag === "Prism" ? Av(e)(t) : kv(e)(t), Rv = Qf(), zv = Object.defineProperty, Bv = Object.defineProperties, Vv = Object.getOwnPropertyDescriptors, Hv = Object.getOwnPropertySymbols, Uv = Object.prototype.hasOwnProperty, Wv = Object.prototype.propertyIsEnumerable, Gv = (e, t, n) => t in e ? zv(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Q = (e, t) => {
	for (var n in t ||= {}) Uv.call(t, n) && Gv(e, n, t[n]);
	if (Hv) for (var n of Hv(t)) Wv.call(t, n) && Gv(e, n, t[n]);
	return e;
}, Kv = (e, t) => Bv(e, Vv(t)), qv = (e, t) => {
	var n = {};
	for (var r in e) Uv.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && Hv) for (var r of Hv(e)) t.indexOf(r) < 0 && Wv.call(e, r) && (n[r] = e[r]);
	return n;
}, Jv = [
	"readOnly",
	"plugins",
	"onChange",
	"decorate",
	"renderElement",
	"renderLeaf"
], Yv = "element", { ElementProvider: Xv, useElementStore: Zv } = Sr({ element: null }, { name: "element" }), Qv = (e = Yv) => Zv(e).get.element() || (console.warn("The `useElement(pluginKey)` hook must be used inside the node component's context"), {}), $v = pa("event-editor")({
	blur: null,
	focus: null,
	last: null
}), ey = $v.set, ty = $v.get;
$v.use;
var ny = (e, t = {}, n = !1) => {
	if (t[e.key]) {
		let r = t[e.key], { plugins: i, then: a } = r;
		e = zd(qv(r, ["plugins", "then"]), e), n || i?.forEach((t) => {
			e.plugins ||= [], e.plugins.find((e) => e.key === t.key) || e.plugins.push(t);
		});
	}
	e.plugins &&= e.plugins.map((e) => ny(e, t, !0));
	let { then: r } = e;
	return r ? (e._thenReplaced === void 0 && (e._thenReplaced = 0), e._thenReplaced < 3 && (e.then = (n, i) => {
		let a = Q({ key: e.key }, r(n, i));
		return zd(ny(a, t), a);
	}, e._thenReplaced++)) : t[e.key]?.then && (e.then = t[e.key].then), e;
}, ry = (e, { components: t, overrideByKey: n } = {}) => {
	let r = {};
	return n && (r = Rd(n)), t && Object.keys(t).forEach((e) => {
		r[e] || (r[e] = {}), r[e].component = t[e];
	}), Object.keys(r).length > 0 ? e.map((e) => ny(e, r)) : e;
}, iy = (e, t) => {
	Uf(e, Q({
		at: [],
		nodes: e.childrenFactory()
	}, t));
}, ay = (e) => {
	iy(e), e.history.undos = [], e.history.redos = [], e.operations = [];
}, oy = (e) => e?.pluginsByKey ?? {}, sy = (e, t) => oy(e)[t] ?? { key: t }, cy = (e, t) => sy(e, t).type ?? t ?? "", ly = (e) => (t, n = {}) => (n[e.key] = t, ny(Q({}, e), n)), uy = ly({
	editor: { insertData: {
		format: "application/x-slate-fragment",
		getFragment: ({ data: e }) => {
			let t = decodeURIComponent(window.atob(e)), n;
			try {
				n = JSON.parse(t);
			} catch {}
			return Bd(n);
		}
	} },
	key: "deserializeAst"
}), dy = (e, t = {}) => ku(e, Kv(Q({}, t), { block: !0 })), fy = (e, t) => {
	let { selection: n } = e;
	if (!n) return !1;
	let r = dy(e, t)?.[1];
	return r ? sd(e, n.focus, r) || Sd(e.selection) && sd(e, n.anchor, r) : !1;
}, py = (e) => {
	let t = ed(e);
	t && Object.keys(t).forEach((t) => {
		ld(e, t);
	});
}, my = ly({
	key: "editorProtocol",
	withOverrides: (e) => {
		let { deleteBackward: t, deleteForward: n, deleteFragment: r } = e, i = () => {
			fy(e) && py(e);
		};
		return e.deleteBackward = (e) => {
			t(e), i();
		}, e.deleteForward = (e) => {
			n(e), i();
		}, e.deleteFragment = (e) => {
			r(e), i();
		}, e;
	}
}), hy = ly({
	key: "history",
	withOverrides: (e) => su(e)
}), gy = ly({
	key: "inline-void",
	withOverrides: (e) => {
		let { isInline: t, isVoid: n, markableVoid: r } = e, i = [], a = [], o = [];
		return e.plugins.forEach((e) => {
			e.isInline && a.push(e.type), e.isVoid && i.push(e.type), e.isMarkableVoid && o.push(e.type);
		}), e.isInline = (e) => a.includes(e.type) ? !0 : t(e), e.isVoid = (e) => i.includes(e.type) ? !0 : n(e), e.markableVoid = (e) => o.includes(e.type) ? !0 : r(e), e;
	}
}), _y = (e, t) => {
	let n = [];
	return [...e.plugins].reverse().forEach((e) => {
		let r = e.inject.pluginsByKey?.[t.key];
		r && n.push(r);
	}), [t, ...n];
}, vy = (e, { data: t, dataTransfer: n }) => e.every((e) => {
	let r = e.editor?.insertData?.query;
	return !r || r({
		data: t,
		dataTransfer: n
	});
}), yy = (e, t, n) => {
	var r = n, { fragment: i } = r, a = qv(r, ["fragment"]);
	Fu(e, () => {
		t.some((e) => {
			var t;
			return ((t = e.editor?.insertData)?.preInsert)?.call(t, i, a) === !0;
		}), e.insertFragment(i);
	});
}, by = (e, { data: t, dataTransfer: n }) => (e.forEach((e) => {
	let r = e.editor?.insertData?.transformData;
	r && (t = r(t, { dataTransfer: n }));
}), t), xy = (e, t) => {
	var n = t, { fragment: r } = n, i = qv(n, ["fragment"]);
	return e.forEach((e) => {
		let t = e.editor?.insertData?.transformFragment;
		t && (r = t(r, i));
	}), r;
}, Sy = ly({
	key: "insertData",
	withOverrides: (e) => {
		let { insertData: t } = e;
		return e.insertData = (n) => {
			[...e.plugins].reverse().some((t) => {
				let r = t.editor.insertData;
				if (!r) return !1;
				let i = _y(e, t), { format: a, getFragment: o } = r;
				if (!a) return !1;
				let s = n.getData(a);
				if (!s) return;
				if (!vy(i, {
					data: s,
					dataTransfer: n
				})) return !1;
				s = by(i, {
					data: s,
					dataTransfer: n
				});
				let c = o?.({
					data: s,
					dataTransfer: n
				});
				return !c?.length || (c = xy(i, {
					data: s,
					dataTransfer: n,
					fragment: c
				}), c.length === 0) ? !1 : (yy(e, i, {
					data: s,
					dataTransfer: n,
					fragment: c
				}), !0);
			}) || t(n);
		}, e;
	}
}), Cy = ly({
	key: "length",
	withOverrides: (e, { options: t }) => {
		let { apply: n } = e;
		return e.apply = (r) => {
			Fu(e, () => {
				if (n(r), t.maxLength) {
					let n = Qu(e, []).length;
					if (n > t.maxLength) {
						let r = n - t.maxLength;
						e.delete({
							distance: r,
							reverse: !0,
							unit: "character"
						});
					}
				}
			});
		}, e;
	}
}), wy = ({ apply: e, node: t, path: n = [], query: r, source: i }) => {
	Ed([t, n], r) && (i instanceof Function ? e(t, i()) : e(t, i)), bd(t) && t.children.forEach((t, a) => {
		wy({
			apply: e,
			node: t,
			path: n.concat([a]),
			query: r,
			source: i
		});
	});
}, Ty = (e, t) => {
	let n = Q({}, t), { then: r } = n;
	if (r) {
		delete n.then;
		let { plugins: t } = n, i = Ty(e, zd(r(e, n), n));
		return t && i.plugins && (i.plugins = Jf(qf(Kf(t, "key"), Kf(i.plugins, "key")))), i;
	}
	return n;
}, Ey = (e) => (e.type === void 0 && (e.type = e.key), e.options ||= {}, e.inject ||= {}, e.editor ||= {}, e), Dy = (e, t) => {
	t && t.forEach((t) => {
		let n = Ey(t);
		if (n = Ty(e, n), n.enabled !== !1) {
			if (e.pluginsByKey[n.key]) {
				let t = e.plugins.indexOf(e.pluginsByKey[n.key]), r = zd(n, e.pluginsByKey[n.key]);
				t >= 0 && (e.plugins[t] = r), e.pluginsByKey[n.key] = r;
			} else e.plugins.push(n), e.pluginsByKey[n.key] = n;
			Dy(e, n.plugins);
		}
	});
}, Oy = (e) => `slate-${e}`, ky = ({ attributes: e, dangerouslyAllowAttributes: t, nodeProps: n, props: r, type: i }) => {
	let a = {};
	r && (a = (typeof r == "function" ? r(n) : r) ?? {}), !a.nodeProps && e && (a.nodeProps = Zf(e, t ?? [])), n = Q(Q({}, n), a), n.nodeProps && Object.keys(n.nodeProps).forEach((e) => {
		var t;
		n.nodeProps?.[e] === void 0 && ((t = n.nodeProps) == null || delete t[e]);
	});
	let { className: o } = n;
	return Kv(Q({}, n), { className: Xf(Oy(i), o) });
}, Ay = (e) => {
	wy(Kv(Q({}, e), { apply: qf }));
}, jy = (e) => Q({
	editor: {},
	inject: {},
	key: "",
	options: {},
	type: ""
}, e), My = (e) => (t) => Iu(t) || wu(t) && e.isInline(t), Ny = (e) => () => ({
	children: [],
	type: e
}), Py = (e, t) => e.some((e, n, r) => {
	let i = r[n - 1];
	return n !== 0 && t(e) !== t(i);
}), Fy = (e, t, n) => {
	let r = Py(e, t), { fragment: i } = e.reduce((e, i) => {
		if (r && t(i)) {
			let t = e.precedingBlock;
			t || (t = n(), e.precedingBlock = t, e.fragment.push(t)), t.children.push(i);
		} else e.fragment.push(i), e.precedingBlock = null;
		return e;
	}, {
		fragment: [],
		precedingBlock: null
	});
	return i;
}, Iy = (e) => e.length === 0 ? [{ text: "" }] : e, Ly = (e, t, n) => (e = Iy(e), e = Fy(e, t, n), e = e.map((e) => wu(e) ? Kv(Q({}, e), { children: Ly(e.children, t, n) }) : e), e), Ry = (e, { descendants: t }) => Ly(t, My(e), Ny(cy(e, "p"))), zy = (e, t) => {
	let n = e.plugins.flatMap((t) => t.decorate?.call(t, e, t) ?? []);
	if (t && n.push(t), n.length !== 0) return (e) => {
		let t = [], r = (e) => {
			e?.length && (t = [...t, ...e]);
		};
		return n.forEach((t) => {
			r(t(e));
		}), t;
	};
}, By = (e) => {
	let t = !1;
	return Kv(Q({}, e), {
		bubbles: e.bubbles,
		cancelable: e.cancelable,
		currentTarget: e.currentTarget,
		defaultPrevented: e.defaultPrevented,
		eventPhase: e.eventPhase,
		isDefaultPrevented: () => e.defaultPrevented,
		isPropagationStopped: () => t,
		isTrusted: e.isTrusted,
		nativeEvent: e,
		persist: () => {
			throw Error("persist is not implemented for synthetic events created using convertDomEventToSyntheticEvent");
		},
		preventDefault: () => e.preventDefault(),
		stopPropagation: () => {
			t = !0, e.stopPropagation();
		},
		target: e.target,
		timeStamp: e.timeStamp,
		type: e.type
	});
}, Vy = (e, t) => t ? t(e) ?? e.isPropagationStopped() : !1, Hy = (e, { editableProps: t, handlerKey: n }) => {
	let r = [];
	r = e.plugins.flatMap((t) => {
		var r;
		return ((r = t.handlers)?.[n])?.call(r, e, t) ?? [];
	});
	let i = t?.[n];
	if (!(r.length === 0 && !i)) return (e) => {
		let t = e instanceof Event ? By(e) : e;
		return r.some((e) => Vy(t, e)) ? !0 : Vy(t, i);
	};
}, Uy = (e, { inject: { props: t }, key: n }, r) => {
	let { className: i, element: a, style: o, text: s } = r, c = a ?? s;
	if (!c || !t) return;
	let { classNames: l, defaultNodeValue: u, nodeKey: d = n, query: f, styleKey: p = d, transformClassName: m, transformNodeValue: h, transformProps: g, transformStyle: _, validNodeValues: v, validTypes: y } = t, b = f?.(t, r);
	if (!b && y && wu(c) && c.type && !y.includes(c.type)) return;
	let x = c[d];
	if (!b && (!$d(x) || v && !v.includes(x) || x === u)) return;
	let S = Kv(Q({}, r), { nodeValue: x }), C = h?.(S) ?? x;
	S.value = C;
	let w = {};
	return a && (w.className = Xf(i, `slate-${d}-${x}`)), (l?.[x] || m) && (w.className = m?.(S) ?? Xf(i, l?.[C])), p && (w.style = _?.(S) ?? Kv(Q({}, o), { [p]: C })), g && (w = g(S, w) ?? w), w;
}, Wy = (e, t) => (e.plugins.forEach((n) => {
	if (n.inject.props) {
		let r = Uy(e, n, t);
		r && (t = Q(Q({}, t), r));
	}
}), Kv(Q({}, t), { editor: e })), Gy = (e) => {
	let t = e.plugins.flatMap((t) => {
		var n;
		return ((n = t.handlers)?.onChange)?.call(n, e, t) ?? [];
	});
	return (e) => t.some((t) => t ? t(e) ?? !1 : !1);
}, Ky = {
	bold: "mod+b",
	compose: [
		"down",
		"left",
		"right",
		"up",
		"backspace",
		"enter"
	],
	deleteBackward: "shift?+backspace",
	deleteForward: "shift?+delete",
	extendBackward: "shift+left",
	extendForward: "shift+right",
	insertSoftBreak: "shift+enter",
	italic: "mod+i",
	moveBackward: "left",
	moveForward: "right",
	moveWordBackward: "ctrl+left",
	moveWordForward: "ctrl+right",
	splitBlock: "enter",
	tab: "tab",
	undo: "mod+z",
	untab: "shift+tab"
}, qy = {
	deleteBackward: ["ctrl+backspace", "ctrl+h"],
	deleteForward: ["ctrl+delete", "ctrl+d"],
	deleteLineBackward: "cmd+shift?+backspace",
	deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
	deleteWordBackward: "opt+shift?+backspace",
	deleteWordForward: "opt+shift?+delete",
	extendLineBackward: "opt+shift+up",
	extendLineForward: "opt+shift+down",
	moveLineBackward: "opt+up",
	moveLineForward: "opt+down",
	moveWordBackward: "opt+left",
	moveWordForward: "opt+right",
	redo: "cmd+shift+z",
	transposeCharacter: "ctrl+t"
}, Jy = {
	deleteWordBackward: "ctrl+shift?+backspace",
	deleteWordForward: "ctrl+shift?+delete",
	redo: ["ctrl+y", "ctrl+shift+z"]
}, Yy = (e) => {
	let t = Ky[e], n = qy[e], r = Jy[e], i = t && (0, Rv.isKeyHotkey)(t), a = n && (0, Rv.isKeyHotkey)(n), o = r && (0, Rv.isKeyHotkey)(r);
	return (e) => !!(i?.(e) || Hd && a?.(e) || !Hd && o?.(e));
}, Xy = {
	isBold: Yy("bold"),
	isCompose: Yy("compose"),
	isDeleteBackward: Yy("deleteBackward"),
	isDeleteForward: Yy("deleteForward"),
	isDeleteLineBackward: Yy("deleteLineBackward"),
	isDeleteLineForward: Yy("deleteLineForward"),
	isDeleteWordBackward: Yy("deleteWordBackward"),
	isDeleteWordForward: Yy("deleteWordForward"),
	isExtendBackward: Yy("extendBackward"),
	isExtendForward: Yy("extendForward"),
	isExtendLineBackward: Yy("extendLineBackward"),
	isExtendLineForward: Yy("extendLineForward"),
	isItalic: Yy("italic"),
	isMoveBackward: Yy("moveBackward"),
	isMoveForward: Yy("moveForward"),
	isMoveLineBackward: Yy("moveLineBackward"),
	isMoveLineForward: Yy("moveLineForward"),
	isMoveWordBackward: Yy("moveWordBackward"),
	isMoveWordForward: Yy("moveWordForward"),
	isRedo: Yy("redo"),
	isSoftBreak: Yy("insertSoftBreak"),
	isSplitBlock: Yy("splitBlock"),
	isTransposeCharacter: Yy("transposeCharacter"),
	isUndo: Yy("undo")
}, Zy = ly({
	key: "nodeFactory",
	withOverrides: (e) => (e.blockFactory = (t) => Q({
		children: [{ text: "" }],
		type: cy(e, "p")
	}, t), e.childrenFactory = () => [e.blockFactory()], e)
}), Qy = ly({
	handlers: { onKeyDown: (e) => (t) => {
		t.persist(), e.currentKeyboardEvent = t;
	} },
	key: "prevSelection",
	withOverrides: (e) => {
		let { apply: t } = e;
		return e.apply = (n) => {
			if (n.type === "set_selection") {
				let { properties: r } = n;
				e.prevSelection = r, t(n), e.currentKeyboardEvent = null;
				return;
			}
			t(n);
		}, e;
	}
}), $y = "focus-editor-event", eb = "blur-editor-event", tb = ly({
	handlers: {
		onBlur: (e) => () => {
			ty.focus() === e.id && ey.focus(null), ey.blur(e.id), document.dispatchEvent(new CustomEvent(eb, { detail: { id: e.id } }));
		},
		onFocus: (e) => () => {
			ey.focus(e.id), document.dispatchEvent(new CustomEvent($y, { detail: { id: e.id } }));
		}
	},
	key: "event-editor"
}), nb = (e, { shouldCollapseWhiteSpace: t = !0, trimEnd: n = "collapse", trimStart: r = "collapse", whiteSpaceIncludesNewlines: i = !0 } = {}) => (r === "all" && (e = e.replace(/^\s+/, "")), n === "single-newline" && (e = e.replace(/\n$/, "")), t && (i ? e = e.replaceAll(/\s+/g, " ") : (e = e.replaceAll(/[^\S\n\r]+/g, " "), e = e.replaceAll(/^[^\S\n\r]+/gm, ""), e = e.replaceAll(/[^\S\n\r]+$/gm, ""))), e), rb = /* @__PURE__ */ new Set(/* @__PURE__ */ "A.ABBR.B.BDI.BDO.BR.CITE.CODE.DATA.DFN.EM.I.KBD.MARK.Q.S.SAMP.SMALL.SPAN.STRONG.SUB.SUP.TIME.U.VAR.WBR.IMG.MAP.TRACK.VIDEO.EMBED.IFRAME.OBJECT.PICTURE.PORTAL.SOURCE.svg.math.CANVAS.DEL.INS.BUTTON.INPUT.LABEL.METER.OUTPUT.PROGRESS.SELECT.TEXTAREA.ACRONYM.BIG.CONTENT.FONT.IMG.MARQUEE.MENUITEM.NOBR.SHADOW.STRIKE.TT".split(".")), ib = (e) => e.nodeType === Node.ELEMENT_NODE, ab = (e) => {
	if (!ib(e)) return !1;
	let t = e, n = rb.has(t.tagName), r = t.style.display.split(" ")[0];
	return r === "" ? n : r.startsWith("inline") ? !0 : r === "inherit" && t.parentElement ? ab(t.parentElement) : [
		"contents",
		"initial",
		"none",
		"revert",
		"revert-layer",
		"unset"
	].includes(r) ? n : !1;
}, ob = (e) => e.nodeType === Node.TEXT_NODE, sb = (e) => ib(e) ? !ab(e) : !1, cb = (e) => {
	let t = e;
	for (;;) {
		if (t.nextSibling) t = t.nextSibling;
		else {
			if (t = t.parentElement, t && sb(t)) return !0;
			t = t?.nextSibling || null;
		}
		if (!t || sb(t)) return !0;
		if ((t.textContent || "").length > 0) return !1;
	}
}, lb = (e) => {
	e.inlineFormattingContext ? e.inlineFormattingContext.atStart = !1 : e.inlineFormattingContext = {
		atStart: !0,
		lastHasTrailingWhiteSpace: !1
	};
}, ub = (e) => {
	e.inlineFormattingContext = null;
}, db = (e, t) => {
	let n = e.textContent || "", r = n.trim() === "";
	(t.inlineFormattingContext || !r) && lb(t);
	let { whiteSpaceRule: i } = t, a = i === "normal" && (!t.inlineFormattingContext || t.inlineFormattingContext.atStart || t.inlineFormattingContext.lastHasTrailingWhiteSpace) ? "all" : "collapse", o = i === "normal" ? "collapse" : cb(e) ? "single-newline" : "collapse", s = {
		normal: !0,
		pre: !1,
		"pre-line": !0
	}[i], c = nb(n || "", {
		shouldCollapseWhiteSpace: s,
		trimEnd: o,
		trimStart: a,
		whiteSpaceIncludesNewlines: i !== "pre-line"
	});
	t.inlineFormattingContext && s && (t.inlineFormattingContext.lastHasTrailingWhiteSpace = c.endsWith(" ")), e.textContent = c;
}, fb = (e, t) => {
	if (ib(e)) {
		hb(e, t);
		return;
	}
	if (ob(e)) {
		db(e, t);
		return;
	}
	pb(e, t);
}, pb = (e, t) => {
	let n = Array.from(e.childNodes);
	for (let e of n) fb(e, t);
}, mb = (e) => {
	let t = e.style.whiteSpace;
	switch (t) {
		case "normal":
		case "nowrap": return "normal";
		case "pre":
		case "pre-wrap":
		case "break-spaces": return "pre";
		case "pre-line": return "pre-line";
	}
	return e.tagName === "PRE" ? "pre" : t === "initial" ? "normal" : null;
}, hb = (e, t) => {
	let n = ab(e), r = t.whiteSpaceRule, i = mb(e);
	i && (t.whiteSpaceRule = i), n || ub(t), pb(e, t), n || ub(t), t.whiteSpaceRule = r;
}, gb = (e) => {
	let t = e.cloneNode(!0);
	return hb(t, {
		inlineFormattingContext: null,
		whiteSpaceRule: "normal"
	}), t;
}, _b = (e, t) => Array.from(t.childNodes).flatMap(Eb(e)), vb = (e, t) => {
	if (t.nodeName === "BODY") return Ap("fragment", {}, _b(e, t));
}, yb = (e) => {
	if (e.nodeName === "BR") return "\n";
}, bb = (e, t, { deserializeLeaf: n, element: r }) => {
	let { deserializeHtml: i, isElement: a, isLeaf: o, type: s } = t;
	if (!i) return;
	let { attributeNames: c, isElement: l, isLeaf: u, query: d, rules: f } = i, { getNode: p } = i, m = l || a, h = u || o;
	if (!n && !m || n && !h || f && !f.some(({ validAttribute: e, validClassName: n, validNodeName: i = "*", validStyle: a }) => {
		if (i) {
			let e = Bd(i);
			if (e.length > 0 && !e.includes(r.nodeName) && i !== "*") return !1;
		}
		if (n && !r.classList.contains(n)) return !1;
		if (a) for (let [e, n] of Object.entries(a)) {
			if (!Bd(n).includes(r.style[e]) && n !== "*" || n === "*" && !r.style[e]) return;
			let i = t.inject.props?.defaultNodeValue;
			if (i && i === r.style[e]) return !1;
		}
		if (e) if (typeof e == "string") {
			if (!r.getAttributeNames().includes(e)) return !1;
		} else for (let [t, n] of Object.entries(e)) {
			let e = Bd(n), i = r.getAttribute(t);
			if (!$d(i) || !e.includes(i)) return !1;
		}
		return !0;
	}) || d && !d(r)) return;
	if (!p) if (m) p = () => ({ type: s });
	else if (h) p = () => ({ [s]: !0 });
	else return;
	let g = p(r, {}) ?? {};
	if (Object.keys(g).length !== 0) {
		if (_y(e, t).forEach((e) => {
			var t;
			let n = ((t = e.deserializeHtml)?.getNode)?.call(t, r, g);
			n && (g = Q(Q({}, g), n));
		}), c) {
			let e = {}, t = r.getAttributeNames();
			for (let n of t) c.includes(n) && (e[n] = r.getAttribute(n));
			Object.keys(e).length > 0 && (g.attributes = e);
		}
		return Kv(Q({}, i), { node: g });
	}
}, xb = (e, t) => {
	let n;
	return [...e.plugins].reverse().some((r) => (n = bb(e, r, { element: t }), !!n)), n;
}, Sb = (e, t) => {
	let n = xb(e, t);
	if (n) {
		let { node: r, withoutChildren: i } = n, a = r.children ?? _b(e, t);
		return (a.length === 0 || i) && (a = [{ text: "" }]), Ap("element", r, a);
	}
}, Cb = (e, t) => {
	let n = {};
	return [...e.plugins].reverse().forEach((r) => {
		let i = bb(e, r, {
			deserializeLeaf: !0,
			element: t
		});
		i && (n = Q(Q({}, n), i.node));
	}), n;
}, wb = (e, t) => {
	let n = Cb(e, t);
	return _b(e, t).reduce((e, t) => {
		if (!t) return e;
		if (wu(t)) Object.keys(n).length > 0 && Ay({
			node: t,
			query: { filter: ([e]) => Iu(e) },
			source: n
		}), e.push(t);
		else {
			let r = Q({}, n);
			Iu(t) && t.text && Object.keys(r).forEach((e) => {
				r[e] && t[e] && (r[e] = t[e]);
			}), e.push(Ap("text", r, t));
		}
		return e;
	}, []);
}, Tb = (e) => {
	if (ob(e)) return e.textContent || "";
}, Eb = (e) => (t) => Tb(t) || (ib(t) ? yb(t) || vb(e, t) || Sb(e, t) || wb(e, t) : null), Db = (e, t) => Eb(e)(t), Ob = (e) => {
	let t = document.createElement("body");
	return t.innerHTML = e, t;
}, kb = (e, { collapseWhiteSpace: t = !0, element: n }) => (typeof n == "string" && (n = Ob(n)), t && (n = gb(n)), Ry(e, { descendants: Db(e, n) })), Ab = (e) => new DOMParser().parseFromString(e, "text/html"), jb = ly({
	key: "deserializeHtml",
	then: (e) => ({ editor: { insertData: {
		format: "text/html",
		getFragment: ({ data: t }) => kb(e, { element: Ab(t).body })
	} } })
}), Mb = ly({
	key: "react",
	withOverrides: (e) => {
		let t = C_(e), { reset: n } = t;
		return t.reset = () => {
			let t = O_(e);
			n(), t && k_(e, { edge: "start" });
		}, t;
	}
}), Nb = (e, { disableCorePlugins: t, maxLength: n, plugins: r = [] }) => {
	let i = [];
	if (t !== !0) {
		let r = t;
		(typeof r != "object" || !r?.react) && i.push(e?.pluginsByKey?.react ?? Mb()), (typeof r != "object" || !r?.history) && i.push(e?.pluginsByKey?.history ?? hy()), (typeof r != "object" || !r?.nodeFactory) && i.push(e?.pluginsByKey?.nodeFactory ?? Zy()), (typeof r != "object" || !r?.eventEditor) && i.push(e?.pluginsByKey?.["event-editor"] ?? tb()), (typeof r != "object" || !r?.inlineVoid) && i.push(e?.pluginsByKey?.["inline-void"] ?? gy()), (typeof r != "object" || !r?.insertData) && i.push(e?.pluginsByKey?.insertData ?? Sy()), (typeof r != "object" || !r?.selection) && i.push(e?.pluginsByKey?.prevSelection ?? Qy()), (typeof r != "object" || !r?.length) && $d(n) && i.push(e?.pluginsByKey?.length ?? Cy({ options: { maxLength: n } })), (typeof r != "object" || !r?.deserializeHtml) && i.push(e?.pluginsByKey?.deserializeHtml ?? jb()), (typeof r != "object" || !r?.deserializeAst) && i.push(e?.pluginsByKey?.deserializeAst ?? uy()), (typeof r != "object" || !r?.editorProtocol) && i.push(e?.pluginsByKey?.editorProtocol ?? my());
	}
	i = [...i, ...r], e.plugins = [], e.pluginsByKey = {}, Dy(e, i), e.plugins.forEach((t) => {
		if (t.overrideByKey) {
			let n = e.plugins.map((e) => ny(e, t.overrideByKey));
			e.plugins = [], e.pluginsByKey = {}, Dy(e, n);
		}
	});
}, Pb = (e) => () => {
	console.warn(`editor.${e} should have been overriden but was not. Please report this issue here: https://github.com/udecode/plate/issues`);
}, Fb = (e, { disableCorePlugins: t, id: n, maxLength: r, plugins: i = [] } = {}) => {
	let a = e;
	return a.id = n ?? a.id, a.prevSelection = null, a.isFallback = !1, a.currentKeyboardEvent = null, a.reset = () => ay(a), a.redecorate = () => Pb("redecorate"), a.plate = { get set() {
		return null;
	} }, a.key ||= Math.random(), Nb(a, {
		disableCorePlugins: t,
		maxLength: r,
		plugins: i
	}), a.plugins.forEach((e) => {
		e.withOverrides && (a = e.withOverrides(a, e));
	}), a;
}, Ib = (e = {}) => {
	var t = e, { components: n, editor: r = bu(), normalizeInitialValue: i, overrideByKey: a, plugins: o = [] } = t, s = qv(t, [
		"components",
		"editor",
		"normalizeInitialValue",
		"overrideByKey",
		"plugins"
	]);
	o = ry(o, {
		components: n,
		overrideByKey: a
	});
	let c = Fb(r, Q({ plugins: o }, s));
	return i && cd(c, { force: !0 }), c;
}, Lb = (e = {}) => {
	let t = Ib(e);
	return t.isFallback = !0, t.apply = () => {
		throw Error("Cannot apply operations on the fallback editor. The fallback editor is used when a hook that depends on the Plate store was unable to locate a valid store. If you are using PlateController, use `useEditorMounted(id?: PlateId)` or `!editor.isFallback` to ensure that a valid Plate store is available before attempting to call operations on the editor.");
	}, t;
}, Rb = (e) => (t, n, { composing: r } = {}) => !(!Yy(e)(n) || !!r !== D_(t)), zb = Kv(Q({}, Xy), {
	isTab: Rb("tab"),
	isUntab: Rb("untab")
}), Bb = (e, { component: t, dangerouslyAllowAttributes: n, key: r, props: i, type: a }) => function(o) {
	let { children: s, element: c } = o;
	if (c.type === a) {
		let l = t ?? Pg, u = e.plugins.flatMap((e) => e.inject?.aboveComponent ?? []), d = e.plugins.flatMap((e) => e.inject?.belowComponent ?? []);
		o = ky({
			attributes: c.attributes,
			dangerouslyAllowAttributes: n,
			nodeProps: o,
			props: i,
			type: a
		});
		let f = s;
		d.forEach((e) => {
			let t = e(Kv(Q({}, o), { key: r }));
			t && (f = t(Kv(Q({}, o), { children: f })));
		});
		let p = /* @__PURE__ */ N.createElement(l, Q({}, o), f);
		return u.forEach((e) => {
			let t = e(Kv(Q({}, o), { key: r }));
			t && (p = t(Kv(Q({}, o), { children: p })));
		}), /* @__PURE__ */ N.createElement(Xv, {
			element: c,
			scope: r
		}, p);
	}
}, Vb = (e, t) => {
	let n = [];
	return e.plugins.forEach((t) => {
		t.isElement && n.push(Bb(e, t));
	}), function(r) {
		let i = Wy(e, r), a;
		return n.some((e) => (a = e(i), !!a)), a || (t ? t(i) : /* @__PURE__ */ N.createElement(Pg, Q({}, i)));
	};
};
function Hb(e) {
	var t = e, { attributes: n, children: r, editor: i, leaf: a, nodeProps: o, text: s } = t, c = qv(t, [
		"attributes",
		"children",
		"editor",
		"leaf",
		"nodeProps",
		"text"
	]);
	return /* @__PURE__ */ N.createElement("span", Q(Q({}, n), c), r);
}
var Ub = /* @__PURE__ */ "onCopy.onCopyCapture.onCut.onCutCapture.onPaste.onPasteCapture.onCompositionEnd.onCompositionEndCapture.onCompositionStart.onCompositionStartCapture.onCompositionUpdate.onCompositionUpdateCapture.onFocus.onFocusCapture.onBlur.onBlurCapture.onDOMBeforeInput.onBeforeInput.onBeforeInputCapture.onInput.onInputCapture.onReset.onResetCapture.onSubmit.onSubmitCapture.onInvalid.onInvalidCapture.onLoad.onLoadCapture.onKeyDown.onKeyDownCapture.onKeyPress.onKeyPressCapture.onKeyUp.onKeyUpCapture.onAbort.onAbortCapture.onCanPlay.onCanPlayCapture.onCanPlayThrough.onCanPlayThroughCapture.onDurationChange.onDurationChangeCapture.onEmptied.onEmptiedCapture.onEncrypted.onEncryptedCapture.onEnded.onEndedCapture.onLoadedData.onLoadedDataCapture.onLoadedMetadata.onLoadedMetadataCapture.onLoadStart.onLoadStartCapture.onPause.onPauseCapture.onPlay.onPlayCapture.onPlaying.onPlayingCapture.onProgress.onProgressCapture.onRateChange.onRateChangeCapture.onSeeked.onSeekedCapture.onSeeking.onSeekingCapture.onStalled.onStalledCapture.onSuspend.onSuspendCapture.onTimeUpdate.onTimeUpdateCapture.onVolumeChange.onVolumeChangeCapture.onWaiting.onWaitingCapture.onAuxClick.onAuxClickCapture.onClick.onClickCapture.onContextMenu.onContextMenuCapture.onDoubleClick.onDoubleClickCapture.onDrag.onDragCapture.onDragEnd.onDragEndCapture.onDragEnter.onDragEnterCapture.onDragExit.onDragExitCapture.onDragLeave.onDragLeaveCapture.onDragOver.onDragOverCapture.onDragStart.onDragStartCapture.onDrop.onDropCapture.onMouseDown.onMouseDownCapture.onMouseEnter.onMouseLeave.onMouseMove.onMouseMoveCapture.onMouseOut.onMouseOutCapture.onMouseOver.onMouseOverCapture.onMouseUp.onMouseUpCapture.onSelect.onSelectCapture.onTouchCancel.onTouchCancelCapture.onTouchEnd.onTouchEndCapture.onTouchMove.onTouchMoveCapture.onTouchStart.onTouchStartCapture.onPointerDown.onPointerDownCapture.onPointerMove.onPointerUp.onPointerUpCapture.onPointerCancel.onPointerCancelCapture.onPointerEnter.onPointerLeave.onPointerOver.onPointerOverCapture.onPointerOut.onPointerOutCapture.onGotPointerCapture.onGotPointerCaptureCapture.onLostPointerCapture.onLostPointerCaptureCapture.onScroll.onScrollCapture.onWheel.onWheelCapture.onAnimationStart.onAnimationStartCapture.onAnimationEnd.onAnimationEndCapture.onAnimationIteration.onAnimationIterationCapture.onTransitionEnd.onTransitionEndCapture".split("."), Wb = (e, { component: t, dangerouslyAllowAttributes: n, key: r, props: i, type: a = r }) => function(e) {
	let { children: r, leaf: o } = e;
	if (o[a]) {
		let s = t ?? Hb;
		return e = ky({
			attributes: o.attributes,
			dangerouslyAllowAttributes: n,
			nodeProps: e,
			props: i,
			type: a
		}), /* @__PURE__ */ N.createElement(s, Q({}, e), r);
	}
	return r;
}, Gb = (e, t) => {
	let n = [];
	return e.plugins.forEach((t) => {
		t.isLeaf && t.key && n.push(Wb(e, t));
	}), function(r) {
		let i = Wy(e, r);
		return n.forEach((e) => {
			let t = e(i);
			t !== void 0 && (i.children = t);
		}), t ? t(i) : /* @__PURE__ */ N.createElement(Hb, Q({}, i));
	};
}, { PlateControllerProvider: Kb, plateControllerStore: qb, usePlateControllerStore: Jb } = Sr({
	activeId: je(null),
	editorStores: je({}),
	primaryEditorIds: je([])
}, { name: "plateController" }), Yb = () => Jb().get, Xb = () => Jb().set, Zb = () => !!Jb().store({ warnIfNoStore: !1 }), Qb = (e) => {
	let t = N.useMemo(() => je((t) => {
		let n = t(qb.atom.editorStores), r = (e) => e ? n[e] ?? null : null;
		if (e) return r(e);
		let i = [t(qb.atom.activeId), ...t(qb.atom.primaryEditorIds)];
		for (let e of i) {
			let t = r(e);
			if (t) return t;
		}
		return null;
	}), [e]);
	return Yb().atom(t);
}, { PlateProvider: $b, plateStore: ex, usePlateStore: tx } = ((e = {}) => {
	var t = e, { decorate: n = null, editor: r = Lb(), editorRef: i = null, id: a, isMounted: o = !1, onChange: s = null, onSelectionChange: c = null, onValueChange: l = null, plugins: u = [], primary: d = !0, rawPlugins: f = [], readOnly: p = null, renderElement: m = null, renderLeaf: h = null, value: g = null, versionDecorate: _ = 1, versionEditor: v = 1, versionSelection: y = 1 } = t, b = qv(t, [
		"decorate",
		"editor",
		"editorRef",
		"id",
		"isMounted",
		"onChange",
		"onSelectionChange",
		"onValueChange",
		"plugins",
		"primary",
		"rawPlugins",
		"readOnly",
		"renderElement",
		"renderLeaf",
		"value",
		"versionDecorate",
		"versionEditor",
		"versionSelection"
	]);
	return Sr(Q({
		decorate: n,
		editor: r,
		editorRef: i,
		id: a,
		isMounted: o,
		onChange: s,
		onSelectionChange: c,
		onValueChange: l,
		plugins: u,
		primary: d,
		rawPlugins: f,
		readOnly: p,
		renderElement: m,
		renderLeaf: h,
		value: g,
		versionDecorate: _,
		versionEditor: v,
		versionSelection: y
	}, b), {
		extend: (e) => ({
			trackedEditor: je((t) => ({
				editor: t(e.editor),
				version: t(e.versionEditor)
			})),
			trackedSelection: je((t) => ({
				selection: t(e.editor).selection,
				version: t(e.versionSelection)
			}))
		}),
		name: "plate"
	});
})(), nx = (e, { debugHookName: t = "usePlateEditorStore" } = {}) => {
	let n = tx(e).store({ warnIfNoStore: !1 }) ?? null, [r] = N.useState(!!n), i = r ? n : Qb(e), a = Zb(), o = N.useMemo(() => Ne(), []);
	if (!i) {
		if (a) return o;
		throw Error(`${t} must be used inside a Plate or PlateController`);
	}
	return i;
}, rx = (e, t) => tx({ store: nx(e, Q({ debugHookName: "usePlateSelectors" }, t)) }).get, ix = (e, t) => tx({ store: nx(e, Q({ debugHookName: "usePlateActions" }, t)) }).set, ax = () => rx(void 0, { debugHookName: "usePlateId" }).id(), ox = (e, t, n = {}) => {
	let r = N.useRef(1), i = ix(t, Q({ debugHookName: "useIncrementVersion" }, n))[e]();
	return N.useCallback(() => {
		let e = r.current + 1;
		i(e), r.current = e;
	}, [i]);
}, sx = (e, t = {}) => {
	let n = ox("versionDecorate", e, Q({ debugHookName: "useRedecorate" }, t));
	return N.useCallback(() => {
		n();
	}, [n]);
}, cx = (e, t = {}) => rx(e, Q({ debugHookName: "useEditorRef" }, t)).editor(), lx = (e, t = {}) => rx(e, Q({ debugHookName: "useEditorSelection" }, t)).trackedSelection().selection, ux = ({ id: e }) => {
	let t = cx(e), n = sx(e), r = tx(e), i = Object.fromEntries(Jv.map((e) => [e, r.set[e]()])), a = N.useMemo(() => i, []);
	return N.useEffect(() => {
		t.redecorate = n, t.plate = { set: a };
	}, [
		t,
		n,
		a
	]), null;
};
function dx({ id: e, plugin: t }) {
	var n;
	let r = cx(e);
	return (n = t.useHooks) == null || n.call(t, r, t), null;
}
function fx({ id: e }) {
	let t = ix(e).isMounted(), n = rx(e).plugins(), r = cx(e), i = rx(e).editorRef();
	return N.useEffect(() => (t(!0), () => {
		t(!1);
	}), [t]), N.useEffect(() => {
		if (typeof i == "function") return i(r), () => i(null);
		if (i) return i.current = r, () => {
			i.current = null;
		};
	}, [i, r]), /* @__PURE__ */ N.createElement(N.Fragment, null, n.map((t) => /* @__PURE__ */ N.createElement(dx, {
		id: e,
		key: t.key,
		plugin: t
	})));
}
var px = N.memo(({ id: e }) => {
	let t = Hg(), n = ox("versionEditor", e);
	N.useEffect(() => {
		n();
	});
	let r = ox("versionSelection", e), i = N.useRef(t.selection), a = mx(i.current, t.selection);
	return N.useEffect(() => {
		a || r(), i.current = t.selection;
	}, [
		t.selection,
		a,
		r
	]), null;
}), mx = (e, t) => !e && !t ? !0 : !e || !t ? !1 : U.equals(e, t), hx = (e = {}) => {
	let { id: t } = e, n = cx(t), r = rx(t), i = r.versionDecorate(), a = r.readOnly(), o = r.decorate(), s = r.renderLeaf(), c = r.renderElement(), l = N.useMemo(() => zy(n, o ?? e?.decorate), [
		e?.decorate,
		n,
		o
	]), u = N.useMemo(() => {
		if (!(!i || !l)) return (e) => l(e);
	}, [l, i]), d = N.useMemo(() => Vb(n, c ?? e?.renderElement), [
		e?.renderElement,
		n,
		c
	]), f = N.useMemo(() => Gb(n, s ?? e?.renderLeaf), [
		e?.renderLeaf,
		n,
		s
	]), p = F_(() => {
		let t = {
			decorate: u,
			renderElement: d,
			renderLeaf: f
		};
		return $d(a) && (t.readOnly = a), Ub.forEach((r) => {
			let i = Hy(n, {
				editableProps: e,
				handlerKey: r
			});
			i && (t[r] = i);
		}), t;
	}, [
		u,
		e,
		d,
		f,
		a
	]);
	return F_(() => Q(Q({}, A_(e, [
		...Ub,
		"renderElement",
		"renderLeaf"
	])), p), [e, p]);
}, gx = ({ id: e }) => {
	let t = cx(e), n = rx(e).value(), r = ix(e).value(), i = rx(e).onChange(), a = rx(e).onValueChange(), o = rx(e).onSelectionChange(), s = N.useCallback((e) => {
		Gy(t)(e) || i?.(e), r(e);
	}, [
		t,
		r,
		i
	]), c = N.useMemo(() => a, [a]), l = N.useMemo(() => o, [o]);
	return N.useMemo(() => ({
		editor: t,
		initialValue: n,
		key: t.key,
		onChange: s,
		onSelectionChange: l,
		onValueChange: c,
		value: n
	}), [
		t,
		s,
		l,
		c,
		n
	]);
}, _x = ({ id: e }) => {
	let t = ax(), n = e ?? t, r = N.useMemo(() => Iv(qb.atom.editorStores, (e) => e.prop(n)), [n]), i = Xb().atom(r, { warnIfNoStore: !1 }), a = tx(n).store(), o = rx(n).primary(), s = Xb().primaryEditorIds({ warnIfNoStore: !1 }), c = p_(), l = Xb().activeId({ warnIfNoStore: !1 });
	return N.useEffect(() => (i(a ?? null), () => {
		i(null), l((e) => e === n ? null : e);
	}), [
		a,
		i,
		l,
		n
	]), N.useEffect(() => {
		if (o) return s((e) => [...e, n]), () => {
			s((e) => e.filter((e) => e !== n));
		};
	}, [
		n,
		o,
		s
	]), N.useEffect(() => {
		n && c && l(n);
	}, [
		n,
		c,
		l
	]), null;
};
function vx({ children: e, id: t }) {
	var n;
	let r = gx({ id: t }), i = cx(t), a = /* @__PURE__ */ N.createElement(__, Q({}, r), e);
	return (n = i.plugins) == null || n.forEach((e) => {
		let { renderAboveSlate: t } = e;
		t && (a = /* @__PURE__ */ N.createElement(t, null, a));
	}), a;
}
var yx = N.forwardRef((e, t) => {
	var n = e, { renderEditable: r } = n, i = qv(n, ["renderEditable"]);
	let { id: a } = i, o = cx(a);
	if (!o) throw Error("Editor not found. Please ensure that PlateContent is rendered below Plate.");
	let s = hx(i), c = /* @__PURE__ */ N.createElement(a_, Q({ ref: t }, s)), l = null, u = null;
	o.plugins.forEach((e) => {
		let { renderAfterEditable: t, renderBeforeEditable: n } = e;
		t && (l = /* @__PURE__ */ N.createElement(N.Fragment, null, l, /* @__PURE__ */ N.createElement(t, Q({}, s)))), n && (u = /* @__PURE__ */ N.createElement(N.Fragment, null, u, /* @__PURE__ */ N.createElement(n, Q({}, s))));
	});
	let d = /* @__PURE__ */ N.createElement(N.Fragment, null, u, r ? r(c) : c, /* @__PURE__ */ N.createElement(ux, { id: a }), /* @__PURE__ */ N.createElement(px, { id: a }), /* @__PURE__ */ N.createElement(fx, { id: a }), /* @__PURE__ */ N.createElement(_x, { id: a }), l);
	return o.plugins.forEach((e) => {
		let { renderAboveEditable: t } = e;
		t && (d = /* @__PURE__ */ N.createElement(t, null, d));
	}), /* @__PURE__ */ N.createElement(vx, { id: a }, d);
});
yx.displayName = "PlateContent";
//#endregion
//#region ../../../node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var bx = Object.defineProperty, xx = (e, t) => bx(e, "name", {
	value: t,
	configurable: !0
});
function Sx(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
xx(Sx, "setRef");
function Cx(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = Sx(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : Sx(e[t], null);
			}
		};
	};
}
xx(Cx, "composeRefs");
function wx(...e) {
	return M.useCallback(Cx(...e), e);
}
xx(wx, "useComposedRefs");
//#endregion
//#region ../../../node_modules/@radix-ui/react-slot/dist/index.mjs
var Tx = Object.defineProperty, Ex = (e, t) => Tx(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function Dx(e) {
	let t = M.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		Ix(r) && typeof Bx == "function" && (r = Bx(r._payload)), M.Children.forEach(r, (e) => {
			if (Px(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				Ix(n) && typeof Bx == "function" && (n = Bx(n._payload)), a = jx(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = M.cloneElement(a, void 0, s) : !o && M.Children.count(r) === 1 && M.isValidElement(r) && (a = r);
		let c = a ? Nx(a) : void 0, l = wx(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? zx(e) : Rx(e));
			return r;
		}
		let u = Mx(i, a.props ?? {});
		return a.type !== M.Fragment && (u.ref = n ? l : c), M.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
Ex(Dx, "createSlot");
var Ox = /* @__PURE__ */ Dx("Slot"), kx = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function Ax(e) {
	let t = /* @__PURE__ */ Ex((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = kx, t;
}
Ex(Ax, "createSlottable");
var jx = /* @__PURE__ */ Ex((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return M.isValidElement(t) ? M.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return M.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Mx(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
Ex(Mx, "mergeProps");
function Nx(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Ex(Nx, "getElementRef");
function Px(e) {
	return M.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === kx;
}
Ex(Px, "isSlottable");
var Fx = Symbol.for("react.lazy");
function Ix(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === Fx && "_payload" in e && Lx(e._payload);
}
Ex(Ix, "isLazyComponent");
function Lx(e) {
	return typeof e == "object" && !!e && "then" in e;
}
Ex(Lx, "isPromiseLike");
var Rx = /* @__PURE__ */ Ex((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), zx = /* @__PURE__ */ Ex((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), Bx = M.use;
//#endregion
//#region ../../../node_modules/@udecode/react-utils/node_modules/clsx/dist/clsx.m.js
function Vx(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = Vx(e[t])) && (r && (r += " "), r += n);
	else for (t in e) e[t] && (r && (r += " "), r += t);
	return r;
}
function Hx() {
	for (var e, t, n = 0, r = ""; n < arguments.length;) (e = arguments[n++]) && (t = Vx(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region ../../../node_modules/@udecode/react-utils/dist/index.mjs
var Ux = Object.defineProperty, Wx = Object.defineProperties, Gx = Object.getOwnPropertyDescriptors, Kx = Object.getOwnPropertySymbols, qx = Object.prototype.hasOwnProperty, Jx = Object.prototype.propertyIsEnumerable, Yx = (e, t, n) => t in e ? Ux(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Xx = (e, t) => {
	for (var n in t ||= {}) qx.call(t, n) && Yx(e, n, t[n]);
	if (Kx) for (var n of Kx(t)) Jx.call(t, n) && Yx(e, n, t[n]);
	return e;
}, Zx = (e, t) => Wx(e, Gx(t)), Qx = (e, t) => {
	var n = {};
	for (var r in e) qx.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && Kx) for (var r of Kx(e)) t.indexOf(r) < 0 && Jx.call(e, r) && (n[r] = e[r]);
	return n;
}, $x = (e) => N.forwardRef((t, n) => {
	var r = t, { as: i, asChild: a = !1 } = r, o = Qx(r, ["as", "asChild"]);
	let s = a ? Ox : i || e;
	return /* @__PURE__ */ N.createElement(s, Xx({ ref: n }, o));
}), eS = $x("div"), tS = $x("span"), nS = (e, t) => {
	typeof e == "function" ? e(t) : e != null && (e.current = t);
}, rS = (...e) => (t) => e.forEach((e) => nS(e, t)), iS = (...e) => N.useCallback(rS(...e), e), aS = (e) => {
	let t = $x(e);
	return ({ propsHook: e, stateHook: n } = {}) => N.forwardRef((r, i) => {
		var a = r, { asChild: o, className: s, getClassName: c, options: l, state: u } = a, d = Qx(a, [
			"asChild",
			"className",
			"getClassName",
			"options",
			"state"
		]);
		let f = $d(u) ? u : n ? n(l) : void 0, { hidden: p, props: m, ref: h } = e ? e(f) : {
			hidden: !1,
			props: {},
			ref: null
		}, g = iS(i, h), _ = $d(m?.className) || $d(s) ? Hx(m?.className, s) : void 0, v = m?.style || d.style ? Xx(Xx({}, m?.style), d.style) : void 0;
		return !o && p ? null : /* @__PURE__ */ N.createElement(t, Xx(Xx(Zx(Xx({
			asChild: o,
			ref: g
		}, m), {
			className: _,
			style: v
		}), d), d.setProps?.call(d, m ?? {}) ?? {}));
	});
};
typeof window < "u" && window.document?.createElement !== void 0 ? N.useLayoutEffect : N.useEffect;
//#endregion
//#region ../../../node_modules/@udecode/plate-utils/node_modules/clsx/dist/clsx.m.js
function oS(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") if (Array.isArray(e)) for (t = 0; t < e.length; t++) e[t] && (n = oS(e[t])) && (r && (r += " "), r += n);
	else for (t in e) e[t] && (r && (r += " "), r += t);
	return r;
}
function sS() {
	for (var e, t, n = 0, r = ""; n < arguments.length;) (e = arguments[n++]) && (t = oS(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region ../../../node_modules/@udecode/plate-core/dist/server.mjs
var cS = Object.defineProperty, lS = Object.defineProperties, uS = Object.getOwnPropertyDescriptors, dS = Object.getOwnPropertySymbols, fS = Object.prototype.hasOwnProperty, pS = Object.prototype.propertyIsEnumerable, mS = (e, t, n) => t in e ? cS(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, hS = (e, t) => {
	for (var n in t ||= {}) fS.call(t, n) && mS(e, n, t[n]);
	if (dS) for (var n of dS(t)) pS.call(t, n) && mS(e, n, t[n]);
	return e;
}, gS = (e, t) => lS(e, uS(t)), _S = (e, t) => {
	var n = {};
	for (var r in e) fS.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && dS) for (var r of dS(e)) t.indexOf(r) < 0 && pS.call(e, r) && (n[r] = e[r]);
	return n;
}, vS = (e, t = {}, n = !1) => {
	if (t[e.key]) {
		let r = t[e.key], { plugins: i, then: a } = r;
		e = zd(_S(r, ["plugins", "then"]), e), n || i?.forEach((t) => {
			e.plugins ||= [], e.plugins.find((e) => e.key === t.key) || e.plugins.push(t);
		});
	}
	e.plugins &&= e.plugins.map((e) => vS(e, t, !0));
	let { then: r } = e;
	return r ? (e._thenReplaced === void 0 && (e._thenReplaced = 0), e._thenReplaced < 3 && (e.then = (n, i) => {
		let a = hS({ key: e.key }, r(n, i));
		return zd(vS(a, t), a);
	}, e._thenReplaced++)) : t[e.key]?.then && (e.then = t[e.key].then), e;
}, yS = (e) => e?.pluginsByKey ?? {}, bS = (e, t) => yS(e)[t] ?? { key: t }, $ = (e, t) => bS(e, t).type ?? t ?? "", xS = (e, t, n) => {
	let { activeType: r, inactiveType: i = $(e, "p") } = t, a = n?.at ?? e.selection;
	if (!r || !a) return;
	let o = Id(e, gS(hS({}, n), { match: { type: r } }));
	o && r === i || Ld(e, { type: o ? i : r }, { at: a });
}, SS = (e) => (t, n = {}) => (n[e.key] = t, vS(hS({}, e), n)), CS = (e, t) => {
	let n = [];
	return [...e.plugins].reverse().forEach((e) => {
		let r = e.inject.pluginsByKey?.[t.key];
		r && n.push(r);
	}), [t, ...n];
}, wS = (e, { data: t, dataTransfer: n }) => e.every((e) => {
	let r = e.editor?.insertData?.query;
	return !r || r({
		data: t,
		dataTransfer: n
	});
}), TS = ({ apply: e, node: t, path: n = [], query: r, source: i }) => {
	Ed([t, n], r) && (i instanceof Function ? e(t, i()) : e(t, i)), bd(t) && t.children.forEach((t, a) => {
		TS({
			apply: e,
			node: t,
			path: n.concat([a]),
			query: r,
			source: i
		});
	});
}, ES = (e, t) => bS(e, t).options ?? {}, DS = (e, t) => t.map((t) => $(e, t)), OS = (e) => {
	TS(gS(hS({}, e), { apply: qf }));
}, kS = (e) => hS({
	editor: {},
	inject: {},
	key: "",
	options: {},
	type: ""
}, e), AS = (e, t) => e.some((e, n, r) => {
	let i = r[n - 1];
	return n !== 0 && t(e) !== t(i);
}), jS = (e, t, n) => {
	let r = AS(e, t), { fragment: i } = e.reduce((e, i) => {
		if (r && t(i)) {
			let t = e.precedingBlock;
			t || (t = n(), e.precedingBlock = t, e.fragment.push(t)), t.children.push(i);
		} else e.fragment.push(i), e.precedingBlock = null;
		return e;
	}, {
		fragment: [],
		precedingBlock: null
	});
	return i;
}, MS = (e) => e.length === 0 ? [{ text: "" }] : e, NS = (e, t, n) => (e = MS(e), e = jS(e, t, n), e = e.map((e) => wu(e) ? gS(hS({}, e), { children: NS(e.children, t, n) }) : e), e), PS = {
	bold: "mod+b",
	compose: [
		"down",
		"left",
		"right",
		"up",
		"backspace",
		"enter"
	],
	deleteBackward: "shift?+backspace",
	deleteForward: "shift?+delete",
	extendBackward: "shift+left",
	extendForward: "shift+right",
	insertSoftBreak: "shift+enter",
	italic: "mod+i",
	moveBackward: "left",
	moveForward: "right",
	moveWordBackward: "ctrl+left",
	moveWordForward: "ctrl+right",
	splitBlock: "enter",
	tab: "tab",
	undo: "mod+z",
	untab: "shift+tab"
}, FS = {
	deleteBackward: ["ctrl+backspace", "ctrl+h"],
	deleteForward: ["ctrl+delete", "ctrl+d"],
	deleteLineBackward: "cmd+shift?+backspace",
	deleteLineForward: ["cmd+shift?+delete", "ctrl+k"],
	deleteWordBackward: "opt+shift?+backspace",
	deleteWordForward: "opt+shift?+delete",
	extendLineBackward: "opt+shift+up",
	extendLineForward: "opt+shift+down",
	moveLineBackward: "opt+up",
	moveLineForward: "opt+down",
	moveWordBackward: "opt+left",
	moveWordForward: "opt+right",
	redo: "cmd+shift+z",
	transposeCharacter: "ctrl+t"
}, IS = {
	deleteWordBackward: "ctrl+shift?+backspace",
	deleteWordForward: "ctrl+shift?+delete",
	redo: ["ctrl+y", "ctrl+shift+z"]
}, LS = (e) => {
	let t = PS[e], n = FS[e], r = IS[e], i = t && (0, Rv.isKeyHotkey)(t), a = n && (0, Rv.isKeyHotkey)(n), o = r && (0, Rv.isKeyHotkey)(r);
	return (e) => !!(i?.(e) || Hd && a?.(e) || !Hd && o?.(e));
};
LS("bold"), LS("compose"), LS("deleteBackward"), LS("deleteForward"), LS("deleteLineBackward"), LS("deleteLineForward"), LS("deleteWordBackward"), LS("deleteWordForward"), LS("extendBackward"), LS("extendForward"), LS("extendLineBackward"), LS("extendLineForward"), LS("italic"), LS("moveBackward"), LS("moveForward"), LS("moveLineBackward"), LS("moveLineForward"), LS("moveWordBackward"), LS("moveWordForward"), LS("redo"), LS("insertSoftBreak"), LS("splitBlock"), LS("transposeCharacter"), LS("undo");
var RS = pa("event-editor")({
	blur: null,
	focus: null,
	last: null
});
RS.set, RS.get, RS.use;
var zS = (e, { shouldCollapseWhiteSpace: t = !0, trimEnd: n = "collapse", trimStart: r = "collapse", whiteSpaceIncludesNewlines: i = !0 } = {}) => (r === "all" && (e = e.replace(/^\s+/, "")), n === "single-newline" && (e = e.replace(/\n$/, "")), t && (i ? e = e.replaceAll(/\s+/g, " ") : (e = e.replaceAll(/[^\S\n\r]+/g, " "), e = e.replaceAll(/^[^\S\n\r]+/gm, ""), e = e.replaceAll(/[^\S\n\r]+$/gm, ""))), e), BS = /* @__PURE__ */ new Set(/* @__PURE__ */ "A.ABBR.B.BDI.BDO.BR.CITE.CODE.DATA.DFN.EM.I.KBD.MARK.Q.S.SAMP.SMALL.SPAN.STRONG.SUB.SUP.TIME.U.VAR.WBR.IMG.MAP.TRACK.VIDEO.EMBED.IFRAME.OBJECT.PICTURE.PORTAL.SOURCE.svg.math.CANVAS.DEL.INS.BUTTON.INPUT.LABEL.METER.OUTPUT.PROGRESS.SELECT.TEXTAREA.ACRONYM.BIG.CONTENT.FONT.IMG.MARQUEE.MENUITEM.NOBR.SHADOW.STRIKE.TT".split(".")), VS = (e) => e.nodeType === Node.ELEMENT_NODE, HS = (e) => {
	if (!VS(e)) return !1;
	let t = e, n = BS.has(t.tagName), r = t.style.display.split(" ")[0];
	return r === "" ? n : r.startsWith("inline") ? !0 : r === "inherit" && t.parentElement ? HS(t.parentElement) : [
		"contents",
		"initial",
		"none",
		"revert",
		"revert-layer",
		"unset"
	].includes(r) ? n : !1;
}, US = (e) => e.nodeType === Node.TEXT_NODE, WS = (e) => VS(e) ? !HS(e) : !1, GS = (e) => {
	let t = e;
	for (;;) {
		if (t.nextSibling) t = t.nextSibling;
		else {
			if (t = t.parentElement, t && WS(t)) return !0;
			t = t?.nextSibling || null;
		}
		if (!t || WS(t)) return !0;
		if ((t.textContent || "").length > 0) return !1;
	}
}, KS = (e) => {
	e.inlineFormattingContext ? e.inlineFormattingContext.atStart = !1 : e.inlineFormattingContext = {
		atStart: !0,
		lastHasTrailingWhiteSpace: !1
	};
}, qS = (e) => {
	e.inlineFormattingContext = null;
}, JS = (e, t) => {
	let n = e.textContent || "", r = n.trim() === "";
	(t.inlineFormattingContext || !r) && KS(t);
	let { whiteSpaceRule: i } = t, a = i === "normal" && (!t.inlineFormattingContext || t.inlineFormattingContext.atStart || t.inlineFormattingContext.lastHasTrailingWhiteSpace) ? "all" : "collapse", o = i === "normal" ? "collapse" : GS(e) ? "single-newline" : "collapse", s = {
		normal: !0,
		pre: !1,
		"pre-line": !0
	}[i], c = zS(n || "", {
		shouldCollapseWhiteSpace: s,
		trimEnd: o,
		trimStart: a,
		whiteSpaceIncludesNewlines: i !== "pre-line"
	});
	t.inlineFormattingContext && s && (t.inlineFormattingContext.lastHasTrailingWhiteSpace = c.endsWith(" ")), e.textContent = c;
}, YS = (e, t) => {
	if (VS(e)) {
		QS(e, t);
		return;
	}
	if (US(e)) {
		JS(e, t);
		return;
	}
	XS(e, t);
}, XS = (e, t) => {
	let n = Array.from(e.childNodes);
	for (let e of n) YS(e, t);
}, ZS = (e) => {
	let t = e.style.whiteSpace;
	switch (t) {
		case "normal":
		case "nowrap": return "normal";
		case "pre":
		case "pre-wrap":
		case "break-spaces": return "pre";
		case "pre-line": return "pre-line";
	}
	return e.tagName === "PRE" ? "pre" : t === "initial" ? "normal" : null;
}, QS = (e, t) => {
	let n = HS(e), r = t.whiteSpaceRule, i = ZS(e);
	i && (t.whiteSpaceRule = i), n || qS(t), XS(e, t), n || qS(t), t.whiteSpaceRule = r;
}, $S = (e, t) => Array.from(t.childNodes).flatMap(cC(e)), eC = (e, t) => {
	if (t.nodeName === "BODY") return Ap("fragment", {}, $S(e, t));
}, tC = (e) => {
	if (e.nodeName === "BR") return "\n";
}, nC = (e, t, { deserializeLeaf: n, element: r }) => {
	let { deserializeHtml: i, isElement: a, isLeaf: o, type: s } = t;
	if (!i) return;
	let { attributeNames: c, isElement: l, isLeaf: u, query: d, rules: f } = i, { getNode: p } = i, m = l || a, h = u || o;
	if (!n && !m || n && !h || f && !f.some(({ validAttribute: e, validClassName: n, validNodeName: i = "*", validStyle: a }) => {
		if (i) {
			let e = Bd(i);
			if (e.length > 0 && !e.includes(r.nodeName) && i !== "*") return !1;
		}
		if (n && !r.classList.contains(n)) return !1;
		if (a) for (let [e, n] of Object.entries(a)) {
			if (!Bd(n).includes(r.style[e]) && n !== "*" || n === "*" && !r.style[e]) return;
			let i = t.inject.props?.defaultNodeValue;
			if (i && i === r.style[e]) return !1;
		}
		if (e) if (typeof e == "string") {
			if (!r.getAttributeNames().includes(e)) return !1;
		} else for (let [t, n] of Object.entries(e)) {
			let e = Bd(n), i = r.getAttribute(t);
			if (!$d(i) || !e.includes(i)) return !1;
		}
		return !0;
	}) || d && !d(r)) return;
	if (!p) if (m) p = () => ({ type: s });
	else if (h) p = () => ({ [s]: !0 });
	else return;
	let g = p(r, {}) ?? {};
	if (Object.keys(g).length !== 0) {
		if (CS(e, t).forEach((e) => {
			var t;
			let n = ((t = e.deserializeHtml)?.getNode)?.call(t, r, g);
			n && (g = hS(hS({}, g), n));
		}), c) {
			let e = {}, t = r.getAttributeNames();
			for (let n of t) c.includes(n) && (e[n] = r.getAttribute(n));
			Object.keys(e).length > 0 && (g.attributes = e);
		}
		return gS(hS({}, i), { node: g });
	}
}, rC = (e, t) => {
	let n;
	return [...e.plugins].reverse().some((r) => (n = nC(e, r, { element: t }), !!n)), n;
}, iC = (e, t) => {
	let n = rC(e, t);
	if (n) {
		let { node: r, withoutChildren: i } = n, a = r.children ?? $S(e, t);
		return (a.length === 0 || i) && (a = [{ text: "" }]), Ap("element", r, a);
	}
}, aC = (e, t) => {
	let n = {};
	return [...e.plugins].reverse().forEach((r) => {
		let i = nC(e, r, {
			deserializeLeaf: !0,
			element: t
		});
		i && (n = hS(hS({}, n), i.node));
	}), n;
}, oC = (e, t) => {
	let n = aC(e, t);
	return $S(e, t).reduce((e, t) => {
		if (!t) return e;
		if (wu(t)) Object.keys(n).length > 0 && OS({
			node: t,
			query: { filter: ([e]) => Iu(e) },
			source: n
		}), e.push(t);
		else {
			let r = hS({}, n);
			Iu(t) && t.text && Object.keys(r).forEach((e) => {
				r[e] && t[e] && (r[e] = t[e]);
			}), e.push(Ap("text", r, t));
		}
		return e;
	}, []);
}, sC = (e) => {
	if (US(e)) return e.textContent || "";
}, cC = (e) => (t) => sC(t) || (VS(t) ? tC(t) || eC(e, t) || iC(e, t) || oC(e, t) : null), lC = "deserializeHtml", uC = (e, t) => {
	if (!t(e)) return;
	let n = e.firstChild;
	for (; n;) {
		let r = n, i = n.previousSibling;
		n = n.nextSibling, uC(r, t), !r.previousSibling && !r.nextSibling && !r.parentNode && n && i !== n.previousSibling && n.parentNode ? n = i ? i.nextSibling : e.firstChild : !r.previousSibling && !r.nextSibling && !r.parentNode && n && !n.previousSibling && !n.nextSibling && !n.parentNode && (i ? n = i.nextSibling ? i.nextSibling.nextSibling : null : e.firstChild && (n = e.firstChild.nextSibling));
	}
}, dC = (e, t) => {
	uC(e, (e) => !VS(e) || t(e));
}, fC = (e, t) => {
	let n = null;
	return dC(e, (e) => t(e) ? (n = e, !1) : !0), n;
}, pC = (e, t) => !!fC(e, t), mC = Ze, hC = Object.defineProperty, gC = Object.defineProperties, _C = Object.getOwnPropertyDescriptors, vC = Object.getOwnPropertySymbols, yC = Object.prototype.hasOwnProperty, bC = Object.prototype.propertyIsEnumerable, xC = (e, t, n) => t in e ? hC(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, SC = (e, t) => {
	for (var n in t ||= {}) yC.call(t, n) && xC(e, n, t[n]);
	if (vC) for (var n of vC(t)) bC.call(t, n) && xC(e, n, t[n]);
	return e;
}, CC = (e, t) => gC(e, _C(t)), wC = (e, t) => {
	var n = {};
	for (var r in e) yC.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && vC) for (var r of vC(e)) t.indexOf(r) < 0 && bC.call(e, r) && (n[r] = e[r]);
	return n;
}, TC = (e) => {
	let t = e, { attributes: n, editor: r, element: i, elementToAttributes: a, nodeProps: o } = t, s = wC(t, [
		"attributes",
		"editor",
		"element",
		"elementToAttributes",
		"nodeProps"
	]);
	return {
		props: CC(SC(SC(SC(SC({}, n), s), o), a?.(i)), { className: sS(e.className, o?.className) }),
		ref: iS(e.ref, n.ref)
	};
}, EC = N.forwardRef((e, t) => {
	let { props: n, ref: r } = TC(CC(SC({}, e), { ref: t }));
	return /* @__PURE__ */ N.createElement(eS, CC(SC({}, n), { ref: r }));
});
EC.displayName = "PlateElement";
var DC = (e) => {
	let t = e, { attributes: n, editor: r, leaf: i, leafToAttributes: a, nodeProps: o, text: s } = t, c = wC(t, [
		"attributes",
		"editor",
		"leaf",
		"leafToAttributes",
		"nodeProps",
		"text"
	]);
	return {
		props: CC(SC(SC(SC(SC({}, n), c), o), a?.(i)), { className: sS(e.className, o?.className) }),
		ref: iS(e.ref, n.ref)
	};
}, OC = N.forwardRef((e, t) => {
	let { props: n, ref: r } = DC(CC(SC({}, e), { ref: t }));
	return /* @__PURE__ */ N.createElement(tS, CC(SC({}, n), { ref: r }));
});
OC.displayName = "PlateLeaf";
var kC = (e, t, n) => {
	let r = Bd(n), i = [];
	return r.forEach((t) => i.push($(e, t))), i.includes(t?.type);
}, AC = (e, { options: { hotkey: t }, type: n }) => (r) => {
	if (r.defaultPrevented) return;
	let i = $(e, "p");
	if (!t) return;
	let a = Bd(t);
	for (let t of a) if ((0, Rv.isHotkey)(t, r)) {
		r.preventDefault(), xS(e, {
			activeType: n,
			inactiveType: i
		});
		return;
	}
}, jC = Object.defineProperty, MC = Object.defineProperties, NC = Object.getOwnPropertyDescriptors, PC = Object.getOwnPropertySymbols, FC = Object.prototype.hasOwnProperty, IC = Object.prototype.propertyIsEnumerable, LC = (e, t, n) => t in e ? jC(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, RC = (e, t) => {
	for (var n in t ||= {}) FC.call(t, n) && LC(e, n, t[n]);
	if (PC) for (var n of PC(t)) IC.call(t, n) && LC(e, n, t[n]);
	return e;
}, zC = (e, t) => MC(e, NC(t)), BC = (e, t) => {
	var n = {};
	for (var r in e) FC.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && PC) for (var r of PC(e)) t.indexOf(r) < 0 && IC.call(e, r) && (n[r] = e[r]);
	return n;
}, VC = (e) => {
	let t = e, { attributes: n, editor: r, element: i, elementToAttributes: a, nodeProps: o } = t, s = BC(t, [
		"attributes",
		"editor",
		"element",
		"elementToAttributes",
		"nodeProps"
	]);
	return {
		props: zC(RC(RC(RC(RC({}, n), s), o), a?.(i)), { className: sS(e.className, o?.className) }),
		ref: iS(e.ref, n.ref)
	};
}, HC = N.forwardRef((e, t) => {
	let { props: n, ref: r } = VC(zC(RC({}, e), { ref: t }));
	return /* @__PURE__ */ N.createElement(eS, zC(RC({}, n), { ref: r }));
});
HC.displayName = "PlateElement";
var UC = (e) => {
	let t = e, { attributes: n, editor: r, leaf: i, leafToAttributes: a, nodeProps: o, text: s } = t, c = BC(t, [
		"attributes",
		"editor",
		"leaf",
		"leafToAttributes",
		"nodeProps",
		"text"
	]);
	return {
		props: zC(RC(RC(RC(RC({}, n), c), o), a?.(i)), { className: sS(e.className, o?.className) }),
		ref: iS(e.ref, n.ref)
	};
}, WC = N.forwardRef((e, t) => {
	let { props: n, ref: r } = UC(zC(RC({}, e), { ref: t }));
	return /* @__PURE__ */ N.createElement(tS, zC(RC({}, n), { ref: r }));
});
WC.displayName = "PlateLeaf";
var GC = (e) => {
	TS(zC(RC({}, e), { apply: mC }));
}, KC = (e, { options: { hotkey: t }, type: n }) => (r) => {
	if (r.defaultPrevented) return;
	let i = $(e, "p");
	if (!t) return;
	let a = Bd(t);
	for (let t of a) if ((0, Rv.isHotkey)(t, r)) {
		r.preventDefault(), xS(e, {
			activeType: n,
			inactiveType: i
		});
		return;
	}
}, qC = (e, { options: { clear: t, hotkey: n }, type: r }) => (i) => {
	i.defaultPrevented || n && (0, Rv.isHotkey)(n, i) && (i.preventDefault(), Wf(e, {
		clear: t,
		key: r
	}));
}, JC = SS({
	deserializeHtml: {
		query: (e) => !pC(e, (e) => e.style.fontWeight === "normal"),
		rules: [{ validNodeName: ["STRONG", "B"] }, { validStyle: { fontWeight: [
			"600",
			"700",
			"bold"
		] } }]
	},
	handlers: { onKeyDown: qC },
	isLeaf: !0,
	key: "bold",
	options: { hotkey: "mod+b" }
}), YC = SS({
	deserializeHtml: {
		query(e) {
			return Ud(e, "P")?.style.fontFamily !== "Consolas" && !Ud(e, "PRE");
		},
		rules: [{ validNodeName: ["CODE"] }, { validStyle: { fontFamily: "Consolas" } }]
	},
	handlers: { onKeyDown: qC },
	isLeaf: !0,
	key: "code",
	options: { hotkey: "mod+e" }
}), XC = SS({
	deserializeHtml: {
		query: (e) => !pC(e, (e) => e.style.fontStyle === "normal"),
		rules: [{ validNodeName: ["EM", "I"] }, { validStyle: { fontStyle: "italic" } }]
	},
	handlers: { onKeyDown: qC },
	isLeaf: !0,
	key: "italic",
	options: { hotkey: "mod+i" }
}), ZC = SS({
	deserializeHtml: {
		query: (e) => !pC(e, (e) => e.style.textDecoration === "none"),
		rules: [{ validNodeName: [
			"S",
			"DEL",
			"STRIKE"
		] }, { validStyle: { textDecoration: "line-through" } }]
	},
	handlers: { onKeyDown: qC },
	isLeaf: !0,
	key: "strikethrough",
	options: { hotkey: "mod+shift+x" }
}), QC = SS({
	deserializeHtml: { rules: [{ validNodeName: ["SUB"] }, { validStyle: { verticalAlign: "sub" } }] },
	handlers: { onKeyDown: qC },
	isLeaf: !0,
	key: "subscript",
	options: {
		clear: "superscript",
		hotkey: "mod+,"
	}
}), $C = SS({
	deserializeHtml: { rules: [{ validNodeName: ["SUP"] }, { validStyle: { verticalAlign: "super" } }] },
	handlers: { onKeyDown: qC },
	isLeaf: !0,
	key: "superscript",
	options: {
		clear: "subscript",
		hotkey: "mod+."
	}
}), ew = SS({
	deserializeHtml: {
		query: (e) => !pC(e, (e) => e.style.textDecoration === "none"),
		rules: [{ validNodeName: ["U"] }, { validStyle: { textDecoration: ["underline"] } }]
	},
	handlers: { onKeyDown: qC },
	isLeaf: !0,
	key: "underline",
	options: { hotkey: "mod+u" }
});
JC(), YC(), XC(), ZC(), QC(), $C(), ew();
var tw = SS({
	deserializeHtml: { rules: [{ validNodeName: "BLOCKQUOTE" }] },
	handlers: { onKeyDown: KC },
	isElement: !0,
	key: "blockquote",
	options: { hotkey: "mod+shift+." },
	withOverrides: (e) => {
		let { shouldMergeNodesRemovePrevNode: t } = e;
		return t && (e.shouldMergeNodesRemovePrevNode = (e, n) => e[0].type !== "blockquote" && t(e, n)), e;
	}
}), nw = Object.getOwnPropertySymbols, rw = Object.prototype.hasOwnProperty, iw = Object.prototype.propertyIsEnumerable, aw = (e, t) => {
	var n = {};
	for (var r in e) rw.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && nw) for (var r of nw(e)) t.indexOf(r) < 0 && iw.call(e, r) && (n[r] = e[r]);
	return n;
}, ow = (e, { end: t, start: n }) => {
	let r = !1, i = !1, a = !1;
	return (n || t) && (r = !0, n && Lf(e) && (i = !0, a = !0), t && If(e) && (i = !0), i && Sd(e.selection) && e.deleteFragment()), {
		isEdge: i,
		isStart: a,
		queryEdge: r
	};
}, sw = (e, { before: t, defaultType: n = $(e, "p"), level: r = 0, query: i = {}, relative: a = !1 }) => {
	if (!e.selection) return;
	let { isEdge: o, isStart: s, queryEdge: c } = ow(e, i);
	if (s && (t = !0), c && !o) return;
	let l = rd(e, e.selection), u = a ? l.slice(0, -r) : l.slice(0, r + 1), d = t ? u : H.next(u);
	return Rf(e, e.blockFactory({
		children: [{ text: "" }],
		type: n
	}), {
		at: d,
		select: !s
	}), !0;
}, cw = SS({
	handlers: { onKeyDown: (e, { options: { rules: t = [] } }) => (n) => {
		if (n.defaultPrevented) return;
		let r = ff(e);
		r && t.forEach((t) => {
			var i = t, { hotkey: a } = i, o = aw(i, ["hotkey"]);
			(0, Rv.isHotkey)(a, n) && Ed(r, o.query) && sw(e, o) && (n.preventDefault(), n.stopPropagation());
		});
	} },
	key: "exitBreak",
	options: { rules: [{ hotkey: "mod+enter" }, {
		before: !0,
		hotkey: "mod+shift+enter"
	}] }
}), lw = SS({
	handlers: { onKeyDown: (e, { options: { rules: t = [] } }) => (n) => {
		if (n.defaultPrevented) return;
		let r = ff(e);
		r && t.forEach(({ hotkey: t, query: i }) => {
			(0, Rv.isHotkey)(t, n) && Ed(r, i) && (n.preventDefault(), n.stopPropagation(), e.insertText("\n"));
		});
	} },
	key: "softBreak",
	options: { rules: [{ hotkey: "shift+enter" }] }
}), uw = SS({
	deserializeHtml: { rules: [{ validNodeName: "HR" }] },
	isElement: !0,
	isVoid: !0,
	key: "hr"
}), dw = (e, { options: { types: t } }) => {
	let n = Bd(t), { normalizeNode: r } = e;
	return e.normalizeNode = ([t, i]) => {
		if (wu(t) && t.type && n.includes(t.type) && gd(t) === "") {
			Bu(e, { at: i });
			return;
		}
		r([t, i]);
	}, e;
}, fw = Object.defineProperty, pw = Object.defineProperties, mw = Object.getOwnPropertyDescriptors, hw = Object.getOwnPropertySymbols, gw = Object.prototype.hasOwnProperty, _w = Object.prototype.propertyIsEnumerable, vw = (e, t, n) => t in e ? fw(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, yw = (e, t) => {
	for (var n in t ||= {}) gw.call(t, n) && vw(e, n, t[n]);
	if (hw) for (var n of hw(t)) _w.call(t, n) && vw(e, n, t[n]);
	return e;
}, bw = (e, t) => pw(e, mw(t)), xw = (e, t) => {
	var n = {};
	for (var r in e) gw.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && hw) for (var r of hw(e)) t.indexOf(r) < 0 && _w.call(e, r) && (n[r] = e[r]);
	return n;
}, Sw = (e, { children: t, target: n, text: r = "", url: i }) => {
	let a = $(e, "a");
	return {
		children: t ?? [{ text: r }],
		target: n,
		type: a,
		url: i
	};
}, Cw = (e) => {
	try {
		return e === decodeURIComponent(e) ? encodeURI(e) : e;
	} catch (t) {
		if (t instanceof URIError) return e;
		throw t;
	}
}, ww = (e, t) => {
	let { allowedSchemes: n, dangerouslySkipSanitization: r, defaultLinkAttributes: i } = ES(e, "a"), a = yw({}, i), o = r ? t.url : Yd(t.url, { allowedSchemes: n }) || void 0;
	return o !== void 0 && (a.href = o), "target" in t && (a.target = t.target), a;
}, Tw = (e) => {
	try {
		return decodeURI(e);
	} catch (t) {
		if (t instanceof URIError) return e;
		throw t;
	}
}, Ew = pa("floatingLink")({
	isEditing: !1,
	mode: "",
	mouseDown: !1,
	newTab: !1,
	openEditorId: null,
	text: "",
	updated: !1,
	url: ""
}).extendActions((e) => ({ reset: () => {
	e.url(""), e.text(""), e.newTab(!1), e.mode(""), e.isEditing(!1);
} })).extendActions((e) => ({
	hide: () => {
		e.openEditorId(null), e.reset();
	},
	show: (t, n) => {
		e.mode(t), e.isEditing(!1), e.openEditorId(n);
	}
})).extendSelectors((e) => ({ isOpen: (t) => e.openEditorId === t })), Dw = Ew.set, Ow = Ew.get, kw = () => Ew.use;
aS("input")({
	propsHook: ({ checked: e, ref: t, setChecked: n }) => ({
		props: {
			checked: e,
			onChange: N.useCallback((e) => {
				n(e.target.checked), Dw.newTab(e.target.checked);
			}, [n]),
			type: "checkbox"
		},
		ref: t
	}),
	stateHook: () => {
		let e = kw().updated(), t = N.useRef(null), [n, r] = N.useState(Ow.newTab());
		return N.useEffect(() => {
			t.current && e && setTimeout(() => {
				var e;
				(e = t.current) == null || e.focus();
			}, 0);
		}, [e]), {
			checked: n,
			ref: t,
			setChecked: r
		};
	}
}), aS("input")({
	propsHook: (e) => {
		let t = N.useCallback((e) => {
			let t = Cw(e.target.value);
			Dw.url(t);
		}, []);
		return {
			props: {
				defaultValue: Ow.url(),
				onChange: t
			},
			ref: e.ref
		};
	},
	stateHook: () => {
		let e = kw().updated(), t = N.useRef(null);
		return N.useEffect(() => {
			t.current && e && setTimeout(() => {
				let e = t.current;
				e && (e.focus(), e.value = Ow.url() ? Tw(Ow.url()) : "");
			}, 0);
		}, [e]), { ref: t };
	}
}), aS("a")({
	propsHook: ({ element: e }) => {
		let t = cx();
		return e ? { props: bw(yw({}, ww(t, e)), {
			"aria-label": "Open link in a new tab",
			onMouseOver: (e) => {
				e.stopPropagation();
			},
			target: "_blank"
		}) } : { props: {} };
	},
	stateHook: () => {
		let e = cx(), t = lx(), n = N.useMemo(() => Fd(e, { match: { type: $(e, "a") } }), [e, t]);
		if (!n) return {};
		let [r] = n;
		return { element: r };
	}
});
var Aw = (e, t, n) => {
	Dd(e, [Sw(e, t)], n);
}, jw = (e, t) => Fu(e, () => {
	if (t?.split) {
		if (ku(e, {
			at: e.selection?.anchor,
			match: { type: $(e, "a") }
		})) return jd(e, {
			at: e.selection?.anchor,
			match: (t) => wu(t) && t.type === $(e, "a")
		}), jw(e, { at: e.selection?.anchor }), !0;
		if (ku(e, {
			at: e.selection?.focus,
			match: { type: $(e, "a") }
		})) return jd(e, {
			at: e.selection?.focus,
			match: (t) => wu(t) && t.type === $(e, "a")
		}), jw(e, { at: e.selection?.focus }), !0;
	}
	Nd(e, yw({ match: { type: $(e, "a") } }, t));
}), Mw = (e, { text: t }) => {
	let n = ku(e, { match: { type: $(e, "a") } });
	if (n) {
		let [r, i] = n;
		if (t?.length && t !== Qu(e, i)) {
			let n = r.children[0];
			Uf(e, {
				at: i,
				insertOptions: { select: !0 },
				nodes: bw(yw({}, n), { text: t })
			});
		}
	}
}, Nw = (e, t) => {
	var n = t, { target: r, url: i } = n, a = xw(n, ["target", "url"]);
	Pd(e, {
		children: [],
		target: r,
		type: $(e, "a"),
		url: i
	}, yw({ split: !0 }, a));
}, Pw = (e, { insertNodesOptions: t, insertTextInLink: n, skipValidation: r = !1, target: i, text: a, url: o }) => {
	let s = e.selection;
	if (!s) return;
	let c = ku(e, {
		at: s,
		match: { type: $(e, "a") }
	});
	if (n && c) return e.insertText(o), !0;
	if (!r && !Fw(e, o)) return;
	if ($d(a) && a.length === 0 && (a = o), c) return (o !== c[0]?.url || i !== c[0]?.target) && Ad(e, {
		target: i,
		url: o
	}, { at: c[1] }), Mw(e, {
		target: i,
		text: a,
		url: o
	}), !0;
	let [l, u] = Fd(e, {
		at: s,
		match: { type: $(e, "a") }
	}) ?? [], d = !1;
	if (u && a?.length) {
		let t = Qu(e, u);
		a !== t && (d = !0);
	}
	if (Sd(s)) return c ? jw(e, { at: c[1] }) : jw(e, { split: !0 }), Nw(e, {
		target: i,
		url: o
	}), Mw(e, {
		target: i,
		text: a,
		url: o
	}), !0;
	d && Bu(e, { at: u });
	let f = hd(l ?? {}), p = e.selection?.focus.path;
	if (!p) return;
	let m = md(e, p);
	return a?.length || (a = o), Aw(e, bw(yw({}, f), {
		children: [bw(yw({}, m), { text: a })],
		target: i,
		url: o
	}), t), !0;
}, Fw = (e, t) => {
	let { allowedSchemes: n, dangerouslySkipSanitization: r, isUrl: i } = ES(e, "a");
	return !(i && !i(t) || !r && !Yd(t, {
		allowedSchemes: n,
		permitInvalid: !0
	}));
}, Iw = SS({
	dangerouslyAllowAttributes: ["target"],
	isElement: !0,
	isInline: !0,
	key: "a",
	options: {
		allowedSchemes: [
			"http",
			"https",
			"mailto",
			"tel"
		],
		dangerouslySkipSanitization: !1,
		defaultLinkAttributes: {},
		isUrl: Jd,
		keepSelectedTextOnPaste: !0,
		rangeBeforeOptions: {
			afterMatch: !0,
			matchString: " ",
			skipInvalid: !0
		},
		triggerFloatingLinkHotkeys: "meta+k, ctrl+k"
	},
	then: (e, { type: t }) => ({
		deserializeHtml: {
			getNode: (n) => {
				let r = n.getAttribute("href");
				if (r && Fw(e, r)) return {
					target: n.getAttribute("target") || "_blank",
					type: t,
					url: r
				};
			},
			rules: [{ validNodeName: "A" }]
		},
		props: ({ element: t }) => ({ nodeProps: ww(e, t) })
	}),
	withOverrides: (e, { options: { getUrlHref: t, isUrl: n, keepSelectedTextOnPaste: r, rangeBeforeOptions: i }, type: a }) => {
		let { apply: o, insertBreak: s, insertData: c, insertText: l, normalizeNode: u } = e, d = () => {
			Fu(e, () => {
				let r = e.selection, a = Of(e, r, i);
				if (a ||= kf(e), !a || Id(e, {
					at: a,
					match: { type: $(e, "a") }
				})) return;
				let o = Qu(e, a);
				o = t?.(o) ?? o, n(o) && (Vu(e, a), Pw(e, { url: o }), Cd(e, { edge: "end" }));
			});
		};
		return e.insertBreak = () => {
			if (!xd(e.selection)) return s();
			d(), s();
		}, e.insertText = (t) => {
			t === " " && xd(e.selection) && d(), l(t);
		}, e.insertData = (n) => {
			let i = n.getData("text/plain"), a = t?.(i);
			if (i) {
				let t = a || i;
				if (Pw(e, {
					insertTextInLink: !0,
					text: r ? void 0 : t,
					url: t
				})) return;
			}
			c(n);
		}, e.apply = (t) => {
			if (t.type === "set_selection") {
				let n = t.newProperties;
				if (n?.focus && n.anchor && xd(n)) {
					let r = ku(e, {
						at: n,
						match: { type: $(e, "a") }
					});
					if (r) {
						let [, i] = r, a;
						sd(e, n.focus, i) && (a = Ef(e, i)), ad(e, n.focus, i) && (a = xf(e, i)), a && (t.newProperties = {
							anchor: a,
							focus: a
						});
					}
				}
			}
			o(t);
		}, e.normalizeNode = ([t, n]) => {
			if (t.type === $(e, "a")) {
				let t = e.selection;
				if (t && xd(t) && ad(e, t.focus, n)) {
					let t = xf(e, n);
					if (t) Vu(e, t);
					else {
						let t = H.next(n);
						Dd(e, { text: "" }, { at: t }), Vu(e, t);
					}
				}
			}
			u([t, n]);
		}, e = dw(e, kS({ options: { types: a } })), e;
	}
}), Lw = {
	key: "",
	which: 8
}, Rw = (e, { options: { rules: t } }) => (n) => {
	if (n.defaultPrevented) return;
	let r;
	if (e.selection) return xd(e.selection) && t.forEach(({ defaultType: t, hotkey: i, onReset: a, predicate: o, types: s }) => {
		var c;
		i && (0, Rv.isHotkey)(i, n) && o(e) && Id(e, { match: { type: s } }) && ((c = n.preventDefault) == null || c.call(n), Ld(e, { type: t }), a && a(e), r = !0);
	}), r;
}, zw = Object.defineProperty, Bw = Object.defineProperties, Vw = Object.getOwnPropertyDescriptors, Hw = Object.getOwnPropertySymbols, Uw = Object.prototype.hasOwnProperty, Ww = Object.prototype.propertyIsEnumerable, Gw = (e, t, n) => t in e ? zw(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, Kw = (e, t) => {
	for (var n in t ||= {}) Uw.call(t, n) && Gw(e, n, t[n]);
	if (Hw) for (var n of Hw(t)) Ww.call(t, n) && Gw(e, n, t[n]);
	return e;
}, qw = (e, t) => Bw(e, Vw(t)), Jw = (e, t) => Mu(e, t)?.[0]?.type === $(e, "li"), Yw = (e) => $(e, "ul"), Xw = (e) => $(e, "ol"), Zw = (e) => [Xw(e), Yw(e)], Qw = (e) => $(e, "li"), $w = (e) => $(e, "lic"), eT = (e, { diffListPath: t, liPath: n }) => {
	let r = ku(e, {
		at: n,
		match: { type: Zw(e) }
	});
	if (!r) return;
	let [i, a] = r;
	if (!t || !H.equals(a, t)) {
		if (i.children.length < 2) {
			let n = ku(e, {
				at: a,
				match: { type: $(e, "li") }
			});
			if (n) return eT(e, {
				diffListPath: t,
				liPath: n[1]
			}) || a;
		}
		return n;
	}
}, tT = (e, { at: t = e.selection } = {}) => {
	let n = $(e, "li"), r;
	if (r = U.isRange(t) && !xd(t) ? t.focus.path : U.isRange(t) ? t.anchor.path : t, r && dd(e, r)) {
		let t = ku(e, {
			at: r,
			match: { type: n }
		});
		if (t) return {
			list: Mu(e, t[1]),
			listItem: t
		};
	}
}, nT = (e, t = e.selection) => {
	if (!t) return;
	let n = ku(e, {
		at: t,
		match: { type: [$(e, "ul"), $(e, "ol")] }
	});
	if (n) {
		let [, t] = n;
		return nT(e, t) ?? n;
	}
}, rT = (e, t) => t.children.some((t) => Du(t, [], { type: Zw(e) })), iT = (e) => {
	let { selection: t } = e;
	return !t || xd(t) || !Cf(e) ? !1 : Id(e, { match: { type: $(e, "li") } });
}, aT = (e, t) => wu(t) && Zw(e).includes(t.type), oT = (e, { list: t, listItem: n }) => {
	let r = !1, [i] = t, [, a] = n, o;
	try {
		o = H.previous(a);
	} catch {
		return;
	}
	let s = nd(e, o);
	if (s) {
		let [t, n] = s, o = t.children.find((t) => Du(t, [], { type: Zw(e) })), c = n.concat(o ? [1, o.children.length] : [1]);
		Fu(e, () => {
			o || Pd(e, {
				children: [],
				type: i.type
			}, { at: a }), zu(e, {
				at: a,
				to: c
			}), r = !0;
		});
	}
	return r;
}, sT = (e, { deleteFromList: t = !0, fromList: n, fromListItem: r, fromStartIndex: i, to: a, toList: o, toListIndex: s = null }) => {
	let c, l;
	return Fu(e, () => {
		if (r) {
			let t = df(e, {
				at: r[1],
				match: { type: Zw(e) }
			});
			if (!t) return;
			c = t?.[1];
		} else if (n) c = n[1];
		else return;
		let u = null;
		if (a && (u = a), o) if (s === null) {
			let e = gf(o);
			u = H.next(e);
		} else u = o[1].concat([s]);
		u && (l = Bf(e, {
			at: c,
			fromStartIndex: i,
			to: u
		}), t && Ru(e, { at: c }));
	}), l;
}, cT = (e, { at: t } = {}) => {
	let n = () => {
		if (ku(e, { match: {
			at: t,
			type: Zw(e)
		} })) return !0;
		if (!t && e.selection) {
			let t = ud(e, e.selection.anchor.path, e.selection.focus.path);
			if (wu(t[0]) && Zw(e).includes(t[0].type)) return !0;
		}
		return !1;
	};
	Fu(e, () => {
		do
			ff(e, {
				at: t,
				match: { type: $(e, "lic") }
			}) && Ld(e, {
				at: t,
				type: $(e, "p")
			}), Nd(e, {
				at: t,
				match: { type: $(e, "li") },
				split: !0
			}), Nd(e, {
				at: t,
				match: { type: [$(e, "ul"), $(e, "ol")] },
				split: !0
			});
		while (n());
	});
}, lT = (e, { list: t, listItem: n }) => {
	let r = () => {
		let [r, i] = t, [a, o] = n, s = ku(e, {
			at: i,
			match: { type: $(e, "li") }
		});
		if (!s) {
			let s;
			try {
				s = H.next(i);
			} catch {
				return;
			}
			let c = rT(e, a), l = !_f(t, o);
			if ((c || l) && Rf(e, {
				children: [],
				type: r.type
			}, { at: s }), c) {
				let t = dd(e, s);
				if (!t) return;
				sT(e, {
					fromListItem: n,
					toList: [t, s]
				});
			}
			if (l) {
				let n = dd(e, s);
				if (!n) return;
				sT(e, {
					deleteFromList: !1,
					fromList: t,
					fromStartIndex: o.at(-1) + 1,
					toList: [n, s]
				});
			}
			return cT(e, { at: o.concat(0) }), !0;
		}
		let [, c] = s, l = o.concat([1]);
		if (!_f(t, o)) {
			rT(e, a) || Rf(e, {
				children: [],
				type: r.type
			}, { at: l });
			let t = dd(e, l);
			if (!t) return;
			sT(e, {
				deleteFromList: !1,
				fromListItem: s,
				fromStartIndex: o.at(-1) + 1,
				toList: [t, l]
			});
		}
		return zu(e, {
			at: o,
			to: H.next(c)
		}), !0;
	}, i = !1;
	return Fu(e, () => {
		i = r();
	}), i;
}, uT = (e, { list: t, listItem: n }) => {
	let [, r] = t;
	return Jw(e, r) ? !1 : (lT(e, {
		list: t,
		listItem: n
	}), !0);
}, dT = (e, { at: t = ((t) => (t = e.selection) ?? void 0)(), enableResetOnShiftTab: n, increase: r = !0 } = {}) => {
	let i = ju(e, {
		at: t,
		match: { type: $(e, "lic") }
	}), a = Array.from(i);
	if (a.length === 0) return;
	let o = [], s = [];
	a.forEach((t) => {
		let n = t[1], r = H.parent(n);
		o.some((e) => {
			let t = H.parent(e);
			return H.isAncestor(t, r);
		}) || (o.push(n), s.push(Su(e, n)));
	});
	let c = r ? s : s.reverse();
	return Fu(e, () => {
		let t = !1;
		return c.forEach((i) => {
			let a = i.unref();
			if (!a) return;
			let o = Mu(e, a);
			if (!o) return;
			let s = Mu(e, o[1]);
			if (!s) return;
			let c;
			r ? c = oT(e, {
				list: s,
				listItem: o
			}) : Jw(e, s[1]) ? c = lT(e, {
				list: s,
				listItem: o
			}) : n && (c = uT(e, {
				list: s,
				listItem: o
			})), t = c || t;
		}), t;
	});
}, fT = (e) => {
	let t = $(e, "li"), n = $(e, "lic");
	if (!e.selection) return !1;
	let r = ku(e, { match: { type: n } });
	if (!r) return !1;
	let [, i] = r, a = Mu(e, i);
	if (!a) return !1;
	let [o, s] = a;
	if (o.type !== t) return !1;
	let c = !1;
	return Fu(e, () => {
		U.isCollapsed(e.selection) || Ru(e);
		let r = sd(e, e.selection.focus, i), a = Mf(e), l = H.next(i), u = H.next(s);
		if (r) {
			Rf(e, {
				children: [{
					children: [{ text: "" }],
					type: n
				}],
				type: t
			}, { at: s }), c = !0;
			return;
		}
		a ? (Rf(e, {
			children: [{
				children: [Kw({ text: "" }, ed(e) || {})],
				type: n
			}],
			type: t
		}, { at: u }), Vu(e, u)) : Fu(e, () => {
			jd(e), Pd(e, {
				children: [],
				type: t
			}, { at: l }), zu(e, {
				at: l,
				to: u
			}), Vu(e, u), Cd(e, { edge: "start" });
		}), o.children.length > 1 && zu(e, {
			at: l,
			to: u.concat(1)
		}), c = !0;
	}), c;
}, pT = (e, { fromListItem: t, start: n, toListItem: r }) => {
	let [, i] = t, [, a] = r, o = 0;
	return Fu(e, () => {
		let t = df(e, {
			at: i,
			match: { type: Zw(e) }
		});
		if (!t) return;
		let [, r] = t, s = df(e, {
			at: a,
			match: { type: Zw(e) }
		}), c;
		if (!s) {
			let t = Mu(e, i);
			if (!t) return;
			let [n] = t, r = n.type, o = a.concat([1]);
			Rf(e, {
				children: [],
				type: r
			}, { at: o }), c = o.concat([0]);
		} else if (n) {
			let [, e] = s;
			c = e.concat([0]);
		} else c = H.next(gf(s));
		o = Bf(e, {
			at: r,
			to: c
		}), Ru(e, { at: r });
	}), o;
}, mT = (e, { list: t, listItem: n, reverse: r = !0 }) => {
	let [i, a] = n;
	if (Sd(e.selection) || !rT(e, i)) return !1;
	let o = Df(a), s = !1;
	return Fu(e, () => {
		if (o) {
			let t = nd(e, o);
			if (!t) return;
			let i = H.next(a);
			Rf(e, {
				children: [{
					children: [{ text: "" }],
					type: $(e, "lic")
				}],
				type: $(e, "li")
			}, { at: i });
			let c = nd(e, i);
			if (!c) return;
			let l = Su(e, c[1]);
			pT(e, {
				fromListItem: n,
				toListItem: c
			}), Xu(e, { reverse: r }), i = l.unref(), pT(e, {
				fromListItem: [c[0], i],
				toListItem: t
			}), Bu(e, { at: i }), s = !0;
			return;
		}
		sT(e, {
			fromListItem: n,
			toList: t,
			toListIndex: 1
		});
	}), s;
}, hT = (e, { type: t, pluginKey: n = t }) => Fu(e, () => {
	if (!e.selection) return;
	let { validLiChildrenTypes: r } = ES(e, n);
	if (xd(e.selection) || !Cf(e)) {
		let n = tT(e);
		if (n) {
			let { list: r } = n;
			r[0].type === t ? cT(e) : Ld(e, { type: t }, {
				at: e.selection,
				match: (t) => wu(t) && Zw(e).includes(t.type),
				mode: "lowest"
			});
		} else {
			Pd(e, {
				children: [],
				type: t
			});
			let n = ju(e, { match: { type: $(e, "p") } }), i = Array.from(n);
			ff(e, { match: { type: r } }) || Ld(e, { type: $(e, "lic") });
			let a = {
				children: [],
				type: $(e, "li")
			};
			for (let [, t] of i) Pd(e, a, { at: t });
		}
	} else {
		let [n, i] = U.edges(e.selection), a = ud(e, n.path, i.path);
		if (Zw(e).includes(a[0].type) || a[0].type === $(e, "li")) if (a[0].type === t) cT(e);
		else {
			let n = Fd(e, {
				at: U.start(e.selection),
				match: { type: Zw(e) },
				mode: "lowest"
			}), r = Fd(e, {
				at: U.end(e.selection),
				match: { type: Zw(e) },
				mode: "lowest"
			}), i = Math.min(n[1].length, r[1].length);
			Ld(e, { type: t }, {
				at: e.selection,
				match: (t, n) => wu(t) && Zw(e).includes(t.type) && n.length >= i,
				mode: "all"
			});
		}
		else {
			let n = a[1].length, i = ju(e, { mode: "all" });
			Array.from(i).filter(([, e]) => e.length === n + 1).forEach((n) => {
				Zw(e).includes(n[0].type) ? Ld(e, { type: t }, {
					at: n[1],
					match: (t) => wu(t) && Zw(e).includes(t.type),
					mode: "all"
				}) : (r?.includes(n[0].type) || Ld(e, { type: $(e, "lic") }, { at: n[1] }), Pd(e, {
					children: [],
					type: $(e, "li")
				}, { at: n[1] }), Pd(e, {
					children: [],
					type: t
				}, { at: n[1] }));
			});
		}
	}
}), gT = (e, { options: { enableResetOnShiftTab: t, hotkey: n }, type: r }) => (i) => {
	if (i.defaultPrevented) return;
	let a = zb.isTab(e, i), o = zb.isUntab(e, i), s = e.selection;
	if (e.selection && (a || o)) {
		let { selection: n } = e;
		if (!xd(e.selection)) {
			let { anchor: t, focus: r } = U.isBackward(n) ? {
				anchor: Kw({}, n.focus),
				focus: Kw({}, n.anchor)
			} : {
				anchor: Kw({}, n.anchor),
				focus: Kw({}, n.focus)
			}, i = Au(e, {
				anchor: t,
				focus: r
			});
			i && (s = i, Vu(e, i));
		}
		let r = Id(e, { match: { type: $(e, "li") } });
		if (s && r) return i.preventDefault(), dT(e, {
			at: s,
			enableResetOnShiftTab: t,
			increase: a
		}), !0;
	}
	if (!n) return;
	let c = Bd(n);
	for (let t of c) (0, Rv.isHotkey)(t)(i) && hT(e, { type: r });
}, _T = (e, t) => {
	let n = tT(e, {}), r = !1;
	if (n) {
		let { list: i, listItem: a } = n;
		Lf(e, { match: (t) => t.type === $(e, "li") }) && Fu(e, () => {
			if (r = uT(e, {
				list: i,
				listItem: a
			}), r || (r = mT(e, {
				list: i,
				listItem: a
			}), r)) return !0;
			if (Nf(a[1]) && !Jw(e, i[1])) {
				Rw(e, kS({ options: { rules: [{
					defaultType: $(e, "p"),
					hotkey: "backspace",
					onReset: (e) => cT(e),
					predicate: () => Lf(e),
					types: [$(e, "li")]
				}] } }))(Lw), r = !0;
				return;
			}
			let n = Ku(e, e.selection.focus), o, s = !1;
			if (n && iT(qw(Kw({}, e), { selection: {
				anchor: e.selection.anchor,
				focus: n
			} }))) {
				let t = $(e, "lic");
				o = [...ju(e, {
					at: a[1],
					match: (e) => e.type === t,
					mode: "lowest"
				})][0], s = o[0].children.length > 1;
			}
			if (Xu(e, {
				reverse: !0,
				unit: t
			}), r = !0, !o || !s) return;
			let c = nd(e, H.parent(o[1]));
			c && c[0].children.length === 0 && Bu(e, { at: c[1] });
		});
	}
	return r;
}, vT = (e) => {
	let t = Gu(e, e.selection.focus.path);
	if (t) {
		let n = tT(e, { at: t });
		if (n) {
			let { listItem: t } = n;
			if (!Qu(e, ff(e, { at: e.selection.anchor })[1])) return Bu(e), !0;
			rT(e, t[0]) && lT(e, tT(e, { at: [
				...t[1],
				1,
				0,
				0
			] }));
		}
	}
	return !1;
}, yT = (e, t, n, r) => {
	let { listItem: i } = t;
	if (!rT(e, i[0])) {
		let t = $(e, "li"), a = ju(e, {
			at: i[1],
			match: (n, r) => {
				if (r.length === 0) return !1;
				let i = n.type === t, a = dd(e, H.next(r))?.type === t;
				return i && a;
			},
			mode: "lowest"
		}), o = Array.from(a, (e) => e[1])[0];
		if (!o) {
			let t = Gu(e, i[1]);
			if (t) {
				let n = tT(e, { at: t });
				if (n) {
					let t = nT(e, i[1]);
					return sT(e, {
						deleteFromList: !0,
						fromList: n.list,
						toList: t
					}), !0;
				}
			}
			return !1;
		}
		let s = nd(e, H.next(o));
		if (!s) return !1;
		let c = Mu(e, s[1]);
		if (c && mT(e, {
			list: c,
			listItem: s,
			reverse: !1
		})) return !0;
		let l = Gu(e, e.selection.focus);
		if (!l || !iT(qw(Kw({}, e), { selection: {
			anchor: e.selection.anchor,
			focus: l
		} }))) return !1;
		let u = $(e, "lic"), d = [...ju(e, {
			at: l.path,
			match: (e) => e.type === u,
			mode: "lowest"
		})][0];
		if (d[0].children.length < 2) return !1;
		n(r);
		let f = nd(e, H.parent(d[1]));
		return f && f[0].children.length === 0 && Bu(e, { at: f[1] }), !0;
	}
	let a = nd(e, H.next([...i[1], 0]));
	if (!a) return !1;
	let o = pf(a)[0];
	return !!(uT(e, {
		list: a,
		listItem: o
	}) || mT(e, {
		list: a,
		listItem: o
	}));
}, bT = (e, t, n) => {
	let r = !1;
	return !e?.selection || !If(e) || Fu(e, () => {
		let i = tT(e, {});
		if (!i) {
			r = vT(e);
			return;
		}
		r = yT(e, i, t, n);
	}), r;
}, xT = (e) => ku(e, {
	at: qu(e, e.selection),
	match: { type: $(e, "li") }
}), ST = (e) => {
	let t = !1;
	return Fu(e, () => {
		if (!iT(e)) return;
		let n = ku(e, {
			at: Uu(e, e.selection),
			match: { type: $(e, "li") }
		}), r = n && !rT(e, n[0]) ? Su(e, n[1]) : void 0;
		if (!xT(e) || !n) {
			t = !1;
			return;
		}
		Xu(e);
		let i = xT(e);
		if (r) {
			let n = r.unref(), a = eT(e, {
				diffListPath: (i && Mu(e, i[1]))?.[1],
				liPath: n
			});
			a && Bu(e, { at: a }), t = !0;
		}
	}), t;
}, CT = (e) => {
	if (!e.selection) return;
	let t = tT(e, {}), n;
	if (t) {
		let { list: r, listItem: i } = t;
		if (jf(e) && (n = lT(e, {
			list: r,
			listItem: i
		}), n)) return !0;
	}
	if (Rw(e, kS({ options: { rules: [{
		defaultType: $(e, "p"),
		onReset: (e) => cT(e),
		predicate: () => !n && jf(e),
		types: [$(e, "li")]
	}] } }))(Lw) || !n && fT(e)) return !0;
}, wT = (e) => {
	let { insertFragment: t } = e, n = bS(e, "li"), r = Qw(e), i = $w(e), a = (e, t, { type: n }) => {
		let r = H.parent(t[1]);
		for (; dd(e, r).type !== n;) r = H.parent(r);
		return [dd(e, r), r];
	}, o = (t) => {
		let n = null, a = t;
		for (; aT(e, a) || a.type === r && a.children[0].type !== i;) n = a, [a] = a.children;
		return n ? n.children : [a];
	}, s = (t) => {
		if (!aT(e, t)) return [t];
		let r = _d(t), i = Array.from(r), s = i.reduce((e, n) => H.isAncestor(e[1], n[1]) ? e : ud(t, n[1], e[1]), a(t, i[0], n)), [c, ...l] = aT(e, s[0]) ? s[0].children : [s[0]];
		return [...o(c), ...l];
	}, c = (e) => e.type === r ? e : {
		children: [e],
		type: r
	}, l = (t) => t.length === 1 && aT(e, t[0]) && [...vd({ children: t })].filter((e) => wu(e[0])).filter(([e]) => e.type === i).length === 1, u = (t, n, r) => {
		let [, i] = n, [a, o] = r, u = !gd(a), [d, ...f] = t.flatMap(s).map(c), p, m;
		if (aT(e, t[0])) if (l(t)) p = d, m = f;
		else if (u) {
			let [, ...t] = dd(e, i).children, [n, ...r] = d.children;
			if (Rf(e, n, {
				at: H.next(o),
				select: !0
			}), Bu(e, { at: o }), r?.length) if (t?.length) {
				let t = [
					...i,
					1,
					0
				];
				Rf(e, r[0].children, {
					at: t,
					select: !0
				});
			} else Rf(e, r, {
				at: H.next(o),
				select: !0
			});
			p = { text: "" }, m = f;
		} else p = { text: "" }, m = [d, ...f];
		else p = d, m = f;
		return {
			listItemNodes: m,
			textNode: p
		};
	};
	return (n) => {
		let a = Fd(e, {
			match: { type: r },
			mode: "lowest"
		});
		if (!a || (t([{ text: "" }]), a = Fd(e, {
			match: { type: r },
			mode: "lowest"
		}), !a)) return t(aT(e, n[0]) ? [{ text: "" }, ...n] : n);
		let o = Fd(e, {
			match: { type: i },
			mode: "lowest"
		});
		if (!o) return t(aT(e, n[0]) ? [{ text: "" }, ...n] : n);
		let { listItemNodes: s, textNode: c } = u(n, a, o);
		t([c]);
		let [, l] = a;
		return Rf(e, s, {
			at: H.next(l),
			select: !0
		});
	};
}, TT = (e, { children: t }) => {
	let n = [];
	for (let r of t) Tu(e, r[0]) ? n.push(...TT(e, { children: pf(r) })) : n.push(r);
	return n;
}, ET = (e, { listItem: t, validLiChildrenTypes: n = [] }) => {
	let r = !1, i = /* @__PURE__ */ new Set([
		$(e, "ul"),
		$(e, "ol"),
		$(e, "lic"),
		...n
	]), [, a] = t, o = pf(t), s = o.filter(([e]) => !i.has(e.type)).map(([, t]) => Su(e, t)), c = o[0], [l, u] = c ?? [];
	if (!c || !Tu(e, l)) return zf(e, $(e, "lic"), { at: a.concat([0]) }), !0;
	if (Tu(e, l) && !Du(l, [], { type: $(e, "lic") })) {
		if (Du(l, [], { type: Zw(e) })) {
			let n = Mu(e, t[1]), r = c;
			return pf(c).reverse().forEach((t) => {
				lT(e, {
					list: r,
					listItem: t
				});
			}), Bu(e, { at: [...n[1], 0] }), !0;
		}
		if (n.includes(l.type)) return !0;
		Ld(e, { type: $(e, "lic") }, { at: u }), r = !0;
	}
	let d = pf(c);
	if (d.length > 0) {
		let t = [], n = [];
		for (let r of d) {
			if (!Tu(e, r[0])) break;
			t.push(Su(e, r[1])), n.push(...TT(e, { children: pf(r) }));
		}
		let i = H.next(d.at(-1)[1]);
		n.reverse().forEach(([, t]) => {
			zu(e, {
				at: t,
				to: i
			});
		}), t.forEach((t) => {
			let n = t.unref();
			n && Bu(e, { at: n });
		}), t.length > 0 && (r = !0);
	}
	return r ? !0 : (s.reverse().forEach((t) => {
		let n = t.unref();
		n && zu(e, {
			at: n,
			to: u.concat([0])
		});
	}), s.length > 0);
}, DT = (e, { nestedListItem: t }) => {
	let [, n] = t, r = Mu(e, n);
	if (!(r && Du(r[0], [], { type: Zw(e) }))) return !1;
	let i;
	try {
		i = H.previous(n);
	} catch {
		return !1;
	}
	let a = nd(e, i);
	if (a) {
		let [, t] = a;
		return zu(e, {
			at: n,
			to: t.concat([1])
		}), !0;
	}
}, OT = (e, { validLiChildrenTypes: t }) => {
	let { normalizeNode: n } = e, r = $(e, "li"), i = $(e, "lic"), a = $(e, "p");
	return ([o, s]) => {
		if (!wu(o)) return n([o, s]);
		if (aT(e, o)) {
			let t = pf([o, s]).find(([e]) => e.type !== r);
			if (t) return Pd(e, {
				children: [],
				type: r
			}, { at: t[1] });
		}
		if (Du(o, [], { type: Zw(e) })) {
			if (o.children.length === 0 || !o.children.some((e) => e.type === r)) return Bu(e, { at: s });
			let t = H.next(s), n = dd(e, t);
			n?.type === o.type && sT(e, {
				deleteFromList: !0,
				fromList: [n, t],
				toList: [o, s]
			});
			let i = Df(s), a = dd(e, i);
			if (a?.type === o.type) {
				e.normalizeNode([a, i]);
				return;
			}
			if (DT(e, { nestedListItem: [o, s] })) return;
		}
		if (!(o.type === $(e, "li") && ET(e, {
			listItem: [o, s],
			validLiChildrenTypes: t
		}))) {
			if (o.type === i && i !== a && Mu(e, s)?.[0].type !== r) {
				Ld(e, { type: a }, { at: s });
				return;
			}
			n([o, s]);
		}
	};
}, kT = SS({
	key: "list",
	plugins: [
		{
			deserializeHtml: { rules: [{ validNodeName: "UL" }] },
			handlers: { onKeyDown: gT },
			isElement: !0,
			key: "ul",
			withOverrides: (e, { options: { validLiChildrenTypes: t } }) => {
				let { deleteBackward: n, deleteForward: r, deleteFragment: i, insertBreak: a } = e;
				return e.insertBreak = () => {
					CT(e) || a();
				}, e.deleteBackward = (t) => {
					_T(e, t) || n(t);
				}, e.deleteForward = (t) => {
					bT(e, r, t) || r(t);
				}, e.deleteFragment = (t) => {
					ST(e) || i(t);
				}, e.insertFragment = wT(e), e.normalizeNode = OT(e, { validLiChildrenTypes: t }), e;
			}
		},
		{
			deserializeHtml: { rules: [{ validNodeName: "OL" }] },
			handlers: { onKeyDown: gT },
			isElement: !0,
			key: "ol"
		},
		{
			deserializeHtml: { rules: [{ validNodeName: "LI" }] },
			isElement: !0,
			key: "li",
			then: (e, { type: t }) => ({ inject: { pluginsByKey: { [lC]: { editor: { insertData: { preInsert: () => Id(e, { match: { type: t } }) } } } } } })
		},
		{
			isElement: !0,
			key: "lic"
		}
	]
});
(/* @__PURE__ */ t(((e, t) => {
	(function(n, r) {
		typeof e == "object" && t !== void 0 ? t.exports = r() : typeof define == "function" && define.amd ? define(r) : (n ||= self, n.urlParser = r());
	})(e, (function() {
		function e(t) {
			"@babel/helpers - typeof";
			return e = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
				return typeof e;
			} : function(e) {
				return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
			}, e(t);
		}
		var t = function(e) {
			if (typeof e != "string") return {};
			e = e.split("+").join(" ");
			var t = {}, n = e.match(/(?:[?](?:[^=]+)=(?:[^&#]*)(?:[&](?:[^=]+)=(?:[^&#]*))*(?:[#].*)?)|(?:[#].*)/), r;
			if (n === null) return {};
			r = n[0].substr(1).split(/[&#=]/);
			for (var i = 0; i < r.length; i += 2) t[decodeURIComponent(r[i])] = decodeURIComponent(r[i + 1] || "");
			return t;
		}, n = function(t, n) {
			if (e(t) !== "object") return "";
			var r = "", i = 0, a = Object.keys(t);
			if (a.length === 0) return "";
			for (a.sort(), n || (r += "?" + a[0] + "=" + t[a[0]], i += 1); i < a.length; i += 1) r += "&" + a[i] + "=" + t[a[i]];
			return r;
		};
		function r(e) {
			var t = 0, n = {
				s: 1,
				m: 60,
				h: 3600,
				d: 3600 * 24,
				w: 3600 * 24 * 7
			}, r;
			e = e.replace(/([smhdw])/g, " $1 ").trim(), r = e.split(" ");
			for (var i = 0; i < r.length; i += 2) t += parseInt(r[i], 10) * n[r[i + 1] || "s"];
			return t;
		}
		function i(e) {
			for (var t = 0, n = [
				1,
				60,
				3600,
				3600 * 24,
				3600 * 24 * 7
			], r = e.split(":"), i = 0; i < r.length; i++) t += parseInt(r[i], 10) * n[r.length - i - 1];
			return t;
		}
		var a = {
			getQueryParams: t,
			combineParams: n,
			getTime: function(e) {
				return e === void 0 ? 0 : e.match(/^(\d+[smhdw]?)+$/) ? r(e) : e.match(/^(\d+:?)+$/) ? i(e) : 0;
			}
		}, o = a.getQueryParams;
		function s() {
			for (var e = 0, t = [
				"parseProvider",
				"parse",
				"bind",
				"create"
			]; e < t.length; e++) {
				var n = t[e];
				this[n] = this[n].bind(this);
			}
			this.plugins = {};
		}
		var c = s;
		s.prototype.parseProvider = function(e) {
			var t = e.match(/(?:(?:https?:)?\/\/)?(?:[^.]+\.)?(\w+)\./i);
			return t ? t[1] : void 0;
		}, s.prototype.parse = function(e) {
			if (e !== void 0) {
				var t = this.parseProvider(e), n, r = this.plugins[t];
				if (!(!t || !r || !r.parse)) return n = r.parse.call(r, e, o(e)), n && (n = l(n), n.provider = r.provider), n;
			}
		}, s.prototype.bind = function(e) {
			if (this.plugins[e.provider] = e, e.alternatives) for (var t = 0; t < e.alternatives.length; t += 1) this.plugins[e.alternatives[t]] = e;
		}, s.prototype.create = function(t) {
			if (!(e(t) !== "object" || e(t.videoInfo) !== "object")) {
				var n = t.videoInfo, r = t.params, i = this.plugins[n.provider];
				if (r = r === "internal" ? n.params : r || {}, i && (t.format = t.format || i.defaultFormat, i.formats.hasOwnProperty(t.format))) return i.formats[t.format].apply(i, [n, Object.assign({}, r)]);
			}
		};
		function l(e) {
			return e.params && Object.keys(e.params).length === 0 && delete e.params, e;
		}
		var u = new c();
		function d() {
			this.provider = "allocine", this.alternatives = [], this.defaultFormat = "embed", this.formats = { embed: this.createEmbedUrl }, this.mediaTypes = { VIDEO: "video" };
		}
		d.prototype.parseUrl = function(e) {
			var t = e.match(/(?:\/video\/player_gen_cmedia=)([A-Za-z0-9]+)/i);
			return t ? t[1] : void 0;
		}, d.prototype.parse = function(e) {
			var t = {
				mediaType: this.mediaTypes.VIDEO,
				id: this.parseUrl(e)
			};
			return t.id ? t : void 0;
		}, d.prototype.createEmbedUrl = function(e) {
			if (!(!e.id || e.mediaType !== this.mediaTypes.VIDEO)) return "https://player.allocine.fr/" + e.id + ".html";
		}, u.bind(new d());
		var f = a.combineParams;
		function p() {
			this.provider = "canalplus", this.defaultFormat = "embed", this.formats = { embed: this.createEmbedUrl }, this.mediaTypes = { VIDEO: "video" };
		}
		p.prototype.parseParameters = function(e) {
			return delete e.vid, e;
		}, p.prototype.parse = function(e, t) {
			var n = this, r = {
				mediaType: this.mediaTypes.VIDEO,
				id: t.vid
			};
			if (r.params = n.parseParameters(t), r.id) return r;
		}, p.prototype.createEmbedUrl = function(e, t) {
			if (!(!e.id || e.mediaType !== this.mediaTypes.VIDEO)) {
				var n = "http://player.canalplus.fr/embed/";
				return t.vid = e.id, n += f(t), n;
			}
		}, u.bind(new p());
		var m = a.combineParams;
		function h() {
			this.provider = "coub", this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		h.prototype.parseUrl = function(e) {
			var t = e.match(/(?:embed|view)\/([a-zA-Z\d]+)/i);
			return t ? t[1] : void 0;
		}, h.prototype.parse = function(e, t) {
			var n = {
				mediaType: this.mediaTypes.VIDEO,
				params: t,
				id: this.parseUrl(e)
			};
			if (n.id) return n;
		}, h.prototype.createUrl = function(e, t, n) {
			if (!(!t.id || t.mediaType !== this.mediaTypes.VIDEO)) {
				var r = e + t.id;
				return r += m(n), r;
			}
		}, h.prototype.createLongUrl = function(e, t) {
			return this.createUrl("https://coub.com/view/", e, t);
		}, h.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("//coub.com/embed/", e, t);
		}, u.bind(new h());
		var g = a.combineParams, _ = a.getTime;
		function v() {
			this.provider = "dailymotion", this.alternatives = ["dai"], this.defaultFormat = "long", this.formats = {
				short: this.createShortUrl,
				long: this.createLongUrl,
				embed: this.createEmbedUrl,
				image: this.createImageUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		v.prototype.parseParameters = function(e) {
			return this.parseTime(e);
		}, v.prototype.parseTime = function(e) {
			return e.start &&= _(e.start), e;
		}, v.prototype.parseUrl = function(e) {
			var t = e.match(/(?:\/video|ly)\/([A-Za-z0-9]+)/i);
			return t ? t[1] : void 0;
		}, v.prototype.parse = function(e, t) {
			var n = this, r = {
				mediaType: this.mediaTypes.VIDEO,
				params: n.parseParameters(t),
				id: n.parseUrl(e)
			};
			return r.id ? r : void 0;
		}, v.prototype.createUrl = function(e, t, n) {
			if (!(!t.id || t.mediaType !== this.mediaTypes.VIDEO)) return e + t.id + g(n);
		}, v.prototype.createShortUrl = function(e, t) {
			return this.createUrl("https://dai.ly/", e, t);
		}, v.prototype.createLongUrl = function(e, t) {
			return this.createUrl("https://dailymotion.com/video/", e, t);
		}, v.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("https://www.dailymotion.com/embed/video/", e, t);
		}, v.prototype.createImageUrl = function(e, t) {
			return delete t.start, this.createUrl("https://www.dailymotion.com/thumbnail/video/", e, t);
		}, u.bind(new v());
		var y = a.combineParams;
		function b() {
			this.provider = "loom", this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		b.prototype.parseUrl = function(e) {
			var t = e.match(/(?:share|embed)\/([a-zA-Z\d]+)/i);
			return t ? t[1] : void 0;
		}, b.prototype.parse = function(e, t) {
			var n = {
				mediaType: this.mediaTypes.VIDEO,
				params: t,
				id: this.parseUrl(e)
			};
			return n.id ? n : void 0;
		}, b.prototype.createUrl = function(e, t, n) {
			if (!(!t.id || t.mediaType !== this.mediaTypes.VIDEO)) {
				var r = e + t.id;
				return r += y(n), r;
			}
		}, b.prototype.createLongUrl = function(e, t) {
			return this.createUrl("https://loom.com/share/", e, t);
		}, b.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("//loom.com/embed/", e, t);
		}, u.bind(new b());
		var x = a.combineParams, S = a.getTime;
		function C() {
			this.provider = "twitch", this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = {
				VIDEO: "video",
				STREAM: "stream",
				CLIP: "clip"
			};
		}
		C.prototype.seperateId = function(e) {
			return {
				pre: e[0],
				id: e.substr(1)
			};
		}, C.prototype.parseChannel = function(e, t) {
			var n = t.channel || t.utm_content || e.channel;
			return delete t.utm_content, delete t.channel, n;
		}, C.prototype.parseUrl = function(e, t, n) {
			var r = e.match(/(clips\.)?twitch\.tv\/(?:(?:videos\/(\d+))|(\w+(?:-[\w\d-]+)?)(?:\/clip\/(\w+))?)/i);
			return r && r[2] ? t.id = "v" + r[2] : n.video ? (t.id = n.video, delete n.video) : n.clip ? (t.id = n.clip, t.isClip = !0, delete n.clip) : r && r[1] && r[3] ? (t.id = r[3], t.isClip = !0) : r && r[3] && r[4] ? (t.channel = r[3], t.id = r[4], t.isClip = !0) : r && r[3] && (t.channel = r[3]), t;
		}, C.prototype.parseMediaType = function(e) {
			var t;
			return e.id ? e.isClip ? (t = this.mediaTypes.CLIP, delete e.isClip) : t = this.mediaTypes.VIDEO : e.channel && (t = this.mediaTypes.STREAM), t;
		}, C.prototype.parseParameters = function(e) {
			return e.t && (e.start = S(e.t), delete e.t), e;
		}, C.prototype.parse = function(e, t) {
			var n = this, r = {};
			return r = n.parseUrl(e, r, t), r.channel = n.parseChannel(r, t), r.mediaType = n.parseMediaType(r), r.params = n.parseParameters(t), r.channel || r.id ? r : void 0;
		}, C.prototype.createLongUrl = function(e, t) {
			var n = "";
			if (e.mediaType === this.mediaTypes.STREAM && e.channel) n = "https://twitch.tv/" + e.channel;
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) n = "https://twitch.tv/videos/" + this.seperateId(e.id).id, t.start && (t.t = t.start + "s", delete t.start);
			else if (e.mediaType === this.mediaTypes.CLIP && e.id) n = e.channel ? "https://www.twitch.tv/" + e.channel + "/clip/" + e.id : "https://clips.twitch.tv/" + e.id;
			else return;
			return n += x(t), n;
		}, C.prototype.createEmbedUrl = function(e, t) {
			var n = "https://player.twitch.tv/";
			if (e.mediaType === this.mediaTypes.STREAM && e.channel) t.channel = e.channel;
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) t.video = e.id, t.start && (t.t = t.start + "s", delete t.start);
			else if (e.mediaType === this.mediaTypes.CLIP && e.id) n = "https://clips.twitch.tv/embed", t.clip = e.id;
			else return;
			return n += x(t), n;
		}, u.bind(new C());
		var w = a.combineParams, T = a.getTime;
		function E() {
			this.provider = "vimeo", this.alternatives = ["vimeopro"], this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		E.prototype.parseUrl = function(e) {
			var t = e.match(/(?:\/showcase\/\d+)?(?:\/(?:channels\/[\w]+|(?:(?:album\/\d+|groups\/[\w]+)\/)?videos?))?\/(\d+)/i);
			return t ? t[1] : void 0;
		}, E.prototype.parseHash = function(e) {
			var t = e.match(/\/\d+\/(\w+)$/i);
			return t ? t[1] : void 0;
		}, E.prototype.parseParameters = function(e) {
			return e.t && (e.start = T(e.t), delete e.t), e.h && (e.hash = e.h, delete e.h), e;
		}, E.prototype.parse = function(e, t) {
			var n = {
				mediaType: this.mediaTypes.VIDEO,
				params: this.parseParameters(t),
				id: this.parseUrl(e)
			}, r = this.parseHash(e, t);
			return r && (n.params.hash = r), n.id ? n : void 0;
		}, E.prototype.createUrl = function(e, t, n, r) {
			if (!(!t.id || t.mediaType !== this.mediaTypes.VIDEO)) {
				var i = e + t.id, a = n.start;
				return delete n.start, n.hash && (r === "embed" ? n.h = n.hash : r === "long" && (i += "/" + n.hash), delete n.hash), i += w(n), a && (i += "#t=" + a), i;
			}
		}, E.prototype.createLongUrl = function(e, t) {
			return this.createUrl("https://vimeo.com/", e, t, "long");
		}, E.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("//player.vimeo.com/video/", e, t, "embed");
		}, u.bind(new E());
		var ee = a.combineParams, D = a.getTime;
		function te() {
			this.provider = "wistia", this.alternatives = [], this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl,
				embedjsonp: this.createEmbedJsonpUrl
			}, this.mediaTypes = {
				VIDEO: "video",
				EMBEDVIDEO: "embedvideo"
			};
		}
		te.prototype.parseUrl = function(e) {
			var t = e.match(/(?:(?:medias|iframe)\/|wvideo=)([\w-]+)/);
			return t ? t[1] : void 0;
		}, te.prototype.parseChannel = function(e) {
			var t = e.match(/(?:(?:https?:)?\/\/)?([^.]*)\.wistia\./), n = t ? t[1] : void 0;
			if (!(n === "fast" || n === "content")) return n;
		}, te.prototype.parseParameters = function(e, t) {
			return e.wtime && (e.start = D(e.wtime), delete e.wtime), e.wvideo === t.id && delete e.wvideo, e;
		}, te.prototype.parseMediaType = function(e) {
			if (e.id && e.channel) return this.mediaTypes.VIDEO;
			if (e.id) return delete e.channel, this.mediaTypes.EMBEDVIDEO;
		}, te.prototype.parse = function(e, t) {
			var n = {
				id: this.parseUrl(e),
				channel: this.parseChannel(e)
			};
			if (n.params = this.parseParameters(t, n), n.mediaType = this.parseMediaType(n), n.id) return n;
		}, te.prototype.createUrl = function(e, t, n) {
			return t.start && (t.wtime = t.start, delete t.start), n += ee(t), n;
		}, te.prototype.createLongUrl = function(e, t) {
			if (!(!e.id || e.mediaType !== this.mediaTypes.VIDEO)) {
				var n = "https://" + e.channel + ".wistia.com/medias/" + e.id;
				return this.createUrl(e, t, n);
			}
		}, te.prototype.createEmbedUrl = function(e, t) {
			if (!(!e.id || !(e.mediaType === this.mediaTypes.VIDEO || e.mediaType === this.mediaTypes.EMBEDVIDEO))) {
				var n = "https://fast.wistia.com/embed/iframe/" + e.id;
				return this.createUrl(e, t, n);
			}
		}, te.prototype.createEmbedJsonpUrl = function(e) {
			if (!(!e.id || !(e.mediaType === this.mediaTypes.VIDEO || e.mediaType === this.mediaTypes.EMBEDVIDEO))) return "https://fast.wistia.com/embed/medias/" + e.id + ".jsonp";
		}, u.bind(new te());
		var ne = a.combineParams;
		function O() {
			this.provider = "youku", this.defaultFormat = "long", this.formats = {
				embed: this.createEmbedUrl,
				long: this.createLongUrl,
				flash: this.createFlashUrl,
				static: this.createStaticUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		O.prototype.parseUrl = function(e) {
			var t = e.match(/(?:(?:embed|sid)\/|v_show\/id_|VideoIDS=)([a-zA-Z0-9]+)/);
			return t ? t[1] : void 0;
		}, O.prototype.parseParameters = function(e) {
			return e.VideoIDS && delete e.VideoIDS, e;
		}, O.prototype.parse = function(e, t) {
			var n = this, r = {
				mediaType: this.mediaTypes.VIDEO,
				id: n.parseUrl(e),
				params: n.parseParameters(t)
			};
			if (r.id) return r;
		}, O.prototype.createUrl = function(e, t, n) {
			if (!(!t.id || t.mediaType !== this.mediaTypes.VIDEO)) {
				var r = e + t.id;
				return r += ne(n), r;
			}
		}, O.prototype.createEmbedUrl = function(e, t) {
			return this.createUrl("http://player.youku.com/embed/", e, t);
		}, O.prototype.createLongUrl = function(e, t) {
			return this.createUrl("http://v.youku.com/v_show/id_", e, t);
		}, O.prototype.createStaticUrl = function(e, t) {
			return this.createUrl("http://static.youku.com/v1.0.0638/v/swf/loader.swf?VideoIDS=", e, t);
		}, O.prototype.createFlashUrl = function(e, t) {
			if (!(!e.id || e.mediaType !== this.mediaTypes.VIDEO)) {
				var n = "http://player.youku.com/player.php/sid/" + e.id + "/v.swf";
				return n += ne(t), n;
			}
		}, u.bind(new O());
		var re = a.combineParams, ie = a.getTime;
		function k() {
			this.provider = "youtube", this.alternatives = ["youtu", "ytimg"], this.defaultFormat = "long", this.formats = {
				short: this.createShortUrl,
				long: this.createLongUrl,
				embed: this.createEmbedUrl,
				shortImage: this.createShortImageUrl,
				longImage: this.createLongImageUrl
			}, this.imageQualities = {
				0: "0",
				1: "1",
				2: "2",
				3: "3",
				DEFAULT: "default",
				HQDEFAULT: "hqdefault",
				SDDEFAULT: "sddefault",
				MQDEFAULT: "mqdefault",
				MAXRESDEFAULT: "maxresdefault"
			}, this.defaultImageQuality = this.imageQualities.HQDEFAULT, this.mediaTypes = {
				VIDEO: "video",
				PLAYLIST: "playlist",
				SHARE: "share",
				CHANNEL: "channel"
			};
		}
		k.prototype.parseVideoUrl = function(e) {
			var t = e.match(/(?:(?:v|vi|be|videos|embed)\/(?!videoseries)|(?:v|ci)=)([\w-]{11})/i);
			return t ? t[1] : void 0;
		}, k.prototype.parseChannelUrl = function(e) {
			var t = e.match(/\/channel\/([\w-]+)/);
			if (t) return {
				id: t[1],
				mediaType: this.mediaTypes.CHANNEL
			};
			if (t = e.match(/\/(?:c|user)\/([\w-]+)/), t) return {
				name: t[1],
				mediaType: this.mediaTypes.CHANNEL
			};
		}, k.prototype.parseParameters = function(e, t) {
			return (e.start || e.t) && (e.start = ie(e.start || e.t), delete e.t), e.v === t.id && delete e.v, e.list === t.id && delete e.list, e;
		}, k.prototype.parseMediaType = function(e) {
			if (e.params.list && (e.list = e.params.list, delete e.params.list), e.id && !e.params.ci) e.mediaType = this.mediaTypes.VIDEO;
			else if (e.list) delete e.id, e.mediaType = this.mediaTypes.PLAYLIST;
			else if (e.params.ci) delete e.params.ci, e.mediaType = this.mediaTypes.SHARE;
			else return;
			return e;
		}, k.prototype.parse = function(e, t) {
			var n = this.parseChannelUrl(e);
			if (n) return n;
			var r = {
				params: t,
				id: this.parseVideoUrl(e)
			};
			return r.params = this.parseParameters(t, r), r = this.parseMediaType(r), r;
		}, k.prototype.createShortUrl = function(e, t) {
			if (!(!e.id || e.mediaType !== this.mediaTypes.VIDEO)) {
				var n = "https://youtu.be/" + e.id;
				return t.start && (n += "#t=" + t.start), n;
			}
		}, k.prototype.createLongUrl = function(e, t) {
			var n = "", r = t.start;
			if (delete t.start, e.mediaType === this.mediaTypes.CHANNEL) if (e.id) n += "https://www.youtube.com/channel/" + e.id;
			else if (e.name) n += "https://www.youtube.com/c/" + e.name;
			else return;
			else if (e.mediaType === this.mediaTypes.PLAYLIST && e.list) t.feature = "share", n += "https://www.youtube.com/playlist";
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) t.v = e.id, n += "https://www.youtube.com/watch";
			else if (e.mediaType === this.mediaTypes.SHARE && e.id) t.ci = e.id, n += "https://www.youtube.com/shared";
			else return;
			return e.list && (t.list = e.list), n += re(t), e.mediaType !== this.mediaTypes.PLAYLIST && r && (n += "#t=" + r), n;
		}, k.prototype.createEmbedUrl = function(e, t) {
			var n = "https://www.youtube.com/embed";
			if (e.mediaType === this.mediaTypes.PLAYLIST && e.list) t.listType = "playlist";
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) n += "/" + e.id, t.loop === "1" && (t.playlist = e.id);
			else return;
			return e.list && (t.list = e.list), n += re(t), n;
		}, k.prototype.createImageUrl = function(e, t, n) {
			if (!(!t.id || t.mediaType !== this.mediaTypes.VIDEO)) return e + t.id + "/" + (n.imageQuality || this.defaultImageQuality) + ".jpg";
		}, k.prototype.createShortImageUrl = function(e, t) {
			return this.createImageUrl("https://i.ytimg.com/vi/", e, t);
		}, k.prototype.createLongImageUrl = function(e, t) {
			return this.createImageUrl("https://img.youtube.com/vi/", e, t);
		}, u.bind(new k());
		var ae = a.combineParams, oe = a.getTime;
		function se() {
			this.provider = "soundcloud", this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = {
				TRACK: "track",
				PLAYLIST: "playlist",
				APITRACK: "apitrack",
				APIPLAYLIST: "apiplaylist"
			};
		}
		se.prototype.parseUrl = function(e, t) {
			var n = e.match(/(?:m\.)?soundcloud\.com\/(?:([\w-]+)\/(sets\/)?)([\w-]+)/i);
			return n ? (t.channel = n[1], n[1] === "playlists" || n[2] ? t.list = n[3] : t.id = n[3], t) : t;
		}, se.prototype.parseParameters = function(e) {
			return e.t && (e.start = oe(e.t), delete e.t), e;
		}, se.prototype.parseMediaType = function(e) {
			return e.id && (e.channel === "tracks" ? (delete e.channel, delete e.params.url, e.mediaType = this.mediaTypes.APITRACK) : e.mediaType = this.mediaTypes.TRACK), e.list && (e.channel === "playlists" ? (delete e.channel, delete e.params.url, e.mediaType = this.mediaTypes.APIPLAYLIST) : e.mediaType = this.mediaTypes.PLAYLIST), e;
		}, se.prototype.parse = function(e, t) {
			var n = {};
			if (n = this.parseUrl(e, n), n.params = this.parseParameters(t), n = this.parseMediaType(n), !(!n.id && !n.list)) return n;
		}, se.prototype.createLongUrl = function(e, t) {
			var n = "", r = t.start;
			if (delete t.start, e.mediaType === this.mediaTypes.TRACK && e.id && e.channel) n = "https://soundcloud.com/" + e.channel + "/" + e.id;
			else if (e.mediaType === this.mediaTypes.PLAYLIST && e.list && e.channel) n = "https://soundcloud.com/" + e.channel + "/sets/" + e.list;
			else if (e.mediaType === this.mediaTypes.APITRACK && e.id) n = "https://api.soundcloud.com/tracks/" + e.id;
			else if (e.mediaType === this.mediaTypes.APIPLAYLIST && e.list) n = "https://api.soundcloud.com/playlists/" + e.list;
			else return;
			return n += ae(t), r && (n += "#t=" + r), n;
		}, se.prototype.createEmbedUrl = function(e, t) {
			var n = "https://w.soundcloud.com/player/";
			if (delete t.start, e.mediaType === this.mediaTypes.APITRACK && e.id) t.url = "https%3A//api.soundcloud.com/tracks/" + e.id;
			else if (e.mediaType === this.mediaTypes.APIPLAYLIST && e.list) t.url = "https%3A//api.soundcloud.com/playlists/" + e.list;
			else return;
			return n += ae(t), n;
		}, u.bind(new se());
		var A = a.combineParams;
		function j() {
			this.provider = "teachertube", this.alternatives = [], this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = {
				VIDEO: "video",
				AUDIO: "audio",
				DOCUMENT: "document",
				CHANNEL: "channel",
				COLLECTION: "collection",
				GROUP: "group"
			};
		}
		j.prototype.parse = function(e, t) {
			var n = {};
			n.list = this.parsePlaylist(t), n.params = t;
			var r = e.match(/\/(audio|video|document|user\/channel|collection|group)\/(?:[\w-]+-)?(\w+)/);
			if (r) return n.mediaType = this.parseMediaType(r[1]), n.id = r[2], n;
		}, j.prototype.parsePlaylist = function(e) {
			if (e["playlist-id"]) {
				var t = e["playlist-id"];
				return delete e["playlist-id"], t;
			}
		}, j.prototype.parseMediaType = function(e) {
			switch (e) {
				case "audio": return this.mediaTypes.AUDIO;
				case "video": return this.mediaTypes.VIDEO;
				case "document": return this.mediaTypes.DOCUMENT;
				case "user/channel": return this.mediaTypes.CHANNEL;
				case "collection": return this.mediaTypes.COLLECTION;
				case "group": return this.mediaTypes.GROUP;
			}
		}, j.prototype.createLongUrl = function(e, t) {
			if (e.id) {
				var n = "https://www.teachertube.com/";
				return e.list && (t["playlist-id"] = e.list), e.mediaType === this.mediaTypes.CHANNEL ? n += "user/channel/" : n += e.mediaType + "/", n += e.id, n += A(t), n;
			}
		}, j.prototype.createEmbedUrl = function(e, t) {
			if (e.id) {
				var n = "https://www.teachertube.com/embed/";
				if (e.mediaType === this.mediaTypes.VIDEO || e.mediaType === this.mediaTypes.AUDIO) n += e.mediaType + "/" + e.id;
				else return;
				return n += A(t), n;
			}
		}, u.bind(new j());
		var ce = a.combineParams;
		function M() {
			this.provider = "tiktok", this.defaultFormat = "long", this.formats = { long: this.createLongUrl }, this.mediaTypes = { VIDEO: "video" };
		}
		M.prototype.parse = function(e, t) {
			var n = {
				params: t,
				mediaType: this.mediaTypes.VIDEO
			}, r = e.match(/@([^/]+)\/video\/(\d{19})/);
			if (r) return n.channel = r[1], n.id = r[2], n;
		}, M.prototype.createLongUrl = function(e, t) {
			var n = "";
			if (e.mediaType === this.mediaTypes.VIDEO && e.id && e.channel) n += `https://www.tiktok.com/@${e.channel}/video/${e.id}`;
			else return;
			return n += ce(t), n;
		}, u.bind(new M());
		var N = a.combineParams;
		function le() {
			this.provider = "ted", this.formats = {
				long: this.createLongUrl,
				embed: this.createEmbedUrl
			}, this.mediaTypes = {
				VIDEO: "video",
				PLAYLIST: "playlist"
			};
		}
		le.prototype.parseUrl = function(e, t) {
			var n = e.match(/\/(talks|playlists\/(\d+))\/([\w-]+)/i), r = n ? n[1] : void 0;
			return r ? (t.channel = r.split("/")[0], t.id = n[3], t.channel === "playlists" && (t.list = n[2]), t) : t;
		}, le.prototype.parseMediaType = function(e) {
			return e.id && e.channel === "playlists" && (delete e.channel, e.mediaType = this.mediaTypes.PLAYLIST), e.id && e.channel === "talks" && (delete e.channel, e.mediaType = this.mediaTypes.VIDEO), e;
		}, le.prototype.parse = function(e, t) {
			var n = { params: t };
			if (n = this.parseUrl(e, n), n = this.parseMediaType(n), n.id) return n;
		}, le.prototype.createLongUrl = function(e, t) {
			var n = "";
			if (e.mediaType === this.mediaTypes.VIDEO && e.id) n += "https://ted.com/talks/" + e.id;
			else if (e.mediaType === this.mediaTypes.PLAYLIST && e.id) n += "https://ted.com/playlists/" + e.list + "/" + e.id;
			else return;
			return n += N(t), n;
		}, le.prototype.createEmbedUrl = function(e, t) {
			var n = "https://embed.ted.com/";
			if (e.mediaType === this.mediaTypes.PLAYLIST && e.id) n += "playlists/" + e.list + "/" + e.id;
			else if (e.mediaType === this.mediaTypes.VIDEO && e.id) n += "talks/" + e.id;
			else return;
			return n += N(t), n;
		}, u.bind(new le());
		var ue = a.combineParams;
		function de() {
			this.provider = "facebook", this.alternatives = [], this.defaultFormat = "long", this.formats = {
				long: this.createLongUrl,
				watch: this.createWatchUrl
			}, this.mediaTypes = { VIDEO: "video" };
		}
		return de.prototype.parse = function(e, t) {
			var n = {
				params: t,
				mediaType: this.mediaTypes.VIDEO
			}, r = e.match(/(?:\/(\d+))?\/videos(?:\/.*?)?\/(\d+)/i);
			if (r && (r[1] && (n.pageId = r[1]), n.id = r[2]), t.v && !n.id && (n.id = t.v, delete t.v, n.params = t), n.id) return n;
		}, de.prototype.createWatchUrl = function(e, t) {
			var n = "https://facebook.com/watch/";
			if (!(e.mediaType !== this.mediaTypes.VIDEO || !e.id)) return t = { v: e.id }, n += ue(t), n;
		}, de.prototype.createLongUrl = function(e, t) {
			var n = "https://facebook.com/";
			if (e.pageId) n += e.pageId;
			else return;
			if (e.mediaType === this.mediaTypes.VIDEO && e.id) n += "/videos/" + e.id;
			else return;
			return n += ue(t), n;
		}, u.bind(new de()), u;
	}));
})))();
var AT = Object.defineProperty, jT = Object.getOwnPropertySymbols, MT = Object.prototype.hasOwnProperty, NT = Object.prototype.propertyIsEnumerable, PT = (e, t, n) => t in e ? AT(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, FT = (e, t) => {
	for (var n in t ||= {}) MT.call(t, n) && PT(e, n, t[n]);
	if (jT) for (var n of jT(t)) NT.call(t, n) && PT(e, n, t[n]);
	return e;
}, IT = (e, t, n = {}) => {
	Dd(e, {
		children: [{ text: "" }],
		type: $(e, "img"),
		url: t
	}, FT({ nextBlock: !0 }, n));
}, LT = /* @__PURE__ */ new Set(/* @__PURE__ */ "ase.art.bmp.blp.cd5.cit.cpt.cr2.cut.dds.dib.djvu.egt.exif.gif.gpl.grf.icns.ico.iff.jng.jpeg.jpg.jfif.jp2.jps.lbm.max.miff.mng.msp.nitf.ota.pbm.pc1.pc2.pc3.pcf.pcx.pdn.pgm.PI1.PI2.PI3.pict.pct.pnm.pns.ppm.psb.psd.pdd.psp.px.pxm.pxr.qfx.raw.rle.sct.sgi.rgb.int.bw.tga.tiff.tif.vtf.xbm.xcf.xpm.3dv.amf.ai.awg.cgm.cdr.cmx.dxf.e2d.egt.eps.fs.gbr.odg.svg.stl.vrml.x3d.sxd.v2d.vnd.wmf.emf.art.xar.png.webp.jxr.hdp.wdp.cur.ecw.iff.lbm.liff.nrrd.pam.pcx.pgf.sgi.rgb.rgba.bw.int.inta.sid.ras.sun.tga".split(".")), RT = (e) => {
	if (!Jd(e)) return !1;
	let t = new URL(e).pathname.split(".").pop();
	return LT.has(t);
}, zT = (e, t) => {
	let { insertData: n } = e;
	return e.insertData = (t) => {
		let r = t.getData("text/plain");
		if (RT(r)) {
			IT(e, r);
			return;
		}
		n(t);
	}, e;
}, BT = (e, t) => {
	let { options: { uploadImage: n } } = t, { insertData: r } = e;
	return e.insertData = (i) => {
		let a = i.getData("text/plain"), { files: o } = i;
		if (!a && o && o.length > 0) {
			if (!wS(CS(e, t), {
				data: a,
				dataTransfer: i
			})) return r(i);
			for (let t of o) {
				let r = new FileReader(), [i] = t.type.split("/");
				i === "image" && (r.addEventListener("load", async () => {
					r.result && IT(e, n ? await n(r.result) : r.result);
				}), r.readAsDataURL(t));
			}
		} else r(i);
	}, e;
}, VT = SS({
	dangerouslyAllowAttributes: [
		"alt",
		"width",
		"height"
	],
	isElement: !0,
	isVoid: !0,
	key: "img",
	then: (e, { type: t }) => ({ deserializeHtml: {
		getNode: (e) => ({
			type: t,
			url: e.getAttribute("src")
		}),
		rules: [{ validNodeName: "IMG" }]
	} }),
	withOverrides: (e, t) => {
		let { options: { disableEmbedInsert: n, disableUploadInsert: r } } = t;
		return r || (e = BT(e, t)), n || (e = zT(e, t)), e;
	}
}), HT = pa("imagePreview")({
	boundingClientRect: {},
	currentPreview: null,
	isEditingScale: !1,
	openEditorId: null,
	previewList: [],
	scale: 1,
	translate: {
		x: 0,
		y: 0
	}
}).extendActions((e) => ({ close: () => {
	e.currentPreview(null), e.previewList([]), e.openEditorId(null), e.scale(1), e.translate({
		x: 0,
		y: 0
	}), e.isEditingScale(!1);
} })).extendSelectors((e) => ({ isOpen: (t) => e.openEditorId === t })), UT = HT.set;
HT.get;
var WT = () => HT.use, GT = (e) => {
	let t = ju(e, {
		at: [],
		match: (e) => e.type === "img"
	});
	return Array.from(t, (e) => ({
		id: e[0].id,
		url: e[0].url
	}));
}, KT = (e, t) => {
	let { id: n, url: r } = t, i = GT(e);
	document.documentElement.style.overflowY = "hidden", UT.openEditorId(e.id), UT.currentPreview({
		id: n,
		url: r
	}), UT.previewList(i);
};
aS("img")({ propsHook: () => {
	let e = Qv(), t = cx();
	return { props: {
		draggable: !0,
		onDoubleClickCapture: () => {
			KT(t, e);
		},
		src: e.url
	} };
} });
var qT = () => {
	let e = WT().scale(), t = UT.scale, n = UT.translate;
	return {
		zoomIn: me(() => {
			if (e >= 2) return;
			let n = [
				0,
				.5,
				1,
				1.5,
				2
			].find((t) => e < t);
			n && t(n);
		}, [e]),
		zoomOut: me(() => {
			if (e <= 0) return;
			let r = [
				0,
				.5,
				1,
				1.5,
				2
			].reverse().find((t) => e > t);
			r === 1 && n({
				x: 0,
				y: 0
			}), r && t(r);
		}, [e])
	};
};
aS("img")({
	propsHook: ({ currentPreview: e, imageRef: t, scale: n, setBoundingClientRect: r, translate: i }) => {
		let a = ye(() => n <= 1, [n]), { zoomIn: o, zoomOut: s } = qT();
		return _e(() => {
			if (n <= 1) return;
			let e = t.current?.getBoundingClientRect();
			e && r(e);
		}, [
			i.x,
			i.y,
			n
		]), { props: {
			draggable: !1,
			onClick: (e) => {
				e.stopPropagation(), a ? o() : s();
			},
			ref: t,
			src: e?.url,
			style: {
				cursor: a ? "zoom-in" : "zoom-out",
				transform: `scale(${n}) translate(${i.x + "px"}, ${i.y + "px"})`
			}
		} };
	},
	stateHook: () => {
		let e = WT().currentPreview(), t = WT().translate(), n = WT().scale();
		return {
			currentPreview: e,
			imageRef: N.useRef(null),
			scale: n,
			setBoundingClientRect: UT.boundingClientRect,
			translate: t
		};
	}
});
var { MediaProvider: JT, mediaStore: YT, useMediaStore: XT } = Sr({ showCaption: !1 }, { name: "media" }), ZT = "media", QT = pa("floatingMedia")({
	isEditing: !1,
	url: ""
}).extendActions((e) => ({ reset: () => {
	e.url(""), e.isEditing(!1);
} })), $T = QT.set, eE = QT.get;
aS("button")({ propsHook: () => {
	let e = Qv();
	return { props: { onClick: N.useCallback(() => {
		$T.url(e.url), $T.isEditing(!0);
	}, [e.url]) } };
} });
var tE = (e, { element: t, pluginKey: n = ZT }) => {
	let r = eE.url();
	if (r === t.url) return $T.reset(), !0;
	let { isUrl: i = Jd, transformUrl: a } = ES(e, n);
	if (i(r)) return a && (r = a(r)), Ad(e, { url: r }), $T.reset(), E_(e, e.selection), !0;
};
aS("input")({
	propsHook: ({ defaultValue: e }) => ({ props: {
		autoFocus: !0,
		defaultValue: e,
		onChange: N.useCallback((e) => {
			$T.url(e.target.value);
		}, [])
	} }),
	stateHook: ({ pluginKey: e } = {}) => {
		let t = cx(), n = Qv();
		return Va("enter", (r) => {
			tE(t, {
				element: n,
				pluginKey: e
			}) && r.preventDefault();
		}, { enableOnFormTags: ["INPUT"] }, []), Va("escape", () => {
			eE.isEditing() && ($T.reset(), E_(t, t.selection));
		}, {
			enableOnContentEditable: !0,
			enableOnFormTags: ["INPUT"]
		}, []), { defaultValue: eE.url() };
	}
});
var { PlaceholderProvider: nE, placeholderStore: rE, usePlaceholderStore: iE } = Sr({
	isUploading: !1,
	progresses: {},
	updatedFiles: []
}, { name: "placeholder" }), aE = Object.defineProperty, oE = Object.defineProperties, sE = Object.getOwnPropertyDescriptors, cE = Object.getOwnPropertySymbols, lE = Object.prototype.hasOwnProperty, uE = Object.prototype.propertyIsEnumerable, dE = (e, t, n) => t in e ? aE(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, fE = (e, t) => {
	for (var n in t ||= {}) lE.call(t, n) && dE(e, n, t[n]);
	if (cE) for (var n of cE(t)) uE.call(t, n) && dE(e, n, t[n]);
	return e;
}, pE = (e, t) => oE(e, sE(t)), mE = SS({
	key: "nodeId",
	options: {
		filter: () => !0,
		filterText: !0,
		idCreator: () => Math.random().toString(36).slice(2, 7),
		idKey: "id"
	},
	withOverrides: (e, { options: { allow: t, disableInsertOverrides: n, exclude: r, filter: i, filterText: a, idCreator: o, idKey: s = "", reuseId: c } }) => {
		let { apply: l, insertNode: u, insertNodes: d } = e, f = () => ({ [s]: o() }), p = (e) => i(e) && (!a || e[0]?.type !== void 0), m = (t) => {
			(!c || Id(e, {
				at: [],
				match: { [s]: t[s] }
			})) && delete t[s];
		}, h = (t) => {
			if ($d(t._id)) {
				let n = t._id;
				delete t._id, Id(e, {
					at: [],
					match: { [s]: n }
				}) || (t[s] = n);
			}
		}, g = {
			allow: t,
			exclude: r,
			filter: p
		};
		return e.insertNodes = (e, t) => {
			let r = Bd(e).filter((e) => !!e);
			r.length !== 0 && d(r.map((e) => (!n && e[s] && (e._id = e[s]), e)), t);
		}, e.insertNode = (e) => {
			!n && e[s] && (e._id = e[s]), u(e);
		}, e.apply = (t) => {
			if (t.type === "insert_node") {
				let e = Rd(t.node);
				return TS({
					apply: m,
					node: e,
					query: g,
					source: {}
				}), GC({
					node: e,
					path: t.path,
					query: g,
					source: f
				}), n || TS({
					apply: h,
					node: e,
					query: g,
					source: {}
				}), l(pE(fE({}, t), { node: e }));
			}
			if (t.type === "split_node") {
				let n = t.properties, r = t.properties[s];
				if (Ed([n, t.path], g)) return (!c || r === void 0 || Id(e, {
					at: [],
					match: { [s]: r }
				})) && (r = o()), l(pE(fE({}, t), { properties: pE(fE({}, t.properties), { [s]: r }) }));
				r && delete t.properties[s];
			}
			return l(t);
		}, e;
	}
}), hE = SS({
	deserializeHtml: {
		query: (e) => e.style.fontFamily !== "Consolas",
		rules: [{ validNodeName: "P" }]
	},
	handlers: { onKeyDown: KC },
	isElement: !0,
	key: "p",
	options: { hotkey: ["mod+opt+0", "mod+shift+0"] }
}), gE = SS({
	key: "selectOnBackspace",
	options: { removeNodeIfEmpty: !1 },
	withOverrides: (e, { options: { query: t, removeNodeIfEmpty: n } }) => {
		let { deleteBackward: r } = e;
		return e.deleteBackward = (i) => {
			let { selection: a } = e;
			if (i === "character" && xd(a)) {
				let o = Ku(e, a, { unit: i });
				if (o) {
					let [s] = ju(e, {
						at: o,
						match: (e) => Ed([e, o.path], t)
					});
					if (s && o) {
						let t = dd(e, id(e, a).path);
						n && t && !gd(t) && Bu(e), Vu(e, o);
					} else r(i);
				} else r(i);
			} else r(i);
		}, e;
	}
}), _E = Object.defineProperty, vE = Object.defineProperties, yE = Object.getOwnPropertyDescriptors, bE = Object.getOwnPropertySymbols, xE = Object.prototype.hasOwnProperty, SE = Object.prototype.propertyIsEnumerable, CE = (e, t, n) => t in e ? _E(e, t, {
	enumerable: !0,
	configurable: !0,
	writable: !0,
	value: n
}) : e[t] = n, wE = (e, t) => {
	for (var n in t ||= {}) xE.call(t, n) && CE(e, n, t[n]);
	if (bE) for (var n of bE(t)) SE.call(t, n) && CE(e, n, t[n]);
	return e;
}, TE = (e, t) => vE(e, yE(t)), EE = (e, t) => {
	var n = {};
	for (var r in e) xE.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && bE) for (var r of bE(e)) t.indexOf(r) < 0 && SE.call(e, r) && (n[r] = e[r]);
	return n;
}, DE = {
	"shift+down": "bottom",
	"shift+left": "left",
	"shift+right": "right",
	"shift+up": "top"
}, OE = (e, t) => {
	let n = nd(e, H.next(t));
	if (!n) return;
	let [r, i] = n, a = r?.children?.[0], o = i.concat(0);
	if (a && o) return nd(e, o);
}, kE = (e, t) => {
	let n = Df(t);
	if (!n) return;
	let r = nd(e, n);
	if (!r) return;
	let [i, a] = r, o = i?.children?.[i.children.length - 1], s = a.concat(i.children.length - 1);
	if (o && s) return nd(e, s);
}, AE = (e) => e.colSpan || Number(e.attributes?.colspan) || 1, jE = (e) => DS(e, ["td", "th"]), ME = (e, { children: t, header: n, row: r } = {}) => (n ??= r ? r.children.every((t) => t.type === $(e, "th")) : !1, {
	children: t ?? [e.blockFactory()],
	type: n ? $(e, "th") : $(e, "td")
}), NE = (e, t = {}) => {
	var n = t, { colCount: r = 1 } = n, i = EE(n, ["colCount"]);
	let { cellFactory: a } = ES(e, fD);
	return {
		children: Array.from({ length: r }).fill(r).map(() => a(i)),
		type: $(e, "tr")
	};
}, PE = (e, t = {}) => {
	var n = t, { colCount: r, header: i, rowCount: a = 0 } = n, o = EE(n, [
		"colCount",
		"header",
		"rowCount"
	]);
	return {
		children: Array.from({ length: a }).fill(a).map((t, n) => NE(e, TE(wE({ colCount: r }, o), { header: i && n === 0 }))),
		type: $(e, fD)
	};
}, FE = (e, t, n, r) => {
	let i = nd(e, H.next(n));
	if (i) return i;
	let [, a] = r;
	return OE(e, a);
}, IE = (e, t, n, r) => {
	let i = Df(n);
	if (!i) {
		let [, t] = r;
		return kE(e, t);
	}
	let a = nd(e, i);
	if (a) return a;
}, LE = (e) => e.rowSpan || Number(e.attributes?.rowspan) || 1, RE = (e, t) => ff(e, wE({ match: { type: $(e, fD) } }, t)), zE = (e) => e.children?.[0]?.children ? e.children[0].children.map((e) => e.colSpan || e?.attributes?.colspan || 1).reduce((e, t) => Number(e) + Number(t)) : 0, BE = (e, { at: t = e.selection } = {}) => {
	if (!t) return;
	let n = Fd(e, {
		at: t,
		match: { type: jE(e) }
	});
	if (!n) return;
	let [, r] = n, i = ku(e, {
		at: r,
		match: { type: $(e, "tr") }
	});
	if (!i) return;
	let [, a] = i, o = ku(e, {
		at: a,
		match: { type: $(e, fD) }
	});
	if (o) return {
		cell: n,
		row: i,
		table: o
	};
};
function VE(e, t, n) {
	var r;
	let i = ES(e, fD), a = t.children, o = -1, s = -1;
	for (let e = 0; e < a.length; e++) {
		let t = a[e], r = 0;
		for (let i of t.children) {
			let t = i;
			if (n === t) {
				s = r, o = e;
				break;
			}
			r += AE(t);
		}
	}
	if (a.slice(0, o).forEach((e, t) => {
		e.children.forEach((e) => {
			let n = e, r = (i?._cellIndices)?.get(n), a = LE(n);
			if (r) {
				let { col: e } = r;
				e <= s && a && a > 1 && o - t < a && (s += AE(n));
			}
		});
	}), o === -1 || s === -1) return null;
	let c = {
		col: s,
		row: o
	};
	return (r = i?._cellIndices) == null || r.set(n, c), c;
}
var HE = (e, t) => e?.get(t), UE = ({ col: e, row: t }, n) => ({
	col: e + AE(n) - 1,
	row: t + LE(n) - 1
}), WE = (e, t, n, r) => {
	let { _cellIndices: i } = ES(e, fD);
	return t.children.flatMap((e) => e.children).find((a) => {
		let o = a, s = HE(i, o) || VE(e, t, o), { col: c, row: l } = s, { col: u, row: d } = UE(s, o);
		return r >= c && r <= u && n >= l && n <= d;
	});
}, GE = (e, { at: t, format: n }) => {
	var r;
	let { _cellIndices: i, getCellChildren: a } = ES(e, fD), o = Fd(e, {
		at: t.anchor.path,
		match: { type: jE(e) }
	}), s = Fd(e, {
		at: t.focus.path,
		match: { type: jE(e) }
	}), c = o[0], l = s[0], u = t.anchor.path.slice(0, -2), d = Fd(e, {
		at: u,
		match: { type: $(e, fD) }
	})[0], { col: f, row: p } = UE(HE(i, c) || VE(e, d, c), c), { col: m, row: h } = UE(HE(i, l) || VE(e, d, l), l), g = Math.min(p, h), _ = Math.max(p, h), v = Math.min(f, m), y = Math.max(f, m), b = _ - g, x = PE(e, {
		children: [],
		colCount: y - v + 1,
		rowCount: b + 1
	}), S = [], C = /* @__PURE__ */ new WeakSet(), w = g, T = v;
	for (;;) {
		let t = WE(e, d, w, T);
		if (!t) break;
		let n = HE(i, t) || VE(e, d, t), { col: r, row: a } = UE(n, t), { col: o, row: s } = n;
		if (s < g || a > _ || o < v || r > y) {
			C = /* @__PURE__ */ new WeakSet(), S = [], g = Math.min(g, s), _ = Math.max(_, a), v = Math.min(v, o), y = Math.max(y, r), w = g, T = v;
			let t = _ - g;
			x = PE(e, {
				children: [],
				colCount: y - v + 1,
				rowCount: t + 1
			});
			continue;
		}
		if (!C.has(t)) {
			C.add(t);
			let n = x.children[w - g].children;
			n[T - v] = t;
			let r = T_(e, t);
			S.push([t, r]);
		}
		if (T + 1 <= y) T += 1;
		else if (w + 1 <= _) T = v, w += 1;
		else break;
	}
	let E = n || "table";
	return E === "cell" ? S : ((r = x.children) == null || r.forEach((e) => {
		let t = e;
		t.children = t.children?.filter((e) => a(e).length > 0);
	}), E === "table" ? [[x, u]] : {
		cellEntries: S,
		tableEntries: [[x, u]]
	});
}, KE = (e, { at: t, format: n = "table" }) => {
	let { enableMerging: r } = ES(e, fD);
	if (r) return GE(e, {
		at: t,
		format: n
	});
	let i = t.anchor.path, a = t.focus.path, o = i.at(-2), s = a.at(-2), c = i.at(-1), l = a.at(-1), u = Math.min(o, s), d = Math.max(o, s), f = Math.min(c, l), p = Math.max(c, l), m = i.slice(0, -2), h = d - u, g = PE(e, {
		children: [],
		colCount: p - f + 1,
		rowCount: h + 1
	}), _ = u, v = f, y = [];
	for (;;) {
		let t = m.concat([_, v]), n = dd(e, t);
		if (!n) break;
		let r = g.children[_ - u].children;
		if (r[v - f] = n, y.push([n, t]), v + 1 <= p) v += 1;
		else if (_ + 1 <= d) v = f, _ += 1;
		else break;
	}
	return n === "cell" ? y : [[g, m]];
}, qE = (e, t = {}) => {
	var n = t, { format: r = "table" } = n, i = EE(n, ["format"]);
	let a = mf(e, wE({ match: { type: jE(e) } }, i));
	if (a) {
		let [t, n] = a;
		if (!H.equals(t[1], n[1])) return KE(e, {
			at: {
				anchor: {
					offset: 0,
					path: t[1]
				},
				focus: {
					offset: 0,
					path: n[1]
				}
			},
			format: r
		});
		if (r === "table") {
			let n = PE(e, { rowCount: 1 });
			return n.children[0].children = [t[0]], [[n, t[1].slice(0, -2)]];
		}
		return [t];
	}
	return [];
}, JE = (e, t, n, r) => {
	let { _cellIndices: i } = ES(e, fD), [a, o] = t, s = a.children[n].children.findIndex((e) => {
		let { col: t } = HE(i, e);
		return t === r;
	});
	return o.concat([n, s]);
}, YE = (e, { at: t, fromCell: n, header: r } = {}) => {
	let { _cellIndices: i } = ES(e, fD), a = n ? Fd(e, {
		at: n,
		match: { type: jE(e) }
	}) : ff(e, { match: { type: jE(e) } });
	if (!a) return;
	let [, o] = a, s = a[0], c = ff(e, {
		at: o,
		match: { type: $(e, fD) }
	});
	if (!c) return;
	let { cellFactory: l, initialTableWidth: u, minColumnWidth: d } = ES(e, fD), [f, p] = c, { col: m } = HE(i, s) || VE(e, f, s), h = AE(s), g, _;
	H.isPath(t) ? (g = m, _ = m - 1) : (g = m + h, _ = m + h - 1);
	let v = f.children.length, y = g <= 0, b = 1;
	y && (_ = 0, b = 0);
	let x = /* @__PURE__ */ new Set();
	Array.from({ length: v }, (e, t) => t).forEach((t) => {
		let n = WE(e, f, t, _);
		n && x.add(n);
	}), Array.from(x).forEach((t) => {
		let n = t, { col: a, row: o } = HE(i, n) || VE(e, f, n), s = LE(n), u = AE(n), d = JE(e, c, o, a);
		if (a + u - 1 >= g && !y) Ad(e, TE(wE({}, n), { colSpan: u + 1 }), { at: d });
		else {
			let t = d.slice(0, -1), n = d.at(-1), i = [...t, n + b], a = Mu(e, d)[0];
			Rf(e, TE(wE({}, l({
				header: r,
				row: a
			})), {
				colSpan: 1,
				rowSpan: s
			}), { at: i });
		}
	}), Fu(e, () => {
		let { colSizes: t } = f;
		if (t) {
			let n = [
				...t.slice(0, g),
				0,
				...t.slice(g)
			];
			if (u) {
				n[g] = t[g] ?? t[g - 1] ?? u / t.length;
				let e = t.reduce((e, t) => e + t, 0), r = n.reduce((e, t) => e + t, 0), i = Math.max(e, u);
				if (r > i) {
					let e = i / r;
					n = n.map((t) => Math.max(d ?? 0, Math.floor(t * e)));
				}
			}
			Ad(e, { colSizes: n }, { at: p });
		}
	});
}, XE = (e, t = {}) => {
	let { enableMerging: n } = ES(e, fD);
	if (n) return YE(e, t);
	let { at: r, disableSelect: i, fromCell: a, header: o } = t, s = a ? Fd(e, {
		at: a,
		match: { type: jE(e) }
	}) : ff(e, { match: { type: jE(e) } });
	if (!s) return;
	let [, c] = s, l = ff(e, {
		at: c,
		match: { type: $(e, fD) }
	});
	if (!l) return;
	let [u, d] = l, f, p;
	H.isPath(r) ? (f = r, p = r.at(-1)) : (f = H.next(c), p = c.at(-1) + 1);
	let m = c.at(-2), { cellFactory: h, initialTableWidth: g, minColumnWidth: _ } = ES(e, fD);
	Fu(e, () => {
		u.children.forEach((t, n) => {
			let a = [...f];
			H.isPath(r) ? a[r.length - 2] = n : a[c.length - 2] = n;
			let s = o === void 0 ? t.children.every((t) => t.type === $(e, "th")) : o;
			Rf(e, h({ header: s }), {
				at: a,
				select: !i && n === m
			});
		});
		let { colSizes: t } = u;
		if (t) {
			let n = [
				...t.slice(0, p),
				0,
				...t.slice(p)
			];
			if (g) {
				n[p] = t[p] ?? t[p - 1] ?? g / t.length;
				let e = t.reduce((e, t) => e + t, 0), r = n.reduce((e, t) => e + t, 0), i = Math.max(e, g);
				if (r > i) {
					let e = i / r;
					n = n.map((t) => Math.max(_ ?? 0, Math.floor(t * e)));
				}
			}
			Ad(e, { colSizes: n }, { at: d });
		}
	});
}, ZE = (e, { at: t, fromRow: n, header: r } = {}) => {
	let { _cellIndices: i, cellFactory: a } = ES(e, fD), o = n ? Fd(e, {
		at: n,
		match: { type: $(e, "tr") }
	}) : ff(e, { match: { type: $(e, "tr") } });
	if (!o) return;
	let [, s] = o, c = ff(e, {
		at: s,
		match: { type: $(e, fD) }
	});
	if (!c) return;
	let l = c[0], u = Fd(e, {
		at: n,
		match: { type: jE(e) }
	});
	if (!u) return;
	let [d, f] = u, p = d, m = LE(p), { row: h } = HE(i, p) || VE(e, l, p), g = f.at(-2), _ = f.slice(0, -2), v, y, b;
	H.isPath(t) ? (v = t.at(-1), y = h - 1, b = t) : (v = h + m, y = h + m - 1, b = [..._, g + m]);
	let x = v === 0;
	x && (y = 0);
	let S = zE(l), C = /* @__PURE__ */ new Set();
	Array.from({ length: S }, (e, t) => t).forEach((t) => {
		let n = WE(e, l, y, t);
		n && C.add(n);
	});
	let w = Array.from(C), T = [];
	w.forEach((t) => {
		if (!t) return;
		let n = t, { col: o, row: s } = HE(i, n) || VE(e, l, n), u = LE(n), d = AE(n), f = JE(e, c, s, o);
		if (s + u - 1 >= v && !x) Ad(e, TE(wE({}, n), { rowSpan: u + 1 }), { at: f });
		else {
			let t = Mu(e, f)[0], n = a({
				header: r,
				row: t
			});
			T.push(TE(wE({}, n), {
				colSpan: d,
				rowSpan: 1
			}));
		}
	}), Fu(e, () => {
		Rf(e, {
			children: T,
			type: $(e, "tr")
		}, { at: b });
	});
}, QE = (e, t = {}) => {
	let { cellFactory: n, enableMerging: r } = ES(e, fD);
	if (r) return ZE(e, t);
	let { at: i, disableSelect: a, fromRow: o, header: s } = t, c = o ? Fd(e, {
		at: o,
		match: { type: $(e, "tr") }
	}) : ff(e, { match: { type: $(e, "tr") } });
	if (!c) return;
	let [l, u] = c, d = ff(e, {
		at: u,
		match: { type: $(e, fD) }
	});
	if (!d) return;
	let f = () => ({
		children: l.children.map((t, r) => {
			let i = d[0].children.length !== 1 && d[0].children.every((t) => t.children[r].type === $(e, "th"));
			return n({ header: s ?? i });
		}),
		type: $(e, "tr")
	});
	if (Fu(e, () => {
		Rf(e, f(), { at: H.isPath(i) ? i : H.next(u) });
	}), !a) {
		let t = ff(e, { match: { type: jE(e) } });
		if (!t) return;
		let [, n] = t;
		H.isPath(i) ? n[n.length - 2] = i.at(-2) : n[n.length - 2] += 1, Vu(e, n);
	}
}, $E = (e, { at: t, edge: n, fromOneCell: r, reverse: i } = {}) => {
	if (n) {
		let i = qE(e, {
			at: t,
			format: "cell"
		}), a = +!r;
		if (i.length > a) {
			let [, t] = i[0], [, r] = i.at(-1), a = [...t], o = [...r];
			switch (n) {
				case "bottom":
					o[o.length - 2] += 1;
					break;
				case "top":
					--a[a.length - 2];
					break;
				case "right":
					o[o.length - 1] += 1;
					break;
				case "left":
					--a[a.length - 1];
					break;
			}
			return yd(e, a) && yd(e, o) && Vu(e, {
				anchor: qu(e, a),
				focus: qu(e, o)
			}), !0;
		}
		return;
	}
	let a = ff(e, {
		at: t,
		match: { type: jE(e) }
	});
	if (a) {
		let [, t] = a, n = [...t], r = i ? -1 : 1;
		if (n[n.length - 2] += r, yd(e, n)) Vu(e, qu(e, n));
		else {
			let n = t.slice(0, -2);
			i ? Fu(e, () => {
				Vu(e, qu(e, n)), kd(e, { reverse: !0 });
			}) : Fu(e, () => {
				Vu(e, Uu(e, n)), kd(e);
			});
		}
		return !0;
	}
}, eD = (e, t) => {
	let n;
	if (!e.currentKeyboardEvent || ![
		"up",
		"down",
		"shift+up",
		"shift+right",
		"shift+down",
		"shift+left"
	].some((t) => {
		let r = (0, Rv.isHotkey)(t, e.currentKeyboardEvent);
		return r && (n = t), r;
	}) || !e.selection?.focus || !t?.focus || !Cf(e, {
		at: {
			anchor: e.selection.focus,
			focus: t.focus
		},
		match: { type: jE(e) }
	}) || !n) return;
	let r = DE[n];
	if (r && !Ff(e, {
		at: e.selection,
		match: { type: jE(e) }
	})) return;
	let i = e.selection, a = ["shift+up", "up"].includes(n);
	setTimeout(() => {
		$E(e, {
			at: i,
			edge: r,
			fromOneCell: !0,
			reverse: a
		});
	}, 0);
}, tD = (e, { type: t }) => (n) => {
	if (n.defaultPrevented) return;
	let r = {
		"shift+down": (0, Rv.isHotkey)("shift+down", n),
		"shift+left": (0, Rv.isHotkey)("shift+left", n),
		"shift+right": (0, Rv.isHotkey)("shift+right", n),
		"shift+up": (0, Rv.isHotkey)("shift+up", n)
	};
	Object.keys(r).forEach((t) => {
		r[t] && $E(e, {
			edge: DE[t],
			reverse: t === "shift+up"
		}) && (n.preventDefault(), n.stopPropagation());
	});
	let i = zb.isTab(e, n), a = zb.isUntab(e, n);
	if (i || a) {
		let t = BE(e);
		if (!t) return;
		let { cell: r, row: o } = t, [, s] = r;
		if (a) {
			let t = IE(e, r, s, o);
			if (t) {
				let [, n] = t;
				Vu(e, n);
			}
		} else if (i) {
			let t = FE(e, r, s, o);
			if (t) {
				let [, n] = t;
				Vu(e, n);
			}
		}
		n.preventDefault(), n.stopPropagation();
	}
	if ((0, Rv.isHotkey)("mod+a", n)) {
		let r = ku(e, { match: { type: t } });
		if (!r) return;
		let [, i] = r;
		Vu(e, i), n.preventDefault(), n.stopPropagation();
	}
}, nD = (e, { reverse: t, unit: n }) => {
	let { selection: r } = e, i = t ? Uu : qu, a = t ? Gu : Ku;
	if (xd(r)) {
		let o = ff(e, { match: { type: jE(e) } });
		if (o) {
			let [, t] = o, n = i(e, t);
			if (r && q.equals(r.anchor, n)) return !0;
		} else if (ff(e, {
			at: a(e, r, { unit: n }),
			match: { type: jE(e) }
		})) return kd(e, { reverse: !t }), !0;
	}
}, rD = (e) => {
	let { deleteBackward: t, deleteForward: n, deleteFragment: r } = e;
	return e.deleteBackward = (n) => {
		if (!nD(e, { unit: n })) return t(n);
	}, e.deleteForward = (t) => {
		if (!nD(e, {
			reverse: !0,
			unit: t
		})) return n(t);
	}, e.deleteFragment = (t) => {
		if (Ff(e, { match: (t) => t.type === $(e, "table") })) {
			let t = qE(e, { format: "cell" });
			if (t.length > 1) {
				Fu(e, () => {
					t.forEach(([, t]) => {
						Uf(e, {
							at: t,
							nodes: e.blockFactory()
						});
					}), Vu(e, {
						anchor: qu(e, t[0][1]),
						focus: Uu(e, t.at(-1)[1])
					});
				});
				return;
			}
		}
		r(t);
	}, e;
}, iD = (e, { options: t }) => {
	let { getFragment: n } = e, { getCellChildren: r } = t;
	return e.getFragment = () => {
		let t = n(), i = [];
		return t.forEach((t) => {
			if (t.type === $(e, "table")) {
				let n = t.children, a = n.length;
				if (!a) return;
				let o = n[0].children.length;
				if (a <= 1 && o <= 1) {
					let e = n[0], t = r(e);
					i.push(...t[0].children);
					return;
				} else {
					let t = qE(e);
					if (t.length > 0) {
						i.push(t[0][0]);
						return;
					}
				}
			}
			i.push(t);
		}), i;
	}, e;
}, aD = (e, { options: t }) => {
	let { insertFragment: n } = e, { disableExpandOnInsert: r, getCellChildren: i, insertColumn: a, insertRow: o } = t, s = xu(e);
	return s.insertFragment = (t) => {
		let s = t.find((t) => t.type === $(e, fD));
		if (!s && RE(e, { at: e.selection?.anchor })) {
			let n = qE(e, { format: "cell" });
			if (n.length > 1) {
				n.forEach((n) => {
					if (n) {
						let [, r] = n;
						Uf(e, {
							at: r,
							nodes: Rd(t)
						});
					}
				}), Vu(e, {
					anchor: qu(e, n[0][1]),
					focus: Uu(e, n.at(-1)[1])
				});
				return;
			}
		}
		if (s) {
			if (RE(e, { at: e.selection?.anchor })) {
				let [t] = qE(e, {
					at: e.selection?.anchor,
					format: "cell"
				});
				if (t) {
					Fu(e, () => {
						let [, n] = t, c = [...n], l = c.at(-1), u = null, d = !0;
						s.children.forEach((t) => {
							if (c[c.length - 1] = l, !d) {
								let t = c.slice(0, -1);
								if (c[c.length - 2] += 1, !yd(e, c)) {
									if (r) return;
									o?.(e, { fromRow: t });
								}
							}
							d = !1;
							let n = t.children, s = !0;
							n.forEach((t) => {
								if (!s) {
									let t = [...c];
									if (c[c.length - 1] += 1, !yd(e, c)) {
										if (r) return;
										a?.(e, { fromCell: t });
									}
								}
								s = !1;
								let n = i(t);
								Uf(e, {
									at: c,
									nodes: Rd(n)
								}), u = [...c];
							});
						}), u && Vu(e, {
							anchor: qu(e, n),
							focus: Uu(e, u)
						});
					});
					return;
				}
			} else if (t.length === 1 && t[0].type === "table") {
				e.insertNode(t[0]);
				return;
			}
		}
		n(t);
	}, e;
}, oD = (e, t) => {
	let { insertText: n } = e;
	return e.insertText = (t) => {
		Sd(e.selection) && RE(e, { at: e.selection?.anchor }) && qE(e, { format: "cell" }).length > 1 && Cd(e, { edge: "focus" }), n(t);
	}, e;
}, sD = (e) => {
	let { addMark: t, getMarks: n, removeMark: r } = e;
	return e.addMark = (n, r) => {
		let { selection: i } = e;
		if (!i || xd(i)) return t(n, r);
		let a = qE(e, { format: "cell" });
		if (a.length <= 1) return t(n, r);
		a.forEach(([t, i]) => {
			Ad(e, { [n]: r }, {
				at: i,
				match: (e) => Iu(e),
				split: !0,
				voids: !0
			});
		});
	}, e.removeMark = (t) => {
		let { selection: n } = e;
		if (!n || xd(n)) return r(t);
		let i = qE(e, { format: "cell" });
		if (i.length === 0) return r(t);
		i.forEach(([n, r]) => {
			Md(e, t, {
				at: r,
				match: (e) => Iu(e),
				split: !0,
				voids: !0
			});
		});
	}, e.getMarks = () => {
		let { selection: t } = e;
		if (!t || xd(t)) return n();
		let r = qE(e, { format: "cell" });
		if (r.length === 0) return n();
		let i = {};
		return r.forEach(([t, n]) => {
			let r = ju(e, {
				at: n,
				match: (e) => Iu(e)
			});
			Array.from(r, (e) => e[0]).forEach((e) => {
				let t = Object.keys(e);
				t.length !== 1 && (t.splice(t.indexOf("text"), 1), t.forEach((t) => {
					i[t] = e[t];
				}));
			});
		}), i;
	}, e;
}, cD = (e) => {
	let { normalizeNode: t } = e, n = xu(e), { initialTableWidth: r } = ES(e, fD);
	return n.normalizeNode = ([n, i]) => {
		if (wu(n)) {
			if (n.type === $(e, "table")) {
				if (ff(e, {
					at: i,
					match: { type: $(e, "table") }
				})) {
					Nd(e, { at: i });
					return;
				}
				if (r) {
					let t = n, a = t.children[0]?.children?.length;
					if (a) {
						let n = [];
						if (t.colSizes) t.colSizes.some((e) => !e) && t.colSizes.forEach((e) => {
							n.push(e || r / a);
						});
						else for (let e = 0; e < a; e++) n.push(r / a);
						if (n.length > 0) {
							Ad(e, { colSizes: n }, { at: i });
							return;
						}
					}
				}
			}
			if (n.type === $(e, "tr") && Mu(e, i)?.[0].type !== $(e, "table")) {
				Nd(e, { at: i });
				return;
			}
			if (jE(e).includes(n.type)) {
				let { children: t } = n;
				if (Mu(e, i)?.[0].type !== $(e, "tr")) {
					Nd(e, { at: i });
					return;
				}
				if (Iu(t[0])) {
					Gf(e, e.blockFactory({}, i), { at: i });
					return;
				}
			}
		}
		return t([n, i]);
	}, e;
}, lD = (e) => {
	let { apply: t } = e;
	return e.apply = (n) => {
		if (n.type === "set_selection" && n.newProperties) {
			let t = wE(wE({}, e.selection), n.newProperties);
			if (U.isRange(t) && Cf(e, {
				at: t,
				match: (t) => t.type === $(e, "table")
			})) {
				let r = ff(e, {
					at: t.anchor,
					match: (t) => t.type === $(e, fD)
				});
				if (r) {
					let [, i] = r;
					U.isBackward(t) ? n.newProperties.focus = qu(e, i) : Ku(e, i) && (n.newProperties.focus = Uu(e, i));
				} else {
					let r = ff(e, {
						at: t.focus,
						match: (t) => t.type === $(e, fD)
					});
					if (r) {
						let [, i] = r;
						if (U.isBackward(t)) {
							let t = qu(e, i), r = Ku(e, t);
							n.newProperties.focus = r ?? t;
						} else n.newProperties.focus = Uu(e, i);
					}
				}
			}
			eD(e, t);
		}
		t(n);
	}, e;
}, uD = (e) => {
	let { setFragmentData: t } = e;
	return e.setFragmentData = (n, r) => {
		let i = qE(e, { format: "table" })?.[0], a = qE(e, { format: "cell" }), o = e.selection;
		if (!i || !o) {
			t(n, r);
			return;
		}
		let s = H.compare(o.anchor.path, o.focus.path) < 1 ? o.anchor : o.focus, [c, l] = i, u = c.children, [d, f] = s.path.slice(l.length, l.length + 2), p = "", m = "", h = document.createElement("div"), g = document.createElement("table");
		if (i && o && a.length === 1 && (r === "copy" || r === "cut")) {
			t(n);
			return;
		}
		Fu(e, () => {
			u.forEach((r, i) => {
				let a = r.children, o = l.concat(d + i), s = [], c = r.type === $(e, "th") ? document.createElement("th") : document.createElement("tr");
				a.forEach((r, i) => {
					n.clearData();
					let a = o.concat(f + i);
					Vu(e, {
						anchor: qu(e, a),
						focus: Uu(e, a)
					}), t(n), s.push(n.getData("text/plain"));
					let l = document.createElement("td");
					l.colSpan = AE(r), l.rowSpan = LE(r), l.innerHTML = n.getData("text/html"), c.append(l);
				}), g.append(c), p += `${s.join(",")}
`, m += `${s.join("	")}
`;
			}), Vu(e, o), h.append(g);
		}), n.setData("text/csv", p), n.setData("text/tsv", m), n.setData("text/plain", m), n.setData("text/html", h.innerHTML);
		let _ = JSON.stringify(c), v = window.btoa(encodeURIComponent(_));
		n.setData("application/x-slate-fragment", v);
	}, e;
}, dD = (e, t) => (e = cD(e), e = rD(e), e = iD(e, t), e = aD(e, t), e = oD(e, t), e = lD(e), e = uD(e), e = sD(e), e), fD = "table", pD = (e) => (t) => {
	let n = t.style.background || t.style.backgroundColor;
	return n ? {
		background: n,
		type: e
	} : { type: e };
}, mD = SS({
	deserializeHtml: { rules: [{ validNodeName: "TABLE" }] },
	handlers: { onKeyDown: tD },
	isElement: !0,
	key: fD,
	options: {
		_cellIndices: /* @__PURE__ */ new WeakMap(),
		enableMerging: !1,
		insertColumn: (e, { fromCell: t }) => {
			XE(e, {
				disableSelect: !0,
				fromCell: t
			});
		},
		insertRow: (e, { fromRow: t }) => {
			QE(e, {
				disableSelect: !0,
				fromRow: t
			});
		},
		minColumnWidth: 48
	},
	plugins: [
		{
			deserializeHtml: { rules: [{ validNodeName: "TR" }] },
			isElement: !0,
			key: "tr"
		},
		{
			dangerouslyAllowAttributes: ["colspan", "rowspan"],
			isElement: !0,
			key: "td",
			props: ({ element: e }) => ({ nodeProps: {
				colSpan: e?.attributes?.colspan,
				rowSpan: e?.attributes?.rowspan
			} }),
			then: (e) => ({ deserializeHtml: {
				attributeNames: ["rowspan", "colspan"],
				getNode: pD($(e, "td")),
				rules: [{ validNodeName: "TD" }]
			} })
		},
		{
			dangerouslyAllowAttributes: ["colspan", "rowspan"],
			isElement: !0,
			key: "th",
			props: ({ element: e }) => ({ nodeProps: {
				colSpan: e?.attributes?.colspan,
				rowSpan: e?.attributes?.rowspan
			} }),
			then: (e) => ({ deserializeHtml: {
				attributeNames: ["rowspan", "colspan"],
				getNode: pD($(e, "th")),
				rules: [{ validNodeName: "TH" }]
			} })
		}
	],
	then: (e) => ({ options: {
		cellFactory: (t) => ME(e, t),
		getCellChildren: (e) => e.children
	} }),
	withOverrides: dD
}), { TableProvider: hD, tableStore: gD, useTableStore: _D } = Sr({
	colSizeOverrides: Me(/* @__PURE__ */ new Map()),
	hoveredColIndex: null,
	marginLeftOverride: null,
	rowSizeOverrides: Me(/* @__PURE__ */ new Map()),
	selectedCells: null,
	selectedTable: null
}, { name: "table" }), vD = Object.getOwnPropertySymbols, yD = Object.prototype.hasOwnProperty, bD = Object.prototype.propertyIsEnumerable, xD = (e, t) => {
	var n = {};
	for (var r in e) yD.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && vD) for (var r of vD(e)) t.indexOf(r) < 0 && bD.call(e, r) && (n[r] = e[r]);
	return n;
}, SD = SS({
	key: "trailingBlock",
	options: { level: 0 },
	then: (e) => ({ type: $(e, "p") }),
	withOverrides: (e, t) => {
		var { options: n } = t, r = n, { level: i, type: a = $(e, "p") } = r, o = xD(r, ["level", "type"]);
		let { normalizeNode: s } = e;
		return e.normalizeNode = ([t, n]) => {
			if (n.length === 0) {
				let t = yf(e, i), n = t?.[0];
				if (!n || n.type !== a && Ed(t, o)) {
					let n = t ? H.next(t[1]) : [0];
					Rf(e, e.blockFactory({ type: a }, n), { at: n });
					return;
				}
			}
			return s([t, n]);
		}, e;
	}
}), CD = (e) => ly(e), wD = (e, t) => ry(e, t);
function TD(e) {
	return "id" in e && "children" in e;
}
//#endregion
//#region ../document-structure/src/plateTypes.ts
var ED = "h_lg", DD = "h_md", OD = "h_sm", kD = "blockquote", AD = "callout", jD = "code_block", MD = "inline_img", ND = "video_embed", PD = "embed", FD = "anchor_link", ID = "interlink", LD = "html", RD = {
	"elevio-box-info": "info",
	"elevio-box-warning": "warning",
	"elevio-box-error": "error",
	"elevio-box-success": "success"
}, zD = Object.values(RD), BD = CD({
	key: AD,
	isElement: !0,
	deserializeHtml: {
		rules: [
			{
				validNodeName: ["CITE", "Q"],
				validClassName: "callout"
			},
			{
				validNodeName: [
					"BLOCKQUOTE",
					"DIV",
					"P"
				],
				validClassName: "callout"
			},
			{
				validNodeName: ["BLOCKQUOTE"],
				validClassName: "elevio-box-info"
			},
			{
				validNodeName: ["BLOCKQUOTE"],
				validClassName: "elevio-box-warning"
			},
			{
				validNodeName: ["BLOCKQUOTE"],
				validClassName: "elevio-box-success"
			},
			{
				validNodeName: ["BLOCKQUOTE"],
				validClassName: "elevio-box-error"
			},
			{ validNodeName: ["CALLOUT", "FIGURE"] }
		],
		getNode: (e) => {
			let t = Object.keys(RD).find((t) => e.classList.contains(t));
			return t ? {
				type: AD,
				variety: RD[t]
			} : {
				type: AD,
				variety: zD.find((t) => e.classList.contains(t)) ?? "neutral"
			};
		}
	},
	handlers: { onKeyDown: AC },
	options: { hotkey: "mod+shift+c" }
}), VD = CD({
	key: jD,
	isElement: !0,
	deserializeHtml: { rules: [{ validNodeName: "PRE" }, {
		validNodeName: "P",
		validStyle: { fontFamily: "Consolas" }
	}] },
	handlers: { onKeyDown: AC },
	options: { hotkey: ["mod+opt+8", "mod+shift+8"] }
}), HD = [
	{
		test_regex: /^.*((youtu.be)|(youtube.com)|(youtube-nocookie.com))\/((v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))?\??v?=?([^#&?]*).*/,
		url_regex: /(?:https?:\/\/)?(?:www\.)?(?:m\.)?(?:youtube\.com|youtu\.be|youtube-nocookie\.com)\/(?:watch\?v=|embed\/)?([0-9a-zA-Z_-]+)(.+)?/g,
		url_text: "https://www.youtube.com/embed/$1?$2",
		provider: "youtube"
	},
	{
		test_regex: /^.*(?:vimeo.com)\/(?:channels(\/\w+\/)?|groups\/*\/videos\/\d+\/|video\/|)(\d+)(?:$|\/|\?)/,
		url_regex: /(?:https?:\/\/)?(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?(\/[a-zA-Z0-9_-]+)?/i,
		url_text: "https://player.vimeo.com/video/$1",
		provider: "vimeo"
	},
	{
		test_regex: /^(?:.+)loom.com\/(?:watch)?\/?([^.&/]+)\/?(?:[^_.&]+)?/,
		url_regex: /^(?:.+)loom.com\/share\/([0-9a-zA-Z_-]+)(.+)?/g,
		url_text: "https://www.loom.com/embed/$1",
		provider: "loom"
	}
];
function UD(e) {
	return !e || !Jd(e) ? null : HD.find((t) => t.test_regex.test(e)) || null;
}
//#endregion
//#region ../document-structure/src/plugins/createVideoEmbedPlugin/createVideoEmbedPlugin.ts
var WD = CD({
	key: ND,
	isElement: !0,
	isVoid: !0,
	deserializeHtml: {
		rules: [{ validNodeName: "IFRAME" }],
		getNode: (e) => {
			let t = e.getAttribute("src"), n = UD(t);
			if (n) return {
				type: ND,
				url: t,
				provider: n.provider,
				align: "stretch"
			};
		}
	}
}), GD = 640, KD = CD({
	key: PD,
	isElement: !0,
	isVoid: !0,
	deserializeHtml: {
		rules: [{ validNodeName: "IFRAME" }],
		getNode: (e) => {
			if (UD(e.getAttribute("src"))) return;
			let t, n = e.parentElement?.style.getPropertyValue("padding-bottom"), r = e.getAttribute("height");
			return t = n?.endsWith("%") ? parseFloat(n) / 100 * GD : r && !r.endsWith("%") ? parseInt(r, 10) : 480, {
				type: PD,
				src: e.getAttribute("src"),
				title: e.getAttribute("title") || void 0,
				height: t,
				children: [{ text: "" }]
			};
		}
	}
}), qD = CD({
	key: ED,
	isElement: !0,
	deserializeHtml: {
		getNode(e, t) {
			let n = e.getAttribute("id");
			return {
				...t,
				type: ED,
				id: n
			};
		},
		rules: [{ validNodeName: ["H1", "H2"] }]
	},
	handlers: { onKeyDown: AC },
	options: { hotkey: ["mod+opt+1", "mod+shift+1"] }
}), JD = CD({
	key: DD,
	isElement: !0,
	deserializeHtml: {
		rules: [{ validNodeName: "H3" }],
		getNode(e, t) {
			let n = e.getAttribute("id");
			return {
				...t,
				type: DD,
				id: n
			};
		}
	},
	handlers: { onKeyDown: AC },
	options: { hotkey: ["mod+opt+2", "mod+shift+2"] }
}), YD = CD({
	key: OD,
	isElement: !0,
	deserializeHtml: {
		rules: [{ validNodeName: [
			"H4",
			"H5",
			"H6"
		] }],
		getNode(e, t) {
			let n = e.getAttribute("id");
			return {
				...t,
				type: OD,
				id: n
			};
		}
	},
	handlers: { onKeyDown: AC },
	options: { hotkey: ["mod+opt+3", "mod+shift+3"] }
}), XD = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict", ZD = (e = 21) => {
	let t = "", n = e | 0;
	for (; n-- > 0;) t += XD[Math.random() * 64 | 0];
	return t;
}, QD = () => ZD(5), $D = CD({
	key: LD,
	isElement: !0,
	isVoid: !0,
	deserializeHtml: {
		rules: [{ validNodeName: ["TABLE"] }],
		getNode(e) {
			let t = e.outerHTML;
			return {
				type: LD,
				id: QD(),
				html: t
			};
		}
	}
}), eO = ly({
	key: MD,
	isElement: !0,
	isInline: !0,
	isVoid: !0,
	deserializeHtml: {
		rules: [{ validNodeName: "IMG" }],
		getNode(e) {
			let t = e.parentElement;
			if (t && (t.textContent ?? "").trim().length !== 0) return {
				type: MD,
				url: e.getAttribute("src"),
				children: [{ text: "" }]
			};
		}
	}
}), tO = CD({
	key: "createInjectDeserializeInlineChildrenPlugin",
	options: { keys: ["p"] },
	withOverrides: (e) => {
		let { normalizeNode: t } = e;
		return e.normalizeNode = ([n, r]) => {
			if (!TD(n)) return t([n, r]);
			if (n.type === "p" && n.children.length > 0) {
				if (r.length > 1) {
					let i = Mu(e, r);
					return i && kC(e, i[0], ["td", "th"]) ? t([n, r]) : void 0;
				}
				t([n, r]), Od(e, {
					at: r,
					match(t, n) {
						return Tu(e, t) && n.length > 1;
					}
				});
				return;
			}
			t([n, r]);
		}, e;
	},
	then(e, t) {
		let n = Eb(e), r = { deserializeHtml: { getNode(t, r) {
			let i = Array.from(t.childNodes).flatMap(n).filter(Boolean).flatMap((t, n) => od(e, t) ? t : typeof t == "string" ? { text: t } : (t?.type === "ul" || t?.type === "ol") && (r.type === "li" || r.type === "lic") ? t : Tu(e, t) ? [nO({
				editor: e,
				node: t,
				index: n
			}), ...t.children].filter(Boolean) : t);
			return {
				...r,
				children: i
			};
		} } };
		return { inject: { pluginsByKey: (t.options?.keys || []).reduce((e, t) => ({
			...e,
			[t]: r
		}), {}) } };
	}
});
function nO({ editor: e, node: t, index: n }) {
	if (n !== 0 && "type" in t) return t.type === "p" && t.children.length > 0 ? t.children.length === 1 && t.children[0].text === "" ? void 0 : { text: "\n\n" } : od(e, t) ? void 0 : { text: "\n" };
}
//#endregion
//#region ../document-structure/src/plugins/link/withMyLinks.ts
var rO = (e) => {
	let { apply: t, normalizeNode: n } = e;
	return e.apply = (n) => {
		if (n.type === "set_selection") {
			let t = n.newProperties;
			if (t && t.focus && t.anchor && xd(t)) {
				let r = ku(e, {
					at: t,
					match: (t) => kC(e, t, [ID, FD])
				});
				if (r) {
					let [, i] = r, a;
					sd(e, t.focus, i) && (a = Ef(e, i)), ad(e, t.focus, i) && (a = xf(e, i)), a && (n.newProperties = {
						anchor: a,
						focus: a
					});
				}
			}
		}
		t(n);
	}, e.normalizeNode = ([t, r]) => {
		if (kC(e, t, ["interlink", "anchor_link"])) {
			let t = e.selection;
			if (t && xd(t) && ad(e, t.focus, r)) {
				let t = xf(e, r);
				if (t) Vu(e, t);
				else {
					let t = H.next(r);
					Dd(e, { text: "" }, { at: t }), Vu(e, t);
				}
			}
		}
		n([t, r]);
	}, e = dw(e, jy({ options: { types: [ID, FD] } })), e;
}, iO = ly({
	key: ID,
	isElement: !0,
	isInline: !0,
	withOverrides: rO,
	options: { rangeBeforeOptions: {
		matchString: " ",
		skipInvalid: !0,
		afterMatch: !0
	} },
	then: () => ({ deserializeHtml: {
		rules: [{ validAttribute: "data-elevio-article" }],
		getNode(e, t) {
			let n = e.getAttribute("data-elevio-article");
			if (n) return {
				id: QD(),
				type: ID,
				linkId: `elevio-article-id:${n}`,
				linkType: "article",
				linkTitle: "",
				...t
			};
		}
	} })
}), aO = pa("floatingLinks")({
	openEditorId: null,
	linkType: "url",
	interlinkId: "",
	interlinkTitle: "",
	interlinkLangId: "",
	linkedElementId: "",
	url: "",
	text: "",
	newTab: !1,
	mode: "",
	isEditing: !1
}).extendActions((e) => ({ reset: () => {
	e.linkType("url"), e.interlinkId(""), e.interlinkTitle(""), e.text(""), e.url(""), e.newTab(!1), e.mode(""), e.isEditing(!1), e.openEditorId(null), e.interlinkLangId("");
} })).extendActions((e) => ({
	show: (t, n) => {
		e.mode(t), e.isEditing(!1), e.openEditorId(n);
	},
	hide: () => {
		e.reset();
	}
})).extendSelectors((e) => ({ isOpen: (t) => e.openEditorId === t }));
aO.set, aO.get;
//#endregion
//#region ../document-structure/src/plugins/link/createAnchorLinkPlugin.ts
var oO = ly({
	key: FD,
	isElement: !0,
	isInline: !0,
	withOverrides: rO,
	options: { rangeBeforeOptions: {
		matchString: " ",
		skipInvalid: !0,
		afterMatch: !0
	} },
	deserializeHtml: {
		rules: [{ validNodeName: ["A"] }],
		getNode(e, t) {
			let n = e.getAttribute("href");
			if (!(!n || !n.startsWith("#"))) return {
				type: FD,
				linkId: n.slice(1),
				...t
			};
		}
	}
}), sO = (e = [], t) => wD([
	...e,
	mE({ options: { idCreator: QD } }),
	hE(),
	tw({ deserializeHtml: {
		rules: [{ validNodeName: "BLOCKQUOTE" }],
		query: (e) => !e.matches(".callout") && !Array.from(e.classList).some((e) => /^elevio-box-/.test(e))
	} }),
	BD(),
	VD(),
	uw(),
	qD(),
	JD(),
	YD(),
	kT(),
	VT({
		options: { disableUploadInsert: !0 },
		deserializeHtml: {
			getNode: (e) => {
				let t = e, n;
				if (e.nodeName === "A") {
					let r = e.querySelector("img");
					if (!r) return;
					t = r, n = e.getAttribute("href");
				}
				let r = e.parentElement;
				if (!r || (r.textContent ?? "").trim().length > 0) return;
				let i = t.classList.contains("fr-fir") ? "end" : t.classList.contains("fr-fil") ? "start" : "center";
				return {
					type: "img",
					url: t.getAttribute("src"),
					filename: null,
					imgAlign: i,
					linkUrl: n,
					children: [{ text: "" }]
				};
			},
			rules: [{ validNodeName: "A" }, { validNodeName: "IMG" }]
		}
	}),
	WD(),
	KD(),
	$D(),
	mD(),
	JC(),
	XC(),
	ew(),
	ZC(),
	YC(),
	Iw({ then(e, t) {
		return { deserializeHtml: { getNode: (e, n) => {
			if (!e.querySelector("img")) return t.deserializeHtml?.getNode?.(e, n);
		} } };
	} }),
	iO(),
	oO(),
	eO(),
	gE({ options: { query: { allow: [
		"hr",
		"img",
		ND
	] } } }),
	lw({ options: { rules: [{ hotkey: "shift+enter" }] } }),
	cw({ options: { rules: [
		{
			hotkey: "mod+shift+enter",
			before: !0
		},
		{
			hotkey: "enter",
			before: !1,
			query: {
				end: !0,
				exclude: [
					"ul",
					"ol",
					"li",
					"lic"
				]
			}
		},
		{ hotkey: "mod+enter" }
	] } }),
	SD({ type: "p" }),
	tO({ options: { keys: [
		"li",
		"lic",
		kD,
		AD,
		ED,
		DD,
		OD
	] } })
], { components: t });
//#endregion
//#region ../document-structure/src/createHeadlessEditor.ts
function cO() {
	return Ib({ plugins: sO([], {}) });
}
//#endregion
//#region ../document-structure/src/structure/empty.ts
var lO = () => [{
	id: QD(),
	type: "p",
	children: [{ text: "" }]
}], uO = [
	"1.0.0",
	"1.1.0",
	"1.2.0",
	"1.3.0"
], dO = uO[uO.length - 1], fO = /href\s*=\s*(["']?)\/\/([^"'>]+)/g;
function pO(e) {
	return e.replace(fO, "href=$1https://$2");
}
//#endregion
//#region ../document-structure/src/deserialize.ts
function mO(e) {
	return {
		constructor: { name: "DataTransfer" },
		getData: (t) => t === "text/html" && e
	};
}
function hO(e) {
	let t = cO();
	t.children = lO();
	let n = pO(e);
	return t.insertData(mO(n)), t.children;
}
CD({
	key: "DEBUG",
	handlers: { onChange: () => (e) => {} }
});
//#endregion
//#region src/components/Modals/components/articleSuccessMessage.tsx
var gO = ({ articleName: e, collectionName: t }) => /* @__PURE__ */ ce(se.Paragraph, {
	withMarginBottom: !0,
	children: [
		"The draft article ",
		/* @__PURE__ */ ce("strong", { children: [
			"“",
			e,
			"”"
		] }),
		" has been successfully created in the collection",
		" ",
		/* @__PURE__ */ ce("strong", { children: [
			"“",
			t,
			"”"
		] })
	]
});
//#endregion
//#region src/components/Modals/useDraftArticleEditor.tsx
function _O({ conversationId: e, languageId: t, collectionId: r, collectionName: i, initialArticleName: o, initialArticleContent: s, draftSource: c, referencedConversationIds: l }) {
	let { hideModal: u } = n(), { successNotify: d, errorNotify: p } = C(), [m, h] = v(), _ = f(), [y] = a(), [b, x] = Se(!1), [S, w] = Se(""), [{ articleName: E, articleContent: ee }, D] = Se({
		articleName: o,
		articleContent: s
	});
	async function te(n) {
		if (n) try {
			Ce.conversationArticleDraftImprovementRequested({
				conversationId: e,
				collectionId: r,
				languageCode: t,
				draftSource: c
			});
			let i = await m({
				csid: e,
				refresh: !1,
				language_id: t,
				save_draft_article_input: { collection_id: r },
				improve: {
					previous_draft_article: {
						title: E,
						article_html: ee
					},
					feedback: n
				}
			});
			Ce.conversationArticleDraftImprovementResponseReceived({
				conversationId: e,
				collectionId: r,
				languageCode: t,
				draftSource: c
			}), D({
				articleName: i.articleName,
				articleContent: i.articleContent
			});
		} catch (e) {
			p({ text: e?.message || "Something went wrong" });
		}
	}
	async function ne() {
		x(!0);
		let n = hO(ee);
		try {
			Ce.conversationArticleDraftSaveRequested({
				conversationId: e,
				collectionId: r,
				languageCode: t,
				draftSource: c
			});
			let a = (await y({
				variables: {
					translations: {
						languageId: t,
						title: E,
						aiAssisted: !0,
						referencedConversationIds: [...l],
						content: {
							version: dO,
							children: n
						}
					},
					parentId: r
				},
				client: _
			})).data?.articleCreate?.id || "";
			Ce.conversationArticleDraftSaveResponseReceived({
				conversationId: e,
				collectionId: r,
				languageCode: t,
				articleId: a,
				draftSource: c
			});
			let o = g.articleEdit({
				articleId: a,
				collectionId: r,
				languageId: t
			});
			d({
				title: "Draft article created",
				time: 1e4,
				text: /* @__PURE__ */ j(T, { children: /* @__PURE__ */ j(gO, {
					articleName: E,
					collectionName: i
				}) }),
				icon: "check-circle",
				leftAction: {
					text: "Edit article",
					action: { navigate: o }
				}
			}), x(!1), u();
		} catch (e) {
			x(!1), p({ text: e?.message || "Something went wrong" });
		}
	}
	return {
		articleName: E,
		articleContent: ee,
		improveInput: S,
		setImproveInput: w,
		onImproveDraft: te,
		onCreateDraft: ne,
		isGenerating: h.loading,
		isSaving: b
	};
}
//#endregion
//#region src/components/Modals/articleDraftModal.tsx
function vO({ onSubmit: t, queueId: r, withCategory: i = !1 }) {
	let { currentConversationId: a } = s(u), { selectedLanguageId: o } = s(_), { data: c, loading: p } = h({ selectedLanguageId: o }), m = c?.selectedLanguage, { data: g, loading: v } = d(), b = g ? g.collections.results.filter((e) => e.linkedResources.some((e) => e.id === r)).map((e) => ({
		id: e.id,
		name: e.title
	})) : [], { hideModal: x } = n(), S = {
		conversationId: a,
		collection: [],
		category: [],
		language: m ? [{
			id: m.languageId,
			name: m.description
		}] : []
	}, { control: C, formState: { isValid: w }, handleSubmit: T, setValue: ee } = ke({
		resolver: rt(Gn(i)),
		defaultValues: S,
		reValidateMode: "onChange",
		mode: "all"
	}), [O] = Ae({
		control: C,
		name: "collection"
	}) || [], { data: ae, loading: oe } = l({
		client: f(),
		variables: { collectionId: O?.id || "" },
		skip: !i || !O
	}), se = ye(() => O ? y({
		categories: ae?.collection?.categories || [],
		collectionId: O.id,
		withCollectionOption: !1,
		currentCategoryId: void 0,
		disabledCategoryIds: []
	}).listItems : [], [ae, O]);
	_e(() => {
		ee("category", [], { shouldValidate: !0 });
	}, [O?.id, ee]);
	let A = c ? c.enabledLanguages.map((e) => ({
		id: e.languageId,
		name: e.description
	})) : [];
	return /* @__PURE__ */ j(e, { children: /* @__PURE__ */ ce("form", {
		onSubmit: T(t),
		children: [
			/* @__PURE__ */ j(k, {
				title: "Create draft article",
				onClose: x
			}),
			/* @__PURE__ */ j(re, { children: /* @__PURE__ */ ce(ne, { children: [
				/* @__PURE__ */ j(te, { children: /* @__PURE__ */ j(at, {
					required: !0,
					control: C,
					multiple: !1,
					label: "Collection",
					name: "collection",
					equalityFn: (e, t) => e.id === t.id,
					itemsLoading: v,
					listItems: b,
					placeholders: {
						empty: "Select a collection",
						loading: "Loading collections..."
					}
				}) }),
				i && /* @__PURE__ */ j(te, { children: /* @__PURE__ */ j(at, {
					required: !0,
					control: C,
					multiple: !1,
					label: "Category",
					name: "category",
					equalityFn: (e, t) => e.id === t.id,
					itemsLoading: oe,
					listItems: se,
					disabled: !O,
					placeholders: {
						empty: se.length ? "Select a category" : "No categories in this collection",
						loading: "Loading categories..."
					}
				}) }),
				/* @__PURE__ */ j(te, { children: /* @__PURE__ */ j(at, {
					required: !0,
					control: C,
					multiple: !1,
					label: "Language",
					name: "language",
					equalityFn: (e, t) => e.id === t.id,
					itemsLoading: p,
					listItems: A,
					placeholders: {
						empty: "Select a collection",
						loading: "Loading collections..."
					}
				}) })
			] }) }),
			/* @__PURE__ */ j(ie, { children: /* @__PURE__ */ ce(D, {
				justifyContent: "flex-end",
				gap: "100",
				children: [/* @__PURE__ */ j(E, {
					variant: "tertiary",
					onClick: x,
					children: "Cancel"
				}), /* @__PURE__ */ j(E, {
					disabled: !w,
					type: "submit",
					children: "Next"
				})]
			}) })
		]
	}) });
}
function yO({ onRetry: t }) {
	let { hideModal: r } = n(), [i, a] = Se(!1);
	return /* @__PURE__ */ ce(e, { children: [
		/* @__PURE__ */ j(k, {
			title: "Create draft article",
			onClose: r
		}),
		/* @__PURE__ */ j(re, { children: /* @__PURE__ */ j(w, {
			variant: "fail",
			headline: "Failed to create draft article",
			description: /* @__PURE__ */ j(se.Paragraph, { children: "Something went wrong while generating the article. Your collection and language are still selected, so you can try again." })
		}) }),
		/* @__PURE__ */ j(ie, { children: /* @__PURE__ */ ce(D, {
			justifyContent: "flex-end",
			gap: "100",
			children: [/* @__PURE__ */ j(E, {
				variant: "tertiary",
				onClick: r,
				children: "Cancel"
			}), /* @__PURE__ */ j(E, {
				variant: "primary",
				disabled: i,
				onClick: () => {
					a(!0), t();
				},
				children: "Try again"
			})]
		}) })
	] });
}
function bO({ children: t }) {
	let { hideModal: r } = n();
	return /* @__PURE__ */ ce(e, { children: [
		/* @__PURE__ */ j(k, {
			title: "Your article is being created",
			onClose: r
		}),
		/* @__PURE__ */ j(re, { children: /* @__PURE__ */ ce(D, {
			flexDirection: "column",
			alignItems: "center",
			gap: "300",
			children: [/* @__PURE__ */ j(oe, { size: 40 }), t]
		}) }),
		/* @__PURE__ */ j(ie, { children: /* @__PURE__ */ j(D, {
			justifyContent: "flex-end",
			gap: "100",
			children: /* @__PURE__ */ j(E, {
				variant: "primary",
				onClick: r,
				children: "Close"
			})
		}) })
	] });
}
function xO({ languageId: t, articleName: r, articleContent: i, collectionId: a, collectionName: o, conversationId: s }) {
	let { hideModal: c } = n(), l = _O({
		conversationId: s,
		languageId: t,
		collectionId: a,
		collectionName: o,
		initialArticleName: r,
		initialArticleContent: i,
		draftSource: "single-conversation",
		referencedConversationIds: [s]
	});
	return /* @__PURE__ */ ce(e, {
		allowEscClose: !1,
		children: [
			/* @__PURE__ */ j(k, {
				title: "Create draft article",
				onClose: c
			}),
			/* @__PURE__ */ ce(re, {
				className: b.modalBody,
				children: [/* @__PURE__ */ j(S, {
					title: l.articleName,
					articleContent: l.articleContent,
					className: b.legacyArticleBackground
				}), /* @__PURE__ */ j(x, {
					value: l.improveInput,
					onChange: l.setImproveInput,
					onSubmit: l.onImproveDraft,
					isGenerating: l.isGenerating,
					isSaving: l.isSaving
				})]
			}),
			/* @__PURE__ */ j(qn, {
				onDiscard: c,
				onSave: l.onCreateDraft,
				isGenerating: l.isGenerating,
				isSaving: l.isSaving
			})
		]
	});
}
//#endregion
export { xO as ArticleDraftCustomizeModal, yO as ArticleDraftFailedModal, vO as ArticleDraftModal, bO as ArticleDraftRequestedModal };

//# sourceMappingURL=articleDraftModal-_xTYT3S2.js.map